/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(67);
	__webpack_require__(131);
	__webpack_require__(271);

/***/ },
/* 1 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular.module('sharebase-config', [])
			.constant('debugInfoEnabled', false);
	})();

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var login_1 = __webpack_require__(3);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('phoenix', [
	    'ngMaterial',
	    'ngMessages',
	    'site.settings',
	    'ui.router',
	    login_1.default.name
	]);
	__webpack_require__(22);
	__webpack_require__(49);
	__webpack_require__(54);
	__webpack_require__(56);
	__webpack_require__(65);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(4);
	__webpack_require__(5);
	var login_component_1 = __webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(10);
	__webpack_require__(12);
	__webpack_require__(14);
	__webpack_require__(16);
	__webpack_require__(18);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = login_component_1.default;


/***/ },
/* 4 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('phoenix.authService', [])
			.factory('pxAuthService', [
				'$http',
				'$q',
				'settingsService',
				'pxLocalStorageService',
				AuthService]);

		/**
		* @ngdoc service
		* @name  phoenix.pxAuthService
		*
		* @description
		* A service that handles user authentication and provides information
		* about the current authenticated user
		*
		**/
		function AuthService($http, $q, settingsService, pxLocalStorageService) {
			var _authToken = getTokenFromStorage();
			var _userStats = null;
			var _verifiedToken = false;
			var _touchInProgress = false;
			var _privileges = null;

			return {

				/**
				 * @ngdoc method
				 * @name pxAuthService#authenticate
				 * @methodOf phoenix.pxAuthService
				 * @kind function
				 *
				 * @description
				 * Authenticates the user and returns a promise that will
				 * be resolved with Phoenix token.
				 *
				 * @param {object} params Object containing the user's login
				 * parameters.
				 *
				 * - email - The user's email address
				 * - password - The user's password
				 * - rememberMe - Should the auth token be persisted?
				 *
				 * @returns {Deferred} A promise that will resolve the response.data
				 *
				 */
				authenticate: authenticate,

				/**
				 * @ngdoc method
				 * @name pxAuthService#invalidateLogin
				 * @methodOf phoenix.pxAuthService
				 * @kind function
				 *
				 * @description
				 * Clears the users Phoenix token
				 *
				 */
				invalidateLogin: invalidateLogin,

				/**
				 * @ngdoc method
				 * @name pxAuthService#getUserStatistics
				 * @methodOf phoenix.pxAuthService
				 * @kind function
				 *
				 * @description
				 * Gets usage statistics for the authenticated user
				 *
				 * @returns {Deferred} A promise that will resolve with the
				 * user statistics if authenticated, otherwise null.
				 *
				 */
				getUserStatistics: getUserStatistics,

				/**
				* @ngdoc method
				* @name pxAuthService#resetPassword
				* @methodOf phoenix.pxAuthService
				* @kind function
				*
				* @description
				* Resets a user's password
				* @param {string} authToken Token supplied by reset password emailAddress
				* @param {string} new password
				*
				* @returns {Deferred} A promise that will resolve with response.data
				*/
				resetPassword: resetPassword,

				/**
				* @ngdoc method
				* @name pxAuthService#requestPasswordReset
				* @methodOf phoenix.pxAuthService
				* @kind function
				*
				* @description
				* Requests an email with a link to reset the user's password
				* @param {string} email Email to request password reset for
				* @param {string} serverWebPath Domain host
				*
				* @returns {Deferred} A promise that will resolve with response.data
				*
				*/
				requestPasswordReset: requestPasswordReset,

				/**
				* @ngdoc method
				* @name pxAuthService#updateExpiredPassword
				* @methodOf phoenix.pxAuthService
				* @kind function
				*
				* @description
				* Updates a user's expired password
				* @param {string} emailAddress User's email address
				* @param {string} oldPassword User's old password
				* @param {string} newPassword User's new password
				*
				* @returns {Deferred} A promise that will resolve with response.data
				*
				*/
				updateExpiredPassword: updateExpiredPassword,

				/**
				 * @ngdoc property
				 * @name pxAuthService#token
				 * @propertyOf phoenix.pxAuthService
				 * @kind property
				 *
				 * @description
				 * Returns the authenticated users Phoenix token.
				 *
				 * @returns {string} The user's Phoenix token
				 */
				get token() { return getToken(); },

				/**
				 * @ngdoc property
				 * @name pxAuthService#displayName
				 * @propertyOf phoenix.pxAuthService
				 * @kind property
				 *
				 * @description
				 * Returns the display name of the authenticated user, or null
				 * if the user is not authenticated.
				 *
				 * @returns {string} The user's display name.
				 */
				get displayName() { return getDisplayName(); },

				/**
				* @ngdoc property
				* @name pxAuthService#systemName
				* @propertyOf phoenix.pxAuthService
				* @kind property
				*
				* @description
				* Returns the system name of the authenticated user, or null
				* if the user is a system administrator.
				*
				* @returns {string} The user's system name.
				*/
				get systemName() { return getSystemName(); },
				/**
				* @ngdoc property
				* @name pxAuthService#userId
				* @propertyOf phoenix.pxAuthService
				* @kind property
				*
				* @description
				* The user ID of the authenticated user.
				*
				* @returns {int} The user's user ID.
				*/
				get userId() { return _authToken ? _authToken.UserId : null; },
				/**
				* @ngdoc property
				* @name pxAuthService#deploymentId
				* @propertyOf phoenix.pxAuthService
				* @kind property
				*
				* @description
				* Returns the deployment ID of the authenticated user, or null
				* if the user is a system administrator.
				*
				* @returns {int} The user's deployment ID.
				*/
				get deploymentId() { return _authToken ? _authToken.DeploymentId : null; },
				/**
				* @ngdoc property
				* @name pxAuthService#deploymentGroupId
				* @propertyOf phoenix.pxAuthService
				* @kind property
				*
				* @description
				* Returns the deployment group ID of the authenticated user, or null
				* if the user is a system administrator.
				*
				* @returns {int} The user's deployment group ID.
				*/
				get deploymentGroupId() {return _authToken && _authToken.DeploymentGroupId > -1 ?  _authToken.DeploymentGroupId : null; },
				/**
				 * @ngdoc property
				 * @name pxAuthService#userStatistics
				 * @propertyOf phoenix.pxAuthService
				 * @kind property
				 *
				 * @description
				 * A set of usage statistics for the authenticated user.
				 *
				 * Calling getUserStatistics will force updates to this
				 * property.
				 *
				 * @returns {array} The user's usage data or null if the user
				 * is not authenticated
				 */

				get userStatistics() { return _userStats; },
				get isSysAdmin() { return _authToken ? _authToken.IsSysAdmin : false; },
				get isSiteAdmin() { return _authToken ? _authToken.Embedded.Roles.indexOf('SiteAdmin') >= 0 : false; },
				get isUserAdmin() { return _authToken ? _authToken.Embedded.Roles.indexOf('UserAdmin') >= 0 : false; },
				get isTenantAdmin() { return _authToken ? _authToken.Embedded.Roles.indexOf('TenantAdmin') >= 0 : false; },
				get isAdmin() { return this.isSysAdmin || this.isTenantAdmin || this.isSiteAdmin || this.isUserAdmin; },
				get isAuthenticated() {
					var validToken = !!_authToken;

					if (validToken && !_touchInProgress && !_verifiedToken) {
						validateAuthToken(_authToken.Token);
					}

					return validToken;
				},

				/**
				* @ngdoc method
				* @name pxAuthService#validateAuthToken
				* @methodOf phoenix.pxAuthService
				* @kind function
				*
				* @description
				* Validates an authorization token. If none is supplied the current auth token is used
				* @param {string} authToken (Optional) Token to validate with the server
				*
				* @returns {Deferred} A promise that resolves if the token is valid
				* otherwise an exception is thrown
				*/
				validateAuthToken : validateAuthToken,
				get privileges() {
					if(!_privileges && _authToken) {
						_privileges = createPrivs(_authToken.Embedded.Privileges);
					}

					return _privileges || {};
				},

				/**
				 * @ngdoc method
				 * @name pxAuthService#registerDeployment
				 * @methodOf phoenix.pxAuthService
				 * @kind function
				 *
				 * @description
				 * Registers a new deployment based on an auth token that has been sent
				 * to a specific user.
				 *
				 * @param {number} id Id of the deployment to register.
				 * @param {string} authToken A temporary authentication token required to validate the user to the deployment.
				 * @param {string} userName User name for the user registering the deployment.
				 * @param {string} password New password for the user registering the deployment.
				 *
				 * @returns {Deferred} A promise that resolves if the deployment has been registered successfully.
				 */
				registerDeployment: registerDeployment,

				/**
				 * @ngdoc method
				 * @name pxAuthService#validatePassword
				 * @methodOf phoenix.pxAuthService
				 * @kind function
				 *
				 * @description
				 * Validate a password agains a deployment's password policies.
				 *
				 * @param {string} password The password to test
				 * @param {string} authToken Use to test against a specific deployment's policies.
				 * @returns {Deferred} A promise that will resolve to an object that indicates if the password was valid.
				 */
				validatePassword: validatePassword
			};

			function authenticate(emailAddress, password, rememberMe) {
				if (!angular.isString(emailAddress) || emailAddress.length === 0) {
					throw new Error('emailAddress parameter required');
				}

				if (!angular.isString(password) || password.length === 0) {
					throw new Error('password parameter required');
				}

				var httpConfig = {
					'headers': {
						'Authorization': function (config) {
							var b64 = btoa(emailAddress + ':' + password);
							return 'Basic ' + b64;
						}
					},
					skipAuth: true
				};

				return $http.get(settingsService.serverAPIPath + '/authenticate', httpConfig)
					.then(function (response) {
						if (tokenIsValid(response)) {
							storeToken(response, rememberMe);
						}
						return response.data;
					});
			}

			function getDisplayName() {
				return _authToken ? _authToken.UserName : null;
			}

			function getSystemName() {
				return _authToken ? _authToken.SystemName : null;
			}

			function getToken() {
				return _authToken ? _authToken.Token : null;
			}

			function getTokenFromStorage() {
				var authToken = pxLocalStorageService.getStoredValue('phoenix_token');

				if (authToken.length !== 0) {
					var authTokenObj = JSON.parse(authToken);
					if (angular.isObject(authTokenObj)) {
						return authTokenObj;
					}
				}
				return null;
			}

			function getUserStatistics() {
				if (!_authToken) {
					return $q.resolve(null);
				}

				var uri = _authToken.Embedded.User.Links.StatisticsUri;

				return $http.get(uri)
					.then(function (response) {
						var stats = {};
						if (response.data.length > 0) {
							angular.forEach(response.data, function (item) {
								stats[item.Id] = { Label: item.Label, Count: item.Count };
							});
						}
						_userStats = stats;

						return _userStats;
					});
			}

			function invalidateLogin() {
				_authToken = null;
				_verifiedToken = false;
				pxLocalStorageService.removeStoredValue('phoenix_token');
			}

			function resetPassword(authToken, newPassword) {
				return $http.post(settingsService.serverAPIPath + '/passwordcallback?auth=' + authToken,
					{
						NewPassword: newPassword
					})
					.then(function (response) {
						if (tokenIsValid(response)) {
							storeToken(response, false);
						}
						return response.data;
					});
			}

			function requestPasswordReset(email, serverWebPath) {
				var serverPath = angular.isString(serverWebPath) ? '&serverWebPath=' + encodeURIComponent(serverWebPath) : '';

				return $http.get(settingsService.serverAPIPath + '/passwordrequest?email=' + email + serverPath)
					.then(function (response) {
						return response.data;
					});
			}

			function storeToken(response, rememberMe) {
				var data = response.data;
				_authToken = data;

				if (rememberMe) {
					pxLocalStorageService.setStoredValue('phoenix_token', JSON.stringify(data));
				}
			}

			function tokenIsValid(response) {
				var data = response.data;
				return angular.isDefined(data.Token) && data.Token !== null;
			}

			function updateExpiredPassword(emailAddress, oldPassword, newPassword) {
				var resetData = {
					'EmailAddress': emailAddress,
					'OldPassword': oldPassword,
					'NewPassword': newPassword
				};

				return $http.post(settingsService.serverAPIPath + '/users/passwordchange', resetData)
					.then(function (response) {
						return response.data;
					});
			}

			function validateAuthToken(authToken) {
				if (!angular.isString(authToken)) {
					throw new Error('authToken parameter required');
				}

				_touchInProgress = true;
				return $http.get(settingsService.serverAPIPath + '/touch?auth=' + authToken)
					.then(function () {
						_verifiedToken = true;
					})
					.finally(function () {
						_touchInProgress = false;
					});
			}

			function createPrivs(privList){
				return privList.reduce(function(privs, priv){
					// map privlege namespace path onto properties of object
					priv.split('/')
						.reduce(function(section, sectionName, i, sectionsArr){
							// camel case the properties
							sectionName = sectionName.charAt(0).toLowerCase() + sectionName.slice(1);
							var isLastSection = i === (sectionsArr.length - 1);

							if(!(sectionName in section)){
								section[sectionName] = Object.create(null);
							}

							if(isLastSection) {
								section[sectionName] = true;
							}

							return section[sectionName];
						}, privs);

					return privs;
				}, {});
			}

			function registerDeployment(id, authToken, userName, password) {
				var uri = settingsService.serverAPIPath + '/admin/registrations/' + id;
				var userInfo = {
					UserName: userName,
					Password: password
				};
				var config = { headers: { Authorization: 'PHOENIX-TOKEN ' + authToken } };
				return $http.post(uri, userInfo, config);
			}

			function validatePassword(password, authToken) {
				var uri = settingsService.serverAPIPath + '/settings/passwordpolicy/test';
				var checkPass = { Password: password };
				var config = { };
				if (authToken) {
					config.headers = {
						Authorization: 'PHOENIX-TOKEN ' + authToken
					};
				}
				return $http.post(uri, checkPass, config)
					.then(function(res) {
						return res.data;
					});
			}
		}
	})();

/***/ },
/* 5 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('phoenix.authInterceptor', [])
			.factory('pxAuthInterceptor', [
				'$q',
				'$location',
				'$injector',
				authInterceptor]);

		/**
		* @ngdoc service
		* @name  phoenix.pxAuthInterceptor
		* 
		* @description 
		* An http interceptor that is responsible for adding the 
		* PHOENIX token to each API request. If the user is not
		* authenticated, the interceptor will redirect them to login
		* 
		*
		* If the request should not include a PHOENIX-TOKEN,
		* you may include { skipAuth: true } in the http config used
		* for the request.
		*
		
		 $http.get('http://localhost/home', {skipAuth: true});
		
		*
		**/
		function authInterceptor($q, $location, $injector) {

			var _redirectUrl = '/';

			/*
			 * pxAuthService is lazy loaded via the setAuthService function to eliminate any http 
			 * injector circular dependancy when adding this interceptor via a module config block.
			 * if a better solution arises it should replace this and the pxAuthService should be 
			 * injected into the service
			 */
			var pxAuthService;

			function requestFn(config) {
				setAuthService();

				if (!skipAuth(config)) {
					if (pxAuthService.token) {
						config.headers.Authorization = 'PHOENIX-TOKEN ' + pxAuthService.token;
					}
				}

				return config;
			}

			function skipAuth(config) {
				return angular.isDefined(config.skipAuth) && config.skipAuth;
			}

			function responseErrorFn(rejection) {
				setAuthService();

				if (rejection.status === 401) {
					pxAuthService.invalidateLogin();

					if ($location.path() !== '/login') {
						_redirectUrl = $location.path();
					}

					$location.path('/login');
				}

				return $q.reject(rejection);
			}

			function redirectPostLogin() {
				var redirect = _redirectUrl;

				_redirectUrl = '/';

				$location.url(redirect);
			}

			function setAuthService() {
				if (!pxAuthService) {
					pxAuthService = $injector.get('pxAuthService');
				}
			}

			return {
				/**
				 * @ngdoc method
				 * @name pxAuthInterceptor#request
				 * @methodOf phoenix.pxAuthInterceptor
				 * @kind function
				 *
				 * @description
				 * Adds the PHOENIX token to every request
				 * 
				 */
				request: requestFn,
				/**
				 * @ngdoc method
				 * @name pxAuthInterceptor#responseError
				 * @methodOf phoenix.pxAuthInterceptor
				 * @kind function
				 *
				 * @description
				 * Redirects to /login on 401
				 * 
				 */
				responseError: responseErrorFn,
				/**
				 * @ngdoc method
				 * @name pxAuthInterceptor#redirectPostLogin
				 * @methodOf phoenix.pxAuthInterceptor
				 * @kind function
				 *
				 * @description
				 * Call this to redirect back to the previous route
				 * after authenticating (deep linking)
				 * 
				 */
				redirectPostLogin: redirectPostLogin
			};
		}

	})();

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var templateUrl = __webpack_require__(7);
	var parentRoute = 'loginComponent';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('phoenix.loginComponent', ['ngMaterial', 'phoenix.authService', 'phoenix.authInterceptor'])
	    .directive('pxLogin', ['pxProgressService', LoginDirective])
	    .controller('pxLoginController', [
	    'pxAuthService',
	    'pxAuthInterceptor',
	    LoginController])
	    .run(['pxAuthService', '$rootScope', '$window', function (pxAuthService, $rootScope, $window) {
	        $rootScope.$on('$stateChangeStart', function (evt, to) {
	            if (to.parent === parentRoute && to.name === 'logout') {
	                evt.preventDefault();
	                pxAuthService.invalidateLogin();
	                // Force reload to clear data stores
	                $window.location.reload();
	            }
	        });
	    }])
	    .config(['$stateProvider', function ($stateProvider) {
	        var login = {
	            parent: parentRoute,
	            url: '/login',
	            params: {
	                errorMessage: null
	            },
	            template: '<px-login-main error-message="vm.sharedObjects.message" email-address="vm.sharedObjects.emailAddress" />'
	        };
	        $stateProvider
	            .state('login', angular.copy(login))
	            .state('logout', angular.copy(login))
	            .state('forgotPassword', {
	            parent: parentRoute,
	            url: '/forgot_password',
	            template: '<px-login-forgot-password error-message="vm.sharedObjects.message" email-address="vm.sharedObjects.emailAddress" />'
	        })
	            .state('passwordExpired', {
	            parent: parentRoute,
	            url: '/password_expired',
	            params: {
	                emailAddress: null
	            },
	            template: '<px-login-expired-password error-message="vm.sharedObjects.message" email-address="vm.sharedObjects.emailAddress"/>',
	            controller: ['$state', '$stateParams', function ($state, $stateParams) {
	                    // State params must contain emailAddress in order to route
	                    if (!angular.isString($stateParams.emailAddress)) {
	                        $state.go('login');
	                    }
	                }]
	        })
	            .state('passwordCallback', {
	            parent: parentRoute,
	            url: '^/passwordcallback?auth',
	            template: '<px-login-reset-password error-message="vm.sharedObjects.message" />',
	            controller: ['$state', '$stateParams', function ($state, $stateParams) {
	                    // State params must contain emailAddress in order to route
	                    if (!angular.isString($stateParams.auth)) {
	                        $state.go('login');
	                    }
	                }]
	        })
	            .state('loginRegister', {
	            parent: parentRoute,
	            url: '^/register/:deploymentId/setpassword?auth',
	            template: function (params) {
	                return "<px-login-register error-message=\"vm.sharedObjects.message\" deployment-id=\"" + params.deploymentId + "\" auth-token=\"" + params.auth + "\" />";
	            }
	        });
	    }]);
	/**
	 * @ngdoc directive
	 * @name phoenix.directive:pxLogin
	 * @module phoenix
	 * @restrict E
	 * @description
	 *
	 * `pxLogin` is a universal login component for logging into the Phoenix API
	 *
	 * @param {string=} title This should typically be the application's name.
	 * If no title is supplied the control's header will not be displayed
	 *
	 * @param {element=} headerIcon Optional element that will be transcluded in the DOM
	 * of the login component's header
	 *
	 * @usage
	 *
	 * <px-login title="ShareBase">
	 *	<header-icon>
	 *		<div class="icon-class-with-backgroundUrlImage"></div>
	 *	</header-icon>
	 * </px-login>
	 *
	 */
	function LoginDirective(pxProgressService) {
	    return {
	        restrict: 'E',
	        transclude: {
	            'headerIcon': 'headerIcon'
	        },
	        controller: 'pxLoginController',
	        controllerAs: 'vm',
	        templateUrl: templateUrl,
	        bindToController: true,
	        scope: {
	            title: '@',
	            headerIcon: '@?headerIcon'
	        },
	        link: function (scope, element, attrs) {
	            //hide the progress indicator
	            pxProgressService.visible = false;
	            pxProgressService.backdrop = false;
	        }
	    };
	}
	function LoginController(pxAuthService, pxAuthInterceptor) {
	    var vm = this;
	    vm.sharedObjects = {
	        emailAddress: '',
	        message: ''
	    };
	    // If user is authenticated navigate to the default route
	    if (pxAuthService.isAuthenticated) {
	        pxAuthInterceptor.redirectPostLogin();
	    }
	}


/***/ },
/* 7 */
/***/ function(module, exports) {

	var path = 'phoenix/components/login/login.template.html';
	var html = "<md-content class=\"app__background pxlogin\" layout-fill layout=\"row\" layout-align-gt-xs=\"center center\" layout-align=\"start stretch\">\r\n\t<md-card class=\"pxlogin__card\" flex-xs=\"100\" layout=\"column\">\r\n\t\t<md-toolbar ng-if=\"vm.title\" class=\"md-card-image md-padding pxlogin__header-wrap\" layout=\"row\" layout-align=\"start center\">\t\r\n\t\t\t<div ng-transclude=\"headerIcon\" class=\"pxlogin__icon-header\">\t\r\n\t\t\t</div>\r\n\t\t\t<span flex class=\"md-headline pxlogin__header\">{{ vm.title }}</span>\t\t\t\r\n\t\t</md-toolbar>\r\n\t\t<div role=\"alert\" class=\"app__background pxlogin__errors-wrap\" ng-if=\"vm.sharedObjects.message\">\r\n\t\t\t<md-subheader class=\"md-warn pxlogin__errors\">{{ vm.sharedObjects.message }}</md-subheader>\r\n\t\t</div>\r\n\t\t<div ui-view>\r\n\t\t\t<px-login-default/>\r\n\t\t</div>\r\n\t</md-card>\r\n</md-content>\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(9);
		
		angular.module('phoenix.loginComponent')
			.directive('pxLoginExpiredPassword', LoginExpiredPasswordDirective)
			.controller('pxLoginExpiredPasswordController', [
				'$timeout',
				'$window',
				'pxAuthService',
				'pxProgressService',
				'pxAuthInterceptor',
				'gettextCatalog',
				'$stateParams',
				'$state',
				LoginExpiredPasswordController
			]);
		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxLoginExpiredPassword
		 * @module phoenix
		 * @restrict E
		 * @description
		 *
		 * `pxLoginExpiredPassword` a view component of `pxLogin`
		 *
		 * @param {string=} errorMessage This should typically be the application's name.
		 * If no title is supplied the control's header will not be displayed
		 * @param {string=} emailAddress Email Address used to populate the email input
		 */
		function LoginExpiredPasswordDirective() {
			return {
				restrict: 'E',
				controller: 'pxLoginExpiredPasswordController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: templateUrl,
				scope: {
					errorMessage: '=?',
					emailAddress: '=?'
				},
				link: function (scope, element, attrs) {

				}
			};
		}
		function LoginExpiredPasswordController($timeout, $window, pxAuthService, pxProgressService, pxAuthInterceptor, gettextCatalog, $stateParams, $state) {
			var vm = this;
			vm.errorMessage = '';
			vm.emailAddress = $stateParams.emailAddress;

			vm.submitting = false;
			//vm.errorMessage = gettextCatalog.getString('Your password has expired.  Please enter a new one.');
			vm.updatePassword = updatePassword;
			vm.stateLogin = stateLogin;

			function updatePassword() {
				vm.errorMessage = '';
				if (vm.expiredPasswordForm.$valid) {
					if (vm.newPassword !== vm.confirmPassword) {
						vm.errorMessage = gettextCatalog.getString('New passwords don\'t match');
					}
					else {
						pxProgressService.text = gettextCatalog.getString('Updating Password');
						isSubmitting(true);
						pxAuthService.updateExpiredPassword(vm.emailAddress, vm.oldPassword, vm.newPassword)
							.then(handleUpdatePasswordResult)
							.finally(function () {
								isSubmitting(false);
							});
					}
				}
			}

			function handleUpdatePasswordResult(result) {
				if (result.AuthenticationFailed) {
					vm.errorMessage = gettextCatalog.getString('Please verify that your Current Password is correct and try again.');
					vm.oldPassword = '';
					// Required to get form in pristine state with Material
					// http://stackoverflow.com/a/35229876/684869
					vm.expiredPasswordForm.$setPristine();
					vm.expiredPasswordForm.$setUntouched();
					// Set focus to the old password field
					$timeout(function () {
						var oldPasswordElement = $window.document.getElementById('oldPassword');
						if (oldPasswordElement) {
							oldPasswordElement.focus();
						}
					});
				}
				else if (result.InvalidPassword) {
					vm.errorMessage = result.Error;
				}
				else {
					pxAuthService.authenticate(vm.emailAddress, vm.newPassword)
						.then(function (response) {
							// route back to a previously stored location, else the main content page
							pxAuthInterceptor.redirectPostLogin();
						})
						.catch(function () {
							vm.errorMessage = gettextCatalog.getString('An Unexpected Error Occurred');
						});
				}
			}

			function stateLogin() {
				$state.go('login');
			}

			function isSubmitting(submitting) {
				if (submitting) {
					pxProgressService.backdrop = submitting;
				}
				pxProgressService.visible = submitting;
				vm.submitting = submitting;
			}
		}

	} ());

/***/ },
/* 9 */
/***/ function(module, exports) {

	var path = 'phoenix/components/login/login-expired-password.template.html';
	var html = "<form name=\"vm.expiredPasswordForm\" novalidate>\r\n        <md-card-header>\r\n            <md-card-header-text>\r\n                <span class=\"md-title\" translate>Password Expired</span>\r\n                <span class=\"md-subhead\" translate>Your password has expired. Please enter a new one.</span>\r\n            </md-card-header-text>\r\n        </md-card-header>\r\n        <md-card-content class=\"md-margin pxlogin__input-wrapper\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"end center\">\r\n            <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n                <md-icon class=\"material-icons pxlogin__input-icon\">person</md-icon>\r\n                <label for=\"emailAddress\" translate>Email</label>\r\n                <input required readonly id=\"emailAddress\" name=\"emailAddress\" ng-model=\"vm.emailAddress\" type=\"email\">\r\n            </md-input-container>\r\n            <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n                <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n                <label for=\"oldPassword\" translate>Previous Password</label>\r\n                <input required id=\"oldPassword\" name=\"oldPassword\" ng-model=\"vm.oldPassword\" type=\"password\">\r\n                <div ng-messages=\"vm.expiredPasswordForm.oldPassword.$error\">\r\n                    <div ng-message=\"required\" translate>Previous password is required</div>\r\n                </div>\r\n            </md-input-container>\r\n            <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n                <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n                <label for=\"newPassword\" translate>New Password</label>\r\n                <input required id=\"newPassword\" name=\"newPassword\" ng-model=\"vm.newPassword\" type=\"password\">\r\n                <div ng-messages=\"vm.expiredPasswordForm.newPassword.$error\">\r\n                    <div ng-message=\"required\" translate>New password is required</div>\r\n                </div>\r\n            </md-input-container>\r\n            <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n                <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n                <label for=\"confirmPassword\">Confirm Password</label>\r\n                <input required id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" type=\"password\">\r\n                <div ng-messages=\"vm.expiredPasswordForm.confirmPassword.$error\">\r\n                    <div ng-message=\"required\" translate>Confirm new password is required</div>\r\n                </div>\r\n            </md-input-container>\r\n        </md-card-content>\r\n        <md-card-actions class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-wrap>\r\n            <md-button type=\"submit\" ng-click=\"vm.updatePassword()\" flex-xs=\"100\" flex-order-xs=\"0\" class=\"md-raised\">\r\n                <translate>Update Password</translate>                    \r\n            </md-button>\r\n            <md-button flex-xs=\"100\" flex-order-xs=\"1\" ng-click=\"vm.stateLogin()\">\r\n                <translate>Cancel</translate>\r\n            </md-button>\r\n        </md-card-actions>\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(11);
		
		angular.module('phoenix.loginComponent')
			.directive('pxLoginForgotPassword', LoginForgotPasswordDirective)
			.controller('pxLoginForgotPasswordController', [
				'pxAuthService',
				'$state',
				'pxProgressService',
				'gettextCatalog',
				'settingsService',
				LoginForgotPasswordController
			]);
		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxLoginForgotPassword
		 * @module phoenix
		 * @restrict E
		 * @description
		 *
		 * `pxLoginForgotPassword` a view component of `pxLogin`
		 *
		 * @param {string=} errorMessage This should typically be the application's name.
		 * If no title is supplied the control's header will not be displayed
		 * @param {string=} emailAddress Email Address used to populate the email input
		 */	
		function LoginForgotPasswordDirective() {
			return {
				restrict: 'E',
				templateUrl: templateUrl,
				controller: 'pxLoginForgotPasswordController',
				controllerAs: 'vm',
				bindToController: true,
				scope: {
					errorMessage: '=?',
					emailAddress: '=?'
				},
				link: function (scope, element, attrs) {
				}
			};
		}
		function LoginForgotPasswordController(pxAuthService, $state, pxProgressService, gettextCatalog, settingsService) {
			var vm = this;
			vm.errorMessage = '';
			vm.submitting = false;
			vm.requestPasswordReset = requestPasswordReset;
			vm.stateLogin = stateLogin;

			vm.resetSuccessful = false;

			function requestPasswordReset() {
				if (vm.forgotPasswordForm.$valid) {
					var email = vm.emailAddress;
					isSubmitting(true);
					pxAuthService.requestPasswordReset(email, settingsService.serverWebPath)
						.then(function () {
							vm.resetSuccessful = true;
						})
						.catch(function () {
							vm.errorMessage = gettextCatalog.getString('Error requesting new password');
						})
						.finally(function () {
							isSubmitting(false);
						});
				}
			}

			function stateLogin() {
				$state.go('login');
			}

			function isSubmitting(submitting) {
				if (submitting) {
					pxProgressService.backdrop = submitting;
				}
				pxProgressService.visible = submitting;
				vm.submitting = submitting;
			}
		}

	} ());

/***/ },
/* 11 */
/***/ function(module, exports) {

	var path = 'phoenix/components/login/login-forgot-password.template.html';
	var html = "<form name=\"vm.forgotPasswordForm\" ng-if=\"!vm.resetSuccessful\" novalidate>\r\n    <md-card-header>\r\n        <md-card-header-text>\r\n            <span class=\"md-title\" translate>Reset Password</span>\r\n            <span class=\"md-subhead\" translate>If the user's email address exists, a reset password link will be sent.</span>\r\n        </md-card-header-text>\r\n    </md-card-header>\r\n    <md-card-content class=\"\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"end center\">\r\n        <md-input-container md-no-float class=\"pxlogin__input\">\r\n            <md-icon class=\"material-icons pxlogin__input-icon\">person</md-icon>\r\n            <label for=\"emailAddress\" translate>Email</label>\r\n            <input required type=\"email\" id=\"emailAddress\" name=\"emailAddress\" ng-model=\"vm.emailAddress\">\r\n            <div ng-messages=\"vm.forgotPasswordForm.emailAddress.$error\">\r\n                <div ng-message=\"required\" translate>Please enter your email</div>\r\n                <div ng-message=\"email\" translate>This field must be a valid email address</div>\r\n            </div>\r\n        </md-input-container>\r\n    </md-card-content>\r\n    <md-card-actions class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-wrap>\r\n        <md-button type=\"submit\" ng-click=\"vm.requestPasswordReset()\" flex-xs=\"100\" flex-order-xs=\"0\" class=\"md-raised\">{{::'Request password reset' | translate}}</md-button>\r\n        <md-button flex-xs=\"100\" flex-order-xs=\"1\" ng-click=\"vm.stateLogin()\">{{::'Cancel' | translate}}</md-button>\r\n    </md-card-actions>\r\n</form>\r\n<!--Displayed after a password reset has been requested -->\r\n<div ng-if=\"vm.resetSuccessful\">\r\n    <md-card-header>\r\n        <md-card-header-text>\r\n            <span class=\"md-title\" translate>Reset Requested</span>\r\n            <span class=\"md-subhead\" translate>Check your email for a link to reset your password.</span>\r\n        </md-card-header-text>\r\n    </md-card-header>\r\n    <md-card-content>\r\n    </md-card-content>\r\n    <md-card-actions class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-wrap>\r\n        <md-button flex-xs=\"100\" flex-order-xs=\"1\" ng-click=\"vm.stateLogin()\">{{::'Return to login' | translate}}</md-button>\r\n    </md-card-actions>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(13);
		
		angular.module('phoenix.loginComponent')
			.directive('pxLoginMain', LoginMainDirective)
			.controller('pxLoginMainController', [
				'$location',
				'$filter',
				'pxAuthService',
				'pxProgressService',
				'pxAuthInterceptor',
				'gettextCatalog',
				'$state',
				'$stateParams',
				LoginMainController
			]);
		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxLoginMain
		 * @module phoenix
		 * @restrict E
		 * @description
		 *
		 * `pxLoginMain` a view component of `pxLogin`
		 *
		 * @param {string=} errorMessage This should typically be the application's name.
		 * If no title is supplied the control's header will not be displayed
		 * @param {string=} emailAddress Email Address used to populate the email input
		 */	
		function LoginMainDirective() {
			return {
				restrict: 'E',
				controller: 'pxLoginMainController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				scope: {
					errorMessage: '=?',
					emailAddress: '=?'
				},
				bindToController: true,
				link: function (scope, element, attrs) {
				}
			};
		}
		function LoginMainController($location, $filter, pxAuthService, pxProgressService, pxAuthInterceptor, gettextCatalog, $state, $stateParams) {
			var vm = this;
			vm.rememberMe = true;
			vm.errorMessage = $stateParams.errorMessage || '';
			vm.submitting = false;		
			vm.login = login;
			vm.stateForgotPassword = stateForgetPassword;

			function login() {
				if (vm.loginForm.$valid) {
					vm.errorMessage = '';
					pxProgressService.text = gettextCatalog.getString('Logging In');
					isSubmitting(true);
					pxAuthService.authenticate(vm.emailAddress, vm.password, vm.rememberMe)
						.then(handleLoginResponse)
						.catch(function (response) {
							handleLoginResponse(response.data);
						})
						.finally(function () {
							isSubmitting(false);
						});
				}
			}

			function handleLoginResponse(response) {
				if (response) {
					if (response.Token) {
						// route back to a previously stored location, else the main content page
						pxAuthInterceptor.redirectPostLogin();
					}
					else if (response.PasswordExpired) {
						$state.go('passwordExpired', { emailAddress: vm.emailAddress });
					}
					else {
						vm.errorMessage = gettextCatalog.getString('Invalid login or account is locked. Please verify that your e-mail and password are correct.');
					}
				}
				else {
					vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred.');
				}
			}

			function stateForgetPassword() {
				$state.go('forgotPassword');
			}

			function isSubmitting(submitting) {
				if (submitting) {
					pxProgressService.backdrop = submitting;
				}
				pxProgressService.visible = submitting;
				vm.submitting = submitting;
			}
		}
	} ());

/***/ },
/* 13 */
/***/ function(module, exports) {

	var path = 'phoenix/components/login/login-main.template.html';
	var html = "<form name=\"vm.loginForm\" novalidate autocomplete=\"on\">\r\n        <md-card-content class=\"pxlogin__input-wrapper\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"end center\">\r\n            <md-input-container md-no-float class=\"pxlogin__input\">\r\n                <md-icon class=\"material-icons pxlogin__input-icon\">person</md-icon>\r\n                <label for=\"emailAddress\" translate>Email</label>\r\n                <input required id=\"emailAddress\" autocomplete=\"on\" name=\"emailAddress\" ng-model=\"vm.emailAddress\" type=\"email\">\r\n                <div ng-messages=\"vm.loginForm.emailAddress.$error\">\r\n                    <div ng-message=\"required\" translate>Please enter your email</div>\r\n                    <div ng-message=\"email\" translate>This field must be a valid email address</div>\r\n                </div>\r\n            </md-input-container>\r\n            <md-input-container md-no-float class=\"pxlogin__input\">\r\n                <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n                <label for=\"password\" translate>Password</label>\r\n                <input required id=\"password\"  autocomplete=\"on\" name=\"password\" ng-model=\"vm.password\" type=\"password\">\r\n                <div ng-messages=\"vm.loginForm.password.$error\">\r\n                    <div ng-message=\"required\" translate>Please enter your password</div>\r\n                </div>\r\n            </md-input-container>\r\n            <div class=\"pxlogin__input pxlogin__input--margin-left\" layout=\"row\" layout-align=\"start center\">\r\n                <md-checkbox ng-model=\"vm.rememberMe\" aria-label=\"Remember Me\" class=\"md-accent\">\r\n                    {{'Remember me'| translate}}\r\n                </md-checkbox>\r\n            </div>\r\n        </md-card-content>\r\n        <md-card-actions class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-wrap>\r\n            <md-button flex-xs=\"100\" flex-order-xs=\"1\" class=\"md-primary app--button-all-lowercase\" ng-click=\"vm.stateForgotPassword()\">{{'Forgot your password?' | translate}}</md-button>\r\n            <md-button type=\"submit\" ng-click=\"vm.login()\" flex-xs=\"100\" flex-order-xs=\"0\" class=\"md-raised\">{{'Login' | translate}}</md-button>\r\n        </md-card-actions>\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(15);
		
		angular.module('phoenix.loginComponent')
			.directive('pxLoginResetPassword', LoginResetPasswordDirective)
			.controller('pxLoginResetPasswordController', [
				'pxAuthService',
				'pxAuthInterceptor',
				'pxProgressService',
				'gettextCatalog',
				'$stateParams',
				'$state',
				LoginResetPasswordController
			]);

		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxLoginResetPassword
		 * @module phoenix
		 * @restrict E
		 * @description
		 *
		 * `pxLoginResetPassword` a view component of `pxLogin`
		 *
		 * @param {string=} errorMessage This should typically be the application's name.
		 * If no title is supplied the control's header will not be displayed
		 */
		function LoginResetPasswordDirective() {
			return {
				restrict: 'E',
				controller: 'pxLoginResetPasswordController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: templateUrl,
				scope: {
					errorMessage: '=?'
				},
				link: function (scope, element, attrs) {

				}
			};
		}
		function LoginResetPasswordController(pxAuthService, pxAuthInterceptor, pxProgressService, gettextCatalog, $stateParams, $state) {
			var vm = this;
			var authToken = $stateParams.auth;
			vm.errorMessage = '';
			vm.submitting = false;
			vm.resetPassword = resetPassword;
			vm.stateLogin = stateLogin;

			isSubmitting(true);
			//user is redirected back to login if the reset auth token is already expired
			pxAuthService.validateAuthToken(authToken)
				.catch(function () {
					$state.go('login', {
						errorMessage: gettextCatalog.getString('The password reset link has expired.')
					});
				})
				.finally(function () {
					isSubmitting(false);
				});

			function resetPassword() {
				if (vm.resetPasswordForm.$valid) {

					if (vm.newPassword !== vm.confirmPassword) {
						vm.errorMessage = gettextCatalog.getString('Passwords don\'t match');
					}
					else {
						pxProgressService.text = gettextCatalog.getString('Updating Password');
						isSubmitting(true);
						pxAuthService.resetPassword(authToken, vm.newPassword)
							.then(function (result) {
								if (result.InvalidPassword) {
									vm.errorMessage = result.Error;
								}
								else {
									pxAuthInterceptor.redirectPostLogin();
								}
							})
							.catch(function (response) {
								vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred.');
							})
							.finally(function () {
								isSubmitting(false);
							});
					}
				}
			}

			function stateLogin() {
				$state.go('login');
			}

			function isSubmitting(submitting) {
				if (submitting) {
					pxProgressService.backdrop = submitting;
				}
				pxProgressService.visible = submitting;
				vm.submitting = submitting;
			}
		}

	} ());

/***/ },
/* 15 */
/***/ function(module, exports) {

	var path = 'phoenix/components/login/login-reset-password.template.html';
	var html = "<form name=\"vm.resetPasswordForm\" novalidate>\r\n    <md-card-header>\r\n        <md-card-header-text>\r\n            <span class=\"md-title\" translate>Reset Password</span>\r\n            <span class=\"md-subhead\" translate>You have requested a password reset</span>\r\n        </md-card-header-text>\r\n    </md-card-header>\r\n    <md-card-content class=\"md-margin pxlogin__input-wrapper\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"end center\">\r\n        <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n            <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n            <label for=\"newPassword\" translate>New Password</label>\r\n            <input required id=\"newPassword\" name=\"newPassword\" ng-model=\"vm.newPassword\" type=\"password\">\r\n            <div ng-messages=\"vm.resetPasswordForm.newPassword.$error\">\r\n                <div ng-message=\"required\" translate>New password is required</div>\r\n            </div>\r\n        </md-input-container>\r\n        <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n            <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n            <label for=\"confirmPassword\" translate>Confirm New Password</label>\r\n            <input required id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" type=\"password\">\r\n            <div ng-messages=\"vm.resetPasswordForm.confirmPassword.$error\">\r\n                <div ng-message=\"required\" translate>Confirm new password is required</div>\r\n            </div>\r\n        </md-input-container>\r\n    </md-card-content>\r\n    <md-card-actions class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-wrap>\r\n        <md-button type=\"submit\" ng-click=\"vm.resetPassword()\" flex-xs=\"100\" flex-order-xs=\"0\" class=\"md-raised\">\r\n            <translate>Reset Password</translate>\r\n        </md-button>\r\n        <md-button flex-xs=\"100\" flex-order-xs=\"1\" ng-click=\"vm.stateLogin()\">\r\n            <translate>Cancel</translate>\r\n        </md-button>\r\n    </md-card-actions>\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var registerTemplate = __webpack_require__(17);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('phoenix.loginComponent')
	    .directive('pxLoginRegister', loginRegister);
	var TOAST_POSITION = 'bottom right';
	var TOAST_DELAY = 3000;
	/**
	 * @ngdoc directive
	 * @name phoenix.loginComponent:pxLoginRegister
	 * @module phoenix
	 * @restrict E
	 *
	 * @description
	 *
	 * `pxLoginRegister` a view component of `pxLogin`
	 * @param {string@} deploymentId Id of the deployment being register
	 * @param {string@} authToken A temporary authentication token used to authorize the user for registration
	 */
	function loginRegister() {
	    return {
	        restrict: 'E',
	        controller: LoginRegisterController,
	        controllerAs: 'vm',
	        bindToController: true,
	        templateUrl: registerTemplate,
	        scope: {
	            deploymentId: '@',
	            authToken: '@',
	            errorMessage: '=?'
	        }
	    };
	}
	exports.loginRegister = loginRegister;
	;
	var LoginRegisterController = (function () {
	    function LoginRegisterController($state, $timeout, $mdToast, gettextCatalog, pxAuthService, pxProgressService, $stateParams) {
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.$mdToast = $mdToast;
	        this.gettextCatalog = gettextCatalog;
	        this.pxAuthService = pxAuthService;
	        this.pxProgressService = pxProgressService;
	        this.password = '';
	        this.confirmPassword = '';
	        // local fields
	        this.errorMessage = '';
	        this.submitting = false;
	        // Validates token, if it is invalid redirect to the main login page with an error message
	        this.pxAuthService.validateAuthToken($stateParams.auth)
	            .catch(function () { return $state.go('login', {
	            errorMessage: gettextCatalog.getString('The registration link has expired')
	        }); });
	    }
	    LoginRegisterController.prototype.completeRegistration = function () {
	        var _this = this;
	        this.errorMessage = '';
	        if (!this.loginRegisterForm.$valid) {
	            return;
	        }
	        if (this.password !== this.confirmPassword) {
	            this.errorMessage = this.gettextCatalog.getString("New passwords don't match");
	        }
	        else {
	            this.pxProgressService.text = this.gettextCatalog.getString('Registering deployment');
	            this.isSubmitting(true);
	            // Must explicitly make a call to validate the password. The registration endpoint does
	            // not validate the password, and if you hit it with an invalid password, the deployment
	            // will enter a state where the user account was not created and cannot be created by the registration form.
	            this.pxAuthService.validatePassword(this.password, this.authToken)
	                .then(function (data) {
	                if (data.Valid) {
	                    return _this.pxAuthService.registerDeployment(_this.deploymentId, _this.authToken, _this.displayName, _this.password)
	                        .then(function () {
	                        _this.showRegistrationSuccessMessage();
	                        _this.$state.go('login');
	                    });
	                }
	                else {
	                    _this.errorMessage = data.Error;
	                }
	            })
	                .catch(function () { return _this.errorMessage = _this.gettextCatalog.getString('An unexpected error has occurred'); })
	                .finally(function () { return _this.isSubmitting(false); });
	        }
	    };
	    LoginRegisterController.prototype.showRegistrationSuccessMessage = function () {
	        var _this = this;
	        this.$timeout(function () {
	            _this.$mdToast.show(_this.$mdToast.simple()
	                .textContent(_this.gettextCatalog.getString('Your account is now registered, please login to continue.'))
	                .position(TOAST_POSITION)
	                .hideDelay(TOAST_DELAY));
	        }, 0);
	    };
	    LoginRegisterController.prototype.isSubmitting = function (submitting) {
	        if (submitting) {
	            this.pxProgressService.backdrop = submitting;
	        }
	        this.pxProgressService.visible = submitting;
	        this.submitting = submitting;
	    };
	    LoginRegisterController.$inject = [
	        '$state',
	        '$timeout',
	        '$mdToast',
	        'gettextCatalog',
	        'pxAuthService',
	        'pxProgressService',
	        '$stateParams'
	    ];
	    return LoginRegisterController;
	}());
	exports.LoginRegisterController = LoginRegisterController;


/***/ },
/* 17 */
/***/ function(module, exports) {

	var path = 'phoenix/components/login/login-register.template.html';
	var html = "<form name=\"vm.loginRegisterForm\" novalidate ng-submit=\"vm.completeRegistration()\">\r\n    <md-card-header>\r\n        <md-card-header-text>\r\n            <span class=\"md-title\" translate>Register</span>\r\n            <span class=\"md-subhead\" translate>Please set your display name and password to finish registration.</span>\r\n        </md-card-header-text>\r\n    </md-card-header>\r\n    <md-card-content class=\"md-margin pxlogin__input-wrapper\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"end center\">\r\n        <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n            <md-icon class=\"material-icons pxlogin__input-icon\">person</md-icon>\r\n            <label for=\"displayName\" translate>Display Name</label>\r\n            <input required id=\"displayName\" name=\"displayName\" ng-model=\"vm.displayName\" type=\"text\">\r\n            <div ng-messages=\"vm.loginRegisterForm.displayName.$error\">\r\n                <div ng-message=\"required\" translate>The display name is required</div>\r\n            </div>\r\n        </md-input-container>\r\n        <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n            <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n            <label for=\"password\" translate>Password</label>\r\n            <input required id=\"password\" name=\"password\" ng-model=\"vm.password\" type=\"password\">\r\n            <div ng-messages=\"vm.loginRegisterForm.password.$error\">\r\n                <div ng-message=\"required\" translate>New password is required</div>\r\n            </div>\r\n        </md-input-container>\r\n        <md-input-container md-no-float class=\"md-block pxlogin__input\">\r\n            <md-icon class=\"material-icons pxlogin__input-icon\">vpn_key</md-icon>\r\n            <label for=\"confirmPassword\" translate>Confirm Password</label>\r\n            <input required id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" type=\"password\">\r\n            <div ng-messages=\"vm.loginRegisterForm.confirmPassword.$error\">\r\n                <div ng-message=\"required\" translate>Confirm new password is required</div>\r\n            </div>\r\n        </md-input-container>\r\n    </md-card-content>\r\n    <md-card-actions class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-wrap>\r\n        <md-button type=\"submit\" flex-xs=\"100\" flex-order-cs=\"0\" class=\"md-raised\">\r\n            <translate>Register</translate>\r\n        </md-button>\r\n    </md-card-actions>\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(23);
	__webpack_require__(25);
	__webpack_require__(27);
	__webpack_require__(29);
	__webpack_require__(31);
	__webpack_require__(33);
	__webpack_require__(35);
	__webpack_require__(40);
	__webpack_require__(45);
	__webpack_require__(47);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(24);

/***/ },
/* 24 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxAutocompleteClearOnBlur', ['$interval', '$timeout', AutocompleteClearOnBlurDirective]);

		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxAutocompleteClearOnBlur
		 * @module phoenix
		 * @restrict A
		 * @description
		 *
		 * A directive to auto clear the autocomplete input if no item is selected 
		 *
		 * @usage
		 *
		 * <md-chips px-autocomplete-clear-on-blur />
	     *
		 */
		function AutocompleteClearOnBlurDirective($interval, $timeout) {
			return {
				restrict: 'A',
				require: 'mdAutocomplete',
				link: function (scope, element, attrs, acCtrl) {
					if (!acCtrl || acCtrl.readonly) { return; }

					// amount of time in MS with which to poll for an input
					var pollingThreshold = 6000; 
					var trigger = null;
					var start = Date.now();
					var timedOut = false;
					var input = null;
					var interval = $interval(function () {
						timedOut = (Date.now() - start) >= pollingThreshold;
						input = element.find('input');

						if (input.length === 1) {
							$interval.cancel(interval);
							input[0].addEventListener('blur', triggerRemove);
						}
						else if (timedOut) {
							$interval.cancel(interval);	
						}
					}, 100);

					function triggerRemove() {
						//timeout to allow user to pick from autocomplete
						$timeout(removeValue, 200);
					}

					function removeValue() {
						$timeout.cancel(trigger);
						//clear the value
						if (input.val() !== '' && !acCtrl.scope.selectedItem) {
							//clear search text
							acCtrl.scope.searchText = null;
						}
					}

					scope.$on('$destroy', function () {
						if(input.length > 0) {
							input[0].removeEventListener('blur', removeValue);
						}
					});
				}
			};
		}
	}());

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(26);

/***/ },
/* 26 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxAutoFitVirtualRepeat', [
	            '$window',
	            '$timeout',
	            AutoFitVirtualRepeatDirective]);

		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxAutoFitVirtualRepeat
		 * @module phoenix
		 * @restrict A
		 * @description
		 *
		 * A directive to automatically size and resize a child md-virtual-scroller-container.
		 *
		 * @usage
		 *
		 * <div px-auto-fit-virtual-repeat px-auto-fit-virtual-repeat-offset="1">
		 *		<md-virtual-repeat-container></md-virtual-repeat-container>
		 * </div>
	     *
		 */
		function AutoFitVirtualRepeatDirective($window, $timeout) {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					//get an offset if specified
					var offset = element.attr('px-auto-fit-virtual-repeat-offset');
					var intOffset = 0;
					if (offset && typeof parseInt(offset) === 'number') {
						intOffset = parseInt(offset);
					}

					function setHeight() {
						$timeout(function () {
							var _height;
							//subtract 1px for height rounding up to closest px IE: 806.75 rounded to 807, which causes second scrollbar
							_height = (element[0].offsetHeight - 1) - intOffset;

							element.find('md-virtual-repeat-container').css('height', _height + 'px');
							$timeout(function () {
								//https://github.com/angular/material/issues/4314
								scope.$broadcast('$md-resize');
								scope.$broadcast('px-recalculate-virtual-tile-view');
							}, 0);
						}, 0);
					}
					
					//add resize events
					var _timeout;
					function resizeHeight() {
						element.css({ 'overflow-y': 'hidden', 'transition-duration': '0s' }); //removes the scroll bar and transitions while resizing
						$timeout.cancel(_timeout);
						_timeout = $timeout(function () {
							$timeout.cancel(_timeout);
							setHeight();
							element.css({ 'overflow-y': '', 'transition-duration': '' });
						}, 150);
					}

					$window.addEventListener('resize', resizeHeight);
					$window.addEventListener('orientationchange', resizeHeight);
					
					//add state changed event if element or child element houses a ui-view, as the child content may have changed
					if (element[0].querySelectorAll('[ui-view]').length > 0 || element[0].hasAttribute('ui-view')) {
						scope.$on('$stateChangeSuccess', function () {
							$timeout(function () {
								setHeight();
							}, 150);
						});
					}

					//add a listener to force a resize
					scope.$on('px-recalulate-auto-fit-virtual-repeat', resizeHeight);

					//run on initial setup
					setHeight();

					scope.$on('$destroy', function () {
						$window.removeEventListener('resize', resizeHeight);
						$window.removeEventListener('orientationchange', resizeHeight);
					});

					//watches to see if the number of rendered virtual repeat items has changed
					scope.$watch(
						function () {
							var count = 0;
							var virtualCount = element.find('md-virtual-repeat-container').attr('virtual-item-count');
							if (virtualCount) {
								if (virtualCount > 0) {
									count = element.find('md-virtual-repeat-container').attr('virtual-item-count');
								}
							}
							return count;
						},
						function () {
							resizeHeight();
						});
					
				}
			};
		}

	}());

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(28);

/***/ },
/* 28 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxContenteditable', [ContenteditableDirective]);

		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxContenteditable
		 * @module phoenix
		 * @restrict A
		 * @description
		 *
		 * Allows a div to be content editable via the ngModel
		 *
		 * @usage
		 *
		 * <div contenteditable ng-model='ctrl.text' />
	     *
		 */
		function ContenteditableDirective() {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, element, attrs, ngModel) {

					function read() {
						ngModel.$setViewValue(element.html());
					}

					ngModel.$render = function () {
						element.html(ngModel.$viewValue || '');
					};

					element.bind('blur keyup change', function () {
						scope.$apply(read);
					});
				}
			};
		}
	}());

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30);

/***/ },
/* 30 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxChipsClearOnBlur', ['$interval','$timeout', ChipsAddOnBlurDirective]);

		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxChipsClearOnBlur
		 * @module phoenix
		 * @restrict A
		 * @description
		 *
		 * A directive to auto remove the value left in the md-chips interface's input 
		 *
		 * @usage
		 *
		 * <md-chips px-chips-clear-on-blur />
	     *
		 */
		function ChipsAddOnBlurDirective($interval, $timeout) {
			return {
				restrict: 'A',
				require: 'mdChips',
				link: function (scope, element, attrs, chipsCtrl) {
					if (!chipsCtrl || chipsCtrl.readonly) { return; }

					// amount of time in MS with which to poll for an input
					var pollingThreshold = 6000; 
					var trigger = null;				
					var start = Date.now();
					var timedOut = false;
					var input = null;
					var interval = $interval(function () {
						timedOut = (Date.now() - start) >= pollingThreshold;
						input = element.find('input');

						if (input.length === 1) {
							$interval.cancel(interval);			
							input[0].addEventListener('blur', triggerRemove);
						}
						else if (timedOut) {
							$interval.cancel(interval);	
						}
					}, 100);

					function triggerRemove() {
						//timeout to allow user to pick from autocomplete
						$timeout(removeValue, 500);
					}

					function removeValue() {
						$timeout.cancel(trigger);
						//clear the value
						if (input.val() !== '') {
							input.val('');
							//clear chips search text
							chipsCtrl.searchText = '';
						}
					}

					scope.$on('$destroy', function () {
						if(input && input.length > 0) {
							input[0].removeEventListener('blur', removeValue);
						}
					});
				}
			};
		}
	}());

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32);

/***/ },
/* 32 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxChipsDisableDeleteKey', ['$interval', ChipsDisableDeleteKeyDirective]);

		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxChipsDisableDeleteKey
		 * @module phoenix
		 * @restrict A
		 * @description
		 *
		 * A directive to disable the delete/backspace key when the input is blank
		 * as the default behavior is to then select a chip and delete it 
		 *
		 * @usage
		 *
		 * <md-chips px-chips-disable-delete-key />
	     *
		 */
		function ChipsDisableDeleteKeyDirective($interval) {
			return {
				restrict: 'A',
				require: 'mdChips',
				link: function (scope, element, attrs, chipsCtrl) {
					if (!chipsCtrl || chipsCtrl.readonly) { return; }

					// amount of time in MS with which to poll for an input
					var pollingThreshold = 6000; 
					var start = Date.now();
					var timedOut = false;
					var input = null;
					var interval = $interval(function () {
						timedOut = (Date.now() - start) > pollingThreshold;
						input = element.find('input');
						if (input.length === 1) {
							$interval.cancel(interval);
							input[0].addEventListener('keypress', disableDeleteKeys);
							input[0].addEventListener('keydown', disableDeleteKeys);
						}
						else if (timedOut) {
							$interval.cancel(interval);	
						}
					}, 100);

					function disableDeleteKeys(event) {
						if (input.val() === '') {
							//disable hitting the delete/backspace button when there is no value in the input as this starts to delete tags
							var key = event.keyCode || event.charCode;

							if (key === 8 || key === 46) {
								// prevent default behaviour
								event.preventDefault();
								return false;
							}
						}
					}

					scope.$on('$destroy', function () {
						if(input && input.length > 0) {
							input[0].removeEventListener('keypress', disableDeleteKeys);
							input[0].removeEventListener('keydown', disableDeleteKeys);
						}
					});
				}
			};
		}
	}());

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(34);

/***/ },
/* 34 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxDebounceImage', ['$timeout', DebounceImageDirective]);

		/**
		 * @ngdoc directive
		 * @name phoenix.directive:pxDebounceImage
		 * @module phoenix
		 * @restrict A
		 * @description
		 *
		 * A directive to delay loading of image src and is to be used in conjunction with 
		 * md-virtual-repeat to limit getting thumbnails or pages if they are scrolled out
		 * of the DOM.
		 *
		 * @usage
		 *
		 * <img px-debounce-image="{{ctrl.imgScr}}" />
	     *
		 */
		function DebounceImageDirective($timeout) {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					function loadImage() {
						if(element[0].tagName === 'IMG'){						
							element.attr('src', ''); //clear the source
							$timeout(function () {
								element.attr('src',attrs.pxDebounceImage);
							}, 550);
						}
						else{
							element[0].style.backgroundImage = '';
							$timeout(function () {
								element[0].style.backgroundImage = attrs.pxDebounceImage;
							}, 550);
						}
					}

					attrs.$observe('pxDebounceImage', function (newVal) {
						if (!newVal) { return; }
						loadImage();
					});

					loadImage();
				}
			};
		}
	}());

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36);
	__webpack_require__(38);


/***/ },
/* 36 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 37 */,
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(39);
		
		/**
		* @ngdoc directive
		* @name phoenix.directive:pxScrollViewer
		* @module phoenix
		* @restrict A
		* @description
		*
		* A Continuous scroll viewer which displays a virtualized set of pages.
		*
		* @usage
		* <div layout-fill>
		*   <px-scroll-viewer 
		*       pages="[
		*           'http://api/document/1/page/1', 
		*           'http://api/document/1/page/2',
		*           'http://api/document/1/page/3']" 
		*       fit-size="width"></px-scroll-viewer>
		* </div>
		* 
		* @element input
		* @param {Array} pages An array of Urls. Each Url is used as the img src for a page
		*
		* @param {string=} fileName Used to display the name at the top of preview mode window
		*
		* @param {string=} fitSize Controls the viewers fit mode. Valid values are
		* 'width' (default) and 'height'
		*
		* @param {string=} mode Controls the display mode of the viewer. Valid values
		* are 'embed' (default) and 'preview'
		*
		* @param {expression=} closePreview Function expression to call when the preview
		* is closed. Only valid if mode='preview'
		*/

		angular.module('phoenix')
			.directive('pxScrollViewer', [
				'$timeout',
				'$window',
				'$interval',
				'$mdUtil',
				ScrollViewerDirective])
			.controller('ScrollViewerController', [ScrollViewerController]);

		function ScrollViewerDirective($timeout, $window, $interval, $mdUtil) {
			return {
				restrict: 'E',
				controller: ScrollViewerController,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					pages: '=',
					fileName: '@',
					fitSize: '@',
					mode: '@',
					closePreview: '&'
				},
				scope: {},
				link: function (scope, element, attrs) {
					var vm = scope.vm;
					vm.rowHeight = null;
					vm.updatePageSize = $mdUtil.debounce(updatePageSize, 400);

					var newHeight = 0;
					function updatePageSize() {
						newHeight = element[0].querySelector('.view__page-img').clientHeight;
						vm.pageSize = {	height: newHeight + 'px' };
						vm.rowHeight = null; //this will reload the whole viewer with the new page heights
						vm.resizing = false; //remove autosizing as we have the new actual height
						reCalcVirtual();
					}

					function reCalcVirtual() {
						$timeout(function () {
							vm.rowHeight = newHeight; //set height will rerender the viewer
							scope.$parent.$broadcast('$md-resize');
						}, 100);
					}

					//event listeners
					$window.addEventListener('orientationchange', vm.updatePageSize);

					//clean up
					scope.$on('$destroy', function () {
						$window.removeEventListener('orientationchange', vm.updatePageSize);
					});

					vm.resizing = false;
					scope.$watch(function () {
						return element[0].clientWidth;
					},
						function (newVal) {
							if (vm.rowHeight) {
								vm.resizing = true; //resizing allows the current pages to autosize
								vm.updatePageSize();
							}
						}
					);

					//shows & hides current page position
					var pageCountTimer = null;
					scope.$watch('vm.pageIndex', function (newVal) {
						vm.showPageCount = true;
						$timeout.cancel(pageCountTimer);
						pageCountTimer = $timeout(function () {
							vm.showPageCount = false;
						}, 3000);
					});

					//set initial sizes
					var _interval = $interval(function () {
						//wait till first page is rendered into the DOM
						var sizer = element[0].querySelector('.view__page-img');
						if (!sizer) { return; }
						if (sizer.clientHeight < 20) { return; }

						$interval.cancel(_interval);
						vm.updatePageSize();
					}, 50);
				}
			};
		}
		function ScrollViewerController() {
		}
	}());

/***/ },
/* 39 */
/***/ function(module, exports) {

	var path = 'phoenix/components/scrollViewer/scrollViewer.template.html';
	var html = "<md-backdrop ng-if=\"vm.mode==='preview'\" class=\"view__preview-backdrop md-opaque\"></md-backdrop>\r\n\r\n<div flex layout=\"column\" layout-align=\"start stretch\" ng-class=\"{'viewer--resizing':vm.resizing, 'viewer--full-screen': vm.mode==='preview'}\">\r\n\t<md-toolbar ng-if=\"vm.mode==='preview'\">\r\n\t\t<div class=\"md-toolbar-tools\">\r\n\t\t\t<h3 flex class=\"ellipsis\">{{vm.fileName}}</h3>\r\n\t\t\t<md-button class=\"md-icon-button\" ng-click=\"vm.closePreview();\">\r\n\t\t\t\t<md-icon class=\"material-icons view__preview-close-icon\">close</md-icon>\r\n\t\t\t</md-button>\r\n\t\t</div>\r\n\t</md-toolbar>\r\n\t<!-- multi page file -->\r\n\t<div flex  layout=\"column\" layout-align=\"start stretch\" ng-if=\"vm.pages.length>1\">\r\n\t\t<md-virtual-repeat-container flex ng-if=\"vm.rowHeight\" md-top-index=\"vm.pageIndex\" virtual-item-count=\"{{vm.pages.length}}\" class=\"viewer app--smooth-scroll\" ng-class=\"{'viewer--ready':vm.rowHeight}\">\r\n\t\t\t<div class=\"viewer__pages-wrapper\">\r\n\t\t\t\t<div class=\"viewer__page md-whiteframe-4dp\" md-virtual-repeat=\"page in vm.pages\" ng-attr-md-item-size=\"vm.rowHeight\" ng-style=\"vm.pageSize\" ng-class=\"{'view__page-preview--first': vm.mode==='preview' && $index===0, 'view__page-preview': vm.mode==='preview' }\">\r\n\t\t\t\t\t<img px-debounce-image=\"{{page}}\" class=\"view__page-img\" ng-class=\"{'view__page-img--width': vm.fitSize!=='height'}\" />\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</md-virtual-repeat-container>\r\n\t\t<!-- Used to calculate page hieght before rendering the full page list -->\r\n\t\t<div class=\"viewer__pages-wrapper\" ng-if=\"!vm.rowHeight\">\r\n\t\t\t<div class=\"viewer__page viewer viewer--dummy viewer__page--show-scroll\">\r\n\t\t\t\t<img ng-src=\"{{vm.pages[0]}}\" class=\"view__page-img\" ng-class=\"{'view__page-img--width': vm.fitSize!=='height'}\" />\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- displays the current page displayed -->\r\n\t\t<div class=\"view__page-count-wrap\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.showPageCount\">\r\n\t\t\t<div class=\"view__page-count md-whiteframe-2dp\" translate\r\n\t\t\t\t translate-params-current-page=\"vm.pageIndex + 1\"\r\n\t\t\t\t translate-params-total-pages=\"vm.pages.length\"\r\n\t\t\t\t translate-comment=\"A document footer label displaying the current and total pages of the document\">\r\n\t\t\t\t{{currentPage}} of {{totalPages}}\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<!-- single page file -->\r\n\t<div flex class=\"view__page-single\" ng-if=\"vm.pages.length === 1\" ng-class=\"{'viewer--full-screen': vm.mode==='preview'}\">\r\n\t\t<img ng-src=\"{{vm.pages[0]}}\" class=\"view__page-img view__page-img--single md-whiteframe-4dp\" ng-class=\"{'view__page-img--width': vm.fitSize!=='height'}\" />\r\n\t</div>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(41);
	__webpack_require__(43);

/***/ },
/* 41 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 42 */,
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(44);
		
		/**
		* @ngdoc directive
		* @name phoenix.directive:pxVirtualTileContainer
		* @module phoenix
		* @restrict E
		* @description
		*
		* `pxVirtualTileContainer` is a virtualizer of tile items that groups items into rows of a fixed height to work with md-virtual-repeat-container
		*
		* @param {object} virtualItems The item to be bound to.
		*
		* @usage
		*
		* <px-virtual-tile-container virtual-items="appCtrl.folders"></px-virtual-tile-container>
		*/

		angular.module('phoenix')
			.directive('pxVirtualTileContainer', [
				'$timeout',
				'$window',
				'$mdUtil',
				'$mdMedia',
				'pxGroupItemsService',
				VirtualizeTileViewDirective
			]);

		function VirtualizeTileViewDirective($timeout, $window, $mdUtil, $mdMedia, pxGroupItemsService) {
			return {
				restrict: 'E',
				controller: ['pxAuthService', VirtualizeTileContainerController],
				controllerAs: 'VirtualTileCtrl',
				bindToController: {
					rawitems: '=virtualItems',
					click: '&virtualClick',
					select: '&virtualSelect'
				},
				scope: {},
				templateUrl: templateUrl,
				link: function (scope, element, attrs) {
					scope.VirtualTileCtrl.calcVirtualGroups = $mdUtil.debounce(calcVirtualGroups, 150);
					scope.VirtualTileCtrl.tilePerLine = null;
					scope.VirtualTileCtrl.style = {};
					var container = null;
					function calcVirtualGroups() {
						var TILE_WIDTH = 170;
						var newTilePerLine = null;
						var containerWidth = null;
						container = $mdUtil.getClosest(element, 'md-virtual-repeat-container');
						if (container) {
							containerWidth = container.clientWidth;
							if(containerWidth > 600){
								containerWidth -= 16; //8px margin on each side
								newTilePerLine = Math.floor(containerWidth / TILE_WIDTH);
							}
							else if(containerWidth < 600 && containerWidth > 475){							
								containerWidth -= 8; //4px margin on each side
								newTilePerLine = 3;
							}
							else{													
								containerWidth -= 8; //4px margin on each side
								newTilePerLine = 2;
							}

							if (newTilePerLine !== scope.VirtualTileCtrl.tilePerLine) {
								scope.VirtualTileCtrl.tilePerLine = newTilePerLine;
								virtualizeItems();
							}
						}
					}

					function virtualizeItems() {
						if (scope.VirtualTileCtrl.rawitems) {
							$timeout(function(){
								scope.VirtualTileCtrl.groupedItems = pxGroupItemsService.groupItems(scope.VirtualTileCtrl.rawitems, scope.VirtualTileCtrl.tilePerLine);	
								//used to set the fixed width to minimize resizing of cards while resizing
								var margin = $mdMedia('sm') || $mdMedia('xs')  ? 8 : 16;							
								var innerWidth = container.querySelector('.md-virtual-repeat-offsetter').clientWidth;					
								scope.VirtualTileCtrl.style.width = (innerWidth - margin) + 'px';
							},0);
						}
					}

					//new items in collection
					scope.$watchCollection('VirtualTileCtrl.rawitems', function (newVal, oldVal) {
						if (newVal === null) { return; }
						scope.VirtualTileCtrl.tilePerLine = null;
						scope.VirtualTileCtrl.calcVirtualGroups();
					});

					//element's width has changed
					scope.$watch(function () { return element[0].clientWidth; },
						function (newVal, oldVal) {
							scope.VirtualTileCtrl.calcVirtualGroups();
						}
					);

					//window size events
					$window.addEventListener('resize', scope.VirtualTileCtrl.calcVirtualGroups);
					$window.addEventListener('orientationchange', scope.VirtualTileCtrl.calcVirtualGroups);

					scope.$on('$destroy', function () {
						$window.removeEventListener('resize', scope.VirtualTileCtrl.calcVirtualGroups);
						$window.removeEventListener('orientationchange', scope.VirtualTileCtrl.calcVirtualGroups);
					});
				}
			};
		}

		function VirtualizeTileContainerController(pxAuthService) {
			var self = this;
			self.pxAuthService = pxAuthService;
			self.itemClick = function ($event, item) {
				self.click({ item: item });
			};
			self.itemSelect = function($event, item){
				self.select({item: item});
			};		
			self.toggleSelected = function($event, item){
				item.selected = !item.selected;
				self.itemSelect($event, item);
			};
			self.itemSelected = function($event, item){
				item.selected = true;	
				self.itemSelect($event, item);
			};
		}

	}());

/***/ },
/* 44 */
/***/ function(module, exports) {

	var path = 'phoenix/components/virtualTileContainer/virtualTileContainer.template.html';
	var html = "<div ng-style=\"VirtualTileCtrl.style\">\r\n\t<div md-virtual-repeat=\"group in VirtualTileCtrl.groupedItems\" md-item-size=\"170\" layout=\"row\" layout-align=\"start start\">\r\n\t\t<!-- Folders -->\r\n\t\t<div class=\"px-folder__card-wrapper\" ng-repeat=\"item in group\" ng-class=\"{'px-folder__card-wrapper---selected': item.selected }\">\r\n\t\t\t<md-card ng-if=\"item.FolderId\" class=\"px-folder__card\" \r\n\t\t\t\tng-click=\"VirtualTileCtrl.itemClick($event, item)\" \r\n\t\t\t\tpx-on-long-click=\"VirtualTileCtrl.itemSelected($event,item)\"\r\n\t\t\t\tpx-on-control-click=\"VirtualTileCtrl.toggleSelected($event,item)\">\r\n\t\t\t\t<div class=\"px-folder__card-top\" layout=\"row\" layout-align=\"center center\">\r\n\t\t\t\t\t<md-icon class=\"md-card-image material-icons px-folder__card-icon\" alt=\"folder\">folder</md-icon>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline ellipsis\">{{item.FolderName}}</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t\t\r\n\t\t\t<!-- Documents -->\r\n\t\t\t<md-card ng-if=\"item.DocumentId\" class=\"px-folder__card\" \r\n\t\t\t\tng-click=\"VirtualTileCtrl.itemClick($event, item)\" \r\n\t\t\t\tpx-on-long-click=\"VirtualTileCtrl.itemSelected($event,item)\"\r\n\t\t\t\tpx-on-control-click=\"VirtualTileCtrl.toggleSelected($event,item)\">\r\n\t\t\t\t<div class=\"px-folder__card-top px-folder__card-top-image\" px-debounce-image=\"url({{item.Links.ThumbnailUri + '?auth='+ VirtualTileCtrl.pxAuthService.token + '&size=240'}})\"></div>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline ellipsis\">{{item.DocumentName}}</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t\t<div class=\"px-folder__card-selector\" layout=\"row\" layout-align=\"center center\">\r\n\t\t\t\t<md-checkbox class=\"md-primary md-hue-3\" ng-model=\"item.selected\" ng-change=\"VirtualTileCtrl.itemSelect($event,item)\" aria-label=\"Select item\">\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t</div>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(46);

/***/ },
/* 46 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxOnLongClick', ['$timeout', 'pxEnvironmentService',LongClickDirective]);

		function LongClickDirective($timeout,EnvironmentService) {
			return {
				restrict: 'A',
				link: function($scope, $elm, $attrs) {
					var timer = null;
					var disableClick = false;
					var _mdListTargeted = false;
					//detect touch set the target event
					var _startEvent = 'mousedown';
					var _endEvent = 'mouseup mouseleave';
					if(EnvironmentService.touchEnabled){
						_startEvent = 'touchstart';
						_endEvent = 'touchend touchmove';
					}

					retargetElement($elm);

					function start(event) {
						timer = $timeout(function() {	
							disableClick = true;
							$scope.$eval($attrs.pxOnLongClick);

							if(_mdListTargeted){
								//disable button to eliminate click event firing
								$elm.attr('disabled', true);
								$timeout(function(){
									$elm.removeAttr('disabled');
									disableClick = false;
								}, 600);
							}

						}, 600);
					}

					function end(event) {	
						if(!disableClick){
							$timeout.cancel(timer);
						}
					}

					function click(event){
						if(disableClick){
							event.stopImmediatePropagation();
							event.stopPropagation();
							event.preventDefault();
							disableClick = false;
							
							$timeout.cancel(timer);
							return;
						}
					}

					function retargetElement(elm){
						switch(elm[0].tagName){
							case 'MD-LIST-ITEM':
								_mdListTargeted = true;
								$timeout(function(){
									//timeout till the next digest cycle to verify all templates have rendered
									$elm = angular.element(elm[0].querySelector('button.md-button'));
									$elm.bind(_startEvent, start);
									$elm.bind('click', click);
									$elm.bind(_endEvent, end);
								},0);
								break;
							default:
								$elm.bind(_startEvent, start);
								$elm.bind('click', click);
								$elm.bind(_endEvent, end);
						}
					}

					$scope.$on('$destroy',function(){
						$elm.unbind(_startEvent, start);
						$elm.unbind(_endEvent, end);
						$elm.unbind('click',click);
					});
				}
			};
		}

	}());

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(48);

/***/ },
/* 48 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.directive('pxOnControlClick', ['$timeout', 'pxEnvironmentService', ControlClickDirective]);

		function ControlClickDirective($timeout, EnvironmentService) {
			return {
				restrict: 'A',
				link: function($scope, $elm, $attrs) {
					//only on nontouch
					if (EnvironmentService.touchEnabled) {
						return;
					}

					var _mdListTargeted = false;
					retargetElement($elm);

					function click(event) {
						if (!event.ctrlKey) {
							return;
						}
						
						event.stopImmediatePropagation();	
						event.preventDefault();
						
						$scope.$apply(function(){
							$scope.$eval($attrs.pxOnControlClick);
						});
						
						if(_mdListTargeted){
							$elm.attr('disabled', true);
							$timeout(function(){
								$elm.removeAttr('disabled');	
							}, 600);
						}	
					}

					function retargetElement(elm){
						switch(elm[0].tagName){
							case 'MD-LIST-ITEM':
								_mdListTargeted = true;
								$timeout(function(){
									//timeout till the next digest cycle to verify all templates have rendered
									$elm = angular.element(elm[0].querySelector('button.md-button'));
									$elm.bind('mousedown', click);
								},0);
								break;
							default:
								$elm.bind('click', click);
						}
					}
					$scope.$on('$destroy',function(){
						$elm.unbind('click', click);
						if(_mdListTargeted){
							$elm.unbind('mousedown', click);
						}
					});
				}
			};
		}

	}());

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(50);
	__webpack_require__(51);
	__webpack_require__(52);
	__webpack_require__(53);

/***/ },
/* 50 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc filter
		* @name phoenix.filter:pxItemSize
		* @kind function
		* 
		* @description
		*  Converts a size in bytes to human readable text
		*
		* @param {string|number} bytes An item size in bytes.
		* 
		*/

		var SIZES = ['B', 'KB', 'MB', 'GB', 'TB'];

		angular
			.module('phoenix')
			.filter('pxItemSize', [ItemSizeFilter]);

		function ItemSizeFilter() {
			return function toHumanReadable(bytes) {
				
				if (bytes == null) {
					return bytes;
				}

				bytes = parseInt(bytes);

				if (bytes <= 0) {
					return '0 B';
				}

				var unitIndex = Math.floor(Math.log(bytes) / Math.log(1024));
				var unit = SIZES[unitIndex];

				var constant = bytes / Math.pow(1024, unitIndex);

				if (unit !== 'B') {
					constant = constant.toFixed(2);
				}

				return constant + ' ' + unit;
			};
		}

	}());

/***/ },
/* 51 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular
			.module('phoenix')
			.filter('pxTokenKeyValue', tokenKeyValueFilter);

		/**
		* @ngdoc filter
		* @name phoenix.filter:pxTokenKeyValue
		* @kind function
		* 
		* @description
		*   Finds the key and value of a specific token.
		*
		* @param {searchToken} expression The name of the token to find
		* 
		* @example
		*   <span ng-init="nameString = '[@Name=john]jgaver[/]' " >
		*       {{nameString|pxTokenKeyValue:'Action').key}} - {{nameString|pxTokenKeyValue:'Action').value }}
		*   </span>
		*/
		function tokenKeyValueFilter() {
			return function tokenKeyValueFilterReplace(str, searchToken) {
				var retVal = { key: null, value: null };
				if (!str) {
					return str;
				}

				if (!searchToken || !str) {
					return str;
				}

				var tokenRegex = new RegExp('\\[@' + searchToken + '=(.*?)\\[\/\]');
				
				str.replace(tokenRegex, function (token, capture) {
					// the captured text is in the form "User=5]john"
					var parts = capture.split(']');

					retVal.key = parts[0];
					retVal.value = parts[1];
				});
				return retVal;
			};
		}
	}());

/***/ },
/* 52 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		/**
		* @ngdoc filter
		* @name phoenix.filter:pxTokenString
		* @kind function
		* 
		* @description
		*   Facilitates replacement of tokens in a tokenized string.
		*
		* @param {function(tokenObj)} expression The replacement function used to replace tokens.
		*       - Given a token "[@Name=john]jgaver[/]", tokenObj will have the form
		*          { attrName: 'Name', attrValue: 'john', stringValue: 'jgaver'}
		* 
		* @example
		*   <span ng-init="nameString = '[@Name=john]jgaver[/]' " >
		*       {{nameString|tokenString:function(tokenObj) { return tokenObj.stringValue; }}}
		*   </span>
		*/

		var tokenRegex = /\[@(.*?)\[\/\]/g; // will capture with User=5]john from [@User=5]john[/]

		angular
			.module('phoenix')
			.filter('pxTokenString', tokenStringFilter);

		function tokenStringFilter() {
			return function tokenStringFilterReplace(str, callback) {

				if (!callback || !str) {
					return str;
				}

				return str.replace(tokenRegex, function (token, capture) {
					// the captured text is in the form "User=5]john"
					var parts = capture.split(']');
					var attrPart = parts[0].split('=');

					return callback({
						attrName: attrPart[0],
						attrValue: attrPart[1],
						stringValue: parts[1],
						originalStringValue: '[@' + capture + '[/]'
					});
				});
			};
		}
	}());

/***/ },
/* 53 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('phoenix')
			.filter('pxFilterUsers', [UsersFilter]);

		function UsersFilter() {
			return function getUsers(users, matchText) {
				if (matchText === '' || matchText === null) { return users; }
				return users.filter(function (user) {
					return user.UserName.toLowerCase().indexOf(matchText.toLowerCase()) > -1 ||
						user.EmailAddress.toLowerCase().indexOf(matchText.toLowerCase()) > -1 ? true : false;
				});
			};
		}
	})();

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(5);
	__webpack_require__(55);

/***/ },
/* 55 */
/***/ function(module, exports) {

	"use strict";
	(function () {
	    'use strict';
	    var APP_IDENTIFIER_HEADER = 'x-phoenix-app-id';
	    angular
	        .module('phoenix.appIdentifier', [
	        'site.settings'
	    ])
	        .provider('pxAppIdentifierInterceptor', appIDInterceptorProvider);
	    /**
	     * @ngdoc provider
	     * @name phoenix.appIdentifier.pxAppIdentifierInterceptor
	     *
	     * @description
	     * Provider for configuring the appIdInterceptorFactory before it is created.
	     * If the provider is not used to configure the interceptor factory, it will
	     * default to providing an interceptor for ShareBase.
	     */
	    function appIDInterceptorProvider() {
	        var appId = 'ShareBase';
	        return {
	            /**
	             * @ngdoc method
	             * @name pxAppIdentifierInterceptorProvider#setAppId
	             * @methodOf phoenix.appIdentifier.pxAppIdentifierInterceptorProvider
	             * @kind function
	             *
	             * @description
	             * Set the app id that will be used in the pxAppIdentifierInterceptor
	             *
	             * @param {String} val The value to use as the app id.
	             */
	            setAppId: setAppId,
	            /**
	             * @ngdoc method
	             * @name pxAppIdentifierInterceptorProvider#$get
	             * @methodOf phoenix.appIdentifier.pxAppIdentifierInterceptorProvider
	             * @kind function
	             *
	             * @description
	             * Used to resolve the 'pxAppIdentifierInterceptor' service. Used by
	             * angular's injector.
	             */
	            $get: getInterceptor
	        };
	        function setAppId(val) {
	            appId = val;
	        }
	        function getInterceptor() {
	            return appIDInterceptorFactory(appId);
	        }
	    }
	    /**
	     * @ngdoc service
	     * @name phoenix.appIdentifier.pxAppIdentifierInterceptor
	     *
	     * @description
	     * An http interceptor that adds an app id header to each request.
	     * The app id is retrieved from the settings service and included
	     * in each request to the API.
	     */
	    function appIDInterceptorFactory(appId) {
	        return {
	            /**
	             * @ngdoc method
	             * @name pxAppIdentifierInterceptor#request
	             * @methodOf phoenix.appIdentifier.pxAppIdentifierInterceptor
	             * @kind function
	             *
	             * @description
	             * Adds x-phoenix-app-id header to each request if there is an app id provided.
	             */
	            request: addIdToRequest
	        };
	        function addIdToRequest(config) {
	            if (appId) {
	                config.headers[APP_IDENTIFIER_HEADER] = appId;
	            }
	            return config;
	        }
	    }
	}());


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(57);
	__webpack_require__(4);
	__webpack_require__(58);
	__webpack_require__(59);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);

/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	/* jshint maxcomplexity: false */
	/* jshint maxstatements: false */
	(function () {
	    'use strict';
	    angular
	        .module('phoenix.acl', [
	        'gettext'
	    ])
	        .constant('PX_OBJECT_TYPE', {
	        DOCUMENT: 0,
	        FOLDER: 1,
	        LIBRARY: 2,
	        UNDEFINED: -1
	    })
	        .constant('PX_RIGHTS_TYPE', {
	        FULLCONTROL: 1,
	        EDIT: 2,
	        VIEW: 3,
	        UPLOADONLY: 4,
	        NOACCESS: 5,
	        UNDEFINED: 0
	    })
	        .constant('PX_PERMISSION_TYPE', {
	        FULLCONTROL: -1,
	        READ: 0x0001,
	        MODIFY: 0x0002,
	        DELETE: 0x0004,
	        ADDDOC: 0x0008,
	        READDOC: 0x0010,
	        MODDOC: 0x0020,
	        DELDOC: 0x0040,
	        ADDFOLD: 0x0080,
	        READFOLD: 0x0100,
	        MODFOLD: 0x0200,
	        DELFOLD: 0x0400,
	        LISTFOLD: 0x0800,
	        SHARE: 0x1000,
	        SHLINK: 0x2000,
	        SHLINKR: 0x4000,
	        DOWNLOAD: 0x8000,
	        SHDOC: 0x10000,
	        SHLKDOC: 0x20000,
	        SHLKRDOC: 0x40000,
	        DNLDDOC: 0x80000,
	        SHFOLD: 0x200000,
	        SHLKFOLD: 0x400000,
	        SHLKRFOLD: 0x800000,
	        DNLDFOLD: 0x100000,
	        UPLOADONLY: 0x0009
	    })
	        .constant('PX_LINK_SETTINGS', {
	        AuthRequired: 1,
	        PasswordRequired: 2,
	        SingleUse: 4,
	        PinRequired: 8
	    })
	        .factory('PX_RIGHTS', [
	        'gettextCatalog',
	        function (gettextCatalog) {
	            return [{
	                    id: '',
	                    defaultPerms: [0, 0, 0],
	                    opts: false,
	                    name: ''
	                }, {
	                    id: '1',
	                    defaultPerms: [-1, -1, -1],
	                    opts: false,
	                    name: gettextCatalog.getString('Full Control')
	                }, {
	                    id: '2',
	                    defaultPerms: [0x188007, 0x188FFF, 0x188FFF],
	                    opts: true,
	                    name: gettextCatalog.getString('Edit')
	                }, {
	                    id: '3',
	                    defaultPerms: [0x08001, 0x188911, 0x188911],
	                    opts: true,
	                    name: gettextCatalog.getString('View')
	                }, {
	                    id: '4',
	                    defaultPerms: [0x0, 0x0009, 0x0],
	                    opts: true,
	                    name: gettextCatalog.getString('Upload Only')
	                }, {
	                    id: '5',
	                    defaultPerms: [0, 0, 0],
	                    opts: false,
	                    name: gettextCatalog.getString('No Access')
	                }];
	        }
	    ])
	        .constant('PX_ACL_CONST', {
	        AllSharePerms: 0xE77000,
	        MaxPermission: 0x1000000
	    })
	        .factory('PX_EDIT_RIGHTS_OPTIONS', [
	        'gettextCatalog',
	        function (gettextCatalog) {
	            return [{
	                    id: 0,
	                    name: gettextCatalog.getString('Share with Users'),
	                    mask: [0x01000, 0x211000, 0x211000],
	                    apply: 'bits',
	                    constr: ''
	                }, {
	                    id: 1,
	                    name: gettextCatalog.getString('Share View Link'),
	                    mask: [0x02000, 0x422000, 0x422000],
	                    apply: 'bits',
	                    constr: ''
	                }, {
	                    id: 2,
	                    name: gettextCatalog.getString('Share Edit Link'),
	                    mask: [0x04000, 0x844000, 0x844000],
	                    apply: 'bits',
	                    constr: '+1'
	                }, {
	                    id: 3,
	                    name: gettextCatalog.getString('Delete'),
	                    mask: [0x00004, 0x00444, 0x00444],
	                    apply: 'bits',
	                    constr: ''
	                }];
	        }
	    ])
	        .factory('PX_VIEW_RIGHTS_OPTIONS', [
	        'gettextCatalog',
	        function (gettextCatalog) {
	            return [{
	                    id: 0,
	                    name: gettextCatalog.getString('Upload'),
	                    mask: [0x00, 0x00088, 0x00088],
	                    apply: 'bits',
	                    constr: ''
	                }, {
	                    id: 2,
	                    name: gettextCatalog.getString('Download'),
	                    mask: [0x08000, 0x188000, 0x188000],
	                    apply: 'bits',
	                    constr: ''
	                }, {
	                    id: 3,
	                    name: gettextCatalog.getString('Share View Link'),
	                    mask: [0x02000, 0x422000, 0x422000],
	                    apply: 'bits',
	                    constr: ''
	                }];
	        }
	    ])
	        .factory('PX_UPLOAD_ONLY_RIGHTS_OPTIONS', [
	        'gettextCatalog',
	        function (gettextCatalog) {
	            return [{
	                    id: 0,
	                    name: gettextCatalog.getString('View Folder Contents'),
	                    mask: [0x00, 0x800, 0],
	                    apply: 'bits',
	                    constr: ''
	                }];
	        }
	    ])
	        .factory('pxRightsOptions', [
	        'PX_EDIT_RIGHTS_OPTIONS',
	        'PX_VIEW_RIGHTS_OPTIONS',
	        'PX_UPLOAD_ONLY_RIGHTS_OPTIONS',
	        function (EditRightsOptions, ViewRightsOptions, UploadOnlyRightsOptions) {
	            return [
	                null,
	                null,
	                EditRightsOptions,
	                ViewRightsOptions,
	                UploadOnlyRightsOptions,
	                null
	            ];
	        }
	    ])
	        .factory('pxObjectTypeMappings', [
	        'gettextCatalog',
	        function (gettextCatalog) {
	            return [
	                gettextCatalog.getString('Document'),
	                gettextCatalog.getString('Folder'),
	                gettextCatalog.getString('Library')
	            ];
	        }
	    ])
	        .factory('pxAclService', [
	        'PX_OBJECT_TYPE',
	        'PX_RIGHTS_TYPE',
	        'PX_PERMISSION_TYPE',
	        'PX_RIGHTS',
	        'PX_ACL_CONST',
	        'pxRightsOptions',
	        'pxObjectTypeMappings',
	        AclFactory
	    ]);
	    /**
	    * @ngdoc service
	    * @name phoenix.acl.pxAclService
	    * @requires PX_OBJECT_TYPE
	    * @requires PX_RIGHTS_TYPE
	    * @requires PX_RIGHTS
	    * @requires PX_ACL_CONST
	    * @requires pxRightsOptions
	    * @requires pxObjectTypeMappings
	    * @description
	    * A service used to create and interrogate ACL instances.
	    **/
	    function AclFactory(ObjectType, RightsType, PermissionType, Rights, AclConst, RightsOptions, ObjectTypeMappings) {
	        function Acl(srvData, _itemType, _userName, _isGroup) {
	            srvData = srvData || {};
	            this.sourceName = '';
	            this.sourceId = 0;
	            this.sourceObjectType = ObjectType.UNDEFINED;
	            this.isInherited = false;
	            this.allowPerms = 0;
	            this.isLinkAcl = false;
	            this.isOwnerAcl = false;
	            this.id = 0;
	            this.rightId = 0;
	            if (angular.isDefined(srvData.elementId)) {
	                // this acl is an override of an existing acl
	                this.type = _itemType;
	                this.userId = srvData.userId;
	                this.userName = srvData.userName;
	                this.isGroup = srvData.isGroup;
	                this.elementId = generateUniqueId(this.userId, this.isGroup);
	                this.isInherited = true;
	                return;
	            }
	            else if (angular.isDefined(srvData.AuthToken)) {
	                // this acl is for a link (old version)
	                this.id = srvData.ReferenceString;
	                this.type = (angular.isDefined(srvData.FolderName) && srvData.FolderName) ? ObjectType.FOLDER : ObjectType.DOCUMENT;
	                this.userId = 0;
	                this.userName = 'anonymous';
	                this.isGroup = false;
	                this.isLinkAcl = true;
	            }
	            else if (angular.isDefined(srvData.ReferenceString)) {
	                // this acl is for a link
	                this.id = srvData.ReferenceString;
	                this.type = srvData.ObjectType === 'Folder' ? ObjectType.FOLDER : ObjectType.DOCUMENT;
	                this.userId = 0;
	                this.userName = 'anonymous';
	                this.isGroup = false;
	                this.isLinkAcl = true;
	                this.allowPerms = srvData.Permissions;
	            }
	            else if (_userName) {
	                // this acl is for a new acl
	                this.type = _itemType;
	                this.userId = typeof (srvData) === 'number' ? srvData : 0;
	                this.userName = _userName;
	                this.isGroup = _isGroup;
	                this.elementId = generateUniqueId(this.userId, this.isGroup);
	                return;
	            }
	            else if (typeof srvData === 'number') {
	                // this acl is constructed from an integer bit array
	                this.allowPerms = srvData;
	                this.userId = 0;
	                this.userName = 'anonymous';
	                this.isGroup = false;
	                this.type = _itemType;
	                this.updatePermissions(this.allowPerms);
	                return;
	            }
	            else {
	                // construct an Acl from a data object returned from a server API call
	                if (angular.isDefined(srvData.FolderACLId)) {
	                    // acl is folder
	                    this.id = srvData.FolderACLId;
	                    this.type = ObjectType.FOLDER;
	                }
	                else if (angular.isDefined(srvData.LibraryACLId)) {
	                    // acl is library
	                    this.id = srvData.LibraryACLId;
	                    this.type = ObjectType.LIBRARY;
	                }
	                else {
	                    // assume Acl is on a document
	                    this.id = srvData.DocumentACLId;
	                    this.type = ObjectType.DOCUMENT;
	                }
	                this.isOwnerAcl = this.id < 0;
	                if (srvData.UserGroupId !== 0) {
	                    this.userId = srvData.UserGroupId;
	                    this.userName = srvData.UserGroupName;
	                    this.isGroup = true;
	                }
	                else {
	                    this.userId = srvData.UserId;
	                    this.userName = srvData.UserName;
	                    this.isGroup = false;
	                }
	                this.elementId = generateUniqueId(this.userId, this.isGroup);
	                if (this.type !== ObjectType.LIBRARY) {
	                    if (srvData.SourceFolderId !== 0) {
	                        this.sourceName = srvData.SourceFolderName;
	                        this.sourceId = srvData.SourceFolderId;
	                        this.sourceObjectType = ObjectType.FOLDER;
	                        this.isInherited = true;
	                    }
	                    else if (srvData.SourceLibraryId !== 0) {
	                        this.sourceName = srvData.SourceLibraryName;
	                        this.sourceId = srvData.SourceLibraryId;
	                        this.sourceObjectType = ObjectType.LIBRARY;
	                        this.isInherited = true;
	                    }
	                }
	            }
	            if (srvData.Embedded && srvData.Embedded.Permissions) {
	                for (var i = 0; i < srvData.Embedded.Permissions.length; ++i) {
	                    var perm = srvData.Embedded.Permissions[i];
	                    if (perm.PermissionValue === PermissionType.FULLCONTROL) {
	                        if (perm.Allow) {
	                            this.allowPerms = -1;
	                            break;
	                        }
	                    }
	                    else {
	                        if (perm.Allow) {
	                            this.allowPerms += perm.PermissionValue;
	                        }
	                        else if (perm.Deny) {
	                            break;
	                        }
	                    }
	                }
	            }
	            this.updatePermissions(this.allowPerms);
	        }
	        Acl.prototype.hasRight = function (right) {
	            return this.rightId === right;
	        };
	        Acl.prototype.sourceString = function () {
	            if (this.sourceObjectType === ObjectType.FOLDER) {
	                return 'folder ' + this.sourceName;
	            }
	            else if (this.sourceObjectType === ObjectType.LIBRARY) {
	                return 'library ' + this.sourceName;
	            }
	            else {
	                return '';
	            }
	        };
	        Acl.prototype.canModify = function () {
	            return this.hasPermission(PermissionType.MODIFY);
	        };
	        Acl.prototype.canRead = function () {
	            return this.hasPermission(PermissionType.READ);
	        };
	        Acl.prototype.canDownload = function () {
	            return this.hasPermission(PermissionType.DOWNLOAD);
	        };
	        Acl.prototype.canUpload = function () {
	            return this.hasPermission(PermissionType.ADDDOC);
	        };
	        Acl.prototype.canShareByLink = function () {
	            return this.hasPermission(PermissionType.SHLINK + PermissionType.SHLINKR);
	        };
	        Acl.prototype.hasAllPermissions = function (perms) {
	            /* jshint -W016 */
	            return ((this.allowPerms & perms) === perms);
	            /* jshint +W016 */
	        };
	        Acl.prototype.hasPermission = function (perms) {
	            /* jshint -W016 */
	            return ((this.allowPerms & perms) !== 0);
	            /* jshint +W016 */
	        };
	        Acl.prototype.updatePermissions = function () {
	            var defaultType;
	            var defaultPerms;
	            /* jshint -W016 */
	            if (arguments.length === 1 && typeof arguments[0] === 'number') {
	                this.allowPerms = arguments[0];
	            }
	            if (this.allowPerms === PermissionType.FULLCONTROL) {
	                this.rightId = RightsType.FULLCONTROL;
	                this.isModifiedRight = false;
	                this.allowAdvancedSettings = false;
	            }
	            else if (this.allowPerms & PermissionType.MODIFY) {
	                // editors have the right to modify documents
	                this.rightId = RightsType.EDIT;
	                defaultType = this.type > ObjectType.FOLDER ? ObjectType.FOLDER : this.type;
	                defaultPerms = Rights[this.rightId].defaultPerms[defaultType];
	                this.isModifiedRight = (defaultPerms !== this.allowPerms);
	                this.allowAdvancedSettings = true;
	            }
	            else if (this.type === ObjectType.FOLDER && ((this.allowPerms & 0x7FF) === PermissionType.UPLOADONLY)) {
	                this.rightId = RightsType.UPLOADONLY;
	                this.isModifiedRight = false;
	                this.allowAdvancedSettings = true;
	            }
	            else if (this.allowPerms & PermissionType.READ) {
	                // viewers have the right to read documents
	                this.rightId = RightsType.VIEW;
	                defaultType = this.type > ObjectType.FOLDER ? ObjectType.FOLDER : this.type;
	                defaultPerms = Rights[this.rightId].defaultPerms[defaultType];
	                this.isModifiedRight = (defaultPerms !== this.allowPerms);
	                this.allowAdvancedSettings = true;
	            }
	            else {
	                this.rightId = RightsType.NOACCESS;
	                this.isModifiedRight = false;
	                this.allowAdvancedSettings = false;
	            }
	            /* jshint +W016 */
	        };
	        /*
	        * @name Acl.getServerAcl
	        *
	        * @description
	        * This method creates a server version of an acl so that it can be passed to the server's updatePermissions API
	        */
	        Acl.prototype.getServerAcl = function () {
	            var newAcl = {
	                UserId: this.isGroup ? 0 : this.userId,
	                UserName: this.isGroup ? '' : this.userName,
	                UserGroupId: this.isGroup ? this.userId : 0,
	                UserGroupName: this.isGroup ? this.userName : '',
	                RoleName: '' + this.rightId + (this.isModifiedRight ? '*' : ''),
	                Embedded: {
	                    Permissions: []
	                }
	            };
	            var permissionValue = PermissionType.FULLCONTROL;
	            while (permissionValue < AclConst.MaxPermission) {
	                var newPerm = {
	                    PermissionValue: permissionValue,
	                    Allow: false,
	                    Deny: false
	                };
	                if (this.rightId === RightsType.FULLCONTROL) {
	                    newPerm.Allow = true;
	                }
	                else if (permissionValue !== PermissionType.FULLCONTROL) {
	                    if (this.rightId === RightsType.NOACCESS) {
	                        newPerm.Deny = true;
	                    }
	                    else {
	                        /* jshint -W016 */
	                        newPerm.Allow = (permissionValue & this.allowPerms) !== 0;
	                    }
	                }
	                newAcl.Embedded.Permissions.push(newPerm);
	                if (permissionValue < 0) {
	                    permissionValue = 1;
	                }
	                else {
	                    /* jshint -W016 */
	                    permissionValue <<= 1;
	                }
	            }
	            return newAcl;
	        };
	        /*
	        * @name Acl.setPermissions
	        *
	        * @description
	        * This method is called to change the permission settings of the acl.
	        */
	        Acl.prototype.setPermissions = function (right, options) {
	            right = +right;
	            options = angular.isArray(options) ? options : [];
	            this.rightId = right;
	            var newPerms = Rights[right].defaultPerms[this.type];
	            if (Rights[right].opts) {
	                /* jshint -W016 */
	                newPerms = newPerms & ~(AclConst.AllSharePerms);
	                /* jshint +W016 */
	                for (var i = 0; i < options.length; ++i) {
	                    var opt = options[i];
	                    var perms = opt.perms || opt.permissions;
	                    if (opt.apply === 'value') {
	                        if (opt.value === true) {
	                            newPerms = perms;
	                            break;
	                        }
	                    }
	                    else {
	                        /* jshint -W016 */
	                        if (opt.value === true) {
	                            newPerms |= perms;
	                        }
	                        else {
	                            newPerms &= ~perms;
	                        }
	                    }
	                }
	            }
	            this.allowPerms = newPerms;
	            this.updatePermissions();
	            return this;
	        };
	        /*
	        * @name Acl.getOptions
	        *
	        * @description
	        * Returns a string with the right options that are set
	        */
	        Acl.prototype.getOptions = function () {
	            var result = '';
	            var right = Rights[this.rightId];
	            if (right.defaultPerms[this.type] !== 0) {
	                var options = RightsOptions[this.rightId];
	                if (options !== null) {
	                    for (var k = 0; k < options.length; ++k) {
	                        var option = options[k];
	                        /* jshint -W016 */
	                        if ((this.allowPerms & option.mask[this.type]) !== 0) {
	                            var nm = option.name;
	                            result = result.length > 0 ? result + ', ' + nm : nm;
	                        }
	                    }
	                }
	            }
	            return result;
	        };
	        /*
	        * @name Acl.getAvailableRights
	        *
	        * @description
	        * This method returns an array of objects where each object describes a right (i.e. Edit, View) that can
	        * be assigned to the user given in the acl.
	        */
	        Acl.prototype.getAvailableRights = function (isInherited) {
	            isInherited = typeof (isInherited) === 'boolean' ? isInherited : this.isInherited;
	            var rights = [];
	            for (var i = 1; i < Rights.length; ++i) {
	                if (i >= this.rightId) {
	                    var right = Rights[i];
	                    var allowRight = false;
	                    switch (+right.id) {
	                        case RightsType.NOACCESS:
	                            allowRight = isInherited;
	                            break;
	                        case RightsType.UPLOADONLY:
	                            allowRight = false;
	                            break;
	                        default:
	                            allowRight = true;
	                    }
	                    if (allowRight) {
	                        rights.push({ id: right.id, name: right.name, options: right.opts });
	                    }
	                }
	            }
	            return rights;
	        };
	        /*
	        * @name Acl.getAvailableLinkRights
	        *
	        * @description
	        * This method returns the list of avaiable rights and options that can be used to set the permissions on a new link
	        */
	        Acl.prototype.getAvailableLinkRights = function (objectType) {
	            var rights = [];
	            for (var i = RightsType.EDIT; i <= RightsType.UPLOADONLY; ++i) {
	                var right = Rights[i];
	                if (right.defaultPerms[objectType] !== 0 && i >= this.rightId && (this.hasPermission(PermissionType.SHLINKR) || i !== RightsType.EDIT)) {
	                    var options = RightsOptions[i];
	                    var uiOpts = [];
	                    if (options !== null) {
	                        for (var k = 0; k < options.length; ++k) {
	                            var option = options[k];
	                            var mask = option.mask[objectType];
	                            if (mask !== 0 &&
	                                /* jshint -W016 */
	                                (mask & AclConst.AllSharePerms) === 0 &&
	                                (mask & this.allowPerms) !== 0) {
	                                uiOpts.push({
	                                    name: option.name,
	                                    id: option.id,
	                                    perms: mask,
	                                    apply: option.apply,
	                                    value: false
	                                });
	                            }
	                        }
	                    }
	                    rights.push({ id: right.id, name: right.name, options: uiOpts });
	                }
	            }
	            return rights;
	        };
	        Acl.prototype.getAdvancedOptions = function (objectType, rightId, perms, asDict) {
	            asDict = typeof (asDict) === 'boolean' ? asDict : false;
	            rightId = +(rightId || this.rightId);
	            perms = perms ? perms : Rights[rightId].defaultPerms[objectType];
	            var result = asDict ? {} : [];
	            var options = RightsOptions[rightId];
	            var self = this;
	            if (options) {
	                options.forEach(function (option) {
	                    var mask = option.mask[objectType];
	                    /* jshint -W016 */
	                    if (mask !== 0 && (mask & self.allowPerms) !== 0) {
	                        var value = option.apply === 'bits' ?
	                            (perms & mask) === mask :
	                            perms === mask;
	                        var advOpt = {
	                            name: option.name,
	                            id: option.id,
	                            perms: mask,
	                            apply: option.apply,
	                            value: value,
	                            constr: option.constr
	                        };
	                        if (asDict) {
	                            result[advOpt.id] = advOpt;
	                        }
	                        else {
	                            result.push(advOpt);
	                        }
	                    }
	                    /* jshint +W016 */
	                });
	            }
	            return result;
	        };
	        // define property getters/setters on the prototype
	        Object.defineProperties(Acl.prototype, {
	            'rightName': {
	                get: function () {
	                    var name = Rights[this.rightId].name;
	                    return name;
	                }
	            }
	        });
	        function generateUniqueId(principalId, isGroup) {
	            if (isGroup === void 0) { isGroup = false; }
	            return (isGroup ? 'acl-g' : 'acl-u') + principalId;
	        }
	        return {
	            /**
	            * @ngdoc method
	            * @name pxAclService#create
	            * @methodOf phoenix.acl.pxAclService
	            * @kind function
	            *
	            * @description
	            * Creates a new ACL instance using the most permissive arguments.
	            *
	            * @param {int} id The ID of the entity to generate an ACL for.
	            *
	            * @param {string} objectType The type of resource to generate an ACL for.
	            *
	            * @param {string} name The name of the entity to generate an ACL for.
	            *
	            * @param {bool} isGroup Value indiciating if this ACL is intended for a group.
	            *
	            * @returns {Object} A new Acl instance.
	            *
	            */
	            create: function (id, objectType, name, isGroup) {
	                // convert to proper array to maintain correct argument position in apply() call
	                var args = Array.prototype.slice.call(arguments);
	                args.unshift(null);
	                // allow proxying of arbitrary arguments rather than keeping 
	                // method signature in sync with Acl constructor arguments
	                /* jshint -W058 */
	                return new (Function.prototype.bind.apply(Acl, args));
	                /* jshint +W058 */
	            },
	            /**
	            * @ngdoc method
	            * @name pxAclService#generateForEntity
	            * @methodOf phoenix.acl.pxAclService
	            * @kind function
	            *
	            * @description
	            * Convenience method that creates a new ACL instance for users or user groups.
	            *
	            * @param {object} entity A user or group to generate an ACL for.
	            *
	            * @param {string} objectType The type of resource to generate an ACL for.
	            *
	            * @returns {Acl} A new Acl instance.
	            *
	            */
	            generateForEntity: function (entity, objectType) {
	                var id = entity.UserId || entity.UserGroupId;
	                var name = entity.UserName || entity.UserGroupName;
	                var isGroup = angular.isString(entity.UserGroupName) && entity.UserGroupName.length > 0;
	                return this.create(id, objectType, name, isGroup);
	            },
	            /**
	            * @ngdoc method
	            * @name pxAclService#isAcl
	            * @methodOf phoenix.acl.pxAclService
	            * @kind function
	            *
	            * @description
	            * Verifies if the given object is an instance of an ACL.
	            *
	            * @param {object} obj The object to test.
	            *
	            * @returns {bool} True if the object is an instance of Acl.
	            *
	            */
	            isAcl: function (obj) {
	                return !!obj && (obj instanceof Acl);
	            },
	            /**
	            * @ngdoc method
	            * @name pxAclService#toRoleNameFromId
	            * @methodOf phoenix.acl.pxAclService
	            * @kind function
	            *
	            * @description
	            * Converts a Phoenix role ID to its human-readable name.
	            *
	            * @param {int} roleId An integer ID representing an ownership role.
	            *
	            * @returns {string} Human readable role name localize for the current language.
	            *
	            */
	            toRoleNameFromId: function (roleId) {
	                var result = '';
	                var rid;
	                roleId = (roleId || '').toString();
	                if (roleId.length > 0) {
	                    rid = +(roleId.charAt(0));
	                    result = rid in Rights ? Rights[rid].name : '';
	                    if (rid < 5) {
	                        result = ', ' + result;
	                        if (roleId.charAt(1) === '*') {
	                            result = result + '*';
	                        }
	                    }
	                }
	                return result;
	            },
	            /**
	            * @ngdoc method
	            * @name pxAclService#toTypeNameFromId
	            * @methodOf phoenix.acl.pxAclService
	            * @kind function
	            *
	            * @description
	            * Converts a phoenix resource type ID to its human-readable name.
	            *
	            * @param {int} typeId An integer ID representing a Phoenix resource type.
	            *
	            * @returns {string} Human readable role name localize for the current language.
	            *
	            */
	            toTypeNameFromId: function (typeId) {
	                return ObjectTypeMappings[typeId] || '';
	            }
	        };
	    }
	})();


/***/ },
/* 58 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  phoenix.clipboardService
		* 
		* @description 
		* A service used to wrap clipboard.js as an injectable Angular dependecy.
		* Removes the global constructor after bootstrap.
		**/
		angular
			.module('phoenix')
			.factory('pxClipboardService', [
				'$window',
				ClipboardService
			]);
		
		function ClipboardService($window) {
			var instance = null;
			var Clipboard = $window.Clipboard;

			// clear global reference
			$window.Clipboard = null;
			delete $window.Clipboard;

			return {
				/**
				* @ngdoc method
				* @name clipboardService#init
				* @methodOf phoenix.clipboardService
				* @kind function
				*
				* @description
				* Initializes clipboard functionality and instantiates a singleton instance.
				* 
				* @param {string} A DOM selector string.
				*
				*/
				init: init,
				/**
				* @ngdoc method
				* @name clipboardService#copy
				* @methodOf phoenix.clipboardService
				* @kind function
				*
				* @description
				* Attempts to copy the provided value to the clipboard.
				* 
				* @param {string} A value whose string representation is to be copied to the clipboard.
				*
				*/
				copy: copy,
				/**
				* @ngdoc property
				* @name clipboardService#init#clipboard
				* @propertyOf phoenix.clipboardService
				* @kind property
				*
				* @description
				* The instantiated Clipboard instance.
				* 
				* @returns {Clipboard} A Clipboard object.
				*/
				get clipboard() {
					return instance;
				}
			};

			function init(selector) {
				if (!instance) {
					if (!Clipboard) {
						throw new Error('Clipboard.js not available.');
					}

					instance = new Clipboard(selector);
				}
			}

			// data-clipboard-text doesn't work on Angular directives
			function copy(value) {
				var body = angular.element($window.document.body);
				var textarea = angular.element('<textarea/>');

				textarea.css({
					position: 'fixed',
					opacity: 0
				});

				textarea.val(value);
				body.append(textarea);
				textarea[0].select();

				try {
					$window.document.execCommand('copy');
				}
				catch (e) {
					throw new Error('Failed to copy to clipboard.');
				}
				
				textarea.remove();
			}
		}
	})();

/***/ },
/* 59 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
	        .module('phoenix')
			.factory('pxEnvironmentService', [
				'$window',
				'$http',
				'$q',
				'settingsService',
				EnvironmentService
			]);

		/**
		* @ngdoc service
		* @name  phoenix.pxEnvironmentService
		* 
		* @description 
		* A service provides details about the user environment
		* 
		**/
		function EnvironmentService($window, $http, $q, settingsService) {
			var self = this;
			self.touchEnabled = null;
			self.language = null;
			self.legalLanguage = null;
			self.isIE = null;

			return {
				/**
				* @ngdoc property
				* @name pxEnvironmentService#touchEnabled
				* @propertyOf phoenix.pxEnvironmentService
				* @kind property
				*
				* @description
				* Returns the availability of touch events
				*/
				get touchEnabled() {
					if (!self.touchEnabled) {
						self.touchEnabled = getTouchSetting();
					}
					return self.touchEnabled;
				},
				/**
				* @ngdoc property
				* @name pxEnvironmentService#isIE
				* @propertyOf phoenix.pxEnvironmentService
				* @kind property
				*
				* @description
				* Returns if the browser is Internet Explorer
				*/
				get isIE(){
					if (!self.isIE) {
						self.isIE = getBrowser();
					}
					return self.isIE;
				},
				/**
				* @ngdoc property
				* @name pxEnvironmentService#language
				* @propertyOf phoenix.pxEnvironmentService
				* @kind property
				*
				* @description
				* Returns the current active language
				*/
				get language() { return self.language; },
				/**
				* @ngdoc method
				* @name pxEnvironmentService#loadLanguages
				* @propertyOf phoenix.pxEnvironmentService
				* @kind method
				*
				* @description
				* Loads the current current language
				*
				* @returns {Deferred} A promise that will resolve with the
				* language to use.
				*/
				loadLanguages: loadLanguages,
				/**
				* @ngdoc property
				* @name pxEnvironmentService#legalLanguage
				* @propertyOf phoenix.pxEnvironmentService
				* @kind property
				*
				* @description
				* Returns the language to target for legal info
				*/
				get legalLanguage() { return self.legalLanguage; },
				/**
				* @ngdoc property
				* @name pxEnvironmentService#legalLanguage
				* @propertyOf phoenix.pxEnvironmentService
				* @kind property
				*
				* @description
				* Sets the language to target for legal info
				*/
				set legalLanguage(val) { self.legalLanguage = val; },
			};

			function getTouchSetting() {
				return (('ontouchstart' in $window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
			}

			function getBrowser() {
				return navigator.userAgent.indexOf('Trident') > -1;
			}

			function loadLanguages() {
				return $http.get(settingsService.serverAPIPath + '/languages')
					.then(function (response) {
						//set language to use
						self.language = response.data.useLangFile;
						return response.data.useLangFile;
					});
			}
		}

	})();

/***/ },
/* 60 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('phoenix')
			.factory('pxGroupItemsService', [
				GroupItemsFactory]);

		/**
		* @ngdoc service
		* @name  phoenix.pxGroupItemsService
		* 
		* @description 
		* A service that takes an array of items and groups them
		* into sub-arrays
		* 
		**/
		function GroupItemsFactory() {
			return {
				/**
				* @ngdoc method
				* @name pxGroupItemsService#groupItems
				* @methodOf phoenix.pxGroupItemsService
				* @kind function
				*
				* @description
				* Group an array of items into sub-arrays
				*
				* @param {number} items An array of items
				* @param {number} itemsInGroup Length of the sub-arrays
				* @returns {array} Array with items grouped into sub-arrays of length `itemsInGroup`
				*/
				groupItems: function (items, itemsInGroup) {
					if (!itemsInGroup) {
						return items;
					}
					var rowCount = Math.ceil(items.length / itemsInGroup);
					var tempitems = JSON.parse(JSON.stringify(items));

					var grouped = [];
					for (var x = 0; x < rowCount; x++) {
						var tiles = tempitems.splice(0, itemsInGroup);
						grouped.push(tiles);
					}
					return grouped;
				}
			};
		}

	})();

/***/ },
/* 61 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('phoenix')
			.factory('pxLocalStorageService', [
				'$window',
				localStorageService]);

		/**
		* @ngdoc service
		* @name  phoenix.pxLocalStorageService
		* 
		* @description 
		* A service to interact with local storage
		* 
		**/
		function localStorageService($window) {
			var _localStorage = getLocalStorage();
			return {
				/**
				 * @ngdoc method
				 * @name pxLocalStorageService#setStoredValue
				 * @methodOf phoenix.pxLocalStorageService
				 * @kind function
				 *
				 * @description
				 * Add a value to local storage
				 *
				 * @param {string} name The key to store the value under
				 * @param {string} value The value to store
				 * @returns {boolean} true if the value was stored, otherwise false
				 */
				setStoredValue: function (name, value) {
					return _localStorage.setItem(name, value);
				},
				/**
				 * @ngdoc method
				 * @name pxLocalStorageService#getStoredValue
				 * @methodOf phoenix.pxLocalStorageService
				 * @kind function
				 *
				 * @description
				 * Get a value from local storage
				 *
				 * @param {string} name The key whose value to fetch
				 * @returns {string} The value from local storage
				 */
				getStoredValue: function (name) {
					var val = _localStorage.getItem(name);
					val = val === null || undefined ? '' : val;
					return val;
				},
				/**
				 * @ngdoc method
				 * @name pxLocalStorageService#removeStoredValue
				 * @methodOf phoenix.pxLocalStorageService
				 * @kind function
				 *
				 * @description
				 * Remove a value from local storage
				 *
				 * @param {string} name The key whose value to remove
				 */
				removeStoredValue: function (name) {
					_localStorage.removeItem(name);
				}
			};

			function getLocalStorage() {
				try {
					$window.localStorage.setItem('pxtest', 'pxtest');
					$window.localStorage.removeItem('pxtest');
					return $window.localStorage;
				} 
				catch (e) {
					return new NullLocalStorage();
				}
			}
			function NullLocalStorage() {
				this.setItem = function (key, value) {
					return false;
				};
				this.getItem = function (key) {
					return null;
				};
				this.removeItem = function (key) {
					return;
				};
			}
		}

	})();

/***/ },
/* 62 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('phoenix')
			.factory('pxProgressService', ['$timeout', ProgressService]);

		/**
		* @ngdoc service
		* @name  phoenix.pxProgressService
		* 
		* @description 
		* A service to interact with the progress indicator
		* 
		**/
		function ProgressService($timeout) {
			var self = this;
			self.visible = false;
			self.text = null;
			self.backdrop = false;
			self.target = null;
			return {
				/**
				* @ngdoc property
				* @name pxProgressService#visible
				* @propertyOf phoenix.pxProgressService
				* @kind property
				*
				* @description
				* The visibility of the progress indicator.
				*
				* @returns {bool} Indicates whether the progress indicator is 
				* visible
				*/
				get visible() { return self.visible; },
				set visible(val) {
					if (val === true) {
						self.visible = true;
					}
					else {
						//reset the factory
						//timeout added to make sure the progress indicator atleast fully displays before hiding
						$timeout(function () {
							self.backdrop = false;
							self.target = null;
							self.visible = false;
							self.text = null;
						}, 700);
					}
				},
				/**
				* @ngdoc property
				* @name pxProgressService#text
				* @propertyOf phoenix.pxProgressService
				* @kind property
				*
				* @description
				* The text displayed on the progress indicator
				*
				* @returns {string} The text displayed on the progress indicator
				*/
				get text() { return self.text; },
				set text(val) { self.text = val===null || val ==='' ? null : val; },
				/**
				* @ngdoc property
				* @name pxProgressService#backdrop
				* @methodOf phoenix.pxProgressService
				* @kind property
				*
				* @description
				* Indicates whether the progress indicator has a backdrop
				*
				* @returns {bool} True if the progress indicator has a backdrop
				*/
				get backdrop() { return self.backdrop; },
				set backdrop(val) { self.backdrop = val === true ? true : false; },

				/**
				* @ngdoc property
				* @name pxProgressService#target
				* @methodOf phoenix.pxProgressService
				* @kind property
				*
				* @description
				* The element to center the progress indicator upon
				*
				* @returns {element} The element to center the progress indicator
				* upon, or null if no target is set
				*/
				get target() { return self.target; },
				set target(element) { self.target = element; }
			};
		}
	}());

/***/ },
/* 63 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  phoenix.pxUriPathService
		* 
		* @description 
		* A service used to construct ShareBase administration URI paths
		**/

		angular
			.module('phoenix')
			.factory('pxUriPathService', [
				'settingsService',
				'pxAuthService',
				UriPathService
			]);

		function UriPathService(settingsService, pxAuthService) {
			var service = {
				/**
				* @ngdoc method
				* @name pxUriPathService#resolvePath
				* @methodOf phoenix.pxUriPathService
				* @kind function
				*
				* @description
				* Updates the path with the input system name and server API path
				* 
				* @param {object} path A URI path
				*
				* @returns {Deferred} An updated URI path with the server API path appended
				* 
				*/
				resolvePath: resolvePath,

				/**
				* @ngdoc property
				* @name pxUriPathService#systemName
				* @propertyOf phoenix.pxUriPathService
				* @kind property
				*
				* @description
				* A deployment name
				* 
				* @returns {string} A deployment's name
				*/
				get systemName() { return pxAuthService.systemName || ''; }
			};

			return service;

			function resolvePath(path, params) {
				params = params || {};

				// a provided system name takes precedence over the default
				params.system = params.system || service.systemName;

				// apply each provided parameter to the path template string 
				Object.keys(params).forEach(function (key) {
					var value = params[key];
					var regex;

					if (angular.isDefined(value) && value !== null) {
						value = value.toString();
						regex = new RegExp('{\s*' + key + '\s*}', 'g');
						
						if (value.length > 0) {
							path = path.replace(regex, value);
						}
					}
				});

				return settingsService.serverAPIPath + path;
			}
		}
	})();

/***/ },
/* 64 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular.module('site.settings', [])
			.factory('settingsService', ['$window', SettingFactory]);

		function SettingFactory($window) {

			var phoenix = $window.$phoenix;
			return {
				serverAPIPath: phoenix.serverPaths.apiPath,
				serverWebPath: phoenix.serverPaths.webPath,
				adminPath: phoenix.serverPaths.adminPath,
				serverLegalPath: phoenix.serverPaths.legalPath,
				serverHelpPath: phoenix.serverPaths.helpPath,
				helpForumPath: phoenix.serverPaths.helpForumPath,
				desktopPollInterval: phoenix.desktopPollInterval,
				desktopPorts: phoenix.desktopPorts,
				maxFileSize : phoenix.maxFileSize
			};
		}
	} ());


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(66);

/***/ },
/* 66 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		// https://github.com/angular/angular.js/blob/master/src/ng/directive/input.js#L14
		var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

		angular
			.module('phoenix')
			.directive('emaillist', function () {
				return {
					require: 'ngModel',
					link: function (scope, elm, attrs, ctrl) {
						ctrl.$validators.emaillist = function (modelValue, viewValue) {

							if (ctrl.$isEmpty(modelValue)) {
								// consider empty models to be invalid
								return false;
							}

							var emails = modelValue.split(',');
							for (var i = 0, ii = emails.length; i < ii; i++) {
								var email = emails[i].trim();
								if (!EMAIL_REGEXP.test(email)) {
									return false;
								}
							}

							// is valid
							return true;
						};
					}
				};
			});
	}());

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * @ngdoc overview
	 * @name sharebase
	 * @module sharebase
	 * @description
	 *
	 * # sharebase (module)
	 * The sharebase module contains components and services available to any
	 * application using the sharebase platform
	 *
	 * Examples of services provided by this module are:
	 * - shares
	 * - comments
	 * - notifications
	 */
	var shareService_1 = __webpack_require__(68);
	var deploymentNameService_1 = __webpack_require__(69);
	var defaultErrorMessages_1 = __webpack_require__(70);
	angular
	    .module('sharebase.services', [
	    'phoenix',
	    'gettext'
	])
	    .service('sbShareService', shareService_1.ShareService)
	    .service('sbDeploymentNameService', deploymentNameService_1.DeploymentNameService);
	angular
	    .module('sharebase', [
	    'phoenix',
	    'sharebase.services',
	    'gettext',
	    defaultErrorMessages_1.default
	]);
	__webpack_require__(73);
	__webpack_require__(106);
	__webpack_require__(112);
	__webpack_require__(114);


/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ShareService = (function () {
	    function ShareService($q, $http, aclService, uriPathService) {
	        this.$q = $q;
	        this.$http = $http;
	        this.aclService = aclService;
	        this.uriPathService = uriPathService;
	        this.type = null;
	    }
	    // configure the service with context-specific information
	    ShareService.prototype.configure = function (type, service, getShares) {
	        this.type = type;
	        this.shareableService = service;
	        this.getExistingShares = getShares;
	    };
	    ShareService.prototype.getShares = function (id) {
	        var _this = this;
	        this.guard();
	        return this.shareableService
	            .getPermissions(id, false)
	            .then(function (shares) {
	            return shares
	                .filter(function (principal) {
	                return principal.RoleName !== 'Owner';
	            })
	                .map(function (prinicpal) { return _this.toShare(prinicpal); });
	        });
	    };
	    ShareService.prototype.createShare = function (itemId, entity, rightId, rights) {
	        // coerce single entity into array to proxy to createShares()
	        var entities = [entity];
	        return this.createShares(itemId, entities, rightId, rights)
	            .then(function (allShares) {
	            return allShares;
	        });
	    };
	    ShareService.prototype.createShares = function (itemId, entities, rightId, rights) {
	        var _this = this;
	        this.guard();
	        var existingShares = this.getExistingShares();
	        var newShares = entities
	            .map(function (entity) {
	            return _this.aclService
	                .generateForEntity(entity, _this.type)
	                .setPermissions(rightId, rights);
	        });
	        var allShares = existingShares
	            .filter(function (existingShare) {
	            // prune out existing shares; 
	            // not ideal since it's O(n*x) but working with a dict isn't convenient and sets are small
	            var isDuplicate = false;
	            var newShare;
	            for (var i = 0; i < newShares.length; i++) {
	                newShare = newShares[i];
	                // userIds aren't unique between groups/users, so that needs to be disambiguated;
	                // use userId here because the ACL ID hasn't been set from the server yet on new share 
	                if (existingShare.isGroup === newShare.isGroup &&
	                    existingShare.userId === newShare.userId) {
	                    isDuplicate = true;
	                    break;
	                }
	            }
	            return !isDuplicate;
	        })
	            .concat(newShares);
	        // coerce domain objects to data access format
	        var acls = allShares.map(function (share) {
	            return share.getServerAcl();
	        });
	        return this.shareableService
	            .savePermissions(itemId, acls)
	            .then(function () {
	            return allShares;
	        });
	    };
	    ShareService.prototype.updateShare = function (itemId, updatedShare, rightId, rights) {
	        this.guard();
	        var shareData = [];
	        var updatedShares = [];
	        var existingShares = this.getExistingShares();
	        updatedShare.setPermissions(rightId, rights);
	        updatedShares = existingShares.map(function (share) {
	            return share.id === updatedShare.id ? updatedShare : share;
	        });
	        shareData = ShareService.toServerJson(updatedShares);
	        return this.shareableService
	            .savePermissions(itemId, shareData)
	            .then(function () {
	            return updatedShares;
	        });
	    };
	    ShareService.prototype.deleteShare = function (itemId, deletedShare) {
	        this.guard();
	        var shareData = [];
	        var remainingShares = [];
	        var existingShares = this.getExistingShares();
	        // modify local share collection in anticipation of success; otherwise discard
	        remainingShares = existingShares.filter(function (share) {
	            // use elementId instead of id since the latter only  
	            // gets filled in from a server-generated ACL
	            return share.elementId !== deletedShare.elementId;
	        });
	        shareData = ShareService.toServerJson(remainingShares);
	        return this.shareableService
	            .savePermissions(itemId, shareData)
	            .then(function () {
	            return remainingShares;
	        });
	    };
	    ShareService.prototype.getCurrentUserAcl = function (id) {
	        var _this = this;
	        this.guard();
	        return this.shareableService
	            .getPermissionsForCurrentUser(id)
	            .then(function (perms) { return _this.aclService.create(perms[0], _this.type); });
	    };
	    ShareService.prototype.getRights = function (sharer, objType, share, isInherited) {
	        var _this = this;
	        if (isInherited === void 0) { isInherited = false; }
	        var p = this.$q.resolve(sharer);
	        if (angular.isNumber(sharer)) {
	            p = this.getCurrentUserAcl(sharer);
	        }
	        return p.then(function (sharerAcl) {
	            var uri = _this.uriPathService.resolvePath('/rights-and-restrictions/shareWithUser?acl={acl}&targetAcl={targetAcl}&objType={type}&isInherted={inherited}', {
	                acl: sharerAcl.allowPerms,
	                type: objType,
	                targetAcl: share ? share.allowPerms : 0,
	                inherited: isInherited
	            });
	            return _this.$http
	                .get(uri)
	                .then(function (resp) { return _this.propsToCamel(resp.data); });
	        });
	    };
	    // this should semantically be static but the aclService has to  
	    // live on the instance due to Angular DI
	    ShareService.prototype.toShare = function (principal) {
	        this.guard();
	        return this.aclService.create(principal);
	    };
	    ShareService.toServerJson = function (acls) {
	        // coerce domain objects to data access format
	        return acls.map(function (share) {
	            return share.getServerAcl();
	        });
	    };
	    ShareService.prototype.guard = function () {
	        if (!this.shareableService) {
	            throw new ShareServiceConfigError('Shareable service must be provided.');
	        }
	        if (this.type < 0) {
	            throw new ShareServiceConfigError('Share type must be specified.');
	        }
	        if (!angular.isFunction(this.getExistingShares)) {
	            throw new ShareServiceConfigError('A function must be specified to retrieve existing shares.');
	        }
	    };
	    ShareService.prototype.propsToCamel = function (obj) {
	        var _this = this;
	        var valType = typeof (obj);
	        var isPrimitive = valType === 'boolean' || valType === 'number' || valType === 'string';
	        if (angular.isArray(obj)) {
	            obj.forEach(function (val) { return _this.propsToCamel(val); });
	        }
	        else if (!isPrimitive) {
	            // cache the keys to avoid infinite recursion while updating
	            var keys = Object.keys(obj);
	            keys.forEach(function (k) {
	                var val = obj[k];
	                obj[k] = null;
	                delete obj[k];
	                var chars = k.split('');
	                chars[0] = k[0].toLowerCase();
	                k = chars.join('');
	                val = _this.propsToCamel(val);
	                obj[k] = val;
	            });
	        }
	        return obj;
	    };
	    ShareService.$inject = ['$q', '$http', 'pxAclService', 'pxUriPathService'];
	    return ShareService;
	}());
	exports.ShareService = ShareService;
	// custom, semantic error class adds no new functionality
	var ShareServiceConfigError = (function (_super) {
	    __extends(ShareServiceConfigError, _super);
	    function ShareServiceConfigError(message) {
	        _super.call(this, message);
	        this.message = message;
	        this.name = 'ShareServiceConfigError';
	        this.stack = (new Error()).stack;
	    }
	    ShareServiceConfigError.prototype.toString = function () {
	        return this.name + ': ' + this.message;
	    };
	    return ShareServiceConfigError;
	}(Error));


/***/ },
/* 69 */
/***/ function(module, exports) {

	"use strict";
	/**
	* A service used to construct ShareBase administration URI paths
	**/
	var DeploymentNameService = (function () {
	    function DeploymentNameService($q, sbDeploymentService, pxAuthService, gettextCatalog) {
	        this.$q = $q;
	        this.sbDeploymentService = sbDeploymentService;
	        this.pxAuthService = pxAuthService;
	        this.gettextCatalog = gettextCatalog;
	        this.deploymentSystemNamesCache = [];
	        this.errorMessage = this.gettextCatalog.getString('Error getting system name. Invalid deployment ID.');
	    }
	    /**
	    * Resolves a deployment's "SystemName" by deploymentID
	    * @param {number} deploymentId - Deployment's ID
	    * @returns {ng.IPromise<string>} SystemName of deployment or null if it cannot be returned
	    */
	    DeploymentNameService.prototype.resolveSystemName = function (deploymentId) {
	        var _this = this;
	        return this.$q(function (resolve, reject) {
	            if (_this.deploymentSystemNamesCache[deploymentId]) {
	                resolve(_this.deploymentSystemNamesCache[deploymentId]);
	            }
	            else if (_this.pxAuthService.deploymentId == deploymentId) {
	                _this.updateCache(deploymentId, _this.pxAuthService.systemName);
	                resolve(_this.pxAuthService.systemName);
	            }
	            else {
	                _this.sbDeploymentService.getDetails(deploymentId)
	                    .then(function (deployment) {
	                    _this.updateCache(deploymentId, deployment.SystemName);
	                    resolve(deployment.SystemName);
	                })
	                    .catch(function () {
	                    reject(new Error(_this.errorMessage));
	                });
	            }
	        });
	    };
	    DeploymentNameService.prototype.updateCache = function (deploymentId, deploymentSystemName) {
	        this.deploymentSystemNamesCache[deploymentId] = deploymentSystemName;
	    };
	    DeploymentNameService.$inject = ['$q', 'sbDeploymentService', 'pxAuthService', 'gettextCatalog'];
	    return DeploymentNameService;
	}());
	exports.DeploymentNameService = DeploymentNameService;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var errorMessages_component_1 = __webpack_require__(71);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('sharebase.defaultErrorMessages', [])
	    .directive('defaultErrorMessages', errorMessages_component_1.defaultErrorMessages).name;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	// CommonJS syntax required
	var errorMessagesTemplate = __webpack_require__(72);
	var DefaultErrorMessagesController = (function () {
	    function DefaultErrorMessagesController($compile, $templateRequest) {
	        this.$compile = $compile;
	        this.$templateRequest = $templateRequest;
	    }
	    DefaultErrorMessagesController.$inject = ['$compile', '$templateRequest'];
	    return DefaultErrorMessagesController;
	}());
	/**
	 * @ngdoc directive
	 * @name defaultErrorMessages
	 * @module sharebase
	 * @restrict E
	 * @requires ngMessages
	 * @description
	 *
	 * `defaultErrorMessages` inserts error messages to cover common form mistakes
	 * @usage
	 *
	 * <div ng-messages="vm.form.customerName.$error" role="alert">
	 *        <default-error-messages />
	 * </div>
	 *
	 */
	function defaultErrorMessages() {
	    return {
	        restrict: 'E',
	        require: ['^^ngMessages', 'defaultErrorMessages'],
	        controller: DefaultErrorMessagesController,
	        link: function ($scope, element, attrs, controllers) {
	            var controller = controllers[1];
	            controller.$templateRequest(errorMessagesTemplate).then(function (html) {
	                controller.$compile(html)($scope, function (contents) {
	                    element.after(contents);
	                    element.remove();
	                });
	            });
	        }
	    };
	}
	exports.defaultErrorMessages = defaultErrorMessages;


/***/ },
/* 72 */
/***/ function(module, exports) {

	var path = 'sharebase/components/defaultErrorMessages/errorMessages.template.html';
	var html = "<div ng-message=\"required\" translate>This field is required.</div>\r\n<div ng-message=\"minlength\" translate>Your field is too short</div>\r\n<div ng-message=\"maxlength\" translate>Your field is too long</div>\r\n<div ng-message=\"email\" translate>You must supply a valid email address.</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(74);
	__webpack_require__(78);
	__webpack_require__(80);
	__webpack_require__(85);
	__webpack_require__(90);
	__webpack_require__(94);
	__webpack_require__(96);
	__webpack_require__(101);

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75);
	__webpack_require__(77);

/***/ },
/* 75 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 76 */,
/* 77 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('sharebase')
			.directive('sbLogin', LoginDirective)
			.controller('sbLoginController', [
				'gettextCatalog',
				LoginController
			]);

		function LoginDirective() {
			return {
				restrict: 'E',
				controller: 'sbLoginController',
				controllerAs: 'vm',
				template: '<px-login title="{{vm.title}}">' +
								'<header-icon>' +
									'<div class="sb-login-icon"></div>' +
								'</header-icon> ' +
							'</px-login>',
				bindToController: true,
				link: function (scope, element, attrs) {
				}
			};
		}
		function LoginController(gettextCatalog) {
			var vm = this;
			vm.title = gettextCatalog.getString('ShareBase');
		}
	} ());

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(79);

/***/ },
/* 79 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular.module('sharebase')
			.controller('sbDeleteDialogController', [
				'$mdDialog',
				'gettextCatalog',
				'content',
				DeleteDialogController]);

		function DeleteDialogController($mdDialog, gettextCatalog, content) {
			var vm = this;
			vm.name = content.DocumentId ? content.DocumentName : content.FolderName;
			vm.title = content.DocumentId ? gettextCatalog.getString('Delete Document') : gettextCatalog.getString('Delete Folder');
			vm.permanentlyDelete = false;

			vm.cancel = function () {
				$mdDialog.cancel();
			};
			vm.delete = function () {
				$mdDialog.hide(vm.permanentlyDelete);
			};
		}
	}());

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(81);
	__webpack_require__(83);

/***/ },
/* 81 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 82 */,
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(84);	

		angular.module('sharebase')
			.directive('sbProgress', LoaderDirective);

		/**
		 * @ngdoc directive
		 * @name sharebase-app.directive:sbProgress
		 * @module sharebase-app
		 * @restrict E
		 * @description
		 *
		 * `sbProgress` is a progress loader ui
		 *
		 * @param {string=} message The message to show below the progress indicator
		 *
		 * @param {bool} backdrop The expression that determines if the backdrop is displayed
		 *
		 * @param {bool} show The expression that determines whether the ui is visible
		 *
		 * @param {element=} target The element that the progress indicator should be centered on
		 *
		 * @usage
		 *
		 * <sb-progress message="text to show" backdrop="true" show="true === true"/>
		 */
		function LoaderDirective() {		
			return {
				restrict: 'E',
				controller: [ProgressController],
				controllerAs: 'ProgressCtlr',
				bindToController: true,
				templateUrl: templateUrl,
				scope: {
					message: '=',
					backdrop: '=',
					show: '=',
					target: '='
				},
				link: function (scope, element) {
					scope.$watch('ProgressCtlr.target', function (newVal) {
						if (!newVal) {
							scope.ProgressCtlr.marginLeft = null;
							return;
						}
						var rects;
						if (newVal.length) {
							rects = newVal[0].getClientRects();
						}
						else {
							rects = newVal.getClientRects();
						}

						scope.ProgressCtlr.marginLeft = ((rects[0].left / 2) - 100) + 'px';

					});
				}
			};
		}

		function ProgressController() {
		}

	}());

/***/ },
/* 84 */
/***/ function(module, exports) {

	var path = 'sharebase/components/progress/progress.template.html';
	var html = "<div class=\"sb-progress\" layout=\"column\" layout-align=\"center center\" \r\n\t ng-if=\"ProgressCtlr.show\" ng-style=\"{'margin-left':ProgressCtlr.marginLeft}\" \r\n\t ng-class=\"{'sb-progress--small-backdrop':(!ProgressCtlr.backdrop && ProgressCtlr.show && ProgressCtlr.message && ProgressCtlr.message!=='')}\">\r\n\t<div class=\"sb-progress__top\">\r\n\t\t<md-progress-circular class=\"sb-progress__progress md-primary\" md-mode=\"{{ProgressCtlr.show ? 'indeterminate':''}}\" md-diameter=\"60\"></md-progress-circular>\r\n\r\n\t\t<div class=\"sb-progress__icon md-whiteframe-8dp\"></div>\r\n\t</div>\r\n\t<div class=\"sb-progress__text\">{{ProgressCtlr.message}}</div>\r\n</div>\r\n<md-backdrop class=\"sb-progress__backdrop md-opaque\" ng-show=\"ProgressCtlr.backdrop && ProgressCtlr.show\"></md-backdrop>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(86);
	__webpack_require__(88);

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(87);
		
		/**
		* @ngdoc directive
		* @name sharebase.directive:sbSearchBox
		* @module sharebase
		* @restrict E
		* @description
		*
		* `sbSearch` enables searching sharebase folders
		*
		* @usage
		*
		* <sb-search-box placeholder="Search My Files" search-type="content" full-results-url="#/search-results"/>
		* 
		* 
		* @param {string=} placeholder The placeholder text to show in the input.  Default
		* value is 'Search'
		*
		* @param {string=} searchType Controls type of items to be searched. Valid values are
		* 'content' (default)
		*
		* @param {expression=} onFullResults Function expression to call when full search
		* results are requested.
		*
		* @param {expression=} onSelection Function expression to call when an item is selected from 
		* the autocomplete list.
		*/

		angular
			.module('sharebase')
			.directive('sbSearchBox', [
				'$timeout',
				SearchBoxDirective]);

		function SearchBoxDirective($timeout) {
			return {
				restrict: 'E',
				controller: ['$q', '$state', 'sbSearchService', 'pxLocalStorageService', 'gettextCatalog', SearchController],
				controllerAs: 'searchCtlr',
				bindToController: true,
				templateUrl: templateUrl,
				scope: {
					placeholder: '@',
					searchType: '@',
					onFullResults: '&',
					onSelection: '&'
				},
				link: function (scope, element, attrs) {
					if (!attrs.searchTarget || attrs.searchTarget === '') {
						scope.searchCtlr.searchType = 'content';
					}

					var searchInput;
					//wait for template to be compiled
					var t = setInterval(function () {
						if (element.find('input').length > 0) {
							clearInterval(t);
							element.find('input').bind('keypress', beginFullSearch);
							searchInput = element.find('input');
						}
					}, 100);

					function beginFullSearch(event) {
						var key = event.keyCode || event.charCode;
						if (key === 13) {
							if (searchInput[0].value.length === 0) {
								//do nothing if no search characters
								return;
							}
							scope.$apply(function () {
								//kick off search
								var val = searchInput[0].value;

								scope.searchCtlr.loadFullResults(val);
							});

						}
					}

					scope.searchCtlr.clearSearchInput = function () {
						$timeout(function () {
							scope.searchCtlr.selectedItem = undefined;
							scope.searchCtlr.searchText = '';
							searchInput.blur();
						}, 800);
					};

					scope.$on('$destroy', function () {
						element.find('input').unbind('keypress', beginFullSearch);

						//clean up 
						var body = document.querySelector('body');
						var searchScrollMask = document.querySelector('body .md-scroll-mask');
						if (searchScrollMask) {
							body.removeChild(searchScrollMask);
						}
					});
				}
			};
		}

		function SearchController($q, $state, sbSearchService, pxLocalStorageService, gettextCatalog) {
			var self = this;
			self.searchService = sbSearchService;
			self.searchResults = searchResults;
			self.loadFullResults = loadFullResults;
			self.selectedItemChange = selectedItemChange;
			self.addSearchHistory = addSearchHistory;

			if (!self.placeholder) {
				self.placeholder = gettextCatalog.getString('Search');
			}	

			function searchResults(val) {
				if (!val || val.length < 3) {
					//show recent search/items
					return getRecentItems();
				}

				//show search results
				var deferred = $q.defer();
				sbSearchService.getResults(val, 10).then(function (data) {
					if (data.hasMore) {
						//add a new item show full results
						data.results.push({ historyTerm: 'See more results for \'' + val + '\'', showMore: true });
					}
					deferred.resolve(data.results);
				});

				return deferred.promise;
			}

			function selectedItemChange(item) {
				if (!item) {
					return;
				}

				self.clearSearchInput();
				if (item.historyTerm) {
					if (item.showMore) {
						//load the rest of the results
						self.onSelection({ item: self.searchText });
						self.addSearchHistory(self.searchText);
					}
					else if (item.historyTerm) {
						self.onSelection({ item: item.historyTerm });
						self.addSearchHistory(item.historyTerm);
					}
				}
				else {
					//folder or file
					self.onSelection({ item: item });
					if (item.FolderId) {
						folderClicked(item);
					}
					if (item.DocumentId) {
						itemClicked(item);
					}
				}
				self.clearSearchInput();
			}

			function loadFullResults(term) {
				self.clearSearchInput();
				self.addSearchHistory(term);
				self.onSelection({ item: term });
			}

			function folderClicked(folder) {
				//add to recent searched items
				var contentAdd = {};
				contentAdd.FolderId = folder.FolderId;
				contentAdd.name = folder.name;
				contentAdd.Type = folder.Type;
				addItemSelectedHistory(contentAdd);
			}

			function itemClicked(item) {
				//add to recent searched items
				var contentAdd = {};
				contentAdd.DocumentId = item.DocumentId;
				contentAdd.name = item.name;
				contentAdd.Icon = item.Icon;
				addItemSelectedHistory(contentAdd);
			}

			var recentSearchList;
			function getRecentItems() {
				if (!recentSearchList) {
					//get search history
					recentSearchList = getSearchHistory();
					//used to add a border between search/item history
					if (recentSearchList.length > 0) {
						recentSearchList[recentSearchList.length - 1].isLast = true;
					}
					var selectedHistory = getItemSelectedHistory();
					angular.forEach(selectedHistory, function (item) {
						recentSearchList.push(item);
					});

					angular.forEach(recentSearchList, function (item) {
						var hdate = new Date(item.searchTime);
						var now = new Date();
						var yesterday = new Date();
						yesterday.setDate(yesterday.getDate() - 1);

						item.timeLabel = 'older';
						if (hdate.getDate() === now.getDate()) {
							item.timeLabel = hdate.toLocaleTimeString();
							var seconds = hdate.getSeconds() > 9 ? hdate.getSeconds() : '0' + hdate.getSeconds();
							item.timeLabel = item.timeLabel.replace(':' + seconds + ' ', ' ');
						}
						else if (hdate.getDate() === yesterday.getDate()) {
							item.timeLabel = 'yesterday';
						}
					});
				}
				return recentSearchList;
			}

			function addItemSelectedHistory(item) {
				recentSearchList = undefined; //clear current recents and force it to be rebuilt
				var selectedItems = pxLocalStorageService.getStoredValue('sharebase' + self.searchType + 'ItemHistory');
				var selectedItemsJSON;
				if (selectedItems === '') {
					selectedItemsJSON = [];
				}
				else {
					selectedItemsJSON = JSON.parse(selectedItems);
				}

				//remove previous similar selectedItems entries
				selectedItemsJSON = selectedItemsJSON.filter(function (iselectedItem) {
					return (item.name.toLowerCase() !== iselectedItem.name.toLowerCase());
				});

				//add new term to beginning
				item.searchTime = new Date();
				selectedItemsJSON.unshift(item);
				//save last x terms
				var last = JSON.stringify(selectedItemsJSON.slice(0, 4));
				pxLocalStorageService.setStoredValue('sharebase' + self.searchType + 'ItemHistory', last);
			}
			function addSearchHistory(term) {
				recentSearchList = undefined; //clear current recents and force it to be rebuilt
				var searches = pxLocalStorageService.getStoredValue('sharebase' + self.searchType + 'SearchHistory');
				var searchesJSON;
				if (searches === '') {
					searchesJSON = [];
				}
				else {
					searchesJSON = JSON.parse(searches);
				}

				//remove previous similar term entries
				searchesJSON = searchesJSON.filter(function (search) {
					return (search.historyTerm.toLowerCase() !== term.toLowerCase());
				});

				//add new term to beginning
				searchesJSON.unshift({ historyTerm: term, searchTime: new Date() });
				//save last x terms
				var last = JSON.stringify(searchesJSON.slice(0, 4));
				pxLocalStorageService.setStoredValue('sharebase' + self.searchType + 'SearchHistory', last);

			}

			function getItemSelectedHistory() {
				var items = pxLocalStorageService.getStoredValue('sharebase' + self.searchType + 'ItemHistory');
				if (items === '') {
					return [];
				}
				return JSON.parse(items);
			}
			function getSearchHistory() {
				var searches = pxLocalStorageService.getStoredValue('sharebase' + self.searchType + 'SearchHistory');
				if (searches === '') {
					return [];
				}
				return JSON.parse(searches);
			}

		}

	}());

/***/ },
/* 87 */
/***/ function(module, exports) {

	var path = 'sharebase/components/searchBox/searchBox.template.html';
	var html = "<md-content layout=\"row\" layout-align=\"start center\">\r\n\t<md-icon class=\"material-icons search-icon\">search</md-icon>\r\n\t<md-autocomplete flex\r\n\t\t\t\t\t md-search-text=\"searchCtlr.searchText\"\r\n\t\t\t\t\t md-selected-item-change=\"searchCtlr.selectedItemChange(item)\"\r\n\t\t\t\t\t md-items=\"item in searchCtlr.searchResults(searchCtlr.searchText)\"\r\n\t\t\t\t\t md-item-text=\"item.historyTerm !== undefined ? item.historyTerm : item.name\"\r\n\t\t\t\t\t md-min-length=\"0\"\r\n\t\t\t\t\t ng-model-options=\"{debounce:500}\"\r\n\t\t\t\t\t md-menu-class=\"search-suggestions\"\r\n\t\t\t\t\t md-no-cache=\"true\"\r\n\t\t\t\t\t ng-attr-placeholder=\"{{searchCtlr.placeholder}}\"\r\n\t\t\t\t\t class=\"search-autocomplete\">\r\n\t\t<md-item-template>\r\n\t\t\t<div class=\"search-term\" ng-class=\"{'last': item.isLast, 'show-more': item.showMore}\" layout=\"row\" layout-align=\"start center\" ng-if=\"item.historyTerm\">\r\n\t\t\t\t<div class=\"suggestion-img\" layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<md-icon class=\"material-icons\">search</md-icon>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div flex layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<span flex class=\"ellipsis\">{{item.historyTerm}}</span>\r\n\t\t\t\t\t<span class=\"search-history-time\">{{item.timeLabel}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div layout=\"row\" layout-align=\"start center\" ng-if=\"!item.historyTerm\">\r\n\t\t\t\t<div class=\"suggestion-img\" layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<md-icon class=\"material-icons\">{{item.FolderId ? 'folder' : 'insert_drive_file' }}</md-icon>\r\n\t\t\t\t</div>\r\n\t\t\t\t\r\n\t\t\t\t<!--\r\n\t\t\t\t<div class=\"suggestion-img\" ng-style=\"{'background-image':'url(' + searchCtlr.getIcon(item) + ')'}\"></div>\r\n\t\t\t\t\t-->\r\n\t\t\t\t<div flex layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<span md-highlight-text=\"searchCtlr.searchText\" md-highlight-flags=\"^i\" flex class=\"ellipsis\">{{item.name}}</span>\r\n\t\t\t\t\t<span class=\"search-history-time\">{{item.timeLabel}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</md-item-template>\r\n\t</md-autocomplete>\r\n</md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 88 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 89 */,
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(91);
	__webpack_require__(92);

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	(function () {
	    'use strict';
	    angular
	        .module('sharebase')
	        .controller('sbShareDialogController', [
	        '$window',
	        '$q',
	        '$mdDialog',
	        '$mdMedia',
	        '$mdConstant',
	        'pxAuthService',
	        'pxProgressService',
	        'sbUsersDataStore',
	        'sbUserGroupsDataStore',
	        'sbToastService',
	        'pxClipboardService',
	        'context',
	        'targetStep',
	        'aclToEdit',
	        'datastore',
	        'gettextCatalog',
	        ShareDialogController
	    ])
	        .constant('ShareDialogTabs', {
	        UserShare: {
	            View: 0,
	            Create: 1,
	            Edit: 1
	        },
	        LinkShare: {
	            View: 0,
	            Create: 3,
	            Edit: 3
	        }
	    });
	    function ShareDialogController($window, $q, $mdDialog, $mdMedia, $mdConstant, authService, progressService, usersDataStore, userGroupsDataStore, sbToastService, clipboardService, context, targetStep, aclToEdit, datastore, gettextCatalog) {
	        var vm = this;
	        var currentAcl = null;
	        var initTasks = [
	            datastore.getPermissions(aclToEdit),
	            usersDataStore.getUsers(),
	            userGroupsDataStore.getUserGroups(),
	            // TODO actual api https://devv-002500.hylandqa.net/jira/browse/SBAPI-206
	            /* with a deployment option set*/
	            $q.resolve({
	                'Name': 'LinkAuthenticationType',
	                'DisplayName': 'Link Authentication',
	                'Value': 1,
	                'DisplayValue': 'Require PIN',
	                'DataType': 'DataSet:None|RequirePin'
	            })
	        ];
	        targetStep = targetStep ? targetStep : 0;
	        var advancedOptions = {};
	        var shareables = [];
	        vm.getTitle = getTitle;
	        vm.tabIndex = targetStep;
	        vm.deploymentId = authService.deploymentId;
	        vm.shares = datastore.shares || [];
	        vm.shareLink = null;
	        vm.datastore = datastore;
	        vm.mdMedia = $mdMedia;
	        vm.emailChipSeperators = [$mdConstant.KEY_CODE.COMMA,
	            $mdConstant.KEY_CODE.SEMICOLON,
	            $mdConstant.KEY_CODE.ENTER,
	            $mdConstant.KEY_CODE.SPACE
	        ];
	        vm.availableRights = [];
	        vm.availableAdvancedOptions = [];
	        vm.context = normalizeContext(context);
	        vm.inEditMode = !!aclToEdit;
	        vm.minExpireDate = new Date();
	        vm.canModify = true;
	        vm.share = {
	            users: [],
	            right: null
	        };
	        vm.linkShare = {
	            currentRecipients: [],
	            newRecipients: [],
	            subject: vm.context.type === 'document' ? gettextCatalog.getString('Subject: A document has been shared with you') : gettextCatalog.getString('Subject: A folder has been shared with you'),
	            message: '',
	            right: 'View',
	            expireType: 'Never',
	            securityType: 'none'
	        };
	        vm.openURL = function (url) {
	            $window.open(url);
	        };
	        vm.close = function () {
	            $mdDialog.hide();
	        };
	        vm.createUpdateShare = guardFormAction(function () {
	            var p;
	            if (vm.inEditMode) {
	                p = datastore.updateShare(aclToEdit, vm.share.right, vm.availableAdvancedOptions);
	            }
	            else {
	                p = datastore.createShares(vm.share.users, vm.share.right, vm.availableAdvancedOptions);
	            }
	            p.then(function () {
	                vm.tabIndex = 2;
	                // update share datastore to get new ids
	                return datastore.getShares();
	            });
	            return p;
	        });
	        vm.updateAdvancedOptions = function () {
	            vm.availableAdvancedOptions = advancedOptions[vm.share.right];
	            vm.availableAdvancedOptions.forEach(vm.checkAllowFlags);
	        };
	        vm.createUpdateLink = function () {
	            vm.error = null;
	            if (vm.linkShare.securityType === 'Require PIN' && (vm.linkShare.newRecipients.length === 0 && vm.linkShare.currentRecipients.length === 0)) {
	                vm.error = gettextCatalog.getString('Please specify one or more email recipeints.');
	                return;
	            }
	            setLoading(true);
	            $q.resolve()
	                .then(function () {
	                // TODO get actual link
	                vm.shareLink = 'https://devv-002500.hylandqa.net/bitbucket/projects/SB/repos/sharebase-web/branches?base=refs%2Fheads%2Ffeat%2FSBWEB-478-design-ux-of-creating-a-multi-factor';
	                vm.tabIndex = 4;
	                setLoading(false);
	            });
	        };
	        function getTitle() {
	            switch (vm.tabIndex) {
	                case 1:
	                    return aclToEdit ? gettextCatalog.getString('Edit Share') : gettextCatalog.getString('Create Share');
	                case 2:
	                    return aclToEdit ? gettextCatalog.getString('Share Updated') : gettextCatalog.getString('Share Created');
	                case 3:
	                    return aclToEdit ? gettextCatalog.getString('Edit Share Link') : gettextCatalog.getString('Create Share Link');
	                case 4:
	                    return aclToEdit ? gettextCatalog.getString('Link Updated') : gettextCatalog.getString('Link Created');
	                case 0:
	                default:
	                    return gettextCatalog.getString('Share Details');
	            }
	        }
	        ;
	        vm.copyURL = function () {
	            try {
	                clipboardService.copy(vm.shareLink);
	                sbToastService.showSimple(gettextCatalog.getString('Share link copied to clipboard.'));
	            }
	            catch (e) {
	                sbToastService.showSimple(gettextCatalog.getString('Could not copy link.'));
	            }
	        };
	        // validates the advanced option to determine if it should affect 
	        // others when enabled/disabled and does so when appropriate
	        vm.checkAllowFlags = function (ao) {
	            var constraint = ao.constraints;
	            if (constraint.length > 0) {
	                var i = 0;
	                // iterate on constraint field characters, 
	                // which represent a command and id of the right it modifies	
	                while (i < constraint.length) {
	                    var cmd = constraint.charAt(i++);
	                    var idx = +(constraint.charAt(i++));
	                    var refAo = vm.availableAdvancedOptions[idx];
	                    if (cmd === '+') {
	                        if (ao.value) {
	                            refAo.disabled = true;
	                            refAo.value = true;
	                        }
	                        else {
	                            refAo.disabled = false;
	                        }
	                    }
	                }
	            }
	        };
	        setLoading(true);
	        $q.all(initTasks)
	            .then(function (taskData) {
	            vm.availableRights = taskData[0].rights;
	            shareables = usersDataStore.users.concat(userGroupsDataStore.userGroups);
	            vm.share.users = aclToEdit ? [findShareable(aclToEdit)] : [];
	            vm.share.right = aclToEdit && (aclToEdit.rightId in vm.availableRights) ? aclToEdit.rightId : +vm.availableRights[vm.availableRights.length - 1].id;
	            // massage advanced options into dict keyed on right ID
	            vm.availableRights.forEach(function (right) {
	                advancedOptions[right.id] = right.embedded.options;
	            });
	            //set deployment link Auth settings
	            vm.linkAuthenticationType = taskData[taskData.length - 1];
	            vm.linkShare.securityType = vm.linkAuthenticationType.DisplayValue ? vm.linkAuthenticationType.DisplayValue : 'none';
	            vm.updateAdvancedOptions();
	        })
	            .finally(setLoading);
	        function guardFormAction(func) {
	            var defaultError = gettextCatalog.getString('There was an issue sharing "{{name}}".', vm.context);
	            var invalidShare = gettextCatalog.getString('Please specify one or more valid users or groups.');
	            if (!angular.isFunction(func)) {
	                return angular.noop;
	            }
	            return function () {
	                var res = $q.resolve();
	                if (vm.f.$valid && vm.share.users.length > 0 && vm.share.right) {
	                    res = func.apply(null, arguments);
	                }
	                else {
	                    vm.error = vm.share.users.length > 0 ? defaultError : invalidShare;
	                }
	                res.catch(function (e) {
	                    vm.error = e.data.Message || defaultError;
	                });
	                return res;
	            };
	        }
	        function findShareable(aclToEdit) {
	            var list = shareables.filter(function (shareable) { return aclToEdit.userId === shareable[aclToEdit.isGroup ? 'UserGroupId' : 'UserId']; });
	            return list.length > 0 ? list[0] : null;
	        }
	        function normalizeContext(context) {
	            var normalizedContext = {
	                id: '',
	                type: '',
	                name: ''
	            };
	            if (context.LibraryId) {
	                normalizedContext.id = context.LibraryId;
	                normalizedContext.type = 'library';
	                normalizedContext.name = context.LibraryName;
	            }
	            else if (context.FolderId) {
	                normalizedContext.id = context.FolderId;
	                normalizedContext.type = 'folder';
	                normalizedContext.name = context.FolderName;
	            }
	            else if (context.DocumentId) {
	                normalizedContext.id = context.DocumentId;
	                normalizedContext.type = 'document';
	                normalizedContext.name = context.DocumentName;
	            }
	            return normalizedContext;
	        }
	        function setLoading(isLoading) {
	            isLoading = typeof (isLoading) === 'boolean' ? isLoading : false;
	            progressService.visible = isLoading;
	        }
	    }
	})();


/***/ },
/* 92 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 93 */,
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(95);

/***/ },
/* 95 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('sharebase')
			.controller('sbadminLinkURLController', [
				'$mdDialog',
				'sbToastService',
				'shareLink',
				'gettextCatalog',
				ShowLinkURLController
			]);

		function ShowLinkURLController($mdDialog, sbToastService, shareLink, gettextCatalog) {
			var self = this;
			self.shareLink = shareLink;

			self.close = function () {
				$mdDialog.hide();
			};

			self.copyURL = function () {
				sbToastService.showSimple(gettextCatalog.getString('Share link copied to clipboard.'));
			};
		}

	}());

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(97);
	__webpack_require__(99);

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(98);
		angular.module('sharebase')
			.directive('sbShareList', ShareListDirective)
			.controller('ShareListController', [
				'$q',
				'$mdDialog',
				'sbToastService',
				'gettextCatalog',
				ShareListController
			]);

		/**
		 * @ngdoc directive
		 * @name sharebase.directive:sbShareList
		 * @module sharebase
		 * @restrict E
		 * @description
		 *
		 * `sbShareList` is a list of an items shares
		 *
		 * @param {string} objectType The type of object, valid values foldder or document
		 *
		 * @param {array} shares An array of shares to display in the list.
		 * 
		 * @usage
		 *
		 * <sb-share-list object-type='folder' shares='datastore.shares' click-event />
		 */
		function ShareListDirective() {
			return {
				restrict: 'E',
				controller: 'ShareListController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: templateUrl,
				scope: {
					shares: '=',
					inheritedShares: '=',
					delete: '=',
					onClick: '=',
					objectType: '@',
					filterPhrase: '=',
					canModify: '=?',
					sort: '=?',
					newShareAction: '=',
					newShareMessage: '@',
					newLinkAction: '=',
					newLinkMessage: '@'
				},
				link: function (scope, element) {
					if(scope.vm.sort) {
						scope.$watch('vm.shares', function(newShares, oldShares) {
							if(newShares && newShares.length > 0 && newShares !== oldShares) {
								newShares.sort(function(a, b){
									if(a.userName.toLowerCase() === b.userName.toLowerCase()) {
										return 0;
									} 
									else {
										return a.userName.toLowerCase() > b.userName.toLowerCase() ? 1 : -1;
									}
								});
							}
						});
					}
				}
			};
		}

		function ShareListController($q, $mdDialog, sbToastService, gettextCatalog) {
			var vm = this;
			vm.links = [];
			vm.isLibrary = vm.objectType === 'library' ? true : false;
			vm.canModify = typeof(vm.canModify) === 'boolean' ? vm.canModify : true;
			vm.sort = typeof(vm.sort) === 'boolean' ? vm.sort : true;
			vm.deleteShare = deleteShare;
			vm.showLinkURL = showLinkURL;

			function deleteShare(ev, share) {
				var confirm = $mdDialog.confirm()
					.title(gettextCatalog.getString('Would you like to remove this share?'))
					.textContent(gettextCatalog.getString('{{name}} will no longer have {{right}} rights.', {
						name: share.userName,
						right: share.rightName.toLowerCase(),
					}))
					.ariaLabel(gettextCatalog.getString('Remove share'))
					.targetEvent(ev)
					.ok(gettextCatalog.getString('Remove'))
					.cancel(gettextCatalog.getString('Cancel'));

				$mdDialog.show(confirm)
					.then(function () {
						vm.delete(share)
							.then(function() {
								sbToastService.showSimple(gettextCatalog.getString('Share removed successfully.'));
							})
							.catch(function() {
								sbToastService.showSimple(gettextCatalog.getString('Failed to remove share.'));
							});
						
					}, angular.noop);
			}

			function showLinkURL($event, link) {
				$mdDialog.show({
					controller: 'sbadminLinkURLController',
					controllerAs: 'vm',
					templateUrl: templateUrl,
					targetEvent: $event,
					clickOutsideToClose: false,
					locals: {
						//TODO - have to get the full link
						shareLink: '/share/' + link.ReferenceString 
					}
				});
			}
		}
	}());

/***/ },
/* 98 */
/***/ function(module, exports) {

	var path = 'sharebase/components/shareList/shareList.template.html';
	var html = "<md-tabs flex=\"auto\" md-stretch-tabs=\"auto\" ng-class=\"{'sb-share-list---no-tabs':vm.isLibrary}\">\r\n\t<md-tab label=\"{{'Users & Groups' | translate}} ({{vm.shares.length}})\">\r\n\t\t<md-tab-content layout=\"column\">\r\n\t\t\t<md-content flex=\"grow\" layout=\"column\" layout-align=\"start stretch\" ng-if=\"vm.shares.length > 0 || vm.inheritedShares.length > 0\">\r\n\t\t\t\t<md-subheader  ng-if=\"vm.shares.length> 0 && !vm.isLibrary\" class=\"md-no-sticky\">{{::'Configured Shares' | translate}}</md-subheader>\r\n\t\t\t\t<md-list ng-if=\"vm.canModify && vm.shares.length > 0\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-list-item class=\"md-2-line md-has-secondary\" ng-click=\"vm.onClick($event, share)\" ng-repeat=\"share in vm.shares | filter:{isGroup:true} | filter:vm.filterPhrase | orderBy:{userName}\">\r\n\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">people</md-icon>\r\n\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ share.userName }}</h3>\r\n\t\t\t\t\t\t\t<p class=\"ellipsis\">{{ share.rightName }}</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteShare($event, share)\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icon\">clear</md-icon>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item class=\"md-2-line md-has-secondary\" ng-click=\"vm.onClick($event, share)\" ng-repeat=\"share in vm.shares | filter:{isGroup:false} | filter:vm.filterPhrase | orderBy:{userName}\">\r\n\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">person</md-icon>\r\n\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ share.userName }}</h3>\r\n\t\t\t\t\t\t\t<p class=\"ellipsis\">{{ share.rightName }}</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteShare($event, share)\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icon\">clear</md-icon>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-divider ></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t\t<md-list ng-if=\"!vm.canModify  && vm.shares.length > 0\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-list-item class=\"md-2-line\"  ng-repeat=\"share in vm.shares | filter:{isGroup:true} | filter:vm.filterPhrase | orderBy:{userName}\">\r\n\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">people</md-icon>\r\n\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ share.userName }}</h3>\r\n\t\t\t\t\t\t\t<p class=\"ellipsis\">{{ share.rightName }}</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item class=\"md-2-line\" ng-repeat=\"share in vm.shares | filter:{isGroup:false} | filter:vm.filterPhrase | orderBy:{userName}\">\r\n\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">person</md-icon>\r\n\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ share.userName }}</h3>\r\n\t\t\t\t\t\t\t<p class=\"ellipsis\">{{ share.rightName }}</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t\t<md-list ng-if=\"vm.shares.length === 0\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-list-item>\r\n\t\t\t\t\t\t<p translate class=\"app---faint-text\">No configured shares</p>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t\t<md-list ng-if=\"vm.inheritedShares.length > 0\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-subheader class=\"md-no-sticky\">{{::'Inherited Permissions' | translate}}</md-subheader>\r\n\t\t\t\t\t<md-list-item class=\"md-3-line\" ng-repeat=\"share in vm.inheritedShares | filter:{isGroup:true} | filter:vm.filterPhrase | orderBy:{userName}\">\r\n\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">people</md-icon>\r\n\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ share.userName }}</h3>\r\n\t\t\t\t\t\t\t<h4 class=\"ellipsis\">{{ share.rightName }}</h4>\r\n\t\t\t\t\t\t\t<p class=\"ellipsis\" ng-if=\"share.sourceName\">{{'From:'|translate}} {{share.sourceName}}</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item class=\"md-3-line\" ng-repeat=\"share in vm.inheritedShares | filter:{isGroup:false} | filter:vm.filterPhrase | orderBy:{userName}\">\r\n\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">person</md-icon>\r\n\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ share.userName }}</h3>\r\n\t\t\t\t\t\t\t<h4 class=\"ellipsis\">{{ share.rightName }}</h4>\r\n\t\t\t\t\t\t\t<p class=\"ellipsis\" ng-if=\"share.sourceName\">{{'From:'|translate}} {{share.sourceName}}</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\t\t\t<md-content flex=\"grow\" ng-if=\"(vm.shares.length === 0 || !vm.shares) && (vm.inheritedShares.length === 0 || !vm.inheritedShares)\">\r\n\t\t\t\t<!-- Empty State -->\r\n\t\t\t\t<div class=\"sba__empty-state-wrap\" flex layout-fill layout=\"column\" layout-align=\"center center\" layout-align-xs=\"start center\">\r\n\t\t\t\t\t<div class=\"sba__empty-state\" layout=\"column\" layout-align=\"center center\" ng-class=\"{'sba__empty-state---clickable': vm.canModify && vm.newShareAction}\"\r\n\t\t\t\t\t\tng-click=\"vm.newShareAction($event)\">\r\n\t\t\t\t\t\t<div class=\"sba__empty-state-bg\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">share</md-icon>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<h2 class=\"sba__empty-state-title\" translate>Content has not been shared.</h2>\r\n\t\t\t\t\t\t<p class=\"sba__empty-state-description\" ng-if=\"vm.canModify && vm.newShareMessage\">{{vm.newShareMessage}}</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-content>\r\n\t\t</md-tab-content>\r\n\t</md-tab>\r\n\t<md-tab label=\"{{'Links' | translate}} ({{vm.links.length}})\">\r\n\t\t<md-tab-content layout=\"column\">\r\n\t\t\t<md-content flex=\"grow\" layout=\"column\" layout-align=\"start stretch\" ng-if=\"vm.links.length > 0\">\r\n\t\t\t\t<md-list flex ng-if=\"vm.hasRightsToModify\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-virtual-repeat-container flex>\r\n\t\t\t\t\t\t<md-list-item class=\"md-2-line md-has-secondary\" ng-click=\"vm.clickEvent\" md-virtual-repeat=\"item in vm.links | filter:vm.filterPhrase\">\r\n\t\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">{{item.Settings === 2 ? 'lock' : 'link'}}</md-icon>\r\n\t\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ item.ACLRight }}</h3>\r\n\t\t\t\t\t\t\t\t<p class=\"ellipsis\" ng-if=\"item.DateExpires === '9999-12-31T23:59:59.9999999Z'\">No expiration</p>\r\n\t\t\t\t\t\t\t\t<p class=\"ellipsis\" ng-if=\"item.DateExpires !== '9999-12-31T23:59:59.9999999Z'\">Expires {{item.DateExpires | sbSimpleDateTimeString}}</p>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"vm.showLinkURL($event, item);$event.stopPropagation();\" style=\"margin:0;\">\r\n\t\t\t\t\t\t\t\t<md-icon class=\"material-icon\">content_copy</md-icon>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"vm.deleteShare($event, item);$event.stopPropagation();\" style=\"margin:0;\">\r\n\t\t\t\t\t\t\t\t<md-icon class=\"material-icon\">clear</md-icon>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t</md-virtual-repeat-container>\r\n\t\t\t\t</md-list>\r\n\r\n\t\t\t\t<md-list flex ng-if=\"!vm.hasRightsToModify\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-virtual-repeat-container flex>\r\n\t\t\t\t\t\t<md-list-item class=\"md-2-line md-has-secondary\" md-virtual-repeat=\"item in vm.links\">\r\n\t\t\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">{{item.Settings === 2 ? 'lock' : 'link'}}</md-icon>\r\n\t\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ item.ACLRight }}</h3>\r\n\t\t\t\t\t\t\t\t<p class=\"ellipsis\" ng-if=\"item.DateExpires === '9999-12-31T23:59:59.9999999Z'\">No expiration</p>\r\n\t\t\t\t\t\t\t\t<p class=\"ellipsis\" ng-if=\"item.DateExpires !== '9999-12-31T23:59:59.9999999Z'\">Expires {{item.DateExpires | sbSimpleDateTimeString}}</p>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.showLinkURL($event, item);$event.stopPropagation();\" style=\"margin:0;\">\r\n\t\t\t\t\t\t\t\t<md-icon class=\"material-icon\">content_copy</md-icon>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t</md-virtual-repeat-container>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\r\n\t\t\t<md-content flex=\"grow\" layout=\"column\" layout-align=\"center stretch\" ng-if=\"vm.links.length === 0\">\r\n\t\t\t\t<!-- Empty State -->\r\n\t\t\t\t<div class=\"sba__empty-state-wrap\" flex layout=\"column\" layout-align=\"center center\">\r\n\t\t\t\t\t<div class=\"sba__empty-state\" layout=\"column\" layout-align=\"center center\" ng-class=\"{'sba__empty-state---clickable': vm.canModify && vm.newLinkAction}\"\r\n\t\t\t\t\t\tng-click=\"vm.newLinkAction($event)\">\r\n\t\t\t\t\t\t<div class=\"sba__empty-state-bg\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">link</md-icon>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<h2 class=\"sba__empty-state-title\" translate>No links to this conent.</h2>\r\n\t\t\t\t\t\t<p class=\"sba__empty-state-description\" ng-if=\"vm.canModify && vm.newLinkMessage\">{{vm.newLinkMessage}}</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-content>\r\n\t\t</md-tab-content>\r\n\t</md-tab>\r\n</md-tabs>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 99 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 100 */,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(102);
	__webpack_require__(104);

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(103);
		angular
			.module('sharebase')
			.component('sbUserSelect', {
				templateUrl: templateUrl,
				controller: [
					'$q',
					'$state',
					'pxProgressService',
					'sbUsersDataStore',
					'sbUserGroupsDataStore',
					'sbDeploymentNameService',
					UserSelect
				],
				controllerAs: 'vm',
				bindings: {
					placeholder: '@',
					includeUsers: '<',
					includeUsergroups: '<',
					readonly: '<',
					required: '<',
					requiredMessage: '@',
					selected: '=',
					multiple: '<',
					deploymentId: '<'
				}
			});

		/**
		 * @ngdoc directive
		 * @name sharebase:sbUserSelect
		 * @module sharebase
		 * @restrict e
		 * @description
		 * `sbUserSelect` creates an autocompelte/chips input for selected users and/or groups.
		 *
		 * @usage
		 *
		 * <sb-user-select placholder="{{Select a user | translate}}" multiple="true" /> 
		 * 
		 * @element input
		 * @param {string=} placeholder A placeholder prompt while not typing, required for single select.
		 * @param {string=} floatLabel A label that floats above the input, only valid in non-multi select.
		 * @param {boolean=} includeUsers If true, includes users for the current deployment in the autocomplete list.
		 * @param {boolean=} includeUsergroups If true, includes usergroups for the current deployment in the autocomplete list.
		 * @param {boolean=} readonly If true, prevents selecting users/groups beyond what is provided.
		 * @param {boolean=} required If true, a valid user/group is required, only valid in non-multi select.
		 * @param {string=} requiredMessage A specific message to show on required error message, only valid in non-multi select.
		 * @param {array=} selected Pre-populates the input with a list of pre-selected choices.
		 * @param {boolean=} multiple If true, a multi select UI is used return array of selected items.
		 */
		function UserSelect($q, $state, progressService, usersDataStore, userGroupsDataStore, sbDeploymentNameService) {
			var vm = this;
			var items = [];
			var deploymentId = +(vm.deploymentId || $state.params.deploymentId || $state.params.deploymentID);
			vm.filter = filter;
			vm.checkExisting = checkExisting;
			vm.includeUsers = typeof(vm.includeUsers) === 'boolean' ? vm.includeUsers : true;
			vm.includeUsergroups = typeof(vm.includeUsergroups) === 'boolean' ? vm.includeUsergroups : true;

			setLoading(true);
			this.$onInit = function() {
				var initTasks = [];
				if (!deploymentId) {
					throw new Error('sbUserSelect must have a deploymentId');
				}
				
				sbDeploymentNameService.resolveSystemName(deploymentId)
					.then(function (systemName) {
						if(!vm.readonly) {
							if(vm.includeUsers) {
								initTasks.push(usersDataStore.getUsers(systemName));
							}

							if(vm.includeUsergroups) {
								initTasks.push(userGroupsDataStore.getUserGroups(systemName));
							}
						}

						return $q.all(initTasks);					
					})
					.then(function(tasks){
						while(tasks.length > 0) {
							items = items.concat(tasks.pop());
						}

						items.sort(function (a, b){
							var aName = a.UserGroupName || a.UserName;
							var bName = b.UserGroupName || b.UserName;

							if(aName.toLowerCase() === bName.toLowerCase()) {
								return 0;
							} 
							else {
								return aName.toLowerCase() > bName.toLowerCase() ? 1 : -1;
							}
						});
					})	
					.finally(setLoading);
			};

			function filter(phrase) {
				var result = [];

				if (typeof(phrase) === 'string'  || phrase.length > 0) { 
					phrase = phrase.toLowerCase();
					result = items.filter(function(item) {
						var name = (item.UserName ? item.UserName + ' ' + item.EmailAddress : item.UserGroupName).toLowerCase();
						return name.indexOf(phrase) > -1;
					});				
				}
				
				return result;			
			}
			
			function checkExisting(chip) {
				var chipName = chip.UserName || chip.UserGroupName;
				var name;
				var selectedItem;
				for (var i = 0; i < vm.selected.length; i++) {
					selectedItem = vm.selected[i];
					name = selectedItem.UserName || selectedItem.UserGroupName;
					if(chipName === name) {
						return null;
					}
				}
			}

			function setLoading(isLoading) {
				isLoading = typeof(isLoading) === 'boolean' ? isLoading : false;
				vm.loading = progressService.visible = isLoading;
			}
		}
	})();

/***/ },
/* 103 */
/***/ function(module, exports) {

	var path = 'sharebase/components/userSelect/userSelect.template.html';
	var html = "<md-chips ng-if=\"vm.multiple\"\r\n\t\tng-model=\"vm.selected\" \r\n\t\tmd-autocomplete-snap\r\n\t\tpx-chips-clear-on-blur\r\n\t\tpx-chips-disable-delete-key\r\n\t\treadonly=\"vm.readonly\"\r\n\t\tmd-require-match=\"true\"\r\n\t\tmd-transform-chip=\"vm.checkExisting($chip)\">\r\n\t<md-autocomplete\r\n\t\tmd-select-on-match=\"true\"\r\n\t\tmd-match-case-insensitive=\"true\"\r\n\t\tmd-search-text=\"vm.searchText\"\r\n\t\tmd-items=\"item in vm.filter(vm.searchText)\"\r\n\t\tmd-item-text=\"item.UserName || item.UserGroupName\"\r\n\t\tmd-min-length=\"1\"\r\n\t\tng-attr-placeholder=\"{{vm.placeholder}}\"\r\n\t\tmd-menu-class=\"sba-users-item-template\">\r\n\t\t<md-item-template class=\"md-block\">\r\n\t\t\t<span layout=\"column\" layout-align=\"start start\">\r\n\t\t\t\t<span class=\"item-title\" md-highlight-flags=\"gi\" md-highlight-text=\"vm.searchText\">\r\n\t\t\t\t\t {{item.UserName || item.UserGroupName}}\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"item-stat\" ng-if=\"item.UserId\"  md-highlight-flags=\"gi\" md-highlight-text=\"vm.searchText\">\r\n\t\t\t\t\t{{item.EmailAddress}}\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"item-stat\" ng-if=\"item.UserGroupId\">\r\n\t\t\t\t\t{{item.UserCount}} users in group\r\n\t\t\t\t</span>\r\n\t\t\t</span>\r\n\t\t</md-item-template>\r\n\t\t<md-not-found>\r\n\t\t\tNo matches found.\r\n\t\t</md-not-found>\r\n\t</md-autocomplete>\r\n\t<md-chip-template>\r\n\t\t<span ng-if=\"$chip.UserId\">\r\n\t\t\t<md-icon class=\"material-icons\">person</md-icon>\r\n\t\t\t<span>{{$chip.UserName}}</span>\r\n\t\t</span>\r\n\t\t<span ng-if=\"$chip.UserGroupId\">\r\n\t\t\t<md-icon class=\"material-icons\">people</md-icon>\r\n\t\t\t<span>{{$chip.UserGroupName}}</span>\r\n\t\t</span>\r\n\t</md-chip-template>\r\n</md-chips>\r\n\r\n<md-autocomplete ng-if=\"!vm.multiple\"\r\n\t\t\t\t ng-readonly=\"{{vm.readonly}}\"\r\n\t\t\t\t ng-required=\"{{vm.required}}\"\r\n\t\t\t\t md-select-on-match=\"true\"\r\n\t\t\t\t md-match-case-insensitive=\"true\"\r\n\t\t\t\t md-input-name=\"userAutocomplete\"\r\n\t\t\t\t md-selected-item=\"vm.selected\"\r\n\t\t\t\t md-search-text=\"vm.searchText\"\r\n\t\t\t\t md-items=\"item in vm.filter(vm.searchText)\"\r\n\t\t\t\t md-item-text=\"item.UserName || item.UserGroupName\"\r\n\t\t\t\t md-min-length=\"1\"\r\n\t\t\t\t md-floating-label=\"{{vm.placeholder}}\"\r\n\t\t\t\t ng-attr-placeholder=\"{{vm.placeholder}}\"\r\n\t\t\t\t md-menu-class=\"sba-users-item-template\"\r\n\t\t\t\t px-autocomplete-clear-on-blur>\r\n\t<md-item-template class=\"md-block\">\r\n\t\t<span layout=\"column\" layout-align=\"start start\">\r\n\t\t\t<span class=\"item-title\" md-highlight-flags=\"gi\" md-highlight-text=\"vm.searchText\">\r\n\t\t\t\t{{item.UserName || item.UserGroupName}}\r\n\t\t\t</span>\r\n\t\t\t<span class=\"item-stat\" ng-if=\"item.UserId\" md-highlight-flags=\"gi\" md-highlight-text=\"vm.searchText\">\r\n\t\t\t\t{{item.EmailAddress}}\r\n\t\t\t</span>\r\n\t\t\t<span class=\"item-stat\" ng-if=\"item.UserGroupId\">\r\n\t\t\t\t{{item.UserCount}} users in group\r\n\t\t\t</span>\r\n\t\t</span>\r\n\t</md-item-template>\r\n\t<md-not-found class=\"md-block\">\r\n\t\tNo matches found.\r\n\t</md-not-found>\r\n\t<div class=\"sba-user-select__errors\" ng-messages=\"{'required': vm.required}\" role=\"alert\">\r\n\t\t<div ng-message=\"required\">\r\n\t\t\t{{vm.requiredMessage || 'Please select a valid value from the list.' | translate}}\r\n\t\t</div>\r\n\t</div>\r\n</md-autocomplete>\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 104 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 105 */,
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107);
	__webpack_require__(108);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);

/***/ },
/* 107 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUserDataStore
		* 
		* @description 
		* A datastore used to retrieve and interact with a ShareBase user
		**/

		angular
			.module('sharebase')
			.factory('sbUserDataStore', [
				'$q',
				'sbUserService',
				UserDataStore
			]);

		function UserDataStore($q, sbUserService) {
			var _user = null;
			var _startState = null;
			var _newUser = {
				'UserName': null,
				'EmailAddress': null,
				'Password': null,
				'Embedded': {
					'Roles': [],
					'AdministratorOfDeploymentGroups': [],
					'Deployment' : {
						'Embedded': {
							'DeploymentGroup' : {}
						}
					}
				}
			};

			var service = {
				/**
				* @ngdoc method
				* @name sbUserDataStore#getUser
				* @methodOf sharebase.sbUserDataStore
				* @kind function
				*
				* @description
				* Gets a user
				*
				* @returns {Deferred} A promise that will resolve with a user
				* 
				*/
				getUser: getUser,

				/**
				* @ngdoc method
				* @name sbUserDataStore#addUser
				* @methodOf sharebase.sbUserDataStore
				* @kind function
				*
				* @description
				* Adds a new user
				*
				* @returns {Deferred} A promise that will resolve with a new user
				* 
				*/
				addUser: addUser,

				/**
				* @ngdoc method
				* @name sbUserDataStore#removeUser
				* @methodOf sharebase.sbUserDataStore
				* @kind function
				*
				* @description
				* Deletes a user and transfers content to another user
				*
				* @returns {Deferred} A promise that will resolve with status result
				* 
				*/
				removeUser: removeUser,

				/**
				* @ngdoc method
				* @name sbUserDataStore#addEditGroupAdmin
				* @methodOf sharebase.sbUserDataStore
				* @kind function
				*
				* @description
				* Adds a new Administrator (Tenant/DeploymentGroup)
				*
				* @returns {Deferred} A promise that will resolve with a new Administrator (Tenant/DeploymentGroup)
				* 
				*/
				updateTenantAdminRights: updateTenantAdminRights,

				/**
				* @ngdoc method
				* @name sbUserDataStore#updateUser
				* @methodOf sharebase.sbUserDataStore
				* @kind function
				*
				* @description
				* Gets an updated user
				*
				* @returns {Deferred} A promise that will resolve with an updated user
				* 
				*/
				updateUser: updateUser,

				/**
				* @ngdoc method
				* @name sbUserDataStore#lockUser
				* @methodOf sharebase.sbUserDataStore
				* @kind function
				*
				* @description
				* Locks a user
				*
				* @returns {Deferred} A promise that will resolve
				* 
				*/
				lockUser: lockUser,

				/**
				* @ngdoc method
				* @name sbUserDataStore#unlockUser
				* @methodOf sharebase.sbUserDataStore
				* @kind function
				*
				* @description
				* Unlocks a user
				*
				* @returns {Deferred} A promise that will resolve
				* 
				*/
				unlockUser: unlockUser,

				/**
				* @ngdoc property
				* @name sbUserDataStore#user
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* A user
				* 
				* @returns {object} A user
				*/
				get user() { return _user; },
				/**
				* @ngdoc property
				* @name sbUserDataStore#isTenantAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Set user tenant admin role
				*/
				set isTenantAdmin(val) { setTenantAdmin(val); },
				/**
				* @ngdoc property
				* @name sbUserDataStore#isTenantAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Get user tenant admin role
				*/
				get isTenantAdmin() { return _user ? _user.Embedded.Roles.indexOf('TenantAdmin') > -1 : false; },
				/**
				* @ngdoc property
				* @name sbUserDataStore#deploymentGroupsAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Set the deployment groups for this user administers.
				* 
				*/
				set deploymentGroupAdmin(val) { setDeploymentGroupAdmin(val); },
				/**
				* @ngdoc property
				* @name sbUserDataStore#deploymentGroupsAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Get the deployment groups for this user administers.
				* 
				* @returns {array} A deployment group.
				*/
				get deploymentGroupAdmin() { return _user ? _user.Embedded.AdministratorOfDeploymentGroups[0] : null; },
				/**
				* @ngdoc property
				* @name sbUserDataStore#isSiteAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Set user site admin role
				*/
				set isSiteAdmin(val) { setSiteAdmin(val);},
				
				/**
				* @ngdoc property
				* @name sbUserDataStore#isSiteAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Get user site admin role
				*/
				get isSiteAdmin() { return _user ? _user.Embedded.Roles.indexOf('SiteAdmin') > -1 : false;},
				/**
				* @ngdoc property
				* @name sbUserDataStore#isUsereAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Set user user admin role
				*/
				set isUserAdmin(val) { setUserAdmin(val);},
				
				/**
				* @ngdoc property
				* @name sbUserDataStore#isUsereAdmin
				* @propertyOf sharebase.sbUserDataStore
				* @kind property
				*
				* @description
				* Get user user admin role
				*/
				get isUserAdmin() { return _user ? _user.Embedded.Roles.indexOf('UserAdmin') > -1 : false;}
			};

			return service;

			function getUser(userId, deploymentId) {
				var p = $q.resolve(angular.copy(_newUser));

				if (userId) {
					p = sbUserService.getUser(userId, deploymentId).then(function (response) {
						//clean duplicate roles
						response.Embedded.Roles = response.Embedded.Roles.filter(function (v, i, a) { 
							return a.indexOf(v) === i; 
						});
						return response;
					});
				}

				return p.then(function(user){
					_user = user;
					_startState = angular.copy(_user);
					return user;
				});
			}

			function addUser(user, deploymentId) {
				return sbUserService.addUser(user, deploymentId).then(function (response) {
					return response;
				});
			}

			function removeUser(user, deploymentId, transferUser, forceDelete) {
				return sbUserService.removeUser(user, deploymentId, transferUser, forceDelete).then(function (response) {
					return response;
				});
			}

			function updateTenantAdminRights() {
				var depGroup = _user.Embedded.AdministratorOfDeploymentGroups[0];
				var startDepGroup = _startState.Embedded.AdministratorOfDeploymentGroups[0];
				var rightChanged = !angular.equals(depGroup, startDepGroup);  
				var p = $q.resolve();

				if(rightChanged) {
					if (service.isTenantAdmin) {
						if(startDepGroup) {
							p = sbUserService.removeGroupAdmin(startDepGroup.DeploymentGroupId, service.user.UserId);
						}
						
						p = p.then(function(){
							return sbUserService.addEditGroupAdmin(depGroup.DeploymentGroupId, service.user);
						}); 				
					}
					else {
						_user.Embedded.AdministratorOfDeploymentGroups = [];
						p = sbUserService.removeGroupAdmin((depGroup || startDepGroup).DeploymentGroupId, service.user.UserId);
					}
				}

				return p;
			}

			function updateUser(user, deploymentId) {
				return sbUserService.updateUser(user, deploymentId).then(function (response) {
					return response;
				});
			}

			function lockUser(userId, deploymentId) {
				return sbUserService.lockUser(userId, deploymentId).then(function (response) {
					return response;
				});
			}

			function unlockUser(userId, deploymentId) {
				return sbUserService.unlockUser(userId, deploymentId).then(function (response) {
					return response;
				});
			}

			function setTenantAdmin(val) {
				var index = _user.Embedded.Roles.indexOf('TenantAdmin');
				val = typeof(val) === 'boolean' ? val : false;
				
				if (val && index < 0) {
					// add role
					_user.Embedded.Roles.push('TenantAdmin');

				}
				else if (!val && index >= 0) {
					// remove role
					_user.Embedded.Roles.splice(index, 1);
				}
			}

			function setDeploymentGroupAdmin(val) {
				_user.Embedded.AdministratorOfDeploymentGroups = typeof(val) === 'undefined' || val === null ? [] : [val];
			}

			function setSiteAdmin(val) {
				var index = _user.Embedded.Roles.indexOf('SiteAdmin');
				if (!val && index > -1) {
					//remove role
					_user.Embedded.Roles.splice(index, 1);
					return;
				}

				if (val && index === -1) {
					//add role
					_user.Embedded.Roles.push('SiteAdmin');
					return;
				}
			}

			function setUserAdmin(val) {
				var index = _user.Embedded.Roles.indexOf('UserAdmin');
				if (!val && index > -1) {
					//remove role
					_user.Embedded.Roles.splice(index, 1);
					return;
				}

				if (val && index === -1) {
					//add role
					_user.Embedded.Roles.push('UserAdmin');
					return;
				}
			}
		}

	})();

/***/ },
/* 108 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUserGroupDataStore
		* 
		* @description 
		* A datastore used to retrieve and interact with a ShareBase user group
		**/

		angular
			.module('sharebase')
			.factory('sbUserGroupDataStore', [
				'$q',
				'$filter',
				'sbUserGroupService',
				UserGroupDataStore
			]);

		function UserGroupDataStore($q, $filter, sbUserGroupService) {
			var _userGroup = [];
			var _userGroupPolicy = {};
			
			/* eslint-disable no-shadow */
			var UserGroup = (function() {

				function UserGroup(id, name, users, isSystemGroup) {
					if (users && users.length > 0) {
						users = $filter('orderBy')(users, 'UserName');
					}
					this.id = id || null;
					this.name = name || '';
					this.users = users || [];
					this.policy = {};
					this.isSystemGroup = isSystemGroup;
				}
				
				UserGroup.prototype.toServer = function() {
					return {
						UserGroupId: this.id,
						UserGroupName: this.name,
						Embedded: {
							Users : this.users
						}					
					};
				};

				UserGroup.prototype.containsUser = function(user) {
					var contains = false;
					for (var i = 0; i < this.users.length; i++) {
						if (this.users[i].UserId === user.UserId) {
							contains = true;
							break;
						}
					}
					return contains;
				};

				return UserGroup;
			})();
			/* eslint-enable no-shadow */

			return {
				/**
				* @ngdoc method
				* @name sbUserGroupDataStore#getUserGroup
				* @methodOf sharebase.sbUserGroupDataStore
				* @kind function
				*
				* @description
				* Gets a user group
				*
				* @returns {Deferred} A promise that will resolve with a user group
				* 
				*/
				getUserGroup: getUserGroup,

				/**
				* @ngdoc method
				* @name sbUserGroupDataStore#getUserGroupPolicy
				* @methodOf sharebase.sbUserGroupDataStore
				* @kind function
				*
				* @description
				* Gets a user group's sharing policy
				*
				* @returns {Deferred} A promise that will resolve with a user group sharing policy
				* 
				*/

				getUserGroupPolicy: getUserGroupPolicy,
				/**
				* @ngdoc method
				* @name sbUserGroupDataStore#saveUserGroup
				* @methodOf sharebase.sbUserGroupDataStore
				* @kind function
				*
				* @description
				* Saves a UserGroup
				*
				* @returns {Deferred} A promise that will resolve with a saved user group
				* 
				*/
				saveUserGroup: saveUserGroup,
				
				/**
				* @ngdoc method
				* @name sbUserGroupDataStore#saveUserGroupPolicy
				* @methodOf sharebase.sbUserGroupDataStore
				* @kind function
				*
				* @description
				* Saves a UserGroup Policy
				*
				* @returns {Deferred} A promise that will resolve with a saved user group policy
				* 
				*/
				saveUserGroupPolicy: saveUserGroupPolicy,
				/**
				* @ngdoc method
				* @name sbUserGroupDataStore#containsUser
				* @methodOf sharebase.sbUserGroupDataStore
				* @kind function
				*
				* @description
				* Determines whether a user exists in the user group's collection of users
				*
				* @returns {boolean} A boolean represnetation of a user's existance in the user group's collection of users
				* 
				*/
				containsUser: function(user){
					return _userGroup.contains(user);
				},

				/**
				* @ngdoc property
				* @name sbUserGroupDataStore#userGroup
				* @propertyOf sharebase.sbUserGroupDataStore
				* @kind property
				*
				* @description
				* A user group
				* 
				* @returns {object} A user group
				*/
				get userGroup() { return _userGroup; },
				/**
				* @ngdoc property
				* @name sbUserGroupDataStore#userGroupPolicy
				* @propertyOf sharebase.sbUserGroupDataStore
				* @kind property
				*
				* @description
				* A user group
				* 
				* @returns {object} A user group policy
				*/
				get userGroupPolicy() { return _userGroupPolicy; },
				
			};

			function getUserGroup(userGroupId, systemName) {
				var p;

				if (!userGroupId) {
					_userGroup = new UserGroup();
					_userGroupPolicy = {};
					p = $q.resolve(_userGroup);
				}
				else {
					p = sbUserGroupService
						.getUserGroup(userGroupId, systemName)
						.then(function (response) {
							_userGroup = toGroup(response);
							return _userGroup;
						});
				}

				return p;
			}

			function getUserGroupPolicy(userGroupId) {
				return sbUserGroupService
					.getUserGroupPolicy(userGroupId)
					.then(function (response) {
						if (response.MaxLinkExpirationDays === 9223372036854775807) {
							response.MaxLinkExpirationDays = null;
						}
						_userGroupPolicy = response;
						return response;
					});
			}

			function saveUserGroup(systemName) {
				if(_userGroup.isSystemGroup) {
					return $q.reject(new Error('System groups cannot be edited'));
				}

				if (_userGroup.id) {
					return sbUserGroupService
						.updateUserGroup(_userGroup.toServer(), systemName)
						.then(function (response) {
							_userGroup = toGroup(response);
							return _userGroup;
						});
				}
				else {
					return sbUserGroupService
						.addUserGroup(_userGroup.toServer(), systemName)
						.then(function (response) {
							_userGroup = toGroup(response);
							return _userGroup;
						});
				}
			}

			function saveUserGroupPolicy(userGroupPolicy) {
				userGroupPolicy.UserGroupId = userGroupPolicy.UserGroupId || _userGroup.Id;
				if (userGroupPolicy.MaxLinkExpirationDays === null) {
					userGroupPolicy.MaxLinkExpirationDays = '9223372036854775807';
				}

				return sbUserGroupService
					.updateUserGroupPolicy(userGroupPolicy)
					.then(function (response) {
						_userGroupPolicy = response;
						return _userGroupPolicy;
					});
			}

			function toGroup(resp) {
				return new UserGroup(resp.UserGroupId, resp.UserGroupName, resp.Embedded.Users, resp.IsSystemGroup);
			}
		}
	})();

/***/ },
/* 109 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUserGroupsDataStore
		* 
		* @description 
		* A datastore used to retrieve ShareBase user groups
		**/

		angular
			.module('sharebase')
			.factory('sbUserGroupsDataStore',
			[
				'$filter',
				'sbUserGroupsService',
				UserGroupsDataStore
			]);

		function UserGroupsDataStore($filter, sbUserGroupsService) {
			var _userGroups = [];

			return {
				/**
				* @ngdoc method
				* @name sbUserGroupsDataStore#getUserGroups
				* @methodOf sharebase.sbUserGroupsDataStore
				* @kind function
				*
				* @description
				* Gets a collection of user groups
				*
				* @returns {Deferred} A promise that will resolve with a collection of user groups
				* 
				*/
				getUserGroups: getUserGroups,

				/**
				* @ngdoc property
				* @name sbUserGroupsDataStore#userGroups
				* @propertyOf sharebase.sbUserGroupsDataStore
				* @kind property
				*
				* @description
				* A collection of user groups
				* 
				* @returns {array} An array of user groups
				*/
				get userGroups() { return _userGroups; }
			};

			function getUserGroups(systemName) {
				return sbUserGroupsService
					.getUserGroups(systemName)
					.then(function (response) {
						_userGroups = $filter('orderBy')(response, 'UserGroupName');
						return response;
					});
			}
		}

	})();

/***/ },
/* 110 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUsersDataStore
		* 
		* @description 
		* A datastore used to retrieve ShareBase users
		**/

		angular
			.module('sharebase')
			.factory('sbUsersDataStore',
			[
				'$filter',
				'sbUsersService',
				UsersDataStore
			]);

		function UsersDataStore($filter, sbUsersService) {
			var _users = [];
			var _pendingUsers = [];

			return {
				/**
				* @ngdoc method
				* @name sbUsersDataStore#getUsers
				* @methodOf sharebase.sbUsersDataStore
				* @kind function
				*
				* @description
				* Gets a collection of users
				*
				* @returns {Deferred} A promise that will resolve with a collection of users
				* 
				*/
				getUsers: getUsers,

				/**
				* @ngdoc property
				* @name sbUsersDataStore#users
				* @propertyOf sharebase.sbUsersDataStore
				* @kind property
				*
				* @description
				* A collection of users
				* 
				* @returns {array} An array of users
				*/
				get users() { return _users; },
				set users(users) {_users = users;},
				/**
				* @ngdoc method
				* @name sbUsersDataStore#getPendingUsers
				* @methodOf sharebase.sbUsersDataStore
				* @kind function
				*
				* @description
				* Gets a collection of pending users
				*
				* @returns {Deferred} A promise that will resolve with a collection of pending users
				* 
				*/
				getPendingUsers: getPendingUsers,

				/**
				* @ngdoc property
				* @name sbUsersDataStore#pendingUsers
				* @propertyOf sharebase.sbUsersDataStore
				* @kind property
				*
				* @description
				* A collection of pending users
				* 
				* @returns {array} An array of pending users
				*/
				get pendingUsers() { return _pendingUsers; }
			};

			function getUsers(systemName) {
				return sbUsersService
					.getUsers(systemName)
					.then(function (response) {
						_users = $filter('orderBy')(response, 'UserName');
						return response;
					});
			}

			function getPendingUsers() {
				return sbUsersService
					.getPendingUsers()
					.then(function (response) {
						_pendingUsers = $filter('orderBy')(response, 'EmailAddress');
						return response;
					});
			}
		}

	})();

/***/ },
/* 111 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('sharebase')
			.factory('sbDeletedItemsDataStore', [
				'$filter',
				'sbDeletedItemsService',
				DeletedItemsDataStore]);

		/**
		* @ngdoc service
		* @name  sharebase-app.sbDeletedItemsDataStore
		* 
		* @description 
		* A datastore used to interact with user's trash.
		* 
		**/
		function DeletedItemsDataStore($filter, sbDeletedItemsService) {

			var _trash = [];
			return {
				/**
				* @ngdoc method
				* @name sbDeletedItemsDataStore#load
				* @methodOf sharebase-app.sbDeletedItemsDataStore
				* @kind function
				*
				* @description
				* Loads or refreshes a selected folder
				* 
				* @param {object} folderId A Folder ID
				*
				* @returns {Deferred} A promise that will resolve with a selected folder
				*/
				load: loadDeletedItems,

				/**
				* @ngdoc property
				* @name sbDeletedItemsDataStore#deletedItems
				* @propertyOf sharebase-app.sbDeletedItemsDataStore
				* @kind property
				*
				* @description
				* A user's recent documents
				* 
				* @returns {array} An array of recent documents
				*/
				get deletedItems() { return _trash; },
			};

			function loadDeletedItems() {
				_trash = [];
				var docs = [];
				var folders = [];
				return sbDeletedItemsService
					.getDeletedItems()
					.then(function (deletedItems) {

						_trash = deletedItems.map(function (item) {
							var delDate = item.DateDeleted;
							item = item.Embedded.Document ? item.Embedded.Document : item.Embedded.Folder;
							item.DateDeleted = delDate;
							if(item.DocumentId){
								docs.push(item);
							}
							else{
								folders.push(item);
							}
							return item;
						});

						_trash = folders.concat(docs);

						return _trash;
					});
			}
		}
	})();

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(113);

/***/ },
/* 113 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('sharebase')
			.filter('sbSimpleDateTimeString', [SimpleDateTimeString]);

		/**
		* @ngdoc filter
		* @name sharebase.filter:sbSimpleDateTimeString
		* @kind function
		* 
		* @description
		*  Converts date time into a simple representation
		*
		* @param {string|number} datetime in string or ticks.
		* 
		*/
		function SimpleDateTimeString() {
			//TODO add to translation
			var DAYS = ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'];
			var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

			return function toSimpleString(val) {
				var today = setDayOnly();
				var dateToFilter;
				var weekAgo = new Date();
				weekAgo.setDate(today.getDate() - 7);
				
				if (val == null) {
					return val;
				}
				else {
					dateToFilter = new Date(val);
				}
				if (dateToFilter) {
					var date = new Date(dateToFilter);
					date = setDayOnly(date);
					var time = readableTime(dateToFilter.getHours(), dateToFilter.getMinutes());
					if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
						//just the time IE: 3:30pm
						return time;
					}
					else if (date < today && date > weekAgo) {
						//just the day of week and time IE: Mon 3:30pm
						return DAYS[date.getDay()] + ' ' + time;
					}
					else {
						//just the short month name and day of month IE: Jan 23
						return MONTHS[date.getMonth()] + ' ' + date.getDate();
					}
				}

				return val;

			};

			function setDayOnly(date) {
				if (!date) {
					date = new Date();
				}

				date.setHours(0);
				date.setMinutes(0);
				date.setSeconds(0);
				return date;
			}
			function readableTime(hours, minutes) {
				var AMPM = hours >= 12 ? 'PM' : 'AM';
				hours = hours % 12;
				hours = hours ? hours : 12;
				minutes = minutes < 10 ? '0' + minutes : minutes;
				return hours + ':' + minutes + ' ' + AMPM;
			}
		}

	}());

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(128);
	__webpack_require__(129);
	__webpack_require__(130);

/***/ },
/* 115 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbDeletedItemsService
		* 
		* @description 
		* A service used to retrieve user's deleted documents and folders
		*
		**/

		angular.module('sharebase')
			.factory('sbDeletedItemsService', [
				'$http',
				'settingsService',
				DeletedItemsFactory]);

		function DeletedItemsFactory($http, settingsService) {

			return {
				/**
				* @ngdoc method
				* @name sbDeletedItemsService#getDeletedItems
				* @methodOf sharebase.sbDeletedItemsService
				* @kind function
				*
				* @description
				* Gets the deleted items for a user
				* 
				* @returns {Deferred} A promise that will resolve with an
				* array of deleted items
				* 
				*/
				getDeletedItems: getDeletedItems
			};
			
			function getDeletedItems() {
				return $http.get(settingsService.serverAPIPath + '/trash/')
					.then(function (response) {
						return response.data;
					});
			}
		}
	})();

/***/ },
/* 116 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		/**
		* @ngdoc service
		* @name sharebase.services.sbDeploymentService
		* @requires $http
		* @requires pxAuthService
		* @requires settingsService
		* @description
		* A service used to retrieve the details of a deployment.
		**/
		angular
			.module('sharebase.services')
			.factory('sbDeploymentService', [
				'$http',
				'pxAuthService',
				'settingsService',
				DeploymentService
			]);

		function DeploymentService($http, authService, settingsService) {
			var deploymentsEndpoint = settingsService.serverAPIPath + '/admin/deployments';
			return {
				/**
				* @ngdoc method
				* @name sbDeploymentService#createDeployment
				* @methodOf sharebase.services.sbDeploymentService
				* @kind function
				*
				* @description
				* Creates a new active deployment.
				*
				* @returns {Deferred} A promise that will resolve with the new deployment information.
				* 
				*/
				createDeployment: createDeployment,
				/**
				* @ngdoc method
				* @name sbDeploymentService#updateDeployment
				* @methodOf sharebase.services.sbDeploymentService
				* @kind function
				*
				* @description
				* Updates the details of a ShareBase deployment.
				*
				* @returns {Deferred} A promise that will resolve with the updated deployment information.
				* 
				*/
				updateDeployment: updateDeployment,
				/**
				* @ngdoc method
				* @name sbDeploymentService#getDetails
				* @methodOf sharebase.services.sbDeploymentService
				* @kind function
				*
				* @description
				* Retrieves details of a ShareBase deployment.
				*
				* @returns {Deferred} A promise that will resolve with the details of a deployment.
				* 
				*/
				getDetails: getDetails,
				/**
				* @ngdoc method
				* @name sbDeploymentService#getSettings
				* @methodOf sharebase.services.sbDeploymentService
				* @kind function
				*
				* @description
				* Retrieves settings of a ShareBase deployment.
				*
				* @returns {Deferred} A promise that will resolve with the settings of a deployment.
				* 
				*/
				getSettings: getSettings,
				/**
				* @ngdoc method
				* @name sbDeploymentService#updateSettings
				* @methodOf sharebase.services.sbDeploymentService
				* @kind function
				*
				* @description
				* Updates the settings of a ShareBase deployment.
				*
				* @returns {Deferred} A promise that will resolve with the updated deployment settings.
				* 
				*/
				updateSettings: updateSettings
			};

			function createDeployment(name, dbServer, dbName, dbLocation, fileLocation, systemName) {
				var deployment = normalizeDeploymentData(name, dbServer, dbName, dbLocation, fileLocation, systemName); 
				return $http.post(deploymentsEndpoint, deployment)
					.then(function (response) {
						return response.data;
					});
			}

			function updateDeployment(deploymentId, name, dbServer, dbName, dbLocation, fileLocation) {
				var deployment = normalizeDeploymentData(name, dbServer, dbName, dbLocation, fileLocation);
				return $http.patch(deploymentsEndpoint + '/' + deploymentId, deployment)
					.then(function (response) {
						return response.data;
					});
			}

			function getDetails(deploymentId) {
				return $http.get(deploymentsEndpoint + '/' + deploymentId)
					.then(function (resp) {
						return resp.data;
					});
			}

			function getSettings(deploymentId) {
				return $http.get(deploymentsEndpoint + '/' + deploymentId + '/settings')
					.then(function (resp) {
						return resp.data;
					});
			}

			function updateSettings(deploymentId, settings) {
				return $http.patch(deploymentsEndpoint + '/' + deploymentId + '/settings', settings)
					.then(function (resp) {
						return resp.data;
					});
			}
		}	

		// normalize passing data as a bag or individual properties
		function normalizeDeploymentData(name, dbServer, dbName, dbLocation, fileLocation, systemName) {
			var data = angular.isObject(arguments[0]) ? arguments[0] : {};
			return {
				CustomerIdentifier: data.CustomerIdentifier,
				Name: typeof (data.Name) === 'string' ? data.Name : name,
				SystemName  : typeof (data.SystemName) === 'string' ? data.SystemName : systemName,
				DatabaseName: data.DatabaseName || dbName,
				DatabaseServer: data.DatabaseServer || dbServer,
				DatabaseRootPath: data.DatabaseRootPath || dbLocation,
				DiskgroupRootPath: data.DisgroupRootPath || fileLocation
			};
		}
	})();

/***/ },
/* 117 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbDocumentDetailService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase
		* document details
		**/

		angular
			.module('sharebase')
			.factory('sbDocumentDetailService', [
				'$http',
				'settingsService',
				'sbDocumentService',
				sbDocumentDetailService]);

		function sbDocumentDetailService($http, settingsService, sbDocumentService) {

			return {
				/**
				* @ngdoc method
				* @name sbDocumentDetailService#getDocumentDetails
				* @methodOf sharebase.sbDocumentDetailService
				* @kind function
				*
				* @description
				* Gets a specific document's details to the user
				* 
				* @param {object} documentId A Document ID
				*
				* @returns {Deferred} A promise that will resolve with a document's details
				* 
				*/
				getDocumentDetails: getDocumentDetails,

				/**
				* @ngdoc method
				* @name sbDocumentDetailService#getActivities
				* @methodOf sharebase.sbDocumentDetailService
				* @kind function
				*
				* @description
				* Gets a specific document's activities to the user
				* 
				* @param {object} documentId A Document ID
				*
				* @returns {Deferred} A promise that will resolve with a document's activities
				* 
				*/
				getActivities: getActivities,

				/**
				* @ngdoc method
				* @name sbDocumentDetailService#getComments
				* @methodOf sharebase.sbDocumentDetailService
				* @kind function
				*
				* @description
				* Gets a specific document's comments to the user
				* 
				* @param {object} documentId A Document ID
				*
				* @returns {Deferred} A promise that will resolve with a document's comments
				* 
				*/
				getComments: getComments,
				
				/**
				* @ngdoc method
				* @name sbDocumentDetailService#getVersions
				* @methodOf sharebase.sbDocumentDetailService
				* @kind function
				*
				* @description
				* Gets a specific document's versions to the user
				* 
				* @param {object} documentId A Document ID
				*
				* @returns {Deferred} A promise that will resolve with a document's versions
				* 
				*/
				getVersions: getVersions,

				/**
				* @ngdoc method
				* @name sbDocumentDetailService#getSharedLinks
				* @methodOf sharebase.sbDocumentDetailService
				* @kind function
				*
				* @description
				* Gets a specific document's shared links to the user
				* 
				* @param {object} documentId A Document ID
				*
				* @returns {Deferred} A promise that will resolve with a document's shared links
				* 
				*/
				getSharedLinks: getSharedLinks,

				/**
				* @ngdoc method
				* @name sbDocumentDetailService#getSharedUsers
				* @methodOf sharebase.sbDocumentDetailService
				* @kind function
				*
				* @description
				* Gets a specific document's shared users to the user
				* 
				* @param {object} documentId A Document ID
				*
				* @returns {Deferred} A promise that will resolve with a document's shared users
				* 
				*/
				getSharedUsers: getSharedUsers
			};

			function getDocumentDetails(documentId) {
				return sbDocumentService.getDocument(documentId)
					.then(function (response) {
						var results = {
							dateCreated: response.Embedded.Document.DateCreated,
							dateModified: response.Embedded.Document.DateModified,
							fileFormat: response.Embedded.Document.FileFormat,
							fileSize: response.Embedded.Document.FileSize,
							owner: response.Embedded.Document.Owner
						};

						return results;
					});
			}

			function getActivities(documentId) {
				return $http.get(settingsService.serverAPIPath + '/documents/' + documentId + '/activities')
					.then(function (response) {
						return response.data;
					});
			}

			function getComments(documentId) {
				return $http.get(settingsService.serverAPIPath + '/documents/' + documentId + '/comments')
					.then(function (response) {
						return response.data;
					});
			}

			function getVersions(documentId) {
				return $http.get(settingsService.serverAPIPath + '/documents/' + documentId + '/revisions')
					.then(function (results) {
						return results.data;
					});
			}
			
			function getSharedLinks(documentId) {
				return $http.get(settingsService.serverAPIPath + '/documents/' + documentId + '/shares/all')
					.then(function (response) {
						return response.data;
					});
			}

			function getSharedUsers(documentId) {
				return $http.get(settingsService.serverAPIPath + '/documents/' + documentId + '/permissions')
					.then(function (response) {
						return response.data;
					});
			}
		}

	})();

/***/ },
/* 118 */
/***/ function(module, exports) {

	"use strict";
	(function () {
	    'use strict';
	    /**
	    * @ngdoc service
	    * @name  sharebase.sbDocumentService
	    *
	    * @description
	    * A service used to retrieve and interact with ShareBase
	    * documents
	    **/
	    angular
	        .module('sharebase')
	        .factory('sbDocumentService', [
	        '$http',
	        'pxUriPathService',
	        'settingsService',
	        DocumentFactory]);
	    function DocumentFactory($http, pxUriPathService, settingsService) {
	        return {
	            /**
	            * @ngdoc method
	            * @name sbDocumentService#getDocument
	            * @methodOf sharebase.sbDocumentService
	            * @kind function
	            *
	            * @description
	            * Gets a specific document to the user
	            *
	            * @param {object} documentId A Document ID
	            *
	            * @returns {Deferred} A promise that will resolve with a document
	            *
	            */
	            getDocument: getDocument,
	            /**
	            * @ngdoc method
	            * @name sbDocumentService#deleteDocument
	            * @methodOf sharebase.sbDocumentService
	            * @kind function
	            *
	            * @description
	            * Delete the document with the specified ID
	            *
	            * @param {int} documentId A Document ID
	            *
	            * @param {bool} purge Will purge the document with the specified ID if true.
	            *
	            * @returns {Deferred} A promise that will resolve if the document is successfully deleted.
	            *
	            */
	            deleteDocument: deleteDocument,
	            /**
	            * @ngdoc method
	            * @name sbDocumentService#getShares
	            * @methodOf sharebase.sbDocumentService
	            * @kind function
	            *
	            * @description
	            * Gets a specific document to the user
	            *
	            * @param {object} documentId A Document ID
	            *
	            * @returns {Deferred} A promise that will resolve with a document's shares
	            *
	            */
	            getShares: getShares,
	            /**
	            * @ngdoc method
	            * @name sbDocumentService#savePermissions
	            * @methodOf sharebase.sbDocumentService
	            * @kind function
	            *
	            * @description
	            * Sets permissions for the specified library ID.
	            *
	            * @param {libraryId} ID of the library to set permissions for.
	            *
	            * @param {acls} Array of ACLs to set for the library.
	            *
	            * @returns {Deferred} An $http promise.
	            *
	            */
	            savePermissions: savePermissions,
	            /**
	            * @ngdoc method
	            * @name sbDocumentService#getPermissions
	            * @methodOf sharebase.sbDocumentService
	            * @kind function
	            *
	            * @description
	            * Retrieves permissions for the specified library ID.
	            *
	            * @param {libraryId} ID of the library to get permissions for.
	            *
	            * @returns {Deferred} A promise resolving with an array of the retrieved permissions.
	            *
	            */
	            getPermissions: getPermissions,
	            /**
	            * @ngdoc method
	            * @name sbadminDocumentService#getPermissionsForCurrentUser
	            * @methodOf sharebase-admin.sbadminDocumentService
	            * @kind function
	            *
	            * @description
	            * Retrieves permissions for the current user for the specified document ID.
	            *
	            * @param {docId} ID of the document to get permissions for.
	            *
	            * @returns {Deferred} A promise resolving with an array of the retrieved permissions.
	            *
	            */
	            getPermissionsForCurrentUser: getPermissionsForCurrentUser
	        };
	        function getDocument(documentId) {
	            var uri = pxUriPathService.resolvePath('/documents/{id}/view', {
	                id: documentId
	            });
	            return $http.get(uri)
	                .then(function (response) {
	                return response.data;
	            });
	        }
	        function deleteDocument(documentId, purge) {
	            if (purge === void 0) { purge = false; }
	            var uri = pxUriPathService.resolvePath('/documents/{documentId}?purge={purge}', {
	                documentId: documentId,
	                purge: purge
	            });
	            return $http.delete(uri);
	        }
	        function savePermissions(documentId, acls) {
	            var uri = pxUriPathService.resolvePath('/documents/{id}/permissions/replace', {
	                id: documentId
	            });
	            return $http.post(uri, acls);
	        }
	        function getPermissions(documentId, compact) {
	            compact = typeof (compact) === 'boolean' ? compact : true;
	            var uri = pxUriPathService.resolvePath('/documents/{id}/permissions', {
	                id: documentId
	            });
	            if (compact) {
	                uri += '?compact=true';
	            }
	            return $http
	                .get(uri)
	                .then(function (response) {
	                return response.data;
	            });
	        }
	        function getPermissionsForCurrentUser(docId) {
	            var uri = pxUriPathService.resolvePath('/documents/{id}/permissionsforuser', {
	                id: docId
	            });
	            return $http
	                .get(uri)
	                .then(function (response) {
	                return response.data;
	            });
	        }
	        function getShares(documentId) {
	            var uri = pxUriPathService.resolvePath('/documents/{id}/shares/all', {
	                id: documentId
	            });
	            return $http
	                .get(uri)
	                .then(function (response) {
	                return response.data;
	            });
	        }
	    }
	})();


/***/ },
/* 119 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		/**
		* @ngdoc service
		* @name sharebase.sbFolderDetailService
		* @requires $http
		* @requires settingService
		* @requires sbFolderService
		* @description
		* A service used to retrieve and interrogate ShareBase folder details.
		**/
		angular
			.module('sharebase')
			.factory('sbFolderDetailService', [
				'$http',
				'$q',
				'settingsService',
				'sbFolderService',
				sbFolderDetailService
			]);

		function sbFolderDetailService($http, $q, settingsService, sbFolderService) {
			return {
				/**
				* @ngdoc method
				* @name sbFolderDetailService#getFolderDetails
				* @methodOf sharebase.sbFolderDetailService
				* @kind function
				*
				* @description
				* Retrieves a specific folder's details for the user.
				* 
				* @param {object} folder A folder object.
				*
				* @returns {Deferred} A promise that will resolve with a folder's details
				* 
				*/
				getFolderDetails: getFolderDetails,
				/**
				* @ngdoc method
				* @name sbFolderDetailService#getFolderShares
				* @methodOf sharebase.sbFolderDetailService
				* @kind function
				*
				* @description
				* Retrieves a specific folder's shares-by-link.
				* 
				* @param {object} folder A folder resource.
				*
				* @returns {Deferred} A promise that will resolve with an array the folder's shares-by-link.
				* 
				*/
				getFolderShares: getFolderShares,
				/**
				* @ngdoc method
				* @name sbFolderDetailService#getFolderPermissions
				* @methodOf sharebase.sbFolderDetailService
				* @kind function
				*
				* @description
				* Retrieves a specific folder's permissions.
				* 
				* @param {object} folder A folder resource.
				*
				* @returns {Deferred} A promise that will resolve with an array of the folder's permissions.
				* 
				*/
				getFolderPermissions: getFolderPermissions,
				/**
				* @ngdoc method
				* @name sbFolderDetailService#getFolderActivities
				* @methodOf sharebase.sbFolderDetailService
				* @kind function
				*
				* @description
				* Retrieves a specific folder's activities.
				* 
				* @param {object} folder A folder resource.
				*
				* @returns {Deferred} A promise that will resolve with an array of the folder's activities.
				* 
				*/
				getFolderActivities: getFolderActivities,
				/**
				* @ngdoc method
				* @name sbFolderDetailService#getFileCount
				* @methodOf sharebase.sbFolderDetailService
				* @kind function
				*
				* @description
				* Retrieves a specific folder's file count.
				* 
				* @param {object} folder A folder resource.
				*
				* @returns {Deferred} A promise that will resolve with the folder's file count.
				* 
				*/
				getFileCount: getFileCount
			};

			function getFolderDetails(folder) {
				return $q.all([
					getFolderActivities(folder),
					getFolderShares(folder),
					getFolderPermissions(folder),
					getFileCount(folder)
				]).then(function (resp) {
					var userShares = resp[2].filter(function (permission) {
						// eslint-disable-next-line eqeqeq
						return permission.RoleName == 3;				
					});
					var results = {
						dateCreated: folder.DateCreated,
						dateModified: folder.DateModified,
						owner: folder.Owner,
						activities: resp[0],
						linkShares: resp[1],
						userShares:userShares,
						totalFiles: parseInt(resp[3])
					};
						
					return results;
				});
			}

			function getFolderActivities(folder) {
				return $http.get(folder.Links.ActivitiesUri).then(function (response) {
					return response.data;
				});
			}

			function getFolderShares(folder) {
				return $http.get(folder.Links.SharesUri).then(function (response) {
					return response.data;
				});
			}

			function getFolderPermissions(folder) {
				return $http.get(settingsService.serverAPIPath + '/f/' + folder.FolderId + '/permissions', {
					compact: true
				}).then(function (response) {
					return response.data;
				});
			}

			function getFileCount(folder) {
				return sbFolderService.getDocuments(folder).then(function (docs) {
					return docs.length;
				});
			}
		}
	})();

/***/ },
/* 120 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbFolderService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase
		* folders
		**/

		angular.module('sharebase')
			.factory('sbFolderService', [
				'$http',
				'settingsService',
				'sbLibraryService',
				FolderFactory]);

		function FolderFactory($http, settingsService, sbLibraryService) {

			return {
				/**
				* @ngdoc method
				* @name sbFolderService#getRootFolders
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Gets the folders available to the user
				* 
				* @returns {Deferred} A promise that will resolve with an
				* array of folders
				* 
				*/
				getRootFolders: getRootFolders,

				/**
				* @ngdoc method
				* @name sbFolderService#getFolder
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Gets a specific folder to the user
				* 
				* @param {object} folderId A Folder ID
				*
				* @returns {Deferred} A promise that will resolve with a folder
				* 
				*/
				getFolder: getFolder,

				/**
				* @ngdoc method
				* @name bFolderService#getSubFolders
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Gets the contents of a given folder
				* 
				* @param {object} folder A folder resource to get sub-folders for
				*
				* @returns {Deferred} A promise that will resolve with an
				* array of subFolders
				* 
				*/
				getSubFolders: getSubFolders,

				/**
				* @ngdoc method
				* @name bFolderService#getDocuments
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Gets the contents of a given folder
				* 
				* @param {object} folder A folder resource to get documents for
				*
				* @returns {Deferred} A promise that will resolve with an
				* array of documents
				* 
				*/
				getDocuments: getDocuments,

				/**
				* @ngdoc method
				* @name bFolderService#hasSubFolders
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Calculates whether a given folder has subFolders
				*
				* @param {object} folder A folder resource to check for children
				* 
				* @returns {Deferred} A promise that will resolve with an
				* boolean indicator as to whether a given folder contains subFolders
				* 
				*/
				hasSubFolders: hasSubFolders,

				/**
				* @ngdoc method
				* @name bFolderService#folderNameExists
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Checks to see if a folder's name already exists in the current directory
				* 
				* @param {object} folder A folder resource whose children to check for a 
				* given name
				* @param {string} folderName A name to check for
				*
				* @returns {Deferred} A boolean value determining if the folder's name 
				* already exists
				* in the current directory.
				* 
				*/
				folderNameExists: folderNameExists,

				/**
				* @ngdoc method
				* @name bFolderService#createFolder
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Creates a new folder
				*
				* @param {string} folderName The name of the new folder
				* @param {object} parentFolder The new folders parent
				* 
				* @returns {Deferred} A promise that will resolve with a created folder
				* 
				*/
				createFolder: createFolder,

				/**
				* @ngdoc method
				* @name bFolderService#renameFolder
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Renames an existing folder
				* 
				* @param {object} folder A folder resource
				* @param {string} newName The new name
				*
				* @returns {Deferred} A promise that will resolve with a renamed folder
				* 
				*/
				renameFolder: renameFolder,

				/**
				* @ngdoc method
				* @name bFolderService#moveFolder
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Moves an existing folder
				* 
				* @param {object} source A folder resource to move
				* @param {object} destination A folder or library resource to
				* move the folder to
				*/
				moveFolder: moveFolder,

				/**
				* @ngdoc method
				* @name bFolderService#deleteFolder
				* @methodOf sharebase.sbFolderService
				* @kind function
				*
				* @description
				* Deletes an existing folder
				* 
				* @param {object} folder A folder resource
				*/
				deleteFolder: deleteFolder
			};

			function getRootFolders() {
				return sbLibraryService.getUserLibrary();
			}

			function getFolder(folderId) {
				return $http.get(settingsService.serverAPIPath + '/f/' + folderId)
					.then(function (response) {
						return response.data;
					});
			}

			function getSubFolders(folder) {
				return $http.get(folder.Links.ChildFoldersUri)
					.then(function (response) {
						return response.data;
					});
			}

			function getDocuments(folder) {
				return $http.get(folder.Links.DocumentsUri)
					.then(function (response) {
						return response.data;
					});
			}

			function hasSubFolders(folder) {
				$http.get(folder.Links.ChildFoldersUri)
					.then(function (response) {
						return angular.isDefined(response.data);
					});
			}

			function folderNameExists(folder, folderName) {
				return $http.get(folder.Links.ChildFoldersUri)
					.then(function (response) {
						var folders = response.data;

						return folders.some(function (child) {
							return child.FolderName === folderName;
						});
					});
			}

			function createFolder(folderName, parentFolder) {
				var apiPath = parentFolder ?
					parentFolder.Links.ChildFoldersUri :
					settingsService.serverAPIPath + '/f';

				return $http.post(apiPath, folderName)
					.then(function (response) {
						return response.data;
					});
			}

			function renameFolder(folder, newName) {
				var renameJson = JSON.stringify({ FolderName: newName });

				return $http.patch(folder.Links.Self, renameJson)
					.then(function (response) {
						return response.data;
					});
			}

			function moveFolder(source, destination) {
				var moveJson = JSON.stringify({ FolderId: source.FolderId });            
				var destResource = destination.Type === 'library' ?
					'/libraries/' :
					'/f/';
				var path = settingsService.serverAPIPath +
					destResource +
					destination.FolderId + '/folders';

				return $http.patch(path, moveJson);
			}

			function deleteFolder(folder) {
				return $http.delete(folder.Links.Self);
			}
		}
	})();

/***/ },
/* 121 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('sharebase')
			.factory('sbLibraryService', [
				'$http',
				'settingsService',
				LibraryService]);

		/**
		* @ngdoc service
		* @name  sharebase.sbLibraryService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase
		* libraries
		* 
		**/
		function LibraryService($http, settingsService) {
			return {
				/**
				* @ngdoc method
				* @name sbLibraryService#getLibraries
				* @methodOf sharebase.sbLibraryService
				* @kind function
				*
				* @description
				* Gets the libraries available to the user
				* 
				* @returns {Deferred} A promise that will resolve with an
				* array of libraries
				* 
				*/
				getLibraries: getLibraries,
				/**
				* @ngdoc method
				* @name sbLibraryService#getUserLibrary
				* @methodOf sharebase.sbLibraryService
				* @kind function
				*
				* @description
				* Gets the user's personal library
				* 
				* @returns {Deferred} A promise that will resolve with the
				* user's library
				* 
				*/
				getUserLibrary: getUserLibrary,
				/**
				* @ngdoc method
				* @name sbLibraryService#getLibraryFolders
				* @methodOf sharebase.sbLibraryService
				* @kind function
				*
				* @description
				* Gets the top level folders of a library
				* 
				* @param {object} library A library resource
				*
				* @returns {Deferred} A promise that will resolve with an
				* array of folders
				* 
				*/
				getLibraryFolders: getLibraryFolders
			};

			function getUserLibrary() {
				return getLibraries()
					.then(selectUsersLibrary);
			}

			function getLibraries() {
				return $http.get(settingsService.serverAPIPath + '/home')
					.then(function (response) {
						return response.data.Embedded.Libraries;
					});
			}

			function selectUsersLibrary(libs) {
				var userLib = null;

				for (var i = 0; i < libs.length; i++) {
					if (libs[i].IsPrivate) {
						userLib = libs[i];
						break;
					}
				}

				return userLib;
			}

			function getLibraryFolders(library) {
				return $http.get(library.Links.RootFoldersUri)
					.then(function (response) {
						return response.data;
					});
			}
		}
	})();

/***/ },
/* 122 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular.module('sharebase')
			.factory('sbNotificationsService', [
				'$http',
				'$q',
				'$filter',
				'settingsService',
				NotificationsFactory]);

		/**
		* @ngdoc service
		* @name  sharebase.sbNotificationsService
		* 
		* @description 
		* A service that handles user authentication and provides information
		* about the current authenticated user
		**/
		function NotificationsFactory($http, $q, $filter, settingsService) {
			return {

				/**
				* @ngdoc method
				* @name sbNotificationsService#getUnreadNotifications
				* @methodOf sharebase.sbNotificationsService
				* @kind function
				*
				* @description
				* Retrieves a user's unread notifications (if applicable).
				*/
				getUnreadNotifications: getUnreadNotifications,

				/**
				* @ngdoc method
				* @name sbNotificationsService#getNotifications
				* @methodOf sharebase.sbNotificationsService
				* @kind function
				*
				* @description
				* Retrieves a user's existing notifications.
				*
				* @param {max} max indicates that the API needs to return
				* the {max} latest notifications.
				*/
				getNotifications: getNotifications,

				/**
				* @ngdoc method
				* @name sbNotificationsService#deleteAllNotifications
				* @methodOf sharebase.sbNotificationsService
				* @kind function
				*
				* @description
				* Deletes the user's existing notifications.
				*/
				deleteAllNotifications: deleteAllNotifications,

				/**
				* @ngdoc method
				* @name sbNotificationsService#deleteNotification
				* @methodOf sharebase.sbNotificationsService
				* @kind function
				*
				* @description
				* Deletes a specified notification.
				*/
				deleteNotification: deleteNotification
			};

			function getUnreadNotifications() {
				return $http.get(settingsService.serverAPIPath + '/notifications/unread')
					.then(function (response) {
						return response.data;
					});
			}

			function getNotifications(max) {
				var path = '/notifications';

				if (max > 0) {
					path += '?top=' + max;
				}

				var notificationsPromise = $http.get(settingsService.serverAPIPath + path);
				var unreadPromise = getUnreadNotifications();

				return $q.all([notificationsPromise, unreadPromise])
					.then(function (responseList) {
						var notifications = responseList[0].data;
						var unreadNotifications = responseList[1];

						// combine read and unread messages
						angular.forEach(unreadNotifications,
							function (item, index) {
								item.Unread = true;
								notifications.splice(index, 1, item);
							});

						return notifications;
					});
			}

			function deleteAllNotifications() {
				return $http.delete(settingsService.serverAPIPath + '/notifications');
			}

			function deleteNotification(notification) {
				return $http.delete(notification.SelfUri);
			}
		}

	})();

/***/ },
/* 123 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbRecentDocumentsService
		* 
		* @description 
		* A service used to retrieve user's recent documents
		*
		**/

		angular.module('sharebase')
			.factory('sbRecentDocumentsService', [
				'$http',
				'settingsService',
				RecentDocumentsFactory]);

		function RecentDocumentsFactory($http, settingsService, sbLibraryService) {

			return {
				/**
				* @ngdoc method
				* @name sbRecentDocumentsService#getDocuments
				* @methodOf sharebase.sbRecentDocumentsService
				* @kind function
				*
				* @description
				* Gets the recent document for a user
				* 
				* @returns {Deferred} A promise that will resolve with an
				* array of recent documents
				* 
				*/
				getDocuments: getDocuments
			};
			
			function getDocuments() {
				return $http.get(settingsService.serverAPIPath + '/recents/')
					.then(function (response) {
						return response.data;
					});
			}
		}
	})();

/***/ },
/* 124 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		/**
		* @ngdoc service
		* @name  sharebase.sbSearchService
		* 
		* @description 
		* A service used to retrieve with ShareBase content search
		* documents
		**/

		angular.module('sharebase')
			.factory('sbSearchService', [
				'$http', 
				'$q', 
				'settingsService',
				SearchService
			]);
			
		function SearchService($http, $q, settingsService) {
			var self = this;
			self.apiUri = settingsService.serverAPIPath + '/search';
			self.results = [];

			function getResults(searchPhrase, resultLimit) {
				var deferred = $q.defer();
				if (searchPhrase.length === 0 || !searchPhrase) {
					self.results = JSON.parse(JSON.stringify([]));
					deferred.resolve(self.results);
				}
				else {
					//set a default result limit
					if (!resultLimit || typeof resultLimit !== 'number') {
						//set a default result limit
						resultLimit = 100;
					}
					else {
						resultLimit = parseInt(resultLimit.toString());
					}

					//remove any non-alphanumeric characters and split each word into a seperate term
					var searchPhraseArr = searchPhrase.replace(/[\W_]+/g, ' ').split(' ');

					$http.post(self.apiUri, searchPhraseArr, { params: { limit: resultLimit } })
						.then(function (result) {
							//success
							var results = [];
							angular.forEach(result.data.Embedded.Folders, function (folder) {
								folder.name = folder.FolderName;
								results.push(folder);
							});
							angular.forEach(result.data.Embedded.Documents, function (doc) {
								doc.name = doc.DocumentName;
								results.push(doc);
							});
							deferred.resolve({ results: results, hasMore: result.data.HasMore });
						}, function (error) {
							//failure
							deferred.reject('Error retreiving search results!');
						});
				}
				return deferred.promise;
			}

			return {
				/**
				* @ngdoc method
				* @name sbSearchService#getResults
				* @methodOf sharebase.sbSearchService
				* @kind function
				*
				* @description
				* Gets matching results of the search
				* 
				* @param {object} searchPhrase A text phrase to search for
				* @param {object} resultLimit The amount of results to return.  Possible
				* values 0-1000 (default) is 100
				*
				* @returns {Deferred} A promise that will resolve with a list of results
				* 
				*/
				getResults: getResults
			};
		}
	})();

/***/ },
/* 125 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbTagService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase tags
		**/

		angular
			.module('sharebase')
			.factory('sbTagService', ['$http', 'settingsService', sbTagService]);

		function sbTagService($http, settingsService) {

			return {
				/**
				* @ngdoc method
				* @name sbTagService#getTagTypes
				* @methodOf sharebase.sbTagService
				* @kind function
				*
				* @description
				* Gets all tags specific to a user
				*
				* @returns {Deferred} A promise that will resolve with a user's tag types
				* 
				*/
				getTagTypes: getTagTypes,

				/**
				* @ngdoc method
				* @name sbTagService#getUserTags
				* @methodOf sharebase.sbTagService
				* @kind function
				*
				* @description
				* Gets all tags specific to a user or system
				* 
				* @param {object} tagTypeId A Tag Type ID
				*
				* @returns {Deferred} A promise that will resolve with a collection of (user or system) tags
				* 
				*/
				getTags: getTags,

				/**
				* @ngdoc method
				* @name sbTagService#getDocumentTags
				* @methodOf sharebase.sbTagService
				* @kind function
				*
				* @description
				* Gets a specific document's tags to the user
				* 
				* @param {object} documentId A Document ID
				*
				* @returns {Deferred} A promise that will resolve with a document's tags
				* 
				*/
				getDocumentTags: getDocumentTags,
				/**
				* @ngdoc method
				* @name sbTagService#setDocumentTags
				* @methodOf sharebase.sbTagService
				* @kind function
				*
				* @description
				* Sets the document's tags
				* 
				* @param {object} documentId A Document ID
				* 
				* @param {array} tags An array of the documents tags
				* 
				*/
				setDocumentTags: setDocumentTags,

				/**
				* @ngdoc method
				* @name sbDocumentDetailService#removeDocumentTag
				* @methodOf sharebase.sbTagService
				* @kind function
				*
				* @description
				* removes document tags
				* 
				* @param {object} documentId A Document ID
				* 
				* @param {array} tags An array of the documents tags to remove
				* 
				*/
				removeDocumentTag: removeDocumentTag,

			};

			function getTagTypes() {
				return $http.get(settingsService.serverAPIPath + '/tagtypes')
					.then(function (response) {
						return response.data;
					});
			}

			function getTags(tagTypeId) {
				return $http.get(settingsService.serverAPIPath + '/tagtypes/' + tagTypeId + '/values')
					.then(function (response) {
						return response.data;
					});
			}

			function getDocumentTags(documentId) {
				return $http.get(settingsService.serverAPIPath + '/documents/' + documentId + '/tags')
					.then(function (response) {
						return response.data;
					});
			}

			function setDocumentTags(documentId, tags) {
				return $http.post(settingsService.serverAPIPath + '/documents/' + documentId + '/tags', tags);
			}

			function removeDocumentTag(documentId, tag) {
				var tags = [];
				if (Array.isArray(tag)) {
					tags = tag;
				}
				else {
					tags.push(tag);
				}
				var deleteTags = { AnonymousTags: tags };
				return $http.post(settingsService.serverAPIPath + '/documents/' + documentId + '/tags?remove=true', deleteTags)
					.then(function (results) {
						return results.data;
					});
			}

		}

	})();

/***/ },
/* 126 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbToastService
		* 
		* @description 
		* A service used to post notification messages to ShareBase
		**/

		angular
			.module('sharebase')
			.factory('sbToastService',
			[
				'$timeout',
				'$mdToast',
				'gettextCatalog',
				ToastService
			]);

		function ToastService($timeout, $mdToast, gettextCatalog) {
			var DEFAULT_POSITION = 'bottom right';
			var DEFAULT_DELAY = 3000;

			return {
				/**
				* @ngdoc method
				* @name sbToastService#showSimple
				* @methodOf sharebase.sbToastService
				* @kind function
				*
				* @description
				* Shows a simple toast message
				*
				*/
				showSimple: showSimple
			};

			function showSimple(message) {
				return $timeout(function () {
					//endables smooth animation when page transition occurs
					return $mdToast.show(
						$mdToast.simple()
							.textContent(gettextCatalog.getString(message))
							.position(DEFAULT_POSITION)
							.hideDelay(DEFAULT_DELAY)
						);
				}, 0);
			}
		}

	})();

/***/ },
/* 127 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUserGroupService
		* 
		* @description 
		* A service used to retrieve a ShareBase user group
		**/

		angular
			.module('sharebase')
			.factory('sbUserGroupService',
			[
				'$http',
				'pxUriPathService',
				UserGroupService
			]);

		function UserGroupService($http, pxUriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbUserGroupService#getUserGroup
				* @methodOf sharebase.sbUserGroupService
				* @kind function
				*
				* @description
				* Gets a user group
				*
				* @returns {Deferred} A promise that will resolve with a user group
				* 
				*/
				getUserGroup: getUserGroup,

				/**
				* @ngdoc method
				* @name sbUserGroupService#getUserGroupPolicy
				* @methodOf sharebase.sbUserGroupService
				* @kind function
				*
				* @description
				* Gets a user group sharing policy
				*
				* @returns {Deferred} A promise that will resolve with a user group's sharing policy
				* 
				*/
				getUserGroupPolicy: getUserGroupPolicy,

				/**
				* @ngdoc method
				* @name sbUserGroupService#addUserGroup
				* @methodOf sharebase.sbUserGroupService
				* @kind function
				*
				* @description
				* Adds a new user group
				*
				* @returns {Deferred} A promise that will resolve with a user group
				* 
				*/
				addUserGroup: addUserGroup,

				/**
				* @ngdoc method
				* @name sbUserGroupService#updateUserGroup
				* @methodOf sharebase.sbUserGroupService
				* @kind function
				*
				* @description
				* Updates an existing user group
				*
				* @returns {Deferred} A promise that will resolve with a user group
				* 
				*/
				updateUserGroup: updateUserGroup,

				/**
				* @ngdoc method
				* @name sbUserGroupService#updateUserGroupPolicy
				* @methodOf sharebase.sbUserGroupService
				* @kind function
				*
				* @description
				* Updates an existing user group policy
				*
				* @returns {Deferred} A promise that will resolve with a user group policy
				* 
				*/
				updateUserGroupPolicy: updateUserGroupPolicy
			};

			function getUserGroup(userGroupId, systemName) {
				return $http
					.get(pxUriPathService.resolvePath('/{system}/usergroups/' + userGroupId, setDeploymentParam(systemName)))
					.then(function (response) {
						return response.data;
					});
			}

			function getUserGroupPolicy(userGroupId) {
				return $http
					.get(pxUriPathService.resolvePath('/usergroups/' + userGroupId + '/policy'))
					.then(function (response) {
						return response.data;
					});
			}

			function addUserGroup(userGroup, systemName) {
				return $http
					.post(pxUriPathService.resolvePath('/{system}/usergroups', setDeploymentParam(systemName)), userGroup)
					.then(function (response) {
						return response.data;
					});
			}

			function updateUserGroup(userGroup, systemName) {
				return $http
					.post(pxUriPathService.resolvePath('/{system}/usergroups/' + userGroup.UserGroupId, setDeploymentParam(systemName)), userGroup)
					.then(function (response) {
						return response.data;
					});
			}

			function updateUserGroupPolicy(userGroupPolicy) {
				return $http
					.put(pxUriPathService.resolvePath('/usergroups/' + userGroupPolicy.UserGroupId + '/policy'), userGroupPolicy)
					.then(function () {
						return userGroupPolicy;
					});
			}

			function setDeploymentParam(systemName) {
				var params = {};
				if (systemName) {
					params.system = systemName;
				}
				return params;
			}
		}

	})();

/***/ },
/* 128 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUserGroupsService
		* 
		* @description 
		* A service used to retrieve ShareBase user groups
		**/

		angular
			.module('sharebase')
			.factory('sbUserGroupsService',
			[
				'$http',
				'pxUriPathService',
				UserGroupsService
			]);

		function UserGroupsService($http, pxUriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbUserGroupsService#getUserGroups
				* @methodOf sharebase.sbUserGroupsService
				* @kind function
				*
				* @description
				* Gets a collection of user groups
				*
				* @returns {Deferred} A promise that will resolve with a collection of user groups
				* 
				*/
				getUserGroups: getUserGroups
			};

			function getUserGroups(systemName) {
				return $http.get(pxUriPathService.resolvePath('/{system}/usergroups', {
					system: systemName
				})).then(function (response) {
					return response.data;
				});
			}
		}

	})();

/***/ },
/* 129 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUserService
		* 
		* @description 
		* A service used to retrieve and interact with a ShareBase user
		**/

		angular
			.module('sharebase')
			.factory('sbUserService',
			[
				'$http',
				'pxUriPathService',
				UserService
			]);

		function UserService($http, pxUriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbUserService#getUser
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Gets a user
				*
				* @returns {Deferred} A promise that will resolve with a user
				* 
				*/
				getUser: getUser,

				/**
				* @ngdoc method
				* @name sbUserService#addUser
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Adds a new user
				*
				* @returns {Deferred} A promise that will resolve with a new user
				* 
				*/
				addUser: addUser,

				/**
				* @ngdoc method
				* @name sbUserService#removeUser
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Adds a new user
				*
				* @returns {Deferred} A promise that will resolve with a new user
				* 
				*/
				removeUser: removeUser,

				/**
				* @ngdoc method
				* @name sbUserService#addEditGroupAdmin
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Adds a new Administrator (Tenant/DeploymentGroup)
				*
				* @returns {Deferred} A promise that will resolve with a new Administrator (Tenant/DeploymentGroup)
				* 
				*/
				addEditGroupAdmin: addEditGroupAdmin,

				/**
				* @ngdoc method
				* @name sbUserService#removeGroupAdmin
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Removes the tenant administrator privileges for the specified deployment group from the specified user. 
				*
				* @returns {Deferred} A promise that will resolve with the updated Administrator
				* 
				*/
				removeGroupAdmin: removeGroupAdmin,

				/**
				* @ngdoc method
				* @name sbUserService#updateUser
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Gets an updated user
				*
				* @returns {Deferred} A promise that will resolve with an updated user
				* 
				*/
				updateUser: updateUser,

				/**
				* @ngdoc method
				* @name sbUserService#lockUser
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Locks a user
				*
				* @returns {Deferred} A promise that will resolve
				* 
				*/
				lockUser: lockUser,

				/**
				* @ngdoc method
				* @name sbUserService#unlockUser
				* @methodOf sharebase.sbUserService
				* @kind function
				*
				* @description
				* Unlocks a user
				*
				* @returns {Deferred} A promise that will resolve
				* 
				*/
				unlockUser: unlockUser,
			};

			function getUser(userId, deploymentId) {
				return $http.get(pxUriPathService.resolvePath('/{system}/users/' + userId, setDeploymentParam(deploymentId)))
					.then(function (response) {
						return response.data;
					});
			}

			function addUser(user, deploymentId) {
				return $http.post(pxUriPathService.resolvePath('/{system}/users', setDeploymentParam(deploymentId)), user)
					.then(function (response) {
						return response.data;
					});
			}

			function removeUser(user, deploymentId, transferToUser, forceDelete) {
				forceDelete = forceDelete ? '?force=true' : '?force=false';
				var transferToUserId = transferToUser ? transferToUser.UserId : null;
				var transferTarget = transferToUserId ? '&targetid=' + transferToUserId : '';
				return $http.delete(pxUriPathService.resolvePath('/users/' + user.UserId + forceDelete + transferTarget))
					.then(function (response) {
						return response.data;
					});
			}

			function addEditGroupAdmin(deploymentGroupId, adminUser) {
				return $http.post(pxUriPathService.resolvePath('/admin/deploymentgroups/' + deploymentGroupId + '/admins'), adminUser)
					.then(function (response) {
						return response.data;
					});
			}

			function removeGroupAdmin(deploymentGroupId, userId) {
				return $http.delete(pxUriPathService.resolvePath('/admin/deploymentgroups/' + deploymentGroupId + '/admins/' + userId))
					.then(function (response) {
						return response.data;
					});
			}

			function updateUser(user, deploymentId) {
				return $http.patch(user.Links.Self, user, setDeploymentParam(deploymentId))
					.then(function (response) {
						return response.data;
					});
			}

			function lockUser(userId, deploymentId) {
				return $http.get(pxUriPathService.resolvePath('/{system}/users/' + userId + '/lock', setDeploymentParam(deploymentId)))
					.then(function (response) {
					
					});
			}

			function unlockUser(userId, deploymentId) {
				return $http.get(pxUriPathService.resolvePath('/{system}/users/' + userId + '/unlock', setDeploymentParam(deploymentId)))
					.then(function (response) {
						return response.data;
					});
			}

			function setDeploymentParam(deploymentId) {
				var params = {};
				if (deploymentId) {
					params.system = deploymentId;
				}
				return params;
			}
		}

	})();

/***/ },
/* 130 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase.sbUsersService
		* 
		* @description 
		* A service used to retrieve ShareBase users
		**/

		angular
			.module('sharebase')
			.factory('sbUsersService',[
				'$http',
				'pxUriPathService',
				UsersService
			]);

		function UsersService($http, uriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbUsersService#getUsers
				* @methodOf sharebase.sbUsersService
				* @kind function
				*
				* @description
				* Gets a collection of users
				*
				* @returns {Deferred} A promise that will resolve with a collection of users
				* 
				*/
				getUsers: getUsers,
				
				/**
				* @ngdoc method
				* @name sbUsersService#getPendingUsers
				* @methodOf sharebase.sbUsersService
				* @kind function
				*
				* @description
				* Gets a collection of invited users
				*
				* @returns {Deferred} A promise that will resolve with a collection of invited users
				* 
				*/
				getPendingUsers: getPendingUsers,
				
				/**
				* @ngdoc method
				* @name sbUsersService#inviteUsers
				* @methodOf sharebase.sbUsersService
				* @kind function
				*
				* @description
				* Submits a collection of new invited users
				*
				* @returns {Deferred} A promise of the status of the submission
				* 
				*/
				inviteUsers: inviteUsers
			};

			function getUsers(systemName) {
				return $http.get(uriPathService.resolvePath('/{system}/users', {
					system: systemName
				})).then(function (response) {
					return response.data;
				});
			}

			function getPendingUsers() {
				return $http.get(uriPathService.resolvePath('/users/invites')).then(function (response) {
					return response.data;
				});
			}

			function inviteUsers(systemName, emails, roles, groups) {
				var uri = uriPathService.resolvePath('/{system}/users/registration', {
					system: systemName
				});

				return $http.post(uri, { 
					EmailAddresses: emails,
					Roles: roles,
					UserGroupIds: groups 
				})
				.then(function (response) {
					return response.data;
				});
			}
		}

	})();

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';

		__webpack_require__(67);

		/**
		 * @ngdoc overview
		 * @name sharebase-admin
		 * @module sharebase-admin
		 * @description
		 *
		 * # sharebase-admin (module)
		 * The sharebase-admin module contains components and services available to any
		 * application using the sharebase-admin platform
		 *
		 * Examples of services provided by this module are:
		 * - deployments
		 * - users
		 * - libraries
		 */

		angular.module('sharebase-admin', [
			'ui.router',
			'ngMaterial',		
			'ngMessages',
			'gettext',
			'site.settings',
			'phoenix',
			'phoenix.acl',
			'sharebase'
		]);
		__webpack_require__(132);
		__webpack_require__(243);
		__webpack_require__(258);
	})();

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(133);
	__webpack_require__(139);
	__webpack_require__(144);
	__webpack_require__(149);
	__webpack_require__(154);
	__webpack_require__(159);
	__webpack_require__(164);
	__webpack_require__(166);
	__webpack_require__(171);
	__webpack_require__(176);
	__webpack_require__(181);
	__webpack_require__(186);
	__webpack_require__(192);
	__webpack_require__(197);
	__webpack_require__(202);
	__webpack_require__(207);
	__webpack_require__(212);
	__webpack_require__(217);
	__webpack_require__(224);
	__webpack_require__(228);
	__webpack_require__(233);
	__webpack_require__(238);


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(134);
	__webpack_require__(136);

/***/ },
/* 134 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 135 */,
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';	
		var templateUrl = __webpack_require__(137);
		var secretKeyTemplateUrl = __webpack_require__(138);
		/**
		* @ngdoc directive
		* @name sharebase-admin.directive:sbadminActiveDirectory
		* @module sharebase-admin
		* @restrict E
		* @description
		*
		* `sbadminActiveDirectory` provides a UI for downloading the Active Directory sync agent
		* and generating an integration secret.
		*
		* @usage
		*
		* <sbadmin-active-directory-controller /> 
		*/
		angular.module('sharebase-admin')
			.directive('sbadminActiveDirectory', ActiveDirectoryDirective)
			.controller('sbadminActiveDirectoryController', [
				'$q',
				'$state',
	            '$mdDialog',
				'$mdMedia',
				'sbToastService',
				'pxAuthService',
				'pxProgressService',
				'sbadminToolbarService',
				'sbadminActiveDirectoryService',
				'gettextCatalog',
				ActiveDirectoryController
			])
			.controller('sbadminNewSecretKeyController', [
				'$mdDialog',
				'$mdMedia',
				'sbToastService',
				'secret',
				'gettextCatalog',
				NewSecretKeyController
			]);

		function ActiveDirectoryDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminActiveDirectoryController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					deploymentId: '@'
				},
				link: function (scope, element, attrs) { }
			};
		}

		function ActiveDirectoryController($q, $state, $mdDialog, $mdMedia, sbToastService, pxAuthService, pxProgressService, sbadminToolbarService, sbadminActiveDirectoryService, gettextCatalog) {
			var vm = this;
			vm.syncSecret = null;
			vm.generateSecret = function ($event) {
				setLoading(true);
				sbadminActiveDirectoryService
					.generateSyncSecret(vm.deploymentId)
					.then(function (secret) {
						
						$mdDialog.show({
							controller: 'sbadminNewSecretKeyController',
							controllerAs: 'newKeyCtrl',
							templateUrl: secretKeyTemplateUrl,
							targetEvent: $event,
							clickOutsideToClose: false,
							fullscreen: $mdMedia('xs'),
							locals: {
								secret: secret
							}
						});

					})
					.catch(function (resp) {
						sbToastService.showSimple(gettextCatalog.getString('There was an issue generating the Active Directory sync agent secret.'));
					})
					.finally(function() {
						setLoading(false);
					});
			};

			vm.copySecret = function () {
				sbToastService.showSimple(gettextCatalog.getString('Copied secret.'));
			};

			sbadminToolbarService.title = gettextCatalog.getString('Active Directory');
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = false;

			function setLoading(isLoading) {
				isLoading = typeof (isLoading) === 'boolean' ? isLoading : false;
				pxProgressService.backdrop = pxProgressService.visible = isLoading;
			}
		}

		function NewSecretKeyController($mdDialog, $mdMedia, sbToastService, secret, gettextCatalog) {
			var self = this;
			self.secret = secret;
			self.isSmall = $mdMedia('xs');

			self.close = function () {
				$mdDialog.hide();
			};

			self.copySecret = function () {
				sbToastService.showSimple(gettextCatalog.getString('Secret key copied to clipboard.'));
			};
		}
	})();

/***/ },
/* 137 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/activeDirectory/activeDirectory.template.html';
	var html = "<md-content  flex layout=\"column\" layout-align=\"start stretch\">\r\n\t<md-list flex class=\"app--list-no-padding\">\r\n\t\t<md-list-item class=\"md-2-line\" ng-click=\"vm.generateSecret($event)\">\r\n\t\t\t<div class=\"md-list-item-text\">\r\n\t\t\t\t<h3 translate>Secret</h3>\r\n\t\t\t\t<p translate>Generate a new secret key</p>\r\n\t\t\t</div>\r\n\t\t</md-list-item>\r\n\t\t<md-divider></md-divider>\r\n\t\t<md-list-item class=\"md-2-line list---href\" href=\"sync-agent/ShareBase.ActiveDirectory.Setup.msi\">\r\n\t\t\t<div class=\"md-list-item-text\">\r\n\t\t\t\t<h3 translate>Sync Agent</h3>\r\n\t\t\t\t<p translate>Download the Active Directory Sync Agent</p>\r\n\t\t\t</div>\r\n\t\t</md-list-item>\r\n\t\t<md-divider></md-divider>\r\n\t</md-list>\r\n</md-content>\r\n\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 138 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/activeDirectory/newSecretKey.template.html';
	var html = "<md-dialog aria-label=\"{{::'Your new secret key' | translate}}\">\r\n\t<md-toolbar hide-gt-xs>\r\n\t\t<div class=\"md-toolbar-tools\">\r\n\t\t\t<h3 translate>Your new secret key</h3>\r\n\t\t\t<span flex></span>\r\n\t\t\t<md-button class=\"md-icon-button\" ng-click=\"newKeyCtrl.close()\">\r\n\t\t\t\t<md-icon class=\"material-icons\" aria-label=\"{{::'Close dialog' | translate}}\">close</md-icon>\r\n\t\t\t</md-button>\r\n\t\t</div>\r\n\t</md-toolbar>\r\n\t<md-dialog-content class=\"md-dialog-content\">\r\n\t\t<h3 translate hide show-gt-xs>Your new secret key</h3>\r\n\t\t<p translate translate-comment=\"HTML tags are used for formatting and should not be translated.\">\r\n\t\t\tPlease copy and paste this value into the <code>secret</code> key of the <code>ShareBaseActiveDirectorySyncAgent.exe.config</code> file's <code>appSettings</code> node.\r\n\t\t</p>\r\n\t\t<p translate translate-comment=\"HTML tags are used for formatting and should not be translated.\">\r\n\t\t\t<strong>Note:</strong> This secret cannot be retrieved again, so a new one must be generated if it is lost or forgotten.\r\n\t\t</p>\r\n\r\n\t\t<md-input-container class=\"md-block new-key-prompt__input\">\r\n\t\t\t<label translate>Generated secret key</label>\r\n\t\t\t<input type=\"text\" readonly id=\"secretInput\" ng-model=\"newKeyCtrl.secret\" />\r\n\t\t</md-input-container>\r\n\t</md-dialog-content>\r\n\t<md-dialog-actions  layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t<md-button class=\"clipbd\" ng-click=\"newKeyCtrl.copySecret()\" data-clipboard-target=\"#secretInput\">{{::'Copy to Clipboard' | translate}}</md-button>\r\n\t\t<md-button flex-order-xs=\"-1\" class=\"md-primary\" ng-class=\"{'md-raised': newKeyCtrl.isSmall}\" ng-click=\"newKeyCtrl.close()\">{{::'Done' | translate}}</md-button>\r\n\t</md-dialog-actions>\r\n</md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(140);
	__webpack_require__(142);

/***/ },
/* 140 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 141 */,
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(143);
		
		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminApiTokenCreate
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminApiTokenCreate` displays a UI for generating API tokens.
		 *
		 * @usage
		 *
		 * <sbadmin-api-token-create /> 
		 * 
		 */

		angular
			.module('sharebase-admin')
			.directive('sbadminApiTokenCreate', [
				'sbadminToolbarService',
				ApiTokenCreateDirective
			])
			.controller('sbadminApiTokenCreateController', [
				'$q',
				'$state',
				'pxProgressService',
				'sbUsersDataStore',
				'sbadminToolbarService',
				'sbadminApiTokenDataStore',
				'gettextCatalog',
				ApiTokenCreateController
			]);

		function ApiTokenCreateDirective(sbadminToolbarService) {
			return {
				restrict: 'E',
				controller: 'sbadminApiTokenCreateController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {},
				link: function (scope, element, attrs) {
					scope.$on('$destroy', function () {
					});
				}
			};
		}

		function ApiTokenCreateController($q, $state, progressService, usersDataStore, toolbarService, apiTokenDataStore, gettextCatalog) {
			var vm = this;
			var initTasks = [
				usersDataStore.getUsers()
			];

			toolbarService.title = gettextCatalog.getString('Create API Token');
			toolbarService.showFilter = false;
			toolbarService.actions = [];

			vm.loading = false;
			vm.userDS = usersDataStore;
			vm.errorMessage = '';
			vm.password = '';
			vm.selectedUser = null;
			vm.filterUsers = function(phrase) {
				var users = angular.copy(usersDataStore.users);

				if (phrase && phrase.length > 0) {
					phrase = phrase.toLowerCase();
					users = users.filter(function(user) {
						return user.UserName.toLowerCase().indexOf(phrase) > -1 ||
							user.EmailAddress.toLowerCase().indexOf(phrase) > -1;
					});
				}

				return users;
			};
			vm.createToken = function() {
				vm.errorMessage = '';
				if (vm.tokenForm.$valid) {
					progressService.backdrop = true;
					apiTokenDataStore
						.createToken(vm.selectedUser.EmailAddress, vm.password)
						.then(function() {
							$state.go('administration.home.deployment.tokens');
						})
						.catch(function(resp) {
							// 500-level messages are generally vague
							vm.errorMessage = resp.status === 500 ? 
								gettextCatalog.getString('Error creating token.') :
								resp.data.Message;
						})
						.finally(setLoading);	
				}	
			};

			setLoading(true);
			$q.all(initTasks)
				.finally(setLoading);

			function setLoading(isLoading) {
				isLoading = typeof(isLoading) === 'boolean' ? isLoading : false;
				vm.loading = isLoading;
				progressService.visible = isLoading;
			}
		}
	})();

/***/ },
/* 143 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/apiTokenCreate/apiTokenCreate.template.html';
	var html = "<form layout-fill name=\"vm.tokenForm\" layout=\"column\" layout-align=\"start stretch\" ng-submit=\"vm.tokenForm.$valid && vm.createToken()\" novalidate>\t\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.errorMessage\">\r\n\t\t<md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\">{{vm.errorMessage}}</md-subheader>\r\n\t</div>\r\n\t<md-content class=\"md-padding\" flex-gt-xs layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\">\r\n\t\t<div>\r\n\t\t\t<sb-user-select placeholder=\"{{::'User' | translate}}\"\r\n\t\t\t\t\t\t\tselected=\"vm.selectedUser\"\r\n\t\t\t\t\t\t\trequired=\"true\"\r\n\t\t\t\t\t\t\trequired-message=\"{{::'Please specify a user to generate a token for.' | translate}}\"\r\n\t\t\t\t\t\t\tinclude-usergroups=\"false\"\r\n\t\t\t\t\t\t\tdeployment-id=\"vm.deploymentId\"></sb-user-select>\r\n\r\n\t\t\t<!-- hidden field added above password field to address autofill logic - http://stackoverflow.com/questions/15738259/disabling-chrome-autofill  -->\r\n\t\t\t<input name=\"password\" type=\"password\" style=\"display: none\">\r\n\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>Password</label>\r\n\t\t\t\t<input ng-model=\"vm.password\" name=\"password\" type=\"password\" required md-maxlength=\"50\">\r\n\t\t\t\t<div ng-messages=\"vm.tokenForm.password.$error\" role=\"alert\" multiple>\r\n\t\t\t\t\t<div ng-message=\"required\" translate>\r\n\t\t\t\t\t\tYou must supply a password.\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div ng-message=\"md-maxlength\" translate>\r\n\t\t\t\t\t\tToken password must be less than 50 characters.\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t</div>\r\n\t\t<span flex-gt-sm></span>\r\n\t\t<div layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t\t<md-button type=\"submit\" flex-order-xs=\"-1\" class=\"md-primary md-raised\">\r\n\t\t\t\t<translate>Create</translate>\r\n\t\t\t</md-button>\r\n\t\t\t<md-button ui-sref=\"^\">\r\n\t\t\t\t<translate>Cancel</translate>\r\n\t\t\t</md-button>\r\n\t\t</div>\r\n</md-content>\r\n</form>\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(145);
	__webpack_require__(147);

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(146);
		
		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminApiTokens
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminApiTokens` displays a deployments configured API Tokens
		 *
		 * @usage
		 *
		 * <sbadmin-api-tokens deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminApiTokens', [
				'sbadminToolbarService',
				ApiTokensDirective
			])
			.controller('sbadminApiTokensController', [
				'$q',
				'$state',
				'$mdDialog',
				'pxProgressService',
				'pxClipboardService',
				'sbToastService',
				'sbadminToolbarService',
				'sbadminApiTokenDataStore',
				'gettextCatalog',
				ApiTokensController
			]);
		
		function ApiTokensDirective(sbadminToolbarService) {
			return {
				restrict: 'E',
				controller: 'sbadminApiTokensController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					deploymentId: '@',
				},
				link: function (scope, element, attrs) {
					scope.$on('$destroy', function () {
						sbadminToolbarService.filterPlaceholder = null;
						sbadminToolbarService.actions = [];
					});
				}
			};
		}
		function ApiTokensController($q, $state, $mdDialog, progressService, clipboardService, toastService, sbadminToolbarService, apiTokenDataStore, gettextCatalog) {
			var vm = this;
			var initTasks = [
				apiTokenDataStore.load()
			];
			// cache dialog across invocations
			var confirm = $mdDialog.confirm()
				.title(gettextCatalog.getString('API Token'))
				.textContent(gettextCatalog.getString('Would you like to delete this API token?'))
				.ariaLabel(gettextCatalog.getString('Delete API Token'))
				.ok(gettextCatalog.getString('Delete Token'))
				.cancel(gettextCatalog.getString('Cancel'));

			vm.sbadminToolbarService = sbadminToolbarService;
			vm.apiTokenDS = apiTokenDataStore;
			
			sbadminToolbarService.title = gettextCatalog.getString('API Tokens');
			sbadminToolbarService.filterPlaceholder = gettextCatalog.getString('Find API tokens');
			sbadminToolbarService.actions = [{ 
				icon: 'add', 
				label: gettextCatalog.getString('New Token'), 
				trigger: createToken
			}];
			
			sbadminToolbarService.showFilter = true;
				
			setLoading(true);
			$q.all(initTasks)
				.then(function() {
					setLoading(false);
				});

			vm.deleteToken = function(tokenId) {
				$mdDialog
					.show(confirm)
					.then(function() {
						return apiTokenDataStore.deleteToken(tokenId);
					})
					.then(function() {
						toastService.showSimple(gettextCatalog.getString('Token deleted.'));
					});
			};

			vm.copyToken = function(tokenValue) {
				try {
					clipboardService.copy(tokenValue);
					toastService.showSimple(gettextCatalog.getString('Token copied.'));
				}
				catch (e) {
					toastService.showSimple(gettextCatalog.getString('Could not copy token.'));
				}			
			};

			function createToken() {
				$state.go('administration.home.deployment.tokens.create');
			}

			function setLoading(isLoading) {
				isLoading = typeof (isLoading) === 'boolean' ? isLoading : false;
				progressService.backdrop = progressService.visible = isLoading;
			}
		}
	})();

/***/ },
/* 146 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/apiTokens/apiTokens.template.html';
	var html = "<div flex layout=\"column\" layout-align=\"start stretch\" ng-if=\"vm.apiTokenDS.tokens.length > 0\">\r\n\t<md-list flex class=\"app--list-no-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t<md-virtual-repeat-container flex md-top-index=\"vm.itemIndex\">\r\n\t\t\t<div md-virtual-repeat=\"token in vm.apiTokenDS.tokens | filter:{userName:vm.sbadminToolbarService.filterPhrase}\">\r\n\t\t\t\t<md-list-item class=\"md-3-line md-has-secondary\" layout=\"row\" layout-align=\"center center\">\r\n\t\t\t\t\t<md-icon class=\"md-avatar sba-list-avatar material-icons\">vpn_key</md-icon>\r\n\t\t\t\t\t<div class=\"md-list-item-text\" flex>\r\n\t\t\t\t\t\t<h3 class=\"ellipsis\">{{token.userName}}</h3>\r\n\t\t\t\t\t\t<h4 class=\"ellipsis\">{{token.value}}</h4>\r\n\t\t\t\t\t\t<p translate \r\n\t\t\t\t\t\ttranslate-params-date=\"token.dateCreated | sbSimpleDateTimeString\" \r\n\t\t\t\t\t\ttranslate-comment=\"value between double braces will become a date\">\r\n\t\t\t\t\t\t\tCreated: {{date}}\r\n\t\t\t\t\t\t</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<md-button class=\"md-icon-button md-secondary\" ng-click=\"vm.copyToken(token.value)\" aria-label=\"{{::'Copy token'| translate}}\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons\">content_copy</md-icon>\r\n\t\t\t\t\t</md-button>\r\n\t\t\t\t\t<md-button class=\"md-icon-button md-secondary\" ng-click=\"vm.deleteToken(token.id)\" aria-label=\"{{::'Delete token'| translate}}\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons\">\r\n\t\t\t\t\t\t\tclear\r\n\t\t\t\t\t\t</md-icon>\r\n\t\t\t\t\t</md-button>\r\n\t\t\t\t</md-list-item>\r\n\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t</div>\r\n\t\t</md-virtual-repeat-container>\r\n\t</md-list>\r\n</div>\r\n<!-- Empty State -->\r\n<div class=\"sba__empty-state-wrap\" flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.apiTokenDS.tokens.length === 0\">\r\n\t<div class=\"sba__empty-state\" layout=\"column\" layout-align=\"center center\">\r\n\t\t<div class=\"sba__empty-state-bg\">\r\n\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">vpn_key</md-icon>\r\n\t\t</div>\r\n\t\t<h2 class=\"sba__empty-state-title\" translate>You haven't created any API tokens</h2>\r\n\t\t<p class=\"sba__empty-state-description\" translate>Create one by clicking here or the plus sign in the top right corner</p>\r\n\t</div>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 147 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 148 */,
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(150);
	__webpack_require__(152);

/***/ },
/* 150 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 151 */,
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(153);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminDeploymentCreateEdit
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminDeploymentCreate` creates new deployments
		 *
		 * @usage
		 *
		 * <sbadmin-deployment-create deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */
		angular.module('sharebase-admin')
			.directive('sbadminDeploymentCreateEdit', DeploymentCreateEditDirective)
			.controller('sbadminDeploymentCreateEditController', [
				'$q',
				'$state',
				'sbToastService',
				'pxAuthService',
				'pxProgressService',
				'pxClipboardService',
				'sbadminPermissionsService',
				'sbadminToolbarService',
				'sbadminDeploymentDataStore',
				'gettextCatalog',
				DeploymentCreateEditController
			]);
		function DeploymentCreateEditDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminDeploymentCreateEditController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					deploymentId: '@'
				},
				link: function (scope, element, attrs) { }
			};
		}

		function DeploymentCreateEditController($q, $state, sbToastService, pxAuthService, pxProgressService, pxClipboardService, sbadminPermissionsService, sbadminToolbarService, sbadminDeploymentDataStore, gettextCatalog) {
			var vm = this;
			var successMsg = '';
			var loadTasks = [];
			var filteredSystemNameInput = /[^a-z0-9_\- ]/ig;	

			vm.disabled = pxProgressService.visible = true;
			vm.authService = pxAuthService;
			vm.submit = submit;
			vm.errorMsg = '';
			vm.creatingNew = !angular.isDefined(vm.deploymentId);
			vm.deploymentDS = sbadminDeploymentDataStore;
			vm.perms = sbadminPermissionsService.deployment;
			vm.canEdit = vm.authService.isSysAdmin || vm.authService.isTenantAdmin;
			vm.updateSystemName = updateSystemName;
			vm.copyAPIPath = copyAPIPath;

			function updateSystemName() {
				if (vm.canEdit && vm.deploymentDS.details.Name) {		
					vm.deploymentDS.details.SystemName = vm.deploymentDS.details.Name.replace(filteredSystemNameInput, '');
				}
			}

			function submit() {
				if (vm.creatingNew) {
					vm.createDeployment();
				}
				else {
					vm.updateDeployment();
				}
			}

			vm.createDeployment = generateFormAction(function createDeployment() {
				return sbadminDeploymentDataStore
					.createDeployment()
					.then(function (dep) {
						successMsg = gettextCatalog.getString('Deployment "{{name}}" successfully created.', {
							name : vm.deploymentDS.details.Name
						});
					});
			}, function transitionCreate(hadError) {
				if (!hadError) {
					$state.go('administration.home');
				}
			});

			vm.updateDeployment = generateFormAction(function updateDeployment() {
				var p = pxAuthService.isSysAdmin || pxAuthService.isTenantAdmin ? 
					sbadminDeploymentDataStore.saveDeployment() :
					$q.resolve();
					
				return p.then(function() {
					return sbadminDeploymentDataStore.updateSettings();
				})
				.then(function() {
					successMsg = gettextCatalog.getString('Deployment "{{name}}" details successfully updated.', {
						name : vm.deploymentDS.details.Name
					});			
				});
			});

			(function init() {
				sbadminToolbarService.title = vm.creatingNew ? gettextCatalog.getString('Create Deployment') : gettextCatalog.getString('Deployment Details');
				sbadminToolbarService.actions = [];
				sbadminToolbarService.showFilter = false;

				if (!vm.creatingNew) {
					loadTasks.push(sbadminDeploymentDataStore
						.load(vm.deploymentId)
						.then(function (details) {
							return sbadminDeploymentDataStore.getSettings();
						}));
				}
				else {
					sbadminDeploymentDataStore.reset();
				}

				$q.all(loadTasks)
					.catch(function (err) {
						vm.errorMsg =  err.data ? err.data.ExceptionMessage : gettextCatalog.getString('An error occurred.');
					})
					.finally(function () {
						vm.disabled = pxProgressService.visible = false;
					});
			})();

			function copyAPIPath() {
				try {
					pxClipboardService.copy(vm.deploymentDS.details.Links.ApiPath);
					sbToastService.showSimple(gettextCatalog.getString('API path copied.'));
				}
				catch (e) {
					sbToastService.showSimple(gettextCatalog.getString('Could not copy path.'));
				}
			}

			function generateFormAction(fn, onComplete) {
				return function () {
					var p;
					var hadError = false;
					if (vm.f.$valid && typeof (fn) === 'function') {
						vm.disabled = pxProgressService.backdrop = pxProgressService.visible = true;
						successMsg = vm.errorMsg = '';
						p = $q.resolve(fn.apply(null, arguments));

						p.catch(function (resp) {
							vm.errorMsg = gettextCatalog.getString('An error occurred.');
							hadError = true;
							
							if(resp.data) {
								vm.errorMsg = resp.data.ExceptionMessage || resp.data.Message  || vm.errorMsg;
							}
						})
						.finally(function () {
							if (typeof (onComplete) === 'function') {
								onComplete(hadError);
							}
							vm.disabled = pxProgressService.visible = false;
							if (successMsg) {
								sbToastService.showSimple(successMsg);
							}
						});
					}
				};
			}
		}
	}());

/***/ },
/* 153 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/deploymentCreateEdit/deploymentCreateEdit.template.html';
	var html = "<form flex name=\"vm.f\" layout=\"column\" layout-align=\"start stretch\" ng-submit=\"vm.f.$valid && vm.submit()\" novalidate>\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.errorMsg\">\r\n\t\t<md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\">{{vm.errorMsg}}</md-subheader>\r\n\t</div>\r\n\t<md-content flex-gt-xs layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\">\r\n\t\t<div class=\"md-padding\">\r\n\t\t\t<md-input-container class=\"md-block\" flex-gt-sm>\r\n\t\t\t\t<label translate>Deployment Name</label>\r\n\t\t\t\t<input name=\"name\" ng-model=\"vm.deploymentDS.details.Name\" ng-disabled=\"!vm.canEdit\" required md-maxlength=\"50\" ng-change=\"vm.updateSystemName()\">\r\n\t\t\t\t<div ng-messages=\"vm.f.name.$error\" role=\"alert\" multiple>\r\n\t\t\t\t\t<div ng-message=\"required\" translate>\r\n\t\t\t\t\t\tYou must supply a deployment name.\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div ng-message=\"md-maxlength\" translate>\r\n\t\t\t\t\t\tYour name must be less than 50 characters.\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-list ng-if=\"vm.deploymentDS.details.Links.ApiPath\" class=\"app--fullbleed-list\">\r\n\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t<md-list-item class=\"md-2-line\">\r\n\t\t\t\t\t<div class=\"md-list-item-text\">\r\n\t\t\t\t\t\t<h3 translate>API Path</h3>\r\n\t\t\t\t\t\t<p id=\"deployment-api-path\">{{vm.deploymentDS.details.Links.ApiPath}}</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.copyAPIPath()\" aria-label=\"{{::'Copy API Path'| translate}}\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons\">content_copy</md-icon>\r\n\t\t\t\t\t</md-button>\r\n\t\t\t\t</md-list-item>\r\n\t\t\t\t<md-divider></md-divider>\r\n\t\t\t</md-list>\r\n\t\t\t<md-input-container ng-if=\"vm.creatingNew\" class=\"md-block\" flex-gt-sm>\r\n\t\t\t\t<label translate>System Identifier</label>\r\n\t\t\t\t<input name=\"name\" ng-model=\"vm.deploymentDS.details.SystemName\" required md-maxlength=\"50\" ng-disabled=\"true\">\r\n\t\t\t\t<div ng-messages=\"vm.f.name.$error\" role=\"alert\" multiple>\t\r\n\t\t\t\t\t<div ng-message=\"md-maxlength\" translate>\r\n\t\t\t\t\t\tYour name must be less than 50 characters.\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\" ng-if=\"vm.canEdit\" flex-gt-sm>\r\n\t\t\t\t<label translate>Customer ID</label>\r\n\t\t\t\t<input name=\"server\" ng-model=\"vm.deploymentDS.details.CustomerIdentifier\">\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\" ng-if=\"vm.canEdit\" flex-gt-sm>\r\n\t\t\t\t<label translate>Database Server</label>\r\n\t\t\t\t<input name=\"server\" ng-model=\"vm.deploymentDS.details.DatabaseServer\">\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\" ng-if=\"vm.canEdit\" flex-gt-sm>\r\n\t\t\t\t<label translate>Database Name</label>\r\n\t\t\t\t<input name=\"database\" ng-model=\"vm.deploymentDS.details.DatabaseName\">\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\" ng-if=\"vm.canEdit\" flex-gt-sm>\r\n\t\t\t\t<label translate>Database Location</label>\r\n\t\t\t\t<input name=\"location\" ng-model=\"vm.deploymentDS.details.DatabaseRootPath\">\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\" ng-if=\"vm.canEdit\" flex-gt-sm>\r\n\t\t\t\t<label translate>File Location</label>\r\n\t\t\t\t<input name=\"files\" ng-model=\"vm.deploymentDS.details.DiskgroupRootPath\">\r\n\t\t\t</md-input-container>\r\n\t\t</div>\r\n\r\n\t\t<div ng-if=\"vm.deploymentDS.settings.length > 0 && vm.authService.isSiteAdmin\">\r\n\t\t\t<md-divider ng-if=\"vm.canEdit\"></md-divider>\r\n\t\t\t<md-subheader class=\"md-accent md-no-sticky\">\r\n\t\t\t\t<translate>Options</translate>\r\n\t\t\t</md-subheader>\r\n\t\t\t<md-list>\r\n\t\t\t\t<md-list-item md-no-ink ng-if=\"setting.DataType === 'Boolean'\" ng-repeat=\"setting in vm.deploymentDS.settings\">\r\n\t\t\t\t\t<md-checkbox ng-model=\"setting.Value\"></md-checkbox>\r\n\t\t\t\t\t<span>{{setting.DisplayName}}</span>\r\n\t\t\t\t</md-list-item>\r\n\t\t\t</md-list>\r\n\t\t\t<div class=\"md-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t<md-input-container ng-if=\"setting.isDataset\" ng-repeat=\"setting in vm.deploymentDS.settings\" ng-init=\"$settingIndex = $index\">\r\n\t\t\t\t\t<label>{{setting.DisplayName}}</label>\r\n\t\t\t\t\t<md-select name=\"myModel\" ng-model=\"setting.Value\" flex=\"100\" flex-gt-xs=\"50\">\r\n\t\t\t\t\t\t<!-- $index*1 forces the option value to an int which the server wants -->\r\n\t\t\t\t\t\t<md-option ng-value=\"{{$index*1}}\" ng-repeat=\"option in setting.dataSet\">{{option}}</md-option>\r\n\t\t\t\t\t</md-select>\r\n\t\t\t\t</md-input-container>\r\n\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\" ng-if=\"vm.authService.isSysAdmin || vm.authService.isTenantAdmin || vm.authService.isSiteAdmin\">\r\n\t\t\t<md-button type=\"submit\" ng-if=\"vm.creatingNew\" flex-order-xs=\"-1\" class=\"md-primary md-raised\">{{::'Create'| translate}}</md-button>\r\n\t\t\t<md-button type=\"submit\" ng-if=\"!vm.creatingNew\" flex-order-xs=\"-1\" class=\"md-primary md-raised\">{{::'Save'| translate}}</md-button>\r\n\t\t\t<md-button ui-sref=\"^\">{{::'Cancel'| translate}}</md-button>\r\n\t\t</div>\r\n\t</md-content>\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(155);
	__webpack_require__(157);

/***/ },
/* 155 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 156 */,
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(158);
		
		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminDeploymentGroupAdminCreate
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminDeploymentGroupAdminCreate` creates new deployment group administrator
		 *
		 * @usage
		 *
		 * <sbadmin-deployment-group-admin-create deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminDeploymentGroupAdminCreate', DeploymentGroupAdminCreateDirective)
			.controller('sbadminDeploymentGroupAdminCreateController', [
				'sbadminToolbarService',
				'gettextCatalog',
				DeploymentGroupAdminCreateController
			]);
		function DeploymentGroupAdminCreateDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminDeploymentGroupAdminCreateController',
				controllerAs: 'groupAdminCreateCtrl',
				templateUrl: templateUrl,
				bindToController: {
					group: '@'
				},
				scope: true,
				link: function (scope, element, attrs) { }
			};
		}
		function DeploymentGroupAdminCreateController(sbadminToolbarService, gettextCatalog) {
			var self = this;
			sbadminToolbarService.title = gettextCatalog.getString('Create Group Administrator');
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = false;
			self.admin = {
				group: self.group !== undefined ? self.group : '',
				name: '',
				email: ''
			};

		}

	}());

/***/ },
/* 158 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/deploymentGroupAdminCreate/deploymentGroupAdminCreate.template.html';
	var html = "<form flex name=\"f\" layout=\"column\" layout-align=\"start stretch\" ng-cloak>\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"groupAdminCreateCtrl.error\">\r\n\t\t<md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\">{{groupAdminCreateCtrl.errorMessage}}</md-subheader>\r\n\t</div>\r\n\t<md-content layout-padding flex-gt-xs layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\">\r\n\t\t<div>\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>Group Name</label>\r\n\t\t\t\t<input name=\"name\" ng-model=\"groupAdminCreateCtrl.admin.group\"\r\n\t\t\t\t\t   required>\r\n\t\t\t\t<div ng-messages=\"f.name.$error\" role=\"alert\">\r\n\t\t\t\t\t<div ng-message=\"required\" class=\"my-message\" translate>You must supply a group name.</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>User Name</label>\r\n\t\t\t\t<input name=\"username\" ng-model=\"groupAdminCreateCtrl.admin.name\"\r\n\t\t\t\t\t   required>\r\n\t\t\t\t<div ng-messages=\"f.username.$error\" role=\"alert\">\r\n\t\t\t\t\t<div ng-message=\"required\" class=\"my-message\" translate>You must supply a user name.</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>Email Address</label>\r\n\t\t\t\t<input name=\"email\" ng-model=\"groupAdminCreateCtrl.admin.email\"\r\n\t\t\t\t\t   required>\r\n\t\t\t\t<div ng-messages=\"f.email.$error\" role=\"alert\">\r\n\t\t\t\t\t<div ng-message=\"required\" class=\"my-message\" translate>You must supply an email address.</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t</div>\r\n\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t<div layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\t\t\t\r\n\t\t\t<md-button type=\"submit\" flex-order-xs=\"-1\" class=\"md-primary md-raised\">{{::'Create'| translate}}</md-button>\r\n\t\t\t<md-button ui-sref=\"^\">{{::'Cancel'| translate}}</md-button>\r\n\t\t</div>\r\n\t</md-content>\r\n\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(160);
	__webpack_require__(162);

/***/ },
/* 160 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 161 */,
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(163);

		/**
		* @ngdoc directive
		* @name sharebase-admin.directive:sbadminDeploymentGroupCreate
		* @module sharebase-admin
		* @restrict E
		* @description
		*
		* `sbadminDeploymentGroupCreate` creates or edits a deployment group
		*
		* @usage
		*
		* <sbadmin-deployment-group-create-edit  /> 
		*/

		angular.module('sharebase-admin')
			.directive('sbadminDeploymentGroupCreateEdit', DeploymentGroupCreateEditDirective)
			.controller('sbadminDeploymentGroupCreateEditController', [
				'sbadminToolbarService',
				'sbadminDeploymentGroupsDataStore',
				'$state',
				'sbToastService',
				'pxProgressService',
				'gettextCatalog',
				'$location',
				DeploymentGroupCreateEditController
			])
			.config(['$stateProvider', function ($stateProvider) {
				$stateProvider
					.state('administration.home.createDeploymentGroup', {
						url: 'deployment-group/create',
						views: {
							'adminContent@administration': {
								template: '<sbadmin-deployment-group-create-edit flex/>'
							}
						}
					})
					.state('administration.home.editDeploymentGroup', {
						url: 'deployment-group/:deploymentGroupId/edit?tab',
						views: {
							'adminContent@administration': {
								template: function (params) {
									return '<sbadmin-deployment-group-create-edit deployment-group-id="' + params.deploymentGroupId + '" tab="' + params.tab + '" flex/>';
								}
							}
						}
					});
			}]);
		function DeploymentGroupCreateEditDirective() {
			return {
				restrict: 'E',
				bindToController: true,
				controller: 'sbadminDeploymentGroupCreateEditController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				scope: {
					deploymentGroupId: '@',
					tab: '@?'
				},
				link: function (scope, element, attrs) {
					if (!angular.isString(scope.tab)) {
						scope.tab = 'details';
					}
				}
			};
		}
		function DeploymentGroupCreateEditController(sbadminToolbarService, sbadminDeploymentGroupsDataStore, $state, sbToastService, pxProgressService, gettextCatalog, $location) {
			var vm = this;
			vm.error = false;
			vm.creatingNew = !angular.isDefined(vm.deploymentGroupId);
			vm.errorMessage = '';
			vm.administrators = [];	
			vm.createUpdateGroup = createUpdateGroup;
			sbadminToolbarService.title = vm.creatingNew ? gettextCatalog.getString('New Deployment Group') : gettextCatalog.getString('Deployment Group Details');
			sbadminToolbarService.showFilter = false;

			if (!vm.creatingNew) {
				sbadminDeploymentGroupsDataStore.getDeploymentGroup(vm.deploymentGroupId)
					.then(function (deploymentGroup) {
						vm.deploymentGroup = deploymentGroup;
						return sbadminDeploymentGroupsDataStore.getDeploymentGroupAdmins(deploymentGroup);
					})
					.then(function (admins) {
						vm.administrators = admins;
					});
			}
			vm.tabSelected = tabSelected;
			function tabSelected(tabName) {
				$location.search('tab', tabName);
			}

			function createUpdateGroup() {
				if(!vm.form.$valid) { return; }
				var p;

				showProgress();
				if(vm.creatingNew) {
					p = sbadminDeploymentGroupsDataStore
						.create(vm.deploymentGroup)
						.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('Deployment Group created.'));
							vm.error = false;
							$state.go('^');
						});
				}
				else {
					p = sbadminDeploymentGroupsDataStore
						.update(vm.deploymentGroup)
						.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('Deployment Group updated.'));
							vm.error = false;
							$state.go('^');
						});
				}

				p.catch(function () {
					vm.error = true;
				})
				.finally(hideProgress);			
			}

			function showProgress() {
				pxProgressService.visible = true;
				pxProgressService.backdrop = true;
			}

			function hideProgress() {
				pxProgressService.visible = false;
			}
		}
	}());

/***/ },
/* 163 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/deploymentGroupCreateEdit/deploymentGroupCreateEdit.template.html';
	var html = "<md-tabs md-border-bottom flex>\r\n\t<md-tab label=\"{{::'DETAILS'|translate}}\" md-active=\"vm.tab=='details'\" md-on-select=\"vm.tabSelected('details')\">\r\n\t\t<md-tab-content>\r\n\t\t\t<form layout-fill novalidate name=\"vm.form\" ng-submit=\"vm.form.$valid && vm.createUpdateGroup()\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.error\">\r\n\t\t\t\t\t<md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\" translate>Error processing request</md-subheader>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-content class=\"md-padding\" flex layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t<label translate>Group Name</label>\r\n\t\t\t\t\t\t<input name=\"groupName\" ng-required=\"true\" ng-model=\"vm.deploymentGroup.GroupName\" />\r\n\t\t\t\t\t\t<div ng-messages=\"vm.form.groupName.$error\" ng-show=\"vm.form.groupName.$dirty\" role=\"alert\">\r\n\t\t\t\t\t\t\t<default-error-messages />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t<label translate>Partner Identifier</label>\r\n\t\t\t\t\t\t<input name=\"partnerIdentifier\" ng-required=\"true\" ng-model=\"vm.deploymentGroup.PartnerIdentifier\" />\r\n\t\t\t\t\t\t<div ng-messages=\"vm.form.PartnerIdentifier.$error\" ng-show=\"vm.form.PartnerIdentifier.$dirty\" role=\"alert\">\r\n\t\t\t\t\t\t\t<default-error-messages />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t<label translate>Database Server (optional)</label>\r\n\t\t\t\t\t\t<input name=\"databaseServer\" ng-model=\"vm.deploymentGroup.DatabaseServer\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t<label translate>Path to MDF files (optional)</label>\r\n\t\t\t\t\t\t<input name=\"databaseRootPath\" ng-model=\"vm.deploymentGroup.DatabaseRootPath\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t<label translate>Path to LDF files (optional)</label>\r\n\t\t\t\t\t\t<input name=\"logFileRootPath\" ng-model=\"vm.deploymentGroup.LogFileRootPath\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t<label translate>Diskgroup Root Path (optional)</label>\r\n\t\t\t\t\t\t<input name=\"diskgroupRootPath\" ng-model=\"vm.deploymentGroup.DiskgroupRootPath\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<span flex-gt-xs></span>\r\n\t\t\t\t\t<div layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t\t\t\t\t<md-button ng-if=\"vm.creatingNew\" type=\"submit\" class=\"md-primary md-raised\">\r\n\t\t\t\t\t\t\t<translate>Create</translate>\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-button ng-if=\"!vm.creatingNew\" type=\"submit\" class=\"md-primary md-raised\">\r\n\t\t\t\t\t\t\t<translate>Save</translate>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-button flex-order-xs=\"2\" type=\"submit\" ui-sref=\"^\">\r\n\t\t\t\t\t\t\t<translate>Cancel</translate>\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-content>\r\n\t\t\t</form>\r\n\t\t</md-tab-content>\r\n\t</md-tab>\r\n\t<md-tab label=\"{{::'ADMINISTRATORS'|translate}}\" md-active=\"vm.tab=='administrators'\" md-on-select=\"vm.tabSelected('administrators')\">\r\n\t\t<md-tab-content>\r\n\t\t\t<md-content layout-fill>\r\n\t\t\t\t<md-list>\r\n\t\t\t\t\t<md-subheader class=\"md-no-sticky\">\r\n\t\t\t\t\t\t<span translate\r\n\t\t\t\t\t\t\t  translate-comment=\"The number of Tenant Administrators associated with a Deployment Group\"\r\n\t\t\t\t\t\t\t  translate-n=\"vm.administrators.length\"\r\n\t\t\t\t\t\t\t  translate-plural=\"{{$count}} Administrators\">\r\n\t\t\t\t\t\t\t1 Administrator\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</md-subheader>\r\n\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t<md-list-item class=\"deployment-group-user md-3-line\" ng-repeat=\"administrator in vm.administrators\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons sba-list-avatar\">person</md-icon>\r\n\t\t\t\t\t\t<div class=\"md-list-item-text\" layout=\"column\">\r\n\t\t\t\t\t\t\t<h3>{{administrator.UserName}}</h3>\r\n\t\t\t\t\t\t\t<h4>{{administrator.EmailAddress}}</h4>\r\n\t\t\t\t\t\t\t<p translate translate-params-date=\"administrator.DateCreated | sbSimpleDateTimeString\">\r\n\t\t\t\t\t\t\t\tCreated on {{date}}\r\n\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t</md-list>\r\n\t\t</md-tab-content>\r\n\t</md-tab>\r\n</md-tabs>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(165);

/***/ },
/* 165 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular.module('sharebase-admin')
			.controller('sbDeploymentGroupSelectController', [
				'$mdDialog',
				'groups',
				DeploymentGroupSelectController]);

		function DeploymentGroupSelectController($mdDialog, groups) {
			var vm = this;
			vm.groups = groups;
			vm.selectedGroup = null;
			vm.cancel = function () {
				$mdDialog.cancel();
			};
			vm.done = function () {
				if (vm.selectedGroup) {
					$mdDialog.hide(vm.selectedGroup);
				}
			};
		}
	}());

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(167);
	__webpack_require__(169);

/***/ },
/* 167 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 168 */,
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(170);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminDeploymentHome
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminDeploymentHome` is the home view of a deployment
		 *
		 * @usage
		 *
		 * <sbadmin-deployment-home deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminDeploymentHome', DeploymentHomeDirective)
			.controller('sbadminDeploymentHomeController', [
				'$q',
				'pxAuthService',
				'sbadminToolbarService',
				'gettextCatalog',
				'sbadminPermissionsService',
				'sbDeploymentNameService',
				'sbadminDeploymentStatisticsDataStore',
				DeploymentHomeController
			])
			.config(['$stateProvider', function ($stateProvider) {
				$stateProvider.state('administration.home.deployment', {
					url: 'deployment/:deploymentID',
					views: {
						'adminContent@administration': {
							template: function (params) {
								return '<sbadmin-deployment-home flex deployment-id="' + params.deploymentID + '" flex />';
							}
						}
					}
				});
			}]);

		function DeploymentHomeDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminDeploymentHomeController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				scope: {
					deploymentId: '@'
				},
				bindToController: true,
				link: function (scope, element, attrs) { }
			};
		}
		function DeploymentHomeController($q, pxAuthService, sbadminToolbarService, gettextCatalog, sbadminPermissionsService, sbDeploymentNameService, sbadminDeploymentStatisticsDataStore) {
			var vm = this;
			sbadminToolbarService.title = gettextCatalog.getString('Site Administration');
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = false;

			vm.refreshStats = refreshStats;
			vm.deploymentName = null;
			vm.statistics = null;
			vm.perms = sbadminPermissionsService; 


			sbDeploymentNameService.resolveSystemName(vm.deploymentId)
				.then(function (systemName) {
					vm.deploymentName = systemName;
					return loadStats();
				});

			function loadStats() {
				if (!vm.perms.deployment.hasRights) { return; }
				return sbadminDeploymentStatisticsDataStore
					.getStatistics(vm.deploymentName)
					.then(function (statistics) {
						vm.statistics = statistics;
					});
			}

			function refreshStats() {
				sbadminDeploymentStatisticsDataStore
					.refreshStatistics(vm.deploymentName)
					.then(function (statistics) {
						vm.statistics = statistics;
					});
			}
		}
	} ());

/***/ },
/* 170 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/deploymentHome/deploymentHome.template.html';
	var html = "<div>\r\n\t<div ng-if=\"vm.perms.deployment.hasRights\">\r\n\t\t<md-subheader class=\"md-accent app__background\">{{'Overview' | translate}}</md-subheader>\r\n\t\t<div  class=\"sbadmin-deployment__admin\" layout-wrap layout=\"row\" layout-align=\"start center\">\r\n\t\t\t<sb-statistic-card flex-sm=\"50\" flex-xs=\"100\" icon=\"people\" label=\"{{'Users' | translate}}\" value=\"vm.statistics.TotalUsers\"></sb-statistic-card>\r\n\t\t\t<sb-statistic-card flex-sm=\"50\" flex-xs=\"100\" icon=\"create_new_folder\" label=\"{{'Libraries Created' | translate}}\" value=\"vm.statistics.TotalLibraries\"></sb-statistic-card>\r\n\t\t\t<sb-statistic-card flex-sm=\"50\" flex-xs=\"100\" icon=\"cloud_upload\" label=\"{{'Documents Created'| translate}}\" value=\"vm.statistics.TotalDocumentsCreated\"></sb-statistic-card>\r\n\t\t\t<sb-statistic-card flex-sm=\"50\" flex-xs=\"100\" icon=\"pageview\" label=\"{{'Document Views'| translate}}\" value=\"vm.statistics.TotalDocumentsViewed\"></sb-statistic-card>\r\n\t\t\t<sb-statistic-card flex-sm=\"50\" flex-xs=\"100\" icon=\"storage\" label=\"{{'Storage Used' | translate}}\" value=\"vm.statistics.TotalLibraryDiskUsage | pxItemSize\"></sb-statistic-card>\r\n\t\t</div>\r\n\t\t<div layout=\"row\" layout-align=\"end center\">\r\n\t\t\t<span class=\"sbadmin-deployment-home__stat-time\" \r\n\t\t\t\ttranslate \r\n\t\t\t\ttranslate-params-date=\"vm.statistics.lastUpdated | sbSimpleDateTimeString\" \r\n\t\t\t\ttranslate-comment=\"Last deployment statistics were updated from the server\">\r\n\t\t\t\t\tUpdated {{date}}\r\n\t\t\t\t</span>\r\n\t\t\t<md-button class=\"md-icon-button\" ng-click=\"vm.refreshStats()\">\r\n\t\t\t\t<md-icon class=\"material-icons\">refresh</md-icon>\r\n\t\t\t</md-button>\r\n\t\t</div>\r\n\t\t<md-divider></md-divider>\r\n\t</div>\r\n\t<md-subheader class=\"md-accent app__background\" ng-if=\"vm.perms.deployment.hasRights\">{{'Administration' | translate}}</md-subheader>\r\n\t<div layout-wrap layout=\"row\" layout-align=\"start center\" class=\"sbadmin-deployment__admin\">\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'Users'| translate}}\" ui-sref=\"administration.home.deployment.users\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">person</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>Users</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'User Groups'| translate}}\" ui-sref=\"administration.home.deployment.userGroups\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">people</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>User Groups</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.perms.deployment.hasRights\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'Libraries'| translate}}\" ui-sref=\"administration.home.deployment.libraries\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">local_library</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>Libraries</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.perms.deployment.hasRights\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'Password Policies'| translate}}\" ui-sref=\"administration.home.deployment.passwordPolicies\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">lock</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>Password Policies</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.perms.deployment.hasRights\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'API Tokens'| translate}}\" ui-sref=\"administration.home.deployment.tokens\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">vpn_key</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>API Tokens</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.perms.deployment.hasRights\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'Active Directory'| translate}}\" ui-sref=\"administration.home.deployment.active-directory\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">domain</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>Active Directory</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t<!--\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.perms.deployment.hasRights\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'Statistics'| translate}}\" ui-sref=\"administration.home.deployment.stats\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">insert_chart</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>Statistics</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.perms.deployment.hasRights\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'Logs'| translate}}\" ui-sref=\"administration.home.deployment.logs\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">warning</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>Logs</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t\t-->\r\n\t\t<div flex-sm=\"50\" flex-xs=\"100\" ng-if=\"vm.perms.deployment.hasRights || vm.perms.system.hasRights\">\r\n\t\t\t<md-card class=\"sbadmin-admin-card\" ui-sref=\"administration.home.deployment.details\">\r\n\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">format_list_bulleted</md-icon>\r\n\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t<span class=\"md-headline\" translate>Details</span>\r\n\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t</md-card-title>\r\n\t\t\t</md-card>\r\n\t\t</div>\r\n\t</div>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(172);
	__webpack_require__(174);

/***/ },
/* 172 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 173 */,
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(175);
		
		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminDeployments
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminDeployments` displays a system/tenant admins top level administration view
		 *
		 * @usage
		 *
		 * <sbadmin-deployments /> 
		 */

		angular.module('sharebase-admin')
			.directive('sbadminDeployments', ['$timeout', DeploymentsDirective])
			.controller('sbadminDeploymentsController', [
				'$q',
				'pxAuthService',
				'pxProgressService',
				'sbadminToolbarService',
				'sbadminDeploymentsDataStore',
				'sbadminTenantAdminsDataStore',
				'sbadminPendingDeploymentsDataStore',
				'sbadminDeploymentGroupsDataStore',
				'gettextCatalog',
				DeploymentsController
			]);

		function DeploymentsDirective($timeout) {
			return {
				restrict: 'E',
				controller: 'sbadminDeploymentsController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {},
				scope: true,
				link: function (scope, element, attrs) {
				}
			};
		}

		function DeploymentsController($q, pxAuthService, pxProgressService, sbadminToolbarService, sbadminDeploymentsDataStore, sbadminTenantAdminsDataStore, sbadminPendingDeploymentsDataStore, sbadminDeploymentGroupsDataStore, gettextCatalog) {
			var vm = this;
			var initTasks = [
				sbadminDeploymentsDataStore.load(),
				sbadminPendingDeploymentsDataStore.load(),
				sbadminTenantAdminsDataStore.getAdministrators()
			];

			if (pxAuthService.isSysAdmin) {
				initTasks.push(sbadminDeploymentGroupsDataStore.load());
			}
			
			sbadminToolbarService.showFilter = true;
			sbadminToolbarService.title = gettextCatalog.getString('System Administration');

			vm.sbadminToolbarService = sbadminToolbarService;
			vm.pendingDeploymentsDS = sbadminPendingDeploymentsDataStore;
			vm.deploymentsDS = sbadminDeploymentsDataStore;
			vm.tenantAdminDS = sbadminTenantAdminsDataStore;
			vm.deploymentGroupsDS = sbadminDeploymentGroupsDataStore;
			vm.authService = pxAuthService;

			pxProgressService.visible = true;
			$q.all(initTasks)
				.finally(function() {
					pxProgressService.visible = false;
				});
		}
	}());

/***/ },
/* 175 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/deployments/deployments.template.html';
	var html = "<div flex class=\"sba-deployments app__background app--selction-disabled app-animate--fade-in\" layout=\"column\" layout-align=\"start stretch\">\r\n\t<div flex class=\"sba-deployments__main\" layout=\"column\" layout-align=\"start stretch\" ng-class=\"{'sba-deployments--search-enabled':vm.showSearch}\">\r\n\r\n\t\t<div flex layout-margin class=\"sba-deployments__content\">\r\n\t\t\t<md-content class=\"md-padding md-whiteframe-2dp\">\r\n\t\t\t\t<h3 translate>Pending Deployments</h3>\r\n\t\t\t\t<md-list>\r\n\t\t\t\t\t<md-list-item hide show-gt-sm>\r\n\t\t\t\t\t\t<div flex class=\"md-list-item-text sba-deployments__table\" layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t\t\t<div flex><strong translate>Customer Name</strong></div>\r\n\t\t\t\t\t\t\t<div flex><strong translate>Customer Identifier</strong></div>\r\n\t\t\t\t\t\t\t<div flex><strong translate>System Name</strong></div>\r\n\t\t\t\t\t\t\t<div flex><strong translate>Email</strong></div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item ui-sref=\"administration.home.pendingDeployment({pendingDeploymentId: {{item.PendingDeploymentRegistrationId}}})\" ng-repeat=\"item in vm.pendingDeploymentsDS.deployments | filter:vm.sbadminToolbarService.filterPhrase\">\r\n\t\t\t\t\t\t<div flex class=\"md-list-item-text sba-deployments__table\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\" layout=\"column\" layout-align=\"start start\">\t\t\r\n\t\t\t\t\t\t\t<div flex class=\"ellipsis\">{{item.CustomerName}}</div>\r\n\t\t\t\t\t\t\t<div flex class=\"ellipsis\">{{item.CustomerIdentifier}}</div>\r\n\t\t\t\t\t\t\t<div flex class=\"ellipsis\">{{item.SystemName}}</div>\r\n\t\t\t\t\t\t\t<div flex class=\"ellipsis\">{{item.EmailAddress}}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\r\n\t\t\t<md-content class=\"md-padding md-whiteframe-2dp\">\r\n\t\t\t\t<div layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<h3 flex translate>Active Deployments</h3>\r\n\t\t\t\t\t<md-button ui-sref=\"administration.home.newDeployment\" class=\"md-primary\" show-gt-xs hide>\r\n\t\t\t\t\t\t<translate>Create Deployment</translate>\r\n\t\t\t\t\t</md-button>\r\n\t\t\t\t\t<md-button ui-sref=\"administration.home.newDeployment\" class=\"md-icon-button\" show-xs hide>\r\n\t\t\t\t\t\t<md-icon class=\"material-icons\">add</md-icon>\r\n\t\t\t\t\t</md-button>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-list>\r\n\t\t\t\t\t<md-list-item hide show-gt-sm>\r\n\t\t\t\t\t\t<div flex class=\"md-list-item-text sba-deployments__table\" layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t\t\t<div flex=\"2\"><strong>#</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"15\"><strong translate>Group</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"20\"><strong translate>System Name</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"25\"><strong translate>Database Server</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"15\"><strong translate>Database Name</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"25\"><strong translate>API Path</strong></div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item ui-sref=\"administration.home.deployment({deploymentID: dep.id})\" ng-repeat=\"dep in vm.deploymentsDS.deployments | filter:vm.sbadminToolbarService.filterPhrase\">\r\n\t\t\t\t\t\t<div flex class=\"md-list-item-text sba-deployments__table\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\" layout=\"column\" layout-align=\"start start\">\r\n\t\t\t\t\t\t\t<div flex=\"2\">{{dep.id}}</div>\r\n\t\t\t\t\t\t\t<div title=\"{{dep.groupName}}\" flex=\"15\" class=\"ellipsis\">{{dep.groupName}}</div>\r\n\t\t\t\t\t\t\t<div title=\"{{dep.name}}\" flex=\"20\" class=\"ellipsis\">{{dep.name}}</div>\r\n\t\t\t\t\t\t\t<div title=\"{{dep.dbServer}}\" flex=\"25\" class=\"ellipsis\">{{dep.dbServer}}</div>\r\n\t\t\t\t\t\t\t<div title=\"{{dep.dbName}}\" flex=\"15\" class=\"ellipsis\">{{dep.dbName}}</div>\r\n\t\t\t\t\t\t\t<div title=\"{{dep.apiPath}}\" flex=\"25\" class=\"ellipsis\">{{dep.apiPath}}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\r\n\t\t\t<md-content class=\"md-padding md-whiteframe-2dp\" ng-if=\"vm.authService.isSysAdmin\">\r\n\t\t\t\t<div layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<h3 flex translate>Deployment Groups</h3>\r\n\t\t\t\t\t<md-button ui-sref=\"administration.home.createDeploymentGroup\" class=\"md-primary\" show-gt-xs hide>{{'Create Group' | translate}}</md-button>\r\n\t\t\t\t\t<md-button ui-sref=\"administration.home.createDeploymentGroup\" class=\"md-icon-button\" show-xs hide>\r\n\t\t\t\t\t\t<md-icon class=\"material-icons\">add</md-icon>\r\n\t\t\t\t\t</md-button>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-list>\r\n\t\t\t\t\t<md-list-item hide show-gt-sm>\r\n\t\t\t\t\t\t<div flex class=\"md-list-item-text sba-deployments__table\" layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t\t\t<div><strong>#</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"20\"><strong translate>Group Name</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"25\"><strong translate>Database Server</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"25\"><strong translate>Database Path</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"25\"><strong translate>Diskgroup Path</strong></div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item ui-sref=\"administration.home.editDeploymentGroup({deploymentGroupId:'{{item.DeploymentGroupId}}'})\" ng-repeat=\"item in vm.deploymentGroupsDS.groups | filter:vm.sbadminToolbarService.filterPhrase\">\r\n                        <div flex class=\"md-list-item-text sba-deployments__table\" layout=\"row\" layout-align=\"start start\">\r\n\t\t\t\t\t\t\t<div>{{item.DeploymentGroupId}}</div>\r\n                            <div title=\"{{item.GroupName}}\" flex-gt-sm=\"20\" flex-xs=\"100\" class=\"ellipsis\">{{item.GroupName}}</div>\r\n                            <div title=\"{{item.DatabaseServer}}\" flex=\"25\" hide show-gt-sm class=\"ellipsis\">{{item.DatabaseServer}}</div>\r\n                            <div title=\"{{item.DatabaseRootPath}}\" flex=\"25\" hide show-gt-sm class=\"ellipsis\">{{item.DatabaseRootPath}}</div>\r\n                            <div title=\"{{item.DiskgroupRootPath}}\" flex=\"25\" hide show-gt-sm class=\"ellipsis\">{{item.DiskgroupRootPath}}</div>\r\n                        </div>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\r\n\t\t\t<md-content class=\"md-padding md-whiteframe-2dp\" ng-if=\"vm.authService.isTenantAdmin\">\r\n\t\t\t\t<div layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<h3 flex translate>Group Administrators</h3>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-list>\r\n\t\t\t\t\t<md-list-item hide show-gt-sm>\r\n\t\t\t\t\t\t<div flex class=\"md-list-item-text sba-deployments__table\" layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t\t\t<div flex=\"33\"><strong translate>Group Name</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"33\"><strong translate>User Name</strong></div>\r\n\t\t\t\t\t\t\t<div flex=\"33\"><strong translate>Email Address</strong></div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item ng-click=\"null\" ng-repeat=\"item in vm.tenantAdminDS.administrators | filter:vm.sbadminToolbarService.filterPhrase\">\r\n\t\t\t\t\t\t<div flex class=\"md-list-item-text sba-deployments__table\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\" layout=\"column\" layout-align=\"start start\">\r\n\t\t\t\t\t\t\t<div title=\"{{item.DeploymentGroupName}}\" flex=\"33\" class=\"ellipsis\">{{item.DeploymentGroupName}}</div>\r\n\t\t\t\t\t\t\t<div title=\"{{item.UserName}}\" flex=\"33\" class=\"ellipsis\">{{item.UserName}}</strong></div>\r\n\t\t\t\t\t\t\t<div title=\"{{item.EmailAddress}}\" f flex=\"33\" class=\"ellipsis\"><a href=\"mailto:{{item.EmailAddress}}\">{{item.EmailAddress}}</a></div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\r\n\t\t</div>\r\n\t</div>\r\n\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(177);
	__webpack_require__(179);

/***/ },
/* 177 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 178 */,
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(180);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminInviteUsers
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminInviteUsers` form to invite users to a deployment
		 *
		 * @usage
		 *
		 * <sbadmin-invite-users deployment-id='1' /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment to invite users to
		 */

		angular.module('sharebase-admin')
			.directive('sbadminInviteUsers', [
				InviteUsersDirective])
			.controller('sbadminInviteUsersController', [
				'$q',
				'$state',
				'pxAuthService',
				'sbToastService',
				'sbUsersService',
				'sbUserGroupsDataStore',
				'sbadminToolbarService',
				'sbDeploymentNameService',
				'pxProgressService',
				'gettextCatalog',
				InviteUsersController
			]);

		function InviteUsersDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminInviteUsersController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId: '@',
				},
				scope: {},
				link: function (scope, element, attrs) {
				}
			};
		}
		function InviteUsersController($q, $state, pxAuthService, sbToastService, sbUsersService, sbUserGroupsDataStore, sbadminToolbarService, sbDeploymentNameService, pxProgressService, gettextCatalog) {
			pxProgressService.visible = pxProgressService.backdrop = true;
			var vm = this;
			var systemName;
			var initTasks = [
				sbDeploymentNameService.resolveSystemName(vm.deploymentId)
			];

			vm.sbadminToolbarService = sbadminToolbarService;
			vm.pxProgressService = pxProgressService;
			vm.submitForm = submitForm;
			vm.queryGroupSearch = queryGroupSearch;
			vm.selectedUserGroups = [];
			vm.canPromoteSiteAdmins = pxAuthService.isSiteAdmin || pxAuthService.isSysAdmin || pxAuthService.isTenantAdmin;

			sbadminToolbarService.title = gettextCatalog.getString('Invite Users');
			sbadminToolbarService.filterPlaceholder = null;
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = false;

			vm.inviteesRaw = '';
			vm.errorMessage = null;

			$q.all(initTasks)
				.then(function(taskData){
					systemName = taskData[0];
				})
				.finally(function(){
					pxProgressService.visible = pxProgressService.backdrop = false;	
				});

			function submitForm() {
				pxProgressService.visible = pxProgressService.backdrop = true;
				var emails = vm.inviteesRaw.split(',');
				var roles = [];
				if (vm.isSiteAdmin) { roles.push('SiteAdmin'); }
				if (vm.isUserAdmin) { roles.push('UserAdmin'); }
				var groups = vm.selectedUserGroups.map(function(group){
					return group.UserGroupId;
				});

				sbUsersService.inviteUsers(systemName, emails, roles, groups)
					.then(function () {
						$state.go('^');
						sbToastService.showSimple(gettextCatalog.getString('User invitations sent!'));				
					})
					.catch(function (e) {
						vm.errorMessage = e.message || gettextCatalog.getString('Error sending invitation.');
					})
					.finally(function () {
						pxProgressService.visible = pxProgressService.visible = false;
					});
			}

			function queryGroupSearch(phrase) {
				if (phrase === '' || !phrase) { return vm.userGroups; }

				phrase = phrase.toLowerCase();
				if (sbUserGroupsDataStore.userGroups.length === 0) {
					return sbUserGroupsDataStore
						.getUserGroups()
						.then(function (groups) {
							return filterGroups(phrase);
						}); 
				}

				return filterGroups(phrase);
			}

			function filterGroups(phrase) {
				return sbUserGroupsDataStore.userGroups.filter(function (group) {
					return group.UserGroupName.toLowerCase().indexOf(phrase) > -1;
				});
			}
		}
	})();

/***/ },
/* 180 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/inviteUsers/inviteUsers.template.html';
	var html = "<form name=\"vm.f\" flex layout=\"column\" layout-align=\"start stretch\" ng-submit=\"vm.f.$valid && vm.submitForm()\" ng-cloak>\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.errorMessage\">\r\n\t\t<md-subheader class=\"md-warn app__background sba-form-errors__message\">{{vm.errorMessage}}</md-subheader>\r\n\t</div>\r\n\t<md-content flex-gt-xs layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\">\r\n\r\n\t\t<md-subheader class=\"md-accent md-no-sticky\">{{'Email List' | translate}}</md-subheader>\r\n\r\n\t\t<div class=\"md-padding  sb-admin---no-top-bottom-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t<md-input-container class=\"md-block\" md-no-float>\r\n\t\t\t\t<textarea ng-model-options=\"{debounce:500}\" class=\"sb-admin-invite__input\" name=\"emails\" emaillist rows=\"3\" ng-model=\"vm.inviteesRaw\" ng-attr-placeholder=\"{{'Email addresses separated by commas' | translate}}\" required></textarea>\r\n\t\t\t\t<div ng-messages=\"vm.f.emails.$error\" role=\"alert\" ng-if=\"vm.f.emails.$touched\">\r\n\t\t\t\t\t<div ng-message=\"emaillist\" translate>Email list is invalid! Please separate each address with a comma.</div>\r\n\t\t\t\t\t<default-error-messages />\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\r\n\t\t</div>\r\n\t\t<md-subheader class=\"md-accent md-no-sticky\">{{'User Groups' | translate}}</md-subheader>\r\n\r\n\t\t<div class=\"md-padding sb-admin---no-top-bottom-padding\">\r\n\t\t\t<sb-user-select flex\r\n\t\t\t\tmultiple=\"true\"\r\n\t\t\t\tselected=\"vm.selectedUserGroups\"\r\n\t\t\t\tplaceholder=\"{{'Add default user groups' | translate}}\"\r\n\t\t\t\tinclude-users=\"false\"\r\n\t\t\t\tdeployment-id=\"vm.deploymentId\">\r\n\t\t\t</sb-user-select>\r\n\t\t</div>\r\n\t\t<md-list>\r\n\t\t\t<md-subheader class=\"md-accent md-no-sticky\">{{'User Roles' | translate}}</md-subheader>\r\n\t\t\t<md-list-item class=\"md-3-line md-with-secondary\" ng-class=\"{'sb-app__disabled-list-item':!vm.canPromoteSiteAdmins}\" ng-disabled=\"!vm.canPromoteSiteAdmins\">\r\n\t\t\t\t<div class=\"md-list-item-text sb-admin-invite---list-with-action\">\r\n\t\t\t\t\t<h3 translate>Site Administrator</h3>\r\n\t\t\t\t\t<p translate>Allow users to control features of this deployment such as libraries, password policies, API tokens, statistics and logs.</p>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-switch ng-disabled=\"!vm.canPromoteSiteAdmins\" class=\"md-secondary\" ng-model=\"vm.isSiteAdmin\"></md-switch>\r\n\t\t\t</md-list-item>\r\n\t\t\t<md-list-item class=\"md-3-line md-with-secondary\" ng-class=\"{'sb-app__disabled-list-item':!vm.canPromoteSiteAdmins}\" ng-disabled=\"!vm.canPromoteSiteAdmins\">\r\n\t\t\t\t<div class=\"md-list-item-text sb-admin-invite---list-with-action\">\r\n\t\t\t\t\t<h3 translate>User Administrator</h3>\r\n\t\t\t\t\t<p translate>Allow users to add/edit/delete users and groups for this deployment.</p>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-switch ng-disabled=\"!vm.canPromoteSiteAdmins\" class=\"md-secondary\" ng-model=\"vm.isUserAdmin\"></md-switch>\r\n\t\t\t</md-list-item>\r\n\t\t</md-list>\r\n\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\t\t\t\r\n\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\">{{::'Send'| translate}}</md-button>\r\n\t\t\t<md-button flex-order-xs=\"1\" ui-sref=\"^\">{{::'Cancel'| translate}}</md-button>\r\n\t\t</div>\r\n\t</md-content>\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(182);
	__webpack_require__(184);

/***/ },
/* 182 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 183 */,
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(185);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminLibraries
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminLibraries` displays a deployments libraryies
		 *
		 * @usage
		 *
		 * <sbadmin-libraries deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminLibraries',
			[
				'sbadminToolbarService',
				LibrariesDirective
			])
			.controller('sbadminLibrariesController',
			[
				'$state',
				'sbadminToolbarService',
				'sbadminLibrariesDataStore',
				'pxProgressService',
				'gettextCatalog',
				LibrariesController
			]);
		
		function LibrariesDirective(sbadminToolbarService) {
			return {
				restrict: 'E',
				controller: 'sbadminLibrariesController',
				controllerAs: 'librariesCtrl',
				templateUrl: templateUrl,
				scope: {},
				link: function (scope, element, attrs) {
					scope.$on('$destroy', function () {
						sbadminToolbarService.filterPlaceholder = null;
						sbadminToolbarService.actions = [];
					});
				}
			};
		}

		function LibrariesController($state, sbadminToolbarService, sbadminLibrariesDataStore, pxProgressService, gettextCatalog) {
			var self = this;
			self.loading = false;
			self.sbadminLibrariesDataStore = sbadminLibrariesDataStore;
			self.pxProgressService = pxProgressService;
			self.doneLoading = doneLoading;
			self.goToLibrary = goToLibrary;

			self.sbadminToolbarService = sbadminToolbarService;
			sbadminToolbarService.title = gettextCatalog.getString('Libraries');
			sbadminToolbarService.filterPlaceholder = gettextCatalog.getString('Find libraries');
			sbadminToolbarService.actions = [{ icon: 'add', label: gettextCatalog.getString('Create Library'), trigger: function () { $state.go('administration.home.deployment.libraries.library', { libraryId: null }); } }];
			sbadminToolbarService.showFilter = true;

			function loadLibraries() {
				isLoading();
				self.sbadminLibrariesDataStore.getLibraries()
					.finally(doneLoading);
			}

			function isLoading() {
				pxProgressService.visible = true;
			}

			function doneLoading() {
				pxProgressService.visible = false;
			}

			function goToLibrary(id) {
				$state.go('administration.home.deployment.libraries.library', { libraryId: id });
			}

			loadLibraries();
		}

	}());

/***/ },
/* 185 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/libraries/libraries.template.html';
	var html = "<md-content flex layout=\"column\" layout-align=\"start stretch\" ng-if=\"librariesCtrl.sbadminLibrariesDataStore.libraries.length > 0\">\r\n\t<md-list flex class=\"app--list-no-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t<md-virtual-repeat-container flex md-top-index=\"librariesCtrl.itemIndex\">\r\n\t\t\t<div md-virtual-repeat=\"library in librariesCtrl.sbadminLibrariesDataStore.libraries | filter:librariesCtrl.sbadminToolbarService.filterPhrase\">\r\n\t\t\t\t<md-list-item class=\"md-3-line\"\r\n\t\t\t\t\tlayout=\"row\" \r\n\t\t\t\t\tlayout-align=\"center center\" \r\n\t\t\t\t\tng-click=\"librariesCtrl.goToLibrary(library.LibraryId)\">\r\n\t\t\t\t\t<md-icon class=\"md-avatar sba-list-avatar material-icons\">account_balance</md-icon>\r\n\t\t\t\t\t<div class=\"md-list-item-text\" flex>\r\n\t\t\t\t\t\t<h3 class=\"ellipsis\">{{library.LibraryName}}</h3>\r\n\t\t\t\t\t\t<h4 class=\"ellipsis\" \r\n\t\t\t\t\t\ttranslate\r\n\t\t\t\t\t\ttranslate-params-person-name=\"library.CreatedByUserName\" \r\n\t\t\t\t\t\ttranslate-comment=\"value between double braces will become a person's name\">\r\n\t\t\t\t\t\tCreated by {{personName}}\r\n\t\t\t\t\t\t</h4>\r\n\t\t\t\t\t\t<p translate \r\n\t\t\t\t\t\ttranslate-params-date=\"library.DateCreated | sbSimpleDateTimeString\"\r\n\t\t\t\t\t\ttranslate-comment=\"value between double braces will become a date\">\r\n\t\t\t\t\t\t\tCreated on {{date}}\r\n\t\t\t\t\t\t</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-list-item>\r\n\t\t\t\t<md-divider></md-divider>\r\n\t\t\t</div>\r\n\t\t</md-virtual-repeat-container>\r\n\t</md-list>\r\n</md-content>\r\n<div class=\"sba__empty-state-wrap\" flex \r\n\tlayout=\"column\" \r\n\tlayout-align=\"center center\" \r\n\tng-if=\"librariesCtrl.sbadminLibrariesDataStore.libraries.length === 0 && !librariesCtrl.pxProgressService.visible\">\r\n\t<div class=\"sba__empty-state sba__empty-state---clickable\" layout=\"column\" layout-align=\"center center\" ui-sref=\"administration.home.deployment.libraries.library\">\r\n\t\t<div class=\"sba__empty-state-bg\">\r\n\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">account_balance</md-icon>\r\n\t\t</div>\r\n\t\t<h2 class=\"sba__empty-state-title\" translate>You haven't created any libraries</h2>\r\n\t\t<p class=\"sba__empty-state-description\" translate>Create one by clicking here or the plus sign in the top right corner</p>\r\n\t</div>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(187);
	__webpack_require__(189);

/***/ },
/* 187 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 188 */,
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(190);
		var dialogTemplateUrl = __webpack_require__(191);
		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminLibrary
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminLibrary` displays a library to add/edit
		 *
		 * @usage
		 *
		 * <sbadmin-add-edit-library library-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} libraryId The id of the library to display
		 */

		angular
			.module('sharebase-admin')
			.directive('sbadminLibrary', [
				'sbadminToolbarService',
				LibraryDirective
			])
			.controller('sbadminLibraryController', [
				'$state',
				'$mdDialog',
				'$mdMedia',
				'pxProgressService',
				'sbToastService',
				'sbadminLibraryDataStore',
				'sbadminToolbarService',
				'gettextCatalog',
				'ShareDialogTabs',
				LibraryController
			]);

		function LibraryDirective(sbadminToolbarService) {
			return {
				restrict: 'E',
				controller: 'sbadminLibraryController',
				templateUrl: templateUrl,
				controllerAs: 'vm',
				bindToController: {
					libraryId: '@'
				},
				scope: {},
				link: function (scope, element, attrs) {

					scope.$on('$destroy', function () {
						sbadminToolbarService.filterPlaceholder = null;
						sbadminToolbarService.actions = [];
					});
				}
			};
		}

		function LibraryController($state, $mdDialog, $mdMedia, pxProgressService, sbToastService, sbadminLibraryDataStore, sbadminToolbarService, gettextCatalog, ShareDialogTabs) {
			var vm = this;

			vm.errorMessage = null;
			vm.doneLoading = doneLoading;
			vm.libraryDS = sbadminLibraryDataStore;
			vm.submitForm = submitForm;
			vm.sbadminToolbarService = sbadminToolbarService;
			vm.editShare = editShare;
			vm.createUserShare = createUserShare;
			vm.creating = !vm.libraryId && vm.libraryId > -1;
			sbadminToolbarService.title = vm.libraryId ? gettextCatalog.getString('Edit Library') : gettextCatalog.getString('Create Library');
			sbadminToolbarService.filterPlaceholder = 'Find shares';
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = true;

			if (!vm.creating) {
				sbadminToolbarService.actions.push({ 
					icon: 'share', 
					label: gettextCatalog.getString('Create User Share'), 
					trigger: createUserShare 
				});
			}

			isLoading();
			sbadminLibraryDataStore
				.load(vm.libraryId)
				.then(function() {
					return sbadminLibraryDataStore.getShares();
				})
				.finally(doneLoading);

			function createUserShare($event) {
				// step index of 1 w/o share = new share
				$mdDialog.show(generateDialogConfig($event, 1));	
			}

			// function createLinkShare($event) {
			// 	$mdDialog.show(generateDialogConfig($event, 'Create Link Share'));		
			// }

			function editShare($event, share) {
				$mdDialog.show(generateDialogConfig($event, ShareDialogTabs.UserShare.Edit, share));
			}

			function generateDialogConfig(event, targetStep, share) {
				return {
					controller: 'sbShareDialogController',
					templateUrl: dialogTemplateUrl,
					controllerAs:'vm',
					targetEvent: event,
					fullscreen: $mdMedia('sm') || $mdMedia('xs'),
					clickOutsideToClose: true,
					locals: {
						context: vm.libraryDS.library,
						aclToEdit: share,
						datastore: vm.libraryDS,
						targetStep: targetStep
					}
				};
			}

			function submitForm() {
				pxProgressService.backdrop = true;
				isLoading();
				sbadminLibraryDataStore.saveLibrary()
					.then(function (response) {
						sbToastService.showSimple(vm.libraryId ? gettextCatalog.getString('Library saved!') : gettextCatalog.getString('Library created!'));
						$state.go('^');
					})
					.catch(function (e) {
						vm.errorMessage = e.data.Message;
					})
					.finally(doneLoading);
			}

			function isLoading() {
				pxProgressService.visible = true;
			}

			function doneLoading() {
				pxProgressService.visible = false;
			}
		}
	})();

/***/ },
/* 190 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/library/library.template.html';
	var html = "<form class=\"sb-admin__library-form\" layout=\"column\" name=\"vm.f\" ng-submit=\"vm.f.$valid && vm.submitForm()\" ng-cloak>\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.errorMessage\">\r\n\t\t<md-subheader class=\"md-warn app__background sba-form-errors__message\">{{vm.errorMessage}}</md-subheader>\r\n\t</div>\r\n\t<md-content class=\"md-padding\" flex-gt-xs layout-gt-xs=\"column\">\r\n\t\t<md-input-container class=\"md-block\">\r\n\t\t\t<label for=\"libraryName\" translate>Library Name</label>\r\n\t\t\t<input required id=\"libraryName\" name=\"name\" ng-model=\"vm.libraryDS.library.LibraryName\" md-maxlength=\"50\">\r\n\t\t\t<div ng-messages=\"f.name.$error\" role=\"alert\" multiple>\r\n\t\t\t\t<div ng-message=\"required\" class=\"my-message\" translate>You must supply a Library name.</div>\r\n\t\t\t\t<div ng-message=\"md-maxlength\" class=\"my-message\" translate>\r\n\t\t\t\t\tYour name must be less than 50 characters.\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</md-input-container>\r\n\t\t<span flex-gt-xs ng-if=\"vm.creating\"></span>\r\n\t\t<div layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t\t<md-button type=\"submit\" ng-if=\"vm.libraryDS.library.LibraryId && vm.f.name.$dirty\" flex-order-xs=\"-1\" class=\"md-primary md-raised app-animate--scale-in\" aria-label=\"{{::Cancel | translate}}\">\r\n\t\t\t\t<translate>Update</translate>\t\t\t\t\r\n\t\t\t</md-button>\r\n\t\t\t<md-button type=\"submit\" ng-if=\"vm.creating\" flex-order-xs=\"-1\" class=\"md-primary md-raised app-animate--scale-in\" aria-label=\"{{::Create | translate}}\">\r\n\t\t\t\t<translate>Create</translate>\r\n\t\t\t</md-button>\r\n\t\t\t<md-button ui-sref=\"^\" class=\"app-animate--scale-in\" ng-if=\"vm.creating || vm.f.name.$dirty\" aria-label=\"{{::Cancel | translate}}\">\r\n\t\t\t\t<translate>Cancel</translate>\r\n\t\t\t</md-button>\r\n\t\t</div>\r\n\t</md-content>\r\n</form>\r\n<div flex ng-if=\"!vm.creating\" layout=\"column\" layout-align=\"start stretch\">\r\n\t<md-divider></md-divider>\r\n\t<md-subheader class=\"md-accent\">{{::'Share Details' | translate}}</md-subheader>\r\n\t<sb-share-list flex object-type=\"library\" shares=\"vm.libraryDS.shares\" delete=\"vm.libraryDS.deleteShare\" on-click=\"vm.editShare\"\r\n\t\tfilter-phrase=\"vm.sbadminToolbarService.filterPhrase\" new-share-action=\"vm.createUserShare\" new-share-message=\"{{::'Share by clicking the share icon here or in the top right corner' | translate}}\">\r\n\t</sb-share-list>\r\n</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 191 */
/***/ function(module, exports) {

	var path = 'sharebase/components/shareDialog/shareDialog.template.html';
	var html = "<md-dialog aria-label=\"{{vm.getTitle()}}\" class=\"sb-share-dialog\" flex=\"80\" ng-cloak>\r\n\t<md-toolbar>\r\n\t\t<div class=\"md-toolbar-tools\">\r\n\t\t\t<h2 flex class=\"ellipsis\">{{vm.getTitle()}}</h2>\r\n\t\t\t<md-button class=\"md-icon-button\" ng-click=\"vm.close()\">\r\n\t\t\t\t<md-icon class=\"material-icons\">clear</md-icon>\r\n\t\t\t</md-button>\r\n\t\t</div>\r\n\t</md-toolbar>\r\n\t<md-dialog-content flex=\"auto\" layout=\"column\" class=\"md-dialog-content md-dialog-content---no-padding\">\r\n\t\t<md-tabs md-selected=\"vm.tabIndex\" class=\"sb-share-dialog__tab---no-tabs sb-share-dialog-tabs\">\r\n\r\n\t\t\t<md-tab label=\"home\">\r\n\t\t\t\t<md-tab-content layout=\"column\">\r\n\t\t\t\t\t<sb-share-list flex=\"grow\" object-type=\"{{vm.context.type}}\" \r\n\t\t\t\t\t\t\t\t   shares=\"vm.datastore.shares\" \r\n\t\t\t\t\t\t\t\t   inherited-shares=\"vm.datastore.inheritedShares\"  \r\n\t\t\t\t\t\t\t\t   delete=\"vm.datastore.deleteShare\"\r\n\t\t\t\t\t\t\t\t   can-modify=\"false\"></sb-share-list>\r\n\t\t\t\t\t<div layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.close();\">\r\n\t\t\t\t\t\t\t<translate>Done</translate>\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.tabIndex=1;\" aria-label=\"{{::'Navigate to share view' | translate}}\">\r\n\t\t\t\t\t\t\t<span ng-if=\"!vm.inEditMode\" translate>New Share</span>\r\n\t\t\t\t\t\t\t<span ng-if=\"vm.inEditMode\" translate>Update Share</span>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-tab-content>\r\n\t\t\t</md-tab>\r\n\r\n\t\t\t<md-tab label=\"create edit share\">\r\n\t\t\t\t<md-tab-content>\r\n\t\t\t\t\t<form name=\"vm.f\" layout-fill layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t\t<md-list>\r\n\t\t\t\t\t\t\t<md-list-item>\r\n\t\t\t\t\t\t\t\t<md-icon class=\"md-avatar sba-list-avatar material-icons\">{{vm.context.type === 'document' ? 'insert_drive_file' : 'folder'}}</md-icon>\r\n\t\t\t\t\t\t\t\t<p>{{vm.context.name}}</p>\r\n\t\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t</md-list>\r\n\t\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.error\">\r\n\t\t\t\t\t\t\t<md-subheader class=\"md-warn app__background sba-form-errors__message\">{{ vm.error }}</md-subheader>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<md-content flex-gt-xs class=\"md-padding\">\r\n\t\t\t\t\t\t\t<h4 ng-if=\"!vm.inEditMode\" translate>Share With:</h4>\r\n\t\t\t\t\t\t\t<h4 ng-if=\"vm.inEditMode\" translate>Shared With:</h4>\r\n\t\t\t\t\t\t\t<sb-user-select flex \r\n\t\t\t\t\t\t\t\tmultiple=\"true\"\r\n\t\t\t\t\t\t\t\treadonly=\"vm.inEditMode\" \r\n\t\t\t\t\t\t\t\tplaceholder=\"{{'Add Users and groups' | translate}}\" \r\n\t\t\t\t\t\t\t\tselected=\"vm.share.users\"\r\n\t\t\t\t\t\t\t\tdeployment-id=\"vm.deploymentId\">\r\n\t\t\t\t\t\t\t</sb-user-select>\r\n\t\t\t\t\t\t\t<h4 translate>Rights:</h4>\r\n\t\t\t\t\t\t\t<md-select aria-label=\"Assign a share right\" ng-model=\"vm.share.right\" ng-change=\"vm.updateAdvancedOptions()\">\r\n\t\t\t\t\t\t\t\t<md-option ng-value=\"right.id\" ng-repeat=\"right in vm.availableRights\">{{ right.name }}</md-option>\r\n\t\t\t\t\t\t\t</md-select>\r\n\t\t\t\t\t\t\t<div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.availableAdvancedOptions.length > 0\">\r\n\t\t\t\t\t\t\t\t<md-button class=\"app--button-all-lowercase md-accent app-animate--scale-in\" ng-click=\"vm.showAdvanced = !vm.showAdvanced\" aria-label=\"{{'Advanced share options' | translate}}\">\r\n\t\t\t\t\t\t\t\t\t<span ng-if=\"!vm.showAdvanced\" translate>show advanced share options</span>\r\n\t\t\t\t\t\t\t\t\t<span ng-if=\"vm.showAdvanced\" translate>hide advanced share options</span>\r\n\t\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div ng-if=\"vm.showAdvanced && vm.availableAdvancedOptions.length > 0\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t\t\t\t<h4 translate>Allow:</h4>\r\n\t\t\t\t\t\t\t\t<md-checkbox ng-model=\"ao.value\" ng-change=\"vm.checkAllowFlags(ao)\" ng-repeat=\"ao in vm.availableAdvancedOptions\" ng-disabled=\"ao.disabled\">\r\n\t\t\t\t\t\t\t\t\t{{ao.name}}\r\n\t\t\t\t\t\t\t\t</md-checkbox>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</md-content>\r\n\t\t\t\t\t\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t\t\t\t\t\t<md-button flex-order-xs=\"2\" ng-click=\"vm.tabIndex=0;\">\r\n\t\t\t\t\t\t\t\t<translate>View Existing Shares</translate>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t<span flex></span>\r\n\t\t\t\t\t\t\t<md-button flex-order-xs=\"1\" ng-click=\"vm.close();\">\r\n\t\t\t\t\t\t\t\t<translate>Cancel</translate>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t<md-button aria-label=\"Update the current or create a new share\" flex-order-xs=\"0\" ng-click=\"vm.createUpdateShare()\" ng-class=\"{'md-raised md-primary' : vm.mdMedia('xs')}\">\r\n\t\t\t\t\t\t\t\t<span ng-if=\"!vm.inEditMode\" translate>Create Share</span>\r\n\t\t\t\t\t\t\t\t<span ng-if=\"vm.inEditMode\" translate>Update Share</span>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</form>\r\n\t\t\t\t</md-tab-content>\r\n\t\t\t</md-tab>\r\n\r\n\t\t\t<md-tab label=\"share created\">\r\n\t\t\t\t<md-tab-content layout=\"column\">\r\n\t\t\t\t\t<md-content flex=\"grow\" class=\"md-padding\" layout=\"column\" layout-align=\"center center\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">check_circle</md-icon>\r\n\t\t\t\t\t\t<div class=\"sba__empty-state-title\">\r\n\t\t\t\t\t\t\t<span ng-if=\"!vm.inEditMode\" translate>Content has been successfully shared!</span>\r\n\t\t\t\t\t\t\t<span ng-if=\"vm.inEditMode\" translate>Share has been successfully updated!</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div ng-if=\"!vm.inEditMode\" class=\"sba__empty-state-description\" translate>Users have been notified of new shared content</div>\r\n\t\t\t\t\t</md-content>\r\n\t\t\t\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t\t\t\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\">\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.close();\">\r\n\t\t\t\t\t\t\t<translate>Done</translate>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-tab-content>\r\n\t\t\t</md-tab>\r\n\r\n\t\t\t<md-tab label=\"create link share\">\r\n\t\t\t\t<md-tab-content layout=\"column\">\r\n\t\t\t\t\t<md-content flex=\"grow\" layout=\"column\">\r\n\t\t\t\t\t\t<h4 class=\"md-title\" translate>Rights:</h4>\r\n\t\t\t\t\t\t<md-select ng-model=\"vm.linkShare.rights\" aria-label=\"{{::'Share rights' | translate}}\">\r\n\t\t\t\t\t\t\t<md-option value=\"Upload Only\" translate ng-if=\"vm.context.type !== 'document'\">Upload Only</md-option>\r\n\t\t\t\t\t\t\t<md-option value=\"View\" translate>View</md-option>\r\n\t\t\t\t\t\t\t<md-option value=\"Edit\" translate>Edit</md-option>\r\n\t\t\t\t\t\t</md-select>\r\n\t\t\t\t\t\t<div layout=\"row\" layout-align=\"end center\">\r\n\t\t\t\t\t\t\t<md-button class=\"app--button-all-lowercase md-accent\" ng-click=\"vm.showAdvanced = !vm.showAdvanced\">\r\n\t\t\t\t\t\t\t\t<translate>show advanced options</translate>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div ng-show=\"vm.showAdvanced\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t\t\t<h4 translate>Allow:</h4>\r\n\t\t\t\t\t\t\t<md-checkbox ng-checked=\"vm.linkShare.allowDelete\" ng-if=\"vm.rights=== 'Edit'\" ng-click=\"vm.linkShare.allowDelete = !vm.linkShare.allowDelete\">\r\n\t\t\t\t\t\t\t\t<translate>Delete</translate>\r\n\t\t\t\t\t\t\t</md-checkbox>\r\n\t\t\t\t\t\t\t<md-checkbox ng-checked=\"vm.linkShare.allowUpload\" ng-if=\"vm.rights=== 'View'\" ng-click=\"vm.linkShare.allowUpload = !vm.linkShare.allowUpload\">\r\n\t\t\t\t\t\t\t\t<translate>Upload</translate>\r\n\t\t\t\t\t\t\t</md-checkbox>\r\n\t\t\t\t\t\t\t<md-checkbox ng-checked=\"vm.linkShare.allowDownload\" ng-if=\"vm.rights=== 'View'\" ng-click=\"vm.linkShare.allowDownload = !vm.linkShare.allowDownload\">\r\n\t\t\t\t\t\t\t\t<translate>Download</translate>\r\n\t\t\t\t\t\t\t</md-checkbox>\r\n\t\t\t\t\t\t\t<md-checkbox ng-checked=\"vm.linkShare.allowFolderContents\" ng-if=\"vm.rights=== 'Upload Only'\" ng-click=\"vm.linkShare.allowFolderContents = !vm.linkShare.allowFolderContents\">\r\n\t\t\t\t\t\t\t\t<translate>View folder contents</translate>\r\n\t\t\t\t\t\t\t</md-checkbox>\r\n\r\n\t\t\t\t\t\t\t<h4 translate>Expires:</h4>\r\n\r\n\t\t\t\t\t\t\t<h4 translate>Password:</h4>\r\n\r\n\t\t\t\t\t\t\t<h4 translate>Recipients:</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</md-content>\r\n\t\t\t\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t\t\t\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\">\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.tabIndex=0;\">\r\n\t\t\t\t\t\t\t<translate>View Existing Shares</translate>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<span flex></span>\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.close();\">\r\n\t\t\t\t\t\t\t<translate>Cancel</translate>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.tabIndex=4;\">\r\n\t\t\t\t\t\t\t<translate>Create Share</translate>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-tab-content>\r\n\t\t\t</md-tab>\r\n\r\n\t\t\t<md-tab label=\"link share created\">\r\n\t\t\t\t<md-tab-content layout=\"column\">\r\n\t\t\t\t\t<md-content flex=\"grow\" class=\"md-padding\" layout=\"column\" layout-align=\"center center\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">check_circle</md-icon>\r\n\t\t\t\t\t\t<div class=\"sba__empty-state-title\">\r\n\t\t\t\t\t\t\t<span ng-if=\"!vm.inEditMode\" translate>New share link has been generated!</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"sba__empty-state-description\" ng-if=\"!vm.linkEmailAddresses.length > 0\" translate>Recipients have been emailed this new link</div>\r\n\r\n\t\t\t\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t\t\t\t<label>Share Link</label>\r\n\t\t\t\t\t\t\t<input type=\"text\" readonly id=\"urlInput\" ng-model=\"vm.shareLink\" />\r\n\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t</md-content>\r\n\t\t\t\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t\t\t\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.copyURL()\" data-clipboard-target=\"#urlInput\">\r\n\t\t\t\t\t\t\t{{::'Copy To Clipboard' | translate}}\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-button ng-click=\"vm.close();\" flex-order-xs=\"-1\" ng-class=\"{'md-raised md-primary' : vm.mdMedia('xs')}\">\r\n\t\t\t\t\t\t\t{{::'Done' | translate}}\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-tab-content>\r\n\t\t\t</md-tab>\r\n\r\n\t\t</md-tabs>\r\n\t</md-dialog-content>\r\n</md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(193);
	__webpack_require__(195);

/***/ },
/* 193 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 194 */,
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(196);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminPasswordPolicies
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminPasswordPolicies` displays a deployments password policies
		 *
		 * @usage
		 *
		 * <sbadmin-password-policies deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminPasswordPolicies',
			[
				'sbadminToolbarService',
				PasswordPoliciesDirective
			])
			.controller('sbadminPasswordPoliciesController',
			[
				'$state',
				'sbadminToolbarService',
				'sbadminPasswordPoliciesDataStore',
				'pxProgressService',
				'gettextCatalog',
				PasswordPoliciesController
			]);
		
		function PasswordPoliciesDirective(sbadminToolbarService) {
			return {
				restrict: 'E',
				controller: 'sbadminPasswordPoliciesController',
				controllerAs: 'passwordsCtrl',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId: '@',
				},
				scope: {},
				link: function (scope, element, attrs) {
					scope.$on('$destroy', function () {
						sbadminToolbarService.filterPlaceholder = null;
						sbadminToolbarService.actions = [];
					});
				}
			};
		}

		function PasswordPoliciesController($state, sbadminToolbarService, sbadminPasswordPoliciesDataStore, pxProgressService, gettextCatalog) {
			var self = this;
			self.doneLoading = doneLoading;
			self.pxProgressService = pxProgressService;
			self.passwordPoliciesDS = sbadminPasswordPoliciesDataStore;
			self.sbadminToolbarService = sbadminToolbarService;
			self.goToPasswordPolicy = goToPasswordPolicy;

			sbadminToolbarService.actions = [{ icon: 'add', label: gettextCatalog.getString('Create Policy'), trigger: function () { $state.go('administration.home.deployment.passwordPolicies.details', { passwordPolicyId: '' }); } }];
			sbadminToolbarService.showFilter = true;
			sbadminToolbarService.title = gettextCatalog.getString('Password Policies');
			sbadminToolbarService.filterPlaceholder = gettextCatalog.getString('Find password policies');

			function loadPasswordPolicies() {
				isLoading();
				sbadminPasswordPoliciesDataStore.getPasswordPolicies()
					.finally(doneLoading);
			}

			function isLoading() {
				pxProgressService.visible = true;
			}

			function doneLoading() {
				pxProgressService.visible = false;
			}

			function goToPasswordPolicy(passwordPolicyId) {
				$state.go('administration.home.deployment.passwordPolicies.details', { passwordPolicyId: passwordPolicyId });
			}

			loadPasswordPolicies();
		}

	}());

/***/ },
/* 196 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/passwordPolicies/passwordPolicies.template.html';
	var html = "<md-content flex layout=\"column\" layout-align=\"start stretch\" ng-if=\"passwordsCtrl.passwordPoliciesDS.passwordPolicies.length > 0\">\r\n\t<md-list flex class=\"app--list-no-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t<md-virtual-repeat-container flex md-top-index=\"passwordsCtrl.itemIndex\">\r\n\t\t\t<div md-virtual-repeat=\"policy in passwordsCtrl.passwordPoliciesDS.passwordPolicies | filter:{Name:passwordsCtrl.sbadminToolbarService.filterPhrase}\">\r\n\t\t\t\t<md-list-item class=\"md-2-line\" layout=\"row\" layout-align=\"center center\" ng-click=\"passwordsCtrl.goToPasswordPolicy(policy.PasswordPolicyId)\">\r\n\t\t\t\t\t<md-icon class=\"md-avatar md-accent sba-list-avatar material-icons\">{{policy.Active === true ? 'check' : ''}}</md-icon>\r\n\t\t\t\t\t<div class=\"md-list-item-text\" flex>\r\n\t\t\t\t\t\t<h3 class=\"ellipsis\">{{policy.Name}}</h3>\r\n\t\t\t\t\t\t<p ng-if=\"policy.Active\">{{::'Active Policy'| translate}}</p>\r\n\t\t\t\t\t\t<p ng-if=\"!policy.Active\"></p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-list-item>\r\n\t\t\t\t<md-divider></md-divider>\r\n\t\t\t</div>\r\n\t\t</md-virtual-repeat-container>\r\n\t</md-list>\r\n</md-content>\r\n<!-- Empty State -->\r\n<div class=\"sba__empty-state-wrap\" flex layout=\"column\" layout-align=\"center center\" ng-if=\"passwordsCtrl.passwordPoliciesDS.passwordPolicies.length === 0 && !passwordsCtrl.pxProgressService.visible\">\r\n\t<div class=\"sba__empty-state sba__empty-state---clickable\" layout=\"column\" layout-align=\"center center\" ui-sref=\"administration.home.deployment.passwordPolicies.details\">\r\n\t\t<div class=\"sba__empty-state-bg\">\r\n\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">lock_open</md-icon>\r\n\t\t</div>\r\n\t\t<h2 class=\"sba__empty-state-title\" translate>You haven't created any password policies</h2>\r\n\t\t<p class=\"sba__empty-state-description\" translate>Create one by clicking here or the plus sign in the top right corner</p>\r\n\t</div>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(198);
	__webpack_require__(200);

/***/ },
/* 198 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 199 */,
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(201);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminPasswordPolicy
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminPasswordPolicy` displays a PasswordPolicy to add/edit
		 *
		 * @usage
		 *
		 * <sbadmin-add-edit-PasswordPolicy PasswordPolicy-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} PasswordPolicyId The id of the PasswordPolicy to display
		 */

		angular
			.module('sharebase-admin')
			.directive('sbadminPasswordPolicy',
			[
				PasswordPolicyDirective
			])
			.controller('sbadminPasswordPolicyController',
			[
				'sbToastService',
				'$state',
				'sbadminPasswordPolicyDataStore',
				'sbadminToolbarService',
				'pxProgressService',
				'gettextCatalog',
				PasswordPolicyController
			]);

		function PasswordPolicyDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminPasswordPolicyController',
				controllerAs: 'ppCtrl',
				templateUrl: templateUrl,
				bindToController: {
					passwordPolicyId: '@'
				},
				scope: {},
				link: function (scope, element, attrs) {
				}
			};
		}

		function PasswordPolicyController(sbToastService, $state, sbadminPasswordPolicyDataStore, sbadminToolbarService, pxProgressService, gettextCatalog) {
			var self = this;
			self.loading = false;
			self.doneLoading = doneLoading;
			self.save = save;
			self.ppDS = sbadminPasswordPolicyDataStore;
			self.updateActiveStatus = updateActiveStatus;

			sbadminToolbarService.title = self.passwordPolicyId ? gettextCatalog.getString('Edit Password Policy') : gettextCatalog.getString('Create Password Policy');
			
			sbadminToolbarService.showFilter = false;
			sbadminToolbarService.actions = [];

			function loadPasswordPolicy() {
				isLoading();

				sbadminPasswordPolicyDataStore.getPasswordPolicy(self.passwordPolicyId)
					.finally(function () {
						doneLoading();
					});
			}

			function updateActiveStatus() {
				if (self.loading || !self.passwordPolicyId) { return; }

				if (self.ppDS.passwordPolicy.Active) {
					self.ppDS.activatePasswordPolicy(self.passwordPolicyId).then(function () {
						sbToastService.showSimple(gettextCatalog.getString('{{name}} policy is now activated.', { name: self.ppDS.passwordPolicy.Name }));
					});
					return;
				}

				self.ppDS.deactivatePasswordPolicy(self.passwordPolicyId).then(function () {
					sbToastService.showSimple(gettextCatalog.getString('{{name}} policy is now deactivated.', { name: self.ppDS.passwordPolicy.Name }));
				});
			}

			function save() {
				pxProgressService.backdrop = true;
				isLoading();

				self.ppDS.savePasswordPolicy()
					.then(function () {
						sbToastService.showSimple(self.passwordPolicyId ? gettextCatalog.getString('Password policy saved!') : gettextCatalog.getString('Password policy created!'));
						$state.go('^');
					})
					.finally(doneLoading);
			}

			function isLoading() {
				self.loading = true;
				pxProgressService.visible = true;
			}

			function doneLoading() {
				self.loading = false;
				pxProgressService.visible = false;
			}

			loadPasswordPolicy();
		}
	})();

/***/ },
/* 201 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/passwordPolicy/passwordPolicy.template.html';
	var html = "<form flex name=\"ppForm\" layout=\"column\" layout-align=\"start stretch\" ng-submit=\"ppForm.$valid && ppCtrl.save()\" ng-cloak>\r\n\t<md-content flex ng-hide=\"ppCtrl.loading\" class=\"app__background\">\r\n\t\t<md-list ng-if=\"ppCtrl.ppDS.passwordPolicy.PasswordPolicyId\">\r\n\t\t\t<md-list-item class=\"md-with-secondary\">\r\n\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar md-accent\" ng-if=\"ppCtrl.ppDS.passwordPolicy.Active\">check</md-icon>\r\n\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\" ng-if=\"!ppCtrl.ppDS.passwordPolicy.Active\">close</md-icon>\r\n\t\t\t\t<p translate>Active Policy</p>\r\n\t\t\t\t<md-switch class=\"md-secondary\" ng-model=\"ppCtrl.ppDS.passwordPolicy.Active\" ng-change=\"ppCtrl.updateActiveStatus()\"></md-switch>\r\n\t\t\t</md-list-item>\r\n\t\t\t<md-divider></md-divider>\r\n\t\t</md-list>\r\n\t\t<div class=\"md-padding\">\r\n\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>Policy Name</label>\r\n\t\t\t\t<input name=\"name\" ng-model=\"ppCtrl.ppDS.passwordPolicy.Name\"\r\n\t\t\t\t\t   required md-maxlength=\"50\">\r\n\t\t\t\t<div ng-messages=\"ppForm.name.$error\" role=\"alert\" multiple>\r\n\t\t\t\t\t<div ng-message=\"required\" class=\"my-message\" translate>You must supply a name.</div>\r\n\t\t\t\t\t<div ng-message=\"md-maxlength\" class=\"my-message\" translate>\r\n\t\t\t\t\t\tYour name must be less than 50 characters.\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t</div>\r\n\t\t<div layout-margin>\r\n\t\t\t<div class=\"md-whiteframe-2dp md-padding sb-admin__card\">\r\n\t\t\t\t<h3 translate>Complexity</h3>\r\n\t\t\t\t<div layout-gt-sm=\"row\" layout-padding>\r\n\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm=\"50\">\r\n\t\t\t\t\t\t<label translate>Maximum Repeated Consecutive Characters</label>\r\n\t\t\t\t\t\t<input name=\"maxRepeat\" ng-model=\"ppCtrl.ppDS.passwordPolicy.MaxRepeatedChars\"\r\n\t\t\t\t\t\t\t   ng-value=\"3\" min=\"0\" max=\"1024\">\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm=\"50\">\r\n\t\t\t\t\t\t<label translate>Minimum Length</label>\r\n\t\t\t\t\t\t<input name=\"minLength\" ng-model=\"ppCtrl.ppDS.passwordPolicy.MinLength\"\r\n\t\t\t\t\t\t\t   ng-value=\"15\" min=\"0\" max=\"1024\">\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"md-whiteframe-2dp md-padding sb-admin__card\">\r\n\t\t\t\t<h3 translate translate-comment=\"How often a password needs to be changed\">Rotation</h3>\r\n\t\t\t\t<md-radio-group ng-model=\"ppCtrl.ppDS.passwordPolicy.ReuseStyle\" flex>\r\n\t\t\t\t\t<md-list>\r\n\t\t\t\t\t\t<md-list-item ng-click=\"ppCtrl.ppDS.passwordPolicy.ReuseStyle = 0\" md-no-ink>\r\n\t\t\t\t\t\t\t<md-radio-button value=\"0\" class=\"sb-admin-pp---list-radio\" aria-label=\"{{::'Allow Reuse' | translate }}\">\r\n\t\t\t\t\t\t\t\t{{::'Allow Reuse' | translate }}\r\n\t\t\t\t\t\t\t</md-radio-button>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t<md-list-item ng-click=\"ppCtrl.ppDS.passwordPolicy.ReuseStyle = 1\" md-no-ink>\r\n\t\t\t\t\t\t\t<md-radio-button value=\"1\" class=\"sb-admin-pp---list-radio\" aria-label=\"{{::'Prevent Reuse' | translate}}\">\r\n\t\t\t\t\t\t\t\t{{::'Prevent Reuse' | translate}}\r\n\t\t\t\t\t\t\t</md-radio-button>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t<md-list-item ng-click=\"ppCtrl.ppDS.passwordPolicy.ReuseStyle = 2\" md-no-ink>\r\n\t\t\t\t\t\t\t<md-radio-button flex value=\"2\" class=\"sb-admin-pp---list-radio\" aria-label=\"{{::'Prevent Reuse Within (n) Days' | translate}}\">\r\n\t\t\t\t\t\t\t\t{{::'Prevent Reuse Within (n) Days' | translate}}\r\n\t\t\t\t\t\t\t</md-radio-button>\r\n\t\t\t\t\t\t\t<md-input-container class=\"md-secondary\">\r\n\t\t\t\t\t\t\t\t<div ng-click=\"$event.stopPropagation()\">\r\n\t\t\t\t\t\t\t\t<input name=\"preventReuseDayLimit\" \r\n\t\t\t\t\t\t\t\t\t   type=\"number\" \r\n\t\t\t\t\t\t\t\t\t   ng-model=\"ppCtrl.ppDS.passwordPolicy.ReuseDaysLimit\" \r\n\t\t\t\t\t\t\t\t\t   ng-disabled=\"ppCtrl.ppDS.passwordPolicy.ReuseStyle != 2\" \r\n\t\t\t\t\t\t\t\t\t   value=\"0\" min=\"0\" max=\"10000\" \r\n\t\t\t\t\t\t\t\t\t   aria-label=\"{{::'Prevent Reuse Within (n) Days' | translate}}\" />\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t<md-list-item ng-click=\"ppCtrl.ppDS.passwordPolicy.ReuseStyle = 3\" md-no-ink>\r\n\t\t\t\t\t\t\t<md-radio-button flex value=\"3\" class=\"sb-admin-pp---list-radio\" aria-label=\"{{::'Prevent Reuse Within (n) Changes' | translate}}\">\r\n\t\t\t\t\t\t\t\t{{'Prevent Reuse Within (n) Changes' | translate}}\r\n\t\t\t\t\t\t\t</md-radio-button>\r\n\t\t\t\t\t\t\t<md-input-container class=\"md-secondary\">\r\n\t\t\t\t\t\t\t\t<div ng-click=\"$event.stopPropagation()\">\r\n\t\t\t\t\t\t\t\t\t<input name=\"preventReuseChangeLimit\" \r\n\t\t\t\t\t\t\t\t\t\ttype=\"number\"\r\n\t\t\t\t\t\t\t\t\t\tng-model=\"ppCtrl.ppDS.passwordPolicy.ReuseChangesLimit\" \r\n\t\t\t\t\t\t\t\t\t\tng-disabled=\"ppCtrl.ppDS.passwordPolicy.ReuseStyle != 3\" \r\n\t\t\t\t\t\t\t\t\t\tvalue=\"0\" min=\"0\" max=\"10000\" \r\n\t\t\t\t\t\t\t\t\t\taria-label=\"{{::'Prevent Reuse Within (n) Changes' | translate}}\" />\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t</md-list>\r\n\t\t\t\t</md-radio-group>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"md-whiteframe-2dp md-padding sb-admin__card\">\r\n\t\t\t\t<h3 translate>Change Frequency</h3>\r\n\t\t\t\t<md-list>\r\n\t\t\t\t\t<md-list-item md-no-ink>\r\n\t\t\t\t\t\t<md-checkbox ng-model=\"ppCtrl.ppDS.requireWait\" aria-label=\"{{::'Require (n) Hours Between Changes' | translate}}\"></md-checkbox>\r\n\t\t\t\t\t\t<p>{{::'Require (n) Hours Between Changes' | translate}}</p>\r\n\t\t\t\t\t\t<md-input-container class=\"sb-admin-pp---list-radio md-secondary\" >\r\n\t\t\t\t\t\t\t<div ng-click=\"$event.stopPropagation()\">\r\n\t\t\t\t\t\t\t<input type=\"number\" \r\n\t\t\t\t\t\t\t\t   name=\"hoursBetween\" \t\t\t\t\t\t\t\t   \r\n\t\t\t\t\t\t\t\t   ng-model=\"ppCtrl.ppDS.passwordPolicy.HoursBetweenChanges\" \r\n\t\t\t\t\t\t\t\t   ng-disabled=\"!ppCtrl.ppDS.requireWait\" \r\n\t\t\t\t\t\t\t\t   value=\"0\" min=\"0\" max=\"10000\" \r\n\t\t\t\t\t\t\t\t   aria-label=\"{{::'Require (n) Hours Between Changes' | translate}}\" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item md-no-ink>\r\n\t\t\t\t\t\t<md-checkbox ng-model=\"ppCtrl.ppDS.expire\" aria-label=\"{{::'Expire Every (n) Days' | translate}}\"></md-checkbox>\r\n\t\t\t\t\t\t<p>{{::'Expire Every (n) Days' | translate}}</p>\r\n\t\t\t\t\t\t<md-input-container class=\"sb-admin-pp---list-radio md-secondary\">\r\n\t\t\t\t\t\t\t<div ng-click=\"$event.stopPropagation()\">\r\n\t\t\t\t\t\t\t<input type=\"number\" \r\n\t\t\t\t\t\t\t\t   name=\"expiry\" \r\n\t\t\t\t\t\t\t\t   ng-model=\"ppCtrl.ppDS.passwordPolicy.ExpiryDays\" \r\n\t\t\t\t\t\t\t\t   ng-disabled=\"!ppCtrl.ppDS.expire\" \r\n\t\t\t\t\t\t\t\t   value=\"180\" min=\"0\" max=\"10000\" \r\n\t\t\t\t\t\t\t\t   aria-label=\"{{::'Expire Every (n) Days' | translate}}\" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t</md-list>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"md-whiteframe-2dp md-padding sb-admin__card\">\r\n\t\t\t\t<h3 translate>Content Quotas</h3>\r\n\t\t\t\t<div layout-gt-sm=\"row\" layout-align-gt-sm=\"start start\" layout=\"column\" layout-align=\"start stretch\" layout-wrap layout-padding>\r\n\t\t\t\t\t<md-input-container flex-gt-sm=\"33\">\r\n\t\t\t\t\t\t<label translate>Require At Least (n) Alphabetic Characters</label>\r\n\t\t\t\t\t\t<input name=\"alphQuota\" ng-model=\"ppCtrl.ppDS.passwordPolicy.AlphaQuota\" value=\"0\" min=\"0\" max=\"1024\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container flex-gt-sm=\"33\">\r\n\t\t\t\t\t\t<label translate>Require At Least (n) Numeric Characters</label>\r\n\t\t\t\t\t\t<input name=\"numQuota\" ng-model=\"ppCtrl.ppDS.passwordPolicy.NumericQuota\" value=\"0\" min=\"0\" max=\"1024\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container flex-gt-sm=\"33\">\r\n\t\t\t\t\t\t<label translate>Require At Least (n) Special Characters (e.g. *!@.)</label>\r\n\t\t\t\t\t\t<input name=\"specialQuota\" ng-model=\"ppCtrl.ppDS.passwordPolicy.SpecialQuota\" value=\"0\" min=\"0\" max=\"1024\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container flex-gt-sm=\"33\">\r\n\t\t\t\t\t\t<label translate>Require At Least (n) Uppercase Characters</label>\r\n\t\t\t\t\t\t<input name=\"upperQuota\" ng-model=\"ppCtrl.ppDS.passwordPolicy.UppercaseQuota\" value=\"0\" min=\"0\" max=\"1024\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container flex-gt-sm=\"33\">\r\n\t\t\t\t\t\t<label translate>Require At Least (n) Lowercase Characters</label>\r\n\t\t\t\t\t\t<input name=\"lowerQuota\" ng-model=\"ppCtrl.ppDS.passwordPolicy.LowercaseQuota\" value=\"0\" min=\"0\" max=\"1024\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<md-input-container flex-gt-sm=\"33\">\r\n\t\t\t\t\t\t<label translate>Satisfy At Least (n) Quota Rules</label>\r\n\t\t\t\t\t\t<input name=\"requiredQuotaMatch\" ng-model=\"ppCtrl.ppDS.passwordPolicy.RequiredQuotaMatch\" value=\"0\" min=\"0\" max=\"5\" />\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"md-whiteframe-2dp md-padding sb-admin__card\">\r\n\t\t\t\t<h3 translate>Account Lockout</h3>\r\n\t\t\t\t<md-list>\r\n\t\t\t\t\t<md-list-item md-no-ink>\r\n\t\t\t\t\t\t<md-checkbox ng-model=\"ppCtrl.ppDS.enforceFailure\" ng-value=\"true\" aria-label=\"{{::'Lockout After (n) Failed Logins' | translate}}\"></md-checkbox>\r\n\t\t\t\t\t\t<p>{{::'Lockout After (n) Failed Logins' | translate}}</p>\r\n\t\t\t\t\t\t<md-input-container class=\"sb-admin-pp---list-radio md-secondary\">\r\n\t\t\t\t\t\t\t<div ng-click=\"$event.stopPropagation()\">\r\n\t\t\t\t\t\t\t\t<input type=\"number\"\r\n\t\t\t\t\t\t\t\t\tname=\"failureLimit\"\r\n\t\t\t\t\t\t\t\t\tng-model=\"ppCtrl.ppDS.passwordPolicy.FailedLoginLimit\"\r\n\t\t\t\t\t\t\t\t\tng-disabled=\"!ppCtrl.ppDS.enforceFailure\"\r\n\t\t\t\t\t\t\t\t\tvalue=\"10\" min=\"0\" max=\"10000\"\r\n\t\t\t\t\t\t\t\t\taria-label=\"{{::'Lockout After (n) Failed Logins' | translate}}\" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-list-item md-no-ink>\r\n\t\t\t\t\t\t<md-checkbox ng-model=\"ppCtrl.ppDS.enforceIdle\" ng-value=\"true\" aria-label=\"{{::'Lockout After Idle (n) Days' | translate}}\"></md-checkbox>\r\n\t\t\t\t\t\t<p>{{::'Lockout After Idle (n) Days' | translate}}</p>\r\n\t\t\t\t\t\t<md-input-container class=\"sb-admin-pp---list-radio md-secondary\">\r\n\t\t\t\t\t\t\t<div ng-click=\"$event.stopPropagation()\">\r\n\t\t\t\t\t\t\t\t<input type=\"number\"\r\n\t\t\t\t\t\t\t\t\tname=\"idleLockout\"\r\n\t\t\t\t\t\t\t\t\tng-model=\"ppCtrl.ppDS.passwordPolicy.IdleLimit\"\r\n\t\t\t\t\t\t\t\t\tng-disabled=\"!ppCtrl.ppDS.enforceIdle\"\r\n\t\t\t\t\t\t\t\t\tng-value=\"360\" min=\"0\" max=\"10000\"\r\n\t\t\t\t\t\t\t\t\taria-label=\"{{::'Lockout After Idle (n) Days' | translate}}\" />\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t<md-radio-group ng-model=\"ppCtrl.ppDS.passwordPolicy.AutoRelease\" flex>\r\n\t\t\t\t\t\t<md-list-item ng-click=\"ppCtrl.ppDS.passwordPolicy.AutoRelease = false\" md-no-ink>\r\n\t\t\t\t\t\t\t<md-radio-button ng-value=\"false\" class=\"sb-admin-pp---list-radio\" aria-label=\"{{::'Manual Release by Administrator' | translate}}\">\r\n\t\t\t\t\t\t\t\t{{::'Manual Release by Administrator' | translate}}\r\n\t\t\t\t\t\t\t</md-radio-button>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t<md-list-item ng-click=\"ppCtrl.ppDS.passwordPolicy.AutoRelease = true\" md-no-ink>\r\n\t\t\t\t\t\t\t<md-radio-button flex ng-value=\"true\" class=\"sb-admin-pp---list-radio\" aria-label=\"{{::'Auto Release After (n) Minutes' | translate}}\">\r\n\t\t\t\t\t\t\t\t{{::'Auto Release After (n) Minutes' | translate}}\r\n\t\t\t\t\t\t\t</md-radio-button>\r\n\t\t\t\t\t\t\t<md-input-container flex=\"10\">\r\n\t\t\t\t\t\t\t\t<input type=\"number\"\r\n\t\t\t\t\t\t\t\t\t   name=\"autoRelease\"\r\n\t\t\t\t\t\t\t\t\t   ng-model=\"ppCtrl.ppDS.passwordPolicy.LockoutLength\"\r\n\t\t\t\t\t\t\t\t\t   ng-disabled=\"!ppCtrl.ppDS.passwordPolicy.AutoRelease\"\r\n\t\t\t\t\t\t\t\t\t   value=\"10\" min=\"0\" max=\"10000\"\r\n\t\t\t\t\t\t\t\t\t   aria-label=\"{{::'Auto Release After (n) Minutes' | translate}}\" />\r\n\t\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t</md-radio-group>\r\n\t\t\t\t</md-list>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"md-padding\" layout-gt-xs=\"row\" layout-align-gt-xs=\"end center\" layout=\"column\" layout-align=\"start strecth\">\t\t\t\r\n\t\t\t<md-button ng-if=\"ppCtrl.ppDS.passwordPolicy.PasswordPolicyId\" flex-order-xs=\"-1\" type=\"submit\"\r\n\t\t\t\t\t   class=\"md-primary md-raised\">\r\n\t\t\t\t\t   {{::'Update' | translate}}\r\n\t\t\t</md-button>\r\n\t\t\t<md-button ng-if=\"!ppCtrl.ppDS.passwordPolicy.PasswordPolicyId\" flex-order-xs=\"-1\" type=\"submit\"\r\n\t\t\t\t\t   class=\"md-primary md-raised\">\r\n\t\t\t\t\t   {{::'Create' | translate}}\r\n\t\t\t</md-button>\r\n\t\t\t<md-button ui-sref=\"^\">{{::'Cancel' | translate}}</md-button>\r\n\t\t</div>\r\n\t</md-content>\r\n</form>\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(203);
	__webpack_require__(205);


/***/ },
/* 203 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 204 */,
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(206);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminPendingDeployment
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminPendingDeployment` Displays pending deployment for editing
		 *
		 * @usage
		 *
		 * <sbadmin-pending-deployment pendingDeploymentId="1" /> 
		 * 
		 * @element input
		 * @param {number=} pendingDeploymentId The id of the pending deployment to edit
		 */
		angular.module('sharebase-admin')
			.directive('sbadminPendingDeployment', DeploymentCreateDirective)
			.controller('sbadminPendingDeploymentController', [
				'sbadminToolbarService',
				'sbadminPendingDeploymentsDataStore',
				'pxProgressService',
				'$state',
				'sbToastService',
				'gettextCatalog',
				'$mdDialog',
				'$q',
				PendingDeploymentController
			]).config(['$stateProvider', function ($stateProvider) {
				$stateProvider.state('administration.home.pendingDeployment', {
					url: 'pending-deployment/:pendingDeploymentId',
					views: {
						'adminContent@administration': {
							template: function (params) { return '<sbadmin-pending-deployment flex pending-deployment-id="' + params.pendingDeploymentId + '" flex />'; }
						}
					},
					resolve: {
						selectedDeployment: ['$stateParams', 'sbadminPendingDeploymentsDataStore', 'pxProgressService',
							function ($stateParams, sbadminPendingDeploymentsDataStore, pxProgressService) {
								pxProgressService.backdrop = false;
								pxProgressService.visible = true;
								return sbadminPendingDeploymentsDataStore.load();
							}]
					}
				});
			}]);
		function DeploymentCreateDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminPendingDeploymentController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: true,
				scope: {
					pendingDeploymentId: '@'
				},
				link: function (scope, element, attrs) { }
			};
		}
		function PendingDeploymentController(sbadminToolbarService, sbadminPendingDeploymentsDataStore, pxProgressService, $state, sbToastService, gettextCatalog, $mdDialog, $q) {
			var vm = this;
			sbadminToolbarService.title = gettextCatalog.getString('Pending Deployment');
			sbadminToolbarService.showFilter = false;

			vm.pendingDeployment = {};
			vm.saveAndResend = saveAndResend;
			vm.cancel = cancel;
			vm.save = save;
			vm.resend = resend;
			vm.error = false;
			vm.errorMessage = null;
			showProgress();

			var confirm = $mdDialog.confirm()
				.title(gettextCatalog.getString('Save Pending Deployment'))
				.textContent(gettextCatalog.getString('Would you to save your changes before resending a notification link?'))
				.ok(gettextCatalog.getString('Yes'))
				.cancel(gettextCatalog.getString('No'));

			function cancel() {
				$state.go('^');
			}

			function resend() {
				if (vm.form.$valid) {
					var promise = $q.resolve();
					if (vm.form.$dirty) {
						// Ask the user if they would like to save their changes before resending the registration link
						promise = $mdDialog.show(confirm)
							.then(function () {
								showProgress();
								return sbadminPendingDeploymentsDataStore.save(vm.pendingDeployment)
									.then(function () {
										sbToastService.showSimple(gettextCatalog.getString('Deployment saved.'));
									});
							}, function () {
								// No-op the dismissive action of the dialog.
								// This prevents the raised exception of the dialog from bubbling to the outer catch()
							});
					}
					promise.then(function (response) {
						showProgress();
						return sbadminPendingDeploymentsDataStore.resendNotification(vm.pendingDeployment)
							.then(function () {
								sbToastService.showSimple(gettextCatalog.getString('Notification resent.'));
								actionComplete();
							});
					})
					.catch(showError)
					.finally(hideProgress);
				}
			}

			function save() {
				if (vm.form.$valid) {
					showProgress();
					sbadminPendingDeploymentsDataStore.save(vm.pendingDeployment)
						.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('Deployment saved.'));
							actionComplete();
						})
						.catch(showError)
						.finally(hideProgress);
				}
			}

			function saveAndResend() {
				if (vm.form.$valid) {
					showProgress();

					// Cannot use $q.all[] since save must occur first
					sbadminPendingDeploymentsDataStore.save(vm.pendingDeployment)
						.then(function () {
							return sbadminPendingDeploymentsDataStore.resendNotification(vm.pendingDeployment);
						})
						.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('Deployment saved. Notification resent.'));
							actionComplete();
						})
						.catch(showError)
						.finally(hideProgress);
				}
			}

			function actionComplete() {
				hideProgress();
				vm.error = false;
				$state.go('^');
			}

			function showProgress() {
				pxProgressService.visible = true;
				pxProgressService.backdrop = true;
			}

			function hideProgress() {
				pxProgressService.visible = false;
			}

			function showError(response) {
				vm.error = true;
				if (response.data) {
					if (angular.isString(response.data)) {
						vm.errorMessage = response.data;
					}
					else if (response.data.ExceptionMessage && angular.isString(response.data.ExceptionMessage)) {
						vm.errorMessage = response.data.ExceptionMessage;
					}
				}
				else {
					vm.errorMessage = gettextCatalog.getString('An unexpected error has occurred.');
				}
			}

			sbadminPendingDeploymentsDataStore.getPendingDeployment(vm.pendingDeploymentId)
				.then(function (pendingDeployment) {
					vm.pendingDeployment = pendingDeployment;
				})
				.catch(showError)
				.finally(hideProgress);
		}
	} ());

/***/ },
/* 206 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/pendingDeployment/pendingDeployment.template.html';
	var html = "<form flex name=\"vm.form\" layout=\"column\" layout-align=\"start stretch\" ng-cloak>\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.error\">\r\n\t\t<md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\" ng-if=\"!vm.errorMessage\" translate>Error processing request</md-subheader>\r\n\t\t<md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</md-subheader>\r\n\t</div>\r\n\t<md-content class=\"md-padding\" flex-gt-xs layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\">\r\n\t\t<md-input-container class=\"md-block\">\r\n\t\t\t<label translate>Customer Name</label>\t\r\n\t\t\t<input name=\"customerName\" ng-required=\"true\" ng-model=\"vm.pendingDeployment.CustomerName\" />\r\n\t\t\t<div ng-messages=\"vm.form.customerName.$error\" role=\"alert\">\r\n\t\t\t\t<default-error-messages />\r\n\t\t\t</div>\r\n\t\t</md-input-container>\r\n\t\t<md-input-container class=\"md-block\">\r\n\t\t\t<label translate>Customer Identifier</label>\r\n\t\t\t<input name=\"customerIdentifier\" ng-required=\"true\" ng-maxlength=\"40\" md-maxlength=\"40\" ng-model=\"vm.pendingDeployment.CustomerIdentifier\" />\r\n\t\t\t<div ng-messages=\"vm.form.customerIdentifier.$error\" role=\"alert\">\r\n\t\t\t\t<div ng-message=\"maxlength\" translate>Customer Identifier must be less than 40 characters.</div>\r\n\t\t\t\t<default-error-messages />\r\n\t\t\t</div>\r\n\t\t</md-input-container>\r\n\t\t<md-input-container class=\"md-block\">\r\n\t\t\t<label translate>System Name</label>\r\n\t\t\t<input name=\"systemName\" ng-model=\"vm.pendingDeployment.SystemName\" />\r\n\t\t\t<div ng-messages=\"vm.form.systemName.$error\" role=\"alert\">\r\n\t\t\t\t<default-error-messages />\r\n\t\t\t</div>\r\n\t\t</md-input-container>\r\n\t\t<md-input-container class=\"md-block\">\r\n\t\t\t<label translate>Email Address</label>\r\n\t\t\t<input name=\"emailAddress\" type=\"email\" ng-required=\"true\" ng-model=\"vm.pendingDeployment.EmailAddress\" />\r\n\t\t\t<div ng-messages=\"vm.form.emailAddress.$error\" role=\"alert\">\r\n\t\t\t\t<default-error-messages />\r\n\t\t\t</div>\r\n\t\t</md-input-container>\r\n\t\t<md-input-container class=\"md-block\">\r\n\t\t\t<label translate>Partner Identifier</label>\r\n\t\t\t<input name=\"partnerIdentifier\" ng-model=\"vm.pendingDeployment.PartnerIdentifier\" />\r\n\t\t\t<div ng-messages=\"vm.form.partnerIdentifier.$error\" role=\"alert\">\r\n\t\t\t\t<default-error-messages />\r\n\t\t\t</div>\r\n\t\t</md-input-container>\r\n\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t<div layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t\t<md-button type=\"submit\" ng-click=\"vm.form.$valid && vm.save()\" class=\"md-primary md-raised\" ng-if=\"!vm.form.emailAddress.$dirty\">\r\n\t\t\t\t<translate>Save</translate>\r\n\t\t\t</md-button>\r\n\t\t\t<md-button type=\"submit\" ng-click=\"vm.form.$valid && vm.saveAndResend()\" class=\"md-primary md-raised\" ng-if=\"vm.form.emailAddress.$dirty\">\r\n\t\t\t\t<translate>Save & Resend</translate>\r\n\t\t\t</md-button>\r\n\t\t\t<md-button type=\"submit\" ng-click=\"vm.form.$valid && vm.resend()\">\r\n\t\t\t\t<translate>Resend</translate>\r\n\t\t\t</md-button>\r\n\t\t\t<md-button type=\"submit\" ng-click=\"vm.cancel()\">\r\n\t\t\t\t<translate>Cancel</translate>\r\n\t\t\t</md-button>\r\n\t\t</div>\r\n\t</md-content>\r\n</form>\r\n\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(208);
	__webpack_require__(210);

/***/ },
/* 208 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 209 */,
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(211);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbStatisticCard
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbStatisticCard` creates a statistic card that displays an icon, label and value
		 *
		 * @usage
		 *
		 * <sb-statistic-card deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbStatisticCard', [StatisticCardDirective])
			.controller('sbStatisticCardController', [
				StatisticCardController
			]);

		function StatisticCardDirective($timeout, $animate) {
			return {
				restrict: 'E',
				controller: 'sbStatisticCardController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				scope: {
					icon: '@',
					label: '@',
					value: '=value'
				},
				bindToController: true,
				link: function (scope, element, attrs) {
				}
			};
		}
		function StatisticCardController() {
		}
	} ());

/***/ },
/* 211 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/statisticCard/statisticCard.template.html';
	var html = "<md-card class=\"sbadmin-stat-card\">\r\n\t<div class=\"sbadmin-stat-card__top\" layout=\"column\" layout-align=\"center center\">\r\n\t\t<md-icon class=\"material-icons md-card-image sbadmin-stat-card__icon\">{{vm.icon}}</md-icon>\r\n\t\t<span class=\"md-headline sbadmin-stat-card__value app--accent-link\">{{vm.value}}</span>\r\n\t</div>\r\n\t<md-card-title class=\"app__background\">\r\n\t\t<md-card-title-text class=\"sbadmin-stat-card--center-text\">\r\n\t\t\t<span class=\"md-headline\">{{vm.label}}</span>\r\n\t\t</md-card-title-text>\r\n\t</md-card-title>\r\n</md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(213);
	__webpack_require__(215);

/***/ },
/* 213 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 214 */,
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(216);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminStatistics
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminStatistics` displays a deployments statistics
		 *
		 * @usage
		 *
		 * <sbadmin-statistics deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminStatistics', [
				'$timeout',
				StatisticsDirective])
			.controller('sbadminStatisticsController', [
				'$mdMedia',
				'sbadminToolbarService',
				'gettextCatalog',
				StatisticsController
			]);
		function StatisticsDirective($timeout) {
			return {
				restrict: 'E',
				controller: 'sbadminStatisticsController',
				controllerAs: 'statisticsCtrl',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId:'@'
				},
				scope: true,
				link: function (scope, element, attrs) {
					scope.statisticsCtrl.toggleSearch = function () {
						scope.statisticsCtrl.showSearch = !scope.statisticsCtrl.showSearch;
						if (!scope.statisticsCtrl.showSearch) {
							scope.statisticsCtrl.filterPhrase = '';
							return;
						}

						$timeout(function () {
							var input = element.find('md-input-container').find('input')[0];
							input.focus();
						}, 400);

					};
				}
			};
		}
		function StatisticsController($mdMedia, sbadminToolbarService, gettextCatalog) {
			var self = this;
			self.sbadminToolbarService = sbadminToolbarService;
			sbadminToolbarService.title = gettextCatalog.getString('Statistics');
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = true;
			self.stepIndex = 0;
			self.recentStats = null;
			self.stats = null;
			self.users = null;
			self.statType = null;
			self.statIcon = statIcon;
			self.chartObject = null;

			function statIcon(type) {
				switch (type) {
					case 'ByUser':
						return 'person';
					case 'ByDate':
						return 'date_range';
					case 'ByInstance':
						return 'data_usage';
					case 'Custom':
						return 'assessment';
				}
			}
			
			//initialize
			(function loadStats() {
				self.recentStats = [
					{ type:'deployment', target:'Content Downloaded by Data', runDate:'2016-04-08T17:04:06.593Z', favorite:true},
					{ type: 'user', target: 'jeff ', runDate: '2016-04-06T17:04:08.593Z', favorite: true },
					{ type: 'deployment', target: 'Content Downloaded by User', runDate: '2016-04-07T17:04:06.593Z', favorite: false },
					{ type: 'deployment', target: 'Security Violations by Date', runDate: '2016-04-06T17:04:06.593Z', favorite: false },
					{ type: 'deployment', target: 'Security Violations by Date', runDate: '2016-04-06T17:04:06.593Z', favorite: false },
					{ type: 'deployment', target: 'Shared by User', runDate: '2016-04-06T17:04:06.593Z', favorite: false },
					{ type: 'user', target: 'Random User', runDate: '2016-03-06T17:04:06.593Z', favorite: false },
					{ type: 'user', target: 'Random User', runDate: '2016-03-06T17:04:06.593Z', favorite: false }
				];

				self.users = [{
					'scope': 'System',
					'displayName': 'Frank Menoni',
					'name': 'Frank Menoni',
					'kind': 'ByUser',
					'description': 'Statistics for user Frank Menoni',
					'uri': 'http://dev-024762/sharebase-api/jeff/users/8/statistics',
					'$$hashKey': 'object:2220'
				}, {
					'scope': 'System',
					'displayName': 'jeff',
					'name': 'jeff',
					'kind': 'ByUser',
					'description': 'Statistics for user jeff',
					'uri': 'http://dev-024762/sharebase-api/jeff/users/6/statistics',
					'$$hashKey': 'object:2221'
				}, {
					'scope': 'System',
					'displayName': 'Jeff Home',
					'name': 'Jeff Home',
					'kind': 'ByUser',
					'description': 'Statistics for user Jeff Home',
					'uri': 'http://dev-024762/sharebase-api/jeff/users/9/statistics',
					'$$hashKey': 'object:2222'
				}, {
					'scope': 'System',
					'displayName': 'Random User',
					'name': 'Random User',
					'kind': 'ByUser',
					'description': 'Statistics for user Random User',
					'uri': 'http://dev-024762/sharebase-api/jeff/users/10/statistics',
					'$$hashKey': 'object:2223'
				}, {
					'scope': 'System',
					'displayName': 'Test Share User',
					'name': 'Test Share User',
					'kind': 'ByUser',
					'description': 'Statistics for user Test Share User',
					'uri': 'http://dev-024762/sharebase-api/jeff/users/7/statistics',
					'$$hashKey': 'object:2224'
				}, {
					'scope': 'System',
					'displayName': 'User Registration Test',
					'name': 'User Registration Test',
					'kind': 'ByUser',
					'description': 'Statistics for user User Registration Test',
					'uri': 'http://dev-024762/sharebase-api/jeff/users/11/statistics',
					'$$hashKey': 'object:2225'
				}];

				self.stats = [{
					'scope': 'Core',
					'displayName': 'Content Downloaded by Date',
					'name': 'ContentDownloadedByDate',
					'kind': 'ByDate',
					'description': 'Document content downloaded by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/ContentDownloadedByDate',
					'$$hashKey': 'object:2154'
				}, {
					'scope': 'Core',
					'displayName': 'Content Downloaded by User',
					'name': 'ContentDownloadedByUser',
					'kind': 'ByUser',
					'description': 'Document content downloaded by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/ContentDownloadedByUser',
					'$$hashKey': 'object:2155'
				}, {
					'scope': 'Core',
					'displayName': 'Deployment Totals',
					'name': 'DeploymentTotalsUsage',
					'kind': 'Custom',
					'description': 'Totals for Deployment',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/DeploymentTotalsUsage',
					'$$hashKey': 'object:2156'
				}, {
					'scope': 'Core',
					'displayName': 'Documents Created By Date',
					'name': 'DocumentsCreatedByDate',
					'kind': 'ByDate',
					'description': 'Documents created by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/DocumentsCreatedByDate',
					'$$hashKey': 'object:2157'
				}, {
					'scope': 'Core',
					'displayName': 'Documents Created By User',
					'name': 'DocumentsCreatedByUser',
					'kind': 'ByUser',
					'description': 'Documents created by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/DocumentsCreatedByUser',
					'$$hashKey': 'object:2158'
				}, {
					'scope': 'Core',
					'displayName': 'Documents Viewed By Date',
					'name': 'DocumentsViewedByDate',
					'kind': 'ByDate',
					'description': 'The number of documents viewed by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/DocumentsViewedByDate',
					'$$hashKey': 'object:2159'
				}, {
					'scope': 'Core',
					'displayName': 'Documents Viewed By User',
					'name': 'DocumentsViewedByUser',
					'kind': 'ByUser',
					'description': 'The number of documents viewed by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/DocumentsViewedByUser',
					'$$hashKey': 'object:2160'
				}, {
					'scope': 'Core',
					'displayName': 'Library Disk Usage',
					'name': 'LibraryDiskUsage',
					'kind': 'ByInstance',
					'description': 'The disk utilization for this library.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/LibraryDiskUsage',
					'$$hashKey': 'object:2161'
				}, {
					'scope': 'System',
					'displayName': 'Logins by Date',
					'name': 'LoginsByDate',
					'kind': 'ByDate',
					'description': 'The number of logins for this deployment by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/System/LoginsByDate',
					'$$hashKey': 'object:2162'
				}, {
					'scope': 'System',
					'displayName': 'Logins by User',
					'name': 'LoginsByUser',
					'kind': 'ByUser',
					'description': 'The number of logins for this deployment by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/System/LoginsByUser',
					'$$hashKey': 'object:2163'
				}, {
					'scope': 'System',
					'displayName': 'Security Violations by Date',
					'name': 'SecurityViolationsByDate',
					'kind': 'ByDate',
					'description': 'The number of security violations for this deployment by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/System/SecurityViolationsByDate',
					'$$hashKey': 'object:2164'
				}, {
					'scope': 'System',
					'displayName': 'Security Violations by User',
					'name': 'SecurityViolationsByUser',
					'kind': 'ByUser',
					'description': 'The number of security violations for this deployment by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/System/SecurityViolationsByUser',
					'$$hashKey': 'object:2165'
				}, {
					'scope': 'Core',
					'displayName': 'Shared by Date',
					'name': 'SharesByDate',
					'kind': 'ByDate',
					'description': 'Document shares by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/SharesByDate',
					'$$hashKey': 'object:2166'
				}, {
					'scope': 'Core',
					'displayName': 'Shared by User',
					'name': 'SharesByUser',
					'kind': 'ByUser',
					'description': 'Document shares by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/SharesByUser',
					'$$hashKey': 'object:2167'
				}, {
					'scope': 'Core',
					'displayName': 'Shares Downloaded by Date',
					'name': 'ShareContentDownloadedByDate',
					'kind': 'ByDate',
					'description': 'Document shares downloaded by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/ShareContentDownloadedByDate',
					'$$hashKey': 'object:2168'
				}, {
					'scope': 'Core',
					'displayName': 'Shares Downloaded by User',
					'name': 'ShareContentDownloadedByUser',
					'kind': 'ByUser',
					'description': 'Document shares downloaded by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/ShareContentDownloadedByUser',
					'$$hashKey': 'object:2169'
				}, {
					'scope': 'Core',
					'displayName': 'Synced by Date',
					'name': 'SyncedByDate',
					'kind': 'ByDate',
					'description': 'Document content synchronized offline by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/SyncedByDate',
					'$$hashKey': 'object:2170'
				}, {
					'scope': 'Core',
					'displayName': 'Synced by User',
					'name': 'SyncedByUser',
					'kind': 'ByUser',
					'description': 'Document content synchronized offline by user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/SyncedByUser',
					'$$hashKey': 'object:2171'
				}, {
					'scope': 'Core',
					'displayName': 'Tag Count',
					'name': 'DocumentTags',
					'kind': 'Custom',
					'description': 'Number of document tags by tag value.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/Core/DocumentTags',
					'$$hashKey': 'object:2172'
				}, {
					'scope': 'System',
					'displayName': 'Users Created by Date',
					'name': 'UsersCreatedByDate',
					'kind': 'ByDate',
					'description': 'The number of users created within this deployment by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/System/UsersCreatedByDate',
					'$$hashKey': 'object:2173'
				}, {
					'scope': 'System',
					'displayName': 'Users Created by User',
					'name': 'UsersCreatedByUser',
					'kind': 'ByUser',
					'description': 'The number of users created witin this deployment by a user.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/System/UsersCreatedByUser',
					'$$hashKey': 'object:2174'
				}, {
					'scope': 'System',
					'displayName': 'Users Self Registered By Date',
					'name': 'UsersSelfRegisteredByDate',
					'kind': 'ByDate',
					'description': 'The number of users that registered themselves by date.',
					'uri': 'http://dev-024762/sharebase-api/jeff/statistics/System/UsersSelfRegisteredByDate',
					'$$hashKey': 'object:2175'
				}];

				self.userData = [{
					'Id': 'SharesByUser',
					'Label': 'Shared',
					'Count': 9,
					'$$hashKey': 'object:490'
				}, {
					'Id': 'ContentDownloadedByUser',
					'Label': 'Content Downloaded',
					'Count': 6,
					'$$hashKey': 'object:491'
				}, {
					'Id': 'SyncedByUser',
					'Label': 'Synced',
					'Count': 0,
					'$$hashKey': 'object:492'
				}, {
					'Id': 'DocumentsCreatedByUser',
					'Label': 'Documents Created',
					'Count': 226,
					'$$hashKey': 'object:493'
				}, {
					'Id': 'ShareContentDownloadedByUser',
					'Label': 'Shares Downloaded',
					'Count': 0,
					'$$hashKey': 'object:494'
				}, {
					'Id': 'DocumentsViewedByUser',
					'Label': 'Documents Viewed',
					'Count': 350,
					'$$hashKey': 'object:495'
				}, {
					'Id': 'LibraryDiskUsage',
					'Label': 'Library Disk Usage (MB)',
					'Count': 155315940 / 1024 / 1024,
					'$$hashKey': 'object:496'
				}, {
					'Id': 'LoginsByUser',
					'Label': 'Logins',
					'Count': 407,
					'$$hashKey': 'object:497'
				}, {
					'Id': 'SecurityViolationsByUser',
					'Label': 'Security Violations',
					'Count': 48,
					'$$hashKey': 'object:498'
				}, {
					'Id': 'UsersCreatedByUser',
					'Label': 'Users Created',
					'Count': 2,
					'$$hashKey': 'object:499'
				}];
				self.chartObject = {};
				self.chartObject.type = 'BarChart';
				self.chartObject.data = {
					'cols': [
						{ id: 't', label: 'Stat', type: 'string' },
						{ id: 's', label: 'Count', type: 'number' }
					],
					'rows': []
				};

				for (var i = 0; i < self.userData.length; i++) {
					self.chartObject.data.rows.push({ c: [{ v: self.userData[i].Label }, { v: self.userData[i].Count }] });
				}

				self.chartObject.options = {
					'backgroundColor': 'transparent',
					'colors': ['#528e42'],
					'legend': { 'position': 'none' }
				};
				
				self.downloads = [{
					'Id': 'ContentDownloadedByDate',
					'Label': '1/2/2016',
					'Count': 15,
					'$$hashKey': 'object:797'
				}, {
					'Id': 'ContentDownloadedByDate',
					'Label': '1/4/2016',
					'Count': 8,
					'$$hashKey': 'object:797'
				}, {
					'Id': 'ContentDownloadedByDate',
					'Label': '1/15/2016',
					'Count': 25,
					'$$hashKey': 'object:797'
				}, {
					'Id': 'ContentDownloadedByDate',
					'Label': '2/17/2016',
					'Count': 2,
					'$$hashKey': 'object:797'
				}, {
					'Id': 'ContentDownloadedByDate',
					'Label': '3/8/2016',
					'Count': 5,
					'$$hashKey': 'object:798'
				}, {
					'Id': 'ContentDownloadedByDate',
					'Label': '3/23/2016',
					'Count': 3,
					'$$hashKey': 'object:799'
				}];

				self.lineObject = {};
				self.lineObject.type = 'LineChart';
				self.lineObject.data = {
					'cols': [
						{ id: 't', label: 'Date', type: 'string' },
						{ id: 's', label: 'Downloads', type: 'number' }
					],
					'rows': []
				};

				for (var x = 0; x < self.downloads.length; x++) {
					self.lineObject.data.rows.push({ c: [{ v: self.downloads[x].Label }, { v: self.downloads[x].Count }] });
				}

				self.lineObject.options = {
					'backgroundColor': 'transparent',
					'colors': ['#528e42'],
					'hAxis': {'slantedText': true, 'slantedTextAngle': 45},
					'vAxis': { 'title': 'Downloads' },
					'legend': {'position': 'none'}
				};
			}());
		}

	}());

/***/ },
/* 216 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/statistics/statistics.template.html';
	var html = "<div flex layout=\"column\" layout-align=\"start stretch\" class=\"sba-statistics\">\r\n\t<md-tabs flex md-no-ink md-selected=\"statisticsCtrl.stepIndex\">\r\n\t\t<md-tab label=\"{{::'Home'| translate}}\">\r\n\t\t\t<md-content flex layout=\"column\" class=\"app__background\">\r\n\t\t\t\t<md-subheader class=\"md-accent app__background\" translate>Statistic Type</md-subheader>\r\n\t\t\t\t<div class=\"sba-statistics__type-selector\" layout-wrap layout-margin layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" layout=\"column\" layout-align=\"center stretch\">\r\n\r\n\t\t\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'View Deployment Stats'| translate}}\" ng-click=\"statisticsCtrl.statType = 0;statisticsCtrl.stepIndex = 1;\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">storage</md-icon>\r\n\t\t\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t\t\t<span class=\"md-headline\" translate>Deployment</span>\r\n\t\t\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t\t\t</md-card-title>\r\n\t\t\t\t\t</md-card>\r\n\r\n\t\t\t\t\t<md-card class=\"sbadmin-admin-card\" aria-label=\"{{::'View User Stats'| translate}}\" ng-click=\"statisticsCtrl.statType = 1;statisticsCtrl.stepIndex = 1;\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons md-card-image sbadmin-admin-card__icon app--accent-link\">person</md-icon>\r\n\t\t\t\t\t\t<md-card-title class=\"app__background\">\r\n\t\t\t\t\t\t\t<md-card-title-text>\r\n\t\t\t\t\t\t\t\t<span class=\"md-headline\" translate>User</span>\r\n\t\t\t\t\t\t\t</md-card-title-text>\r\n\t\t\t\t\t\t</md-card-title>\r\n\t\t\t\t\t</md-card>\r\n\r\n\t\t\t\t</div>\r\n\t\t\t\t<div flex>\r\n\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t<md-subheader class=\"md-accent app__background\" translate>Favorite</md-subheader>\r\n\t\t\t\t\t<md-list>\r\n\t\t\t\t\t\t<md-list-item class=\"md-2-line\" ng-repeat=\"stat in statisticsCtrl.recentStats | filter:{favorite:true} | filter:{target:statisticsCtrl.sbadminToolbarService.filterPhrase}\" ng-click=\"statisticsCtrl.statType = 0;statisticsCtrl.stepIndex = 3;\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icons md-avatar\">{{stat.type  === 'deployment' ? 'storage' : 'person'}}</md-icon>\r\n\t\t\t\t\t\t\t<div class=\"md-list-item-text\">\r\n\t\t\t\t\t\t\t\t<h3>{{stat.target}}</h3>\r\n\t\t\t\t\t\t\t\t<p>{{stat.runDate | sbSimpleDateTimeString}}</p>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t</md-list>\r\n\t\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t\t<md-subheader class=\"md-accent app__background\" translate>Recent</md-subheader>\r\n\t\t\t\t\t<md-list>\r\n\t\t\t\t\t\t<md-list-item class=\"md-2-line\" ng-repeat=\"stat in statisticsCtrl.recentStats | filter:{favorite:false} | filter:{target:statisticsCtrl.sbadminToolbarService.filterPhrase}\" ng-click=\"statisticsCtrl.statType = 0;statisticsCtrl.stepIndex = 3;\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icons md-avatar\">{{stat.type  === 'deployment' ? 'storage' : 'person'}}</md-icon>\r\n\t\t\t\t\t\t\t<div class=\"md-list-item-text\">\r\n\t\t\t\t\t\t\t\t<h3>{{stat.target }}</h3>\r\n\t\t\t\t\t\t\t\t<p>{{stat.runDate |  sbSimpleDateTimeString}}</p>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t</md-list>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t</md-content>\r\n\t\t</md-tab>\r\n\r\n\t\t<md-tab label=\"{{::'Sub Selector'| translate}}\">\r\n\t\t\t<md-content flex layout=\"column\" class=\"app__background\">\r\n\t\t\t\t<div layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<div flex layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" aria-label=\"{{::'Back to statistics home'| translate}}\" ng-click=\"statisticsCtrl.stepIndex = 0;\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icons\">arrow_back</md-icon>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<h3 translate>See Stats for...</h3>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<md-list flex layout=\"column\" layout-align=\"start stretch\" ng-if=\"statisticsCtrl.statType === 0\">\r\n\t\t\t\t\t<md-virtual-repeat-container flex>\r\n\t\t\t\t\t\t<div md-virtual-repeat=\"stat in statisticsCtrl.stats | filter:{displayName:statisticsCtrl.sbadminToolbarService.filterPhrase}\">\r\n\t\t\t\t\t\t\t<md-list-item class=\"md-2-line\" layout=\"row\" layout-align=\"center center\" ng-click=\"statisticsCtrl.stepIndex = 2;\">\r\n\t\t\t\t\t\t\t\t<md-icon class=\"md-avatar sba-list-avatar material-icons\">{{statisticsCtrl.statIcon(stat.kind)}}</md-icon>\r\n\t\t\t\t\t\t\t\t<div class=\"md-list-item-text\" flex>\r\n\t\t\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{stat.displayName}}</h3>\r\n\t\t\t\t\t\t\t\t\t<p>{{stat.description}}</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</md-virtual-repeat-container>\r\n\t\t\t\t</md-list>\r\n\r\n\t\t\t\t<md-list flex layout=\"column\" layout-align=\"start stretch\" ng-if=\"statisticsCtrl.statType === 1\">\r\n\t\t\t\t\t<md-virtual-repeat-container flex>\r\n\t\t\t\t\t\t<div md-virtual-repeat=\"user in statisticsCtrl.users | filter:statisticsCtrl.sbadminToolbarService.filterPhrase\">\r\n\t\t\t\t\t\t\t<md-list-item layout=\"row\" layout-align=\"center center\" ng-click=\"statisticsCtrl.stepIndex = 2;\">\r\n\t\t\t\t\t\t\t\t<md-icon class=\"md-avatar sba-list-avatar material-icons\">account_circle</md-icon>\r\n\t\t\t\t\t\t\t\t<p>{{user.displayName}}</p>\r\n\t\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</md-virtual-repeat-container>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\t\t</md-tab>\r\n\r\n\t\t<md-tab label=\"{{::'Visualization'| translate}}\">\r\n\t\t\t<md-content flex layout=\"column\" class=\"app__background\" layout-align=\"start stretch\">\r\n\t\t\t\t<div layout=\"row\" layout-align=\"start center\">\r\n\t\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"statisticsCtrl.stepIndex = 1;\">\r\n\t\t\t\t\t\t<md-icon class=\"material-icons\">arrow_back</md-icon>\r\n\t\t\t\t\t</md-button>\r\n\t\t\t\t\t<h3 translate>Stats for</h3>\r\n\t\t\t\t\t<div flex layout=\"row\" layout-align=\"end center\">\r\n\r\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" aria-label=\"{{::'Attach to email'| translate}}\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icons\">attach_file</md-icon>\r\n\t\t\t\t\t\t\t<md-tooltip md-delay=\"800\">\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t{{::'Attach to email'| translate}}\r\n\t\t\t\t\t\t\t</md-tooltip>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" aria-label=\"{{::'Toggle favorite'| translate}}\">\r\n\t\t\t\t\t\t\t<md-icon class=\"material-icons\">star_border</md-icon>\r\n\t\t\t\t\t\t\t<md-tooltip md-delay=\"800\">\r\n\t\t\t\t\t\t\t\t{{::'Toggle favorite'| translate}}\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</md-tooltip>\r\n\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t<md-menu md-position-mode=\"target-right target\">\r\n\t\t\t\t\t\t\t<md-button aria-label=\"{{::'Change Chart View'| translate}}\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\">\r\n\t\t\t\t\t\t\t\t<md-icon md-menu-origin class=\"material-icons\">visibility</md-icon>\r\n\t\t\t\t\t\t\t\t<md-tooltip md-delay=\"800\">\r\n\t\t\t\t\t\t\t\t\t{{::'Change Chart View'| translate}}\r\n\t\t\t\t\t\t\t\t</md-tooltip>\r\n\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t<md-menu-content width=\"3\">\r\n\t\t\t\t\t\t\t\t<md-menu-item>\r\n\t\t\t\t\t\t\t\t\t<md-button ng-click=\"\">\r\n\t\t\t\t\t\t\t\t\t\t<md-icon md-menu-align-target class=\"material-icons\">assessment</md-icon>\r\n\t\t\t\t\t\t\t\t\t\t{{::'Bar Chart'| translate}}\r\n\t\t\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t\t</md-menu-item>\r\n\t\t\t\t\t\t\t\t<md-menu-item>\r\n\t\t\t\t\t\t\t\t\t<md-button ng-click=\"\">\r\n\t\t\t\t\t\t\t\t\t\t<md-icon md-menu-align-target class=\"material-icons\">show_chart</md-icon>\r\n\t\t\t\t\t\t\t\t\t\t{{::'Line Chart'| translate}}\r\n\t\t\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t\t</md-menu-item>\r\n\t\t\t\t\t\t\t\t<md-menu-item>\r\n\t\t\t\t\t\t\t\t\t<md-button ng-click=\"\">\r\n\t\t\t\t\t\t\t\t\t\t<md-icon md-menu-align-target class=\"material-icons\">pie_chart</md-icon>\r\n\t\t\t\t\t\t\t\t\t\t{{::'Pie Chart'| translate}}\r\n\t\t\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t\t</md-menu-item>\r\n\t\t\t\t\t\t\t\t<md-menu-item>\r\n\t\t\t\t\t\t\t\t\t<md-button ng-click=\"\">\r\n\t\t\t\t\t\t\t\t\t\t<md-icon md-menu-align-target class=\"material-icons\">bubble_chart</md-icon>\r\n\t\t\t\t\t\t\t\t\t\t{{::'Bubble Chart'| translate}}\r\n\t\t\t\t\t\t\t\t\t</md-button>\r\n\t\t\t\t\t\t\t\t</md-menu-item>\r\n\t\t\t\t\t\t\t</md-menu-content>\r\n\r\n\t\t\t\t\t\t</md-menu>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<div flex ng-if=\"statisticsCtrl.statType === 0\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<div>Google Chart Removed</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div flex ng-if=\"statisticsCtrl.statType === 1\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<div>Google Chart Removed</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t</md-content>\r\n\t\t</md-tab>\r\n\t</md-tabs>\r\n\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(218);
	__webpack_require__(220);

/***/ },
/* 218 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 219 */,
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(221);
		var userDeleteTemplateUrl = __webpack_require__(222);
		var deploymentGroupTemplateUrl = __webpack_require__(223);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminUser
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminInviteUsers` form to invite users to a deployment
		 *
		 * @usage
		 *
		 * <sbadmin-user deployment-id='1' user-id='1' /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment to invite users to
		 * 
		 * @element input
		 * @param {number=} userId The id of the deployment to user to view details
		 */

		angular.module('sharebase-admin')
			.directive('sbadminUser', [UserDirective])
			.controller('sbadminUserController', [
				'$q',
				'$state',
				'$mdDialog',
				'sbToastService',
				'sbUserService',
				'sbUserDataStore',
				'sbadminDeploymentGroupsDataStore',
				'sbadminToolbarService',
				'pxProgressService',
				'pxAuthService',
				'gettextCatalog',
				'sbDeploymentNameService',
				UserController
			]);

		function UserDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminUserController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId: '@',
					userId: '@',
				},
				scope: {},
				link: function (scope, element, attrs) {
				}
			};
		}
		function UserController($q, $state, $mdDialog, sbToastService, sbUserService, sbUserDataStore, sbadminDeploymentGroupsDataStore, sbadminToolbarService, pxProgressService, pxAuthService, gettextCatalog, sbDeploymentNameService) {
			var isLoading = true;
			var vm = this;
			var initTasks = [];
			var STATUS_CODES = {
				ERR_USER_ALREADY_TENANT_ADMIN : gettextCatalog.getString('User is already a tenant admin.')
			};
			var adminDeploymentGroup = null;

			vm.deploymentGroupsDS = sbadminDeploymentGroupsDataStore;
			vm.sbadminToolbarService = sbadminToolbarService;
			vm.sbUserDataStore = sbUserDataStore;
			vm.updateUserLock = updateUserLock;
			vm.toggleTenantAdmin = toggleTenantAdmin;
			vm.deleteUser = deleteUser;
			vm.submitForm = submitForm;
			vm.authService = pxAuthService;
			vm.toastVisible = false;
			vm.errorMessage = null;
			vm.systemName = null;
			vm.promotingAsAdmin = promotingAsAdmin;
			vm.canPromoteSiteAdmins = pxAuthService.isSiteAdmin || pxAuthService.isSysAdmin || pxAuthService.isTenantAdmin;

			sbadminToolbarService.title = !vm.userId ? gettextCatalog.getString('Create User') : gettextCatalog.getString('Edit User');
			sbadminToolbarService.filterPlaceholder = null;
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = false;
			
			
			if(pxAuthService.isSysAdmin) {
				initTasks.push(sbadminDeploymentGroupsDataStore.load());
			}
			else if (pxAuthService.isTenantAdmin) {
				// retrieve the deployment group the logged-in tenant admin administers
				// to potentially promote the modified user to
				initTasks.push(sbUserService
					.getUser(pxAuthService.userId, pxAuthService.deploymentId)
					.then(function(user){
						adminDeploymentGroup = user.Embedded.AdministratorOfDeploymentGroups[0];
					})
				);
			}

			initTasks.push(sbUserDataStore.getUser(vm.userId, vm.deploymentId));

			if(vm.userId) {
				vm.sbadminToolbarService.actions.push({ 
					icon: 'delete', 
					label: gettextCatalog.getString('Delete User'), 
					trigger: deleteUser 
				});
			}

			function updateUserLock() {
				if (isLoading || !vm.userId) { return; }

				if (sbUserDataStore.user.IsLocked) {
					sbUserDataStore.lockUser(sbUserDataStore.user.UserId, vm.deploymentId).then(function () {
						var message = gettextCatalog.getString('{{userName}} is now locked', { userName: sbUserDataStore.user.UserName });
						toast(message);
					});
				}
				else {
					sbUserDataStore.unlockUser(sbUserDataStore.user.UserId, vm.deploymentId).then(function () {
						var message = gettextCatalog.getString('{{userName}} is now unlocked', { userName: sbUserDataStore.user.UserName });
						toast(message);
					});
				}
			}

			function toggleTenantAdmin(isTenantAdmin, ev) {
				if(isTenantAdmin) {
					if (pxAuthService.isTenantAdmin) { 
						sbUserDataStore.deploymentGroupAdmin = adminDeploymentGroup;
					}
					else if (pxAuthService.isSysAdmin) {
						$mdDialog.show({
							controller: 'sbDeploymentGroupSelectController',
							controllerAs: 'vm',
							templateUrl: deploymentGroupTemplateUrl,
							targetEvent: ev,
							locals:{groups: sbadminDeploymentGroupsDataStore.groups},
							clickOutsideToClose: false
						})
						.then(function (group) {
							//done
							sbUserDataStore.deploymentGroupAdmin = group;
						}, function () {
							//canceled
							sbUserDataStore.deploymentGroupAdmin = null;
							vm.sbUserDataStore.isTenantAdmin = false;
						});
					}
				}
				else {
					sbUserDataStore.deploymentGroupAdmin = null;
				}
			}

			function deleteUser($event) {
				$mdDialog.show({
					controller: 'sbUserDeleteDialogController',
					controllerAs: 'vm',
					templateUrl: userDeleteTemplateUrl,
					targetEvent: $event,
					locals: {
						user: vm.sbUserDataStore.user,
						deploymentID: vm.deploymentId
					},
					clickOutsideToClose: false
				})
				.then(function (transferUser) {
					//delete user & reasign content & udate DS
					transferUser = transferUser ? transferUser : null;
					sbUserDataStore.removeUser(vm.sbUserDataStore.user, vm.deploymentId, transferUser)
						.then(function () {
							sbToastService.showSimple(gettextCatalog.getString('User "{{deletedUser}}" deleted successfully.', { deletedUser: vm.sbUserDataStore.user.UserName }));
							$state.go('^');
						})
						.catch(function (response) {
							if (response.status === 409) {
								//conflict - user to delete has other users conent
								var confirm = $mdDialog.confirm()
									.title(gettextCatalog.getString('Continue with user deletion?'))
									.textContent(gettextCatalog.getString('{{deletedUser}} has content that is owned by a different user, which will be deleted if this user is deleted. ', { deletedUser: vm.sbUserDataStore.user.UserName }))
									.ariaLabel(gettextCatalog.getString('Delete User Conflict'))
									.ok(gettextCatalog.getString('Continue'))
									.cancel(gettextCatalog.getString('Cancel'));
								return $mdDialog.show(confirm).then(function () {
									//delete user & force delete shared content
									sbUserDataStore.removeUser(vm.sbUserDataStore.user, vm.deploymentId, null, true)
										.then(function () {
											sbToastService.showSimple(gettextCatalog.getString('User "{{deletedUser}}" deleted successfully.', { deletedUser: vm.sbUserDataStore.user.UserName }));
											$state.go('^');
										})
										.catch(function () {
											sbToastService.showSimple(gettextCatalog.getString('Error deleting user "{{deletedUser}}".', { deletedUser: vm.sbUserDataStore.user.UserName }));
										});
								}, angular.noop());
							}
							sbToastService.showSimple(gettextCatalog.getString('Error deleting user "{{deletedUser}}".', { deletedUser: vm.sbUserDataStore.user.UserName }));
						});
				}, angular.noop());
			}

			function submitSuccess(response) {
				//REMOVE for ticket SBWEB-363
				if (response.Error) {
					submitFailure(response.Error);
					return;
				}
				//end of REMOVE

				//success
				//route
				$state.go('^');

				var message = vm.userId !== null ? gettextCatalog.getString('User updated successfully') : gettextCatalog.getString('User created successfully');
				toast(message);
			}

			function submitFailure(e) {
				//failure
				pxProgressService.visible = false;
				var msg = e;
				if(e.data && e.data.StatusCode in STATUS_CODES) {
					msg += ' ' + STATUS_CODES[e.data.StatusCode];
				}

				vm.errorMessage = msg;
			}

			function submitForm() {
				if (vm.userId) {
					//update user
					pxProgressService.backdrop = true;
					showLoader();

					sbUserDataStore
						.updateUser(sbUserDataStore.user, vm.deploymentId)
						.then(function(resp) {
							return sbUserDataStore
								.updateTenantAdminRights()
								.then(function(){
									return resp;	
								}); 
						})
						.then(submitSuccess)
						.catch(submitFailure)
						.finally(hideLoader);

				}
				else {
					//create user
					if (sbUserDataStore.user.Password !== vm.VerifyPassword) {
						vm.errorMessage = gettextCatalog.getString('Passwords do not match');
						return;
					}

					pxProgressService.backdrop = true;
					showLoader();
					vm.errorMessage = null;

					sbUserDataStore
						.addUser(sbUserDataStore.user, vm.systemName)
						.then(submitSuccess)
						.catch(submitFailure)
						.finally(hideLoader);
				}
			}

			function toast(message) {
				vm.toastVisible = true;
				sbToastService.showSimple(message)
					.finally(function() {
						vm.toastVisible = false;
					});
			}

			function showLoader() {
				pxProgressService.visible = true;
			}
			function hideLoader() {
				isLoading = false;
				pxProgressService.visible = false;
			}
			function promotingAsAdmin() {
				if (vm.sbUserDataStore.isSiteAdmin) {
					vm.sbUserDataStore.isUserAdmin = true;
				}
			}	

			pxProgressService.visible = true;
			$q.all(initTasks)
				.then(function () {
					return sbDeploymentNameService.resolveSystemName(vm.deploymentId)
						.then(function (systemName) {
							vm.systemName = systemName;
						});
				})
				.finally(hideLoader);
		}

	}());

/***/ },
/* 221 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/user/user.template.html';
	var html = "<form name=\"f\" flex layout=\"column\" layout-align=\"start stretch\" ng-submit=\"f.$valid &&  vm.submitForm()\" ng-cloak>\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.errorMessage\">\r\n\t\t<md-subheader class=\"md-warn app__background sba-form-errors__message\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</md-subheader>\r\n\t</div>\r\n\t<md-content class=\"sb-admin-user__content\" flex-gt-xs layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\" ng-class=\"{'sb-admin-user---margin-bottom':vm.toastVisible}\">\r\n\t\t<div class=\"md-padding\">\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>Display Name</label>\r\n\t\t\t\t<input type=\"text\" required name=\"displayname\" ng-model=\"vm.sbUserDataStore.user.UserName\">\r\n\t\t\t\t<div ng-messages=\"f.displayname.$error\" ng-if=\"f.displayname.$touched\" role=\"alert\">\r\n\t\t\t\t\t<default-error-messages />\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>Email Address</label>\r\n\t\t\t\t<input type=\"email\" required name=\"emailAddress\" ng-model=\"vm.sbUserDataStore.user.EmailAddress\">\r\n\t\t\t\t<div ng-messages=\"f.emailAddress.$error\" ng-if=\"f.emailAddress.$touched\" role=\"alert\">\r\n\t\t\t\t\t<default-error-messages />\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\" ng-if=\"!vm.userId\">\r\n\t\t\t\t<label translate>Password</label>\r\n\t\t\t\t<input type=\"password\" required name=\"newpassword\" ng-model=\"vm.sbUserDataStore.user.Password\">\r\n\t\t\t\t<div ng-messages=\"f.newpassword.$error\" ng-if=\"f.newpassword.$touched\" role=\"alert\">\r\n\t\t\t\t\t<default-error-messages />\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t\t<md-input-container class=\"md-block\" ng-if=\"!vm.userId\">\r\n\t\t\t\t<label translate>Verify Password</label>\r\n\t\t\t\t<input type=\"password\" required name=\"newpasswordverify\" ng-model=\"vm.VerifyPassword\">\r\n\t\t\t\t<div ng-messages=\"f.newpasswordverify.$error\" ng-if=\"f.newpasswordverify.$touched\" role=\"alert\">\r\n\t\t\t\t\t<default-error-messages />\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t</div>\r\n\t\t<md-list>\r\n\t\t\t<div ng-if=\"vm.userId\">\r\n\t\t\t\t<md-divider></md-divider>\r\n\t\t\t\t<md-subheader class=\"md-accent md-no-sticky\">{{::'User Settings' | translate}}</md-subheader>\r\n\t\t\t\t<md-list-item class=\"md-with-secondary\">\r\n\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar \">lock</md-icon>\r\n\t\t\t\t\t<p translate>Lock Account</p>\r\n\t\t\t\t\t<md-switch class=\"md-secondary\" ng-model=\"vm.sbUserDataStore.user.IsLocked\" ng-change=\"vm.updateUserLock()\"></md-switch>\r\n\t\t\t\t</md-list-item>\r\n\t\t\t</div>\r\n\t\t\t<md-divider></md-divider>\r\n\t\t\t<md-subheader class=\"md-accent md-no-sticky\">{{::'User Roles' | translate}}</md-subheader>\r\n\t\t\t<md-list-item class=\"md-3-line md-with-secondary\" ng-if=\"vm.authService.isSysAdmin || vm.authService.isTenantAdmin\">\r\n\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar \">group_work</md-icon>\r\n\t\t\t\t<div class=\"md-list-item-text sb-admin-invite---list-with-action\">\r\n\t\t\t\t\t<h3 translate>Tenant Administrator</h3>\r\n\t\t\t\t\t<p translate>Allow user to administer a group of deployments.</p>\r\n\t\t\t\t\t<p ng-if=\"!vm.sbUserDataStore.deploymentGroupAdmin.GroupName\" translate>No group assigned</p>\r\n\t\t\t\t\t<p ng-if=\"vm.sbUserDataStore.deploymentGroupAdmin.GroupName\" translate>Assigned Group: {{vm.sbUserDataStore.deploymentGroupAdmin.GroupName}}</p>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-switch class=\"md-secondary\" ng-change=\"vm.toggleTenantAdmin(vm.sbUserDataStore.isTenantAdmin, $event)\" ng-model=\"vm.sbUserDataStore.isTenantAdmin\"></md-switch>\r\n\t\t\t</md-list-item>\r\n\t\t\t<md-list-item class=\"md-3-line md-with-secondary\" ng-class=\"{'sb-app__disabled-list-item':!vm.canPromoteSiteAdmins}\" ng-disabled=\"!vm.canPromoteSiteAdmins\">\r\n\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar \">settings</md-icon>\r\n\t\t\t\t<div class=\"md-list-item-text\">\r\n\t\t\t\t\t<h3 translate>Site Administrator</h3>\r\n\t\t\t\t\t<p translate>Allow users to control features of this deployment such as libraries, password policies, API tokens, statistics and logs.</p>\r\n\t\t\t\t</div>\r\n\t\t\t\t<md-switch class=\"md-secondary\" \r\n\t\t\t\tng-disabled=\"!vm.canPromoteSiteAdmins\" \r\n\t\t\t\tng-change=\"vm.promotingAsAdmin()\" \r\n\t\t\t\tng-model=\"vm.sbUserDataStore.isSiteAdmin\"></md-switch>\r\n\t\t\t</md-list-item>\r\n\t\t\t<md-divider hide show-xs class=\"sb-admin-user__role-divider\"></md-divider>\r\n\t\t\t<md-list-item class=\"md-3-line md-with-secondary\"\r\n\t\t\t\t\tng-class=\"{'sb-app__disabled-list-item':!vm.canPromoteSiteAdmins}\" \r\n\t\t\t\t\tng-disabled=\"!vm.canPromoteSiteAdmins\">\r\n\t\t\t\t\t<md-icon class=\"md-avatar material-icons sba-list-avatar\">people</md-icon>\r\n\t\t\t\t\t<div class=\"md-list-item-text\">\r\n\t\t\t\t\t\t<h3 translate>User Administrator</h3>\r\n\t\t\t\t\t\t<p translate>Allow users to add/edit/delete users and groups for this deployment.</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<md-switch class=\"md-secondary\" \r\n\t\t\t\t\tng-disabled=\"!vm.canPromoteSiteAdmins\" \r\n\t\t\t\t\tng-model=\"vm.sbUserDataStore.isUserAdmin\"></md-switch>\r\n\t\t\t</md-list-item>\r\n\t\t</md-list>\r\n\t\t<span flex-gt-xs><!-- push buttons to the bottom --></span>\r\n\t\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\t\t\t\r\n\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\" ng-if=\"vm.userId\">{{::'Update' | translate}}</md-button>\r\n\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\" ng-if=\"!vm.userId\">{{::'Create' | translate}}</md-button>\r\n\t\t\t<md-button flex-order-xs=\"1\" ui-sref=\"^\">{{::'Cancel' | translate}}</md-button>\r\n\t\t</div>\r\n\t</md-content>\r\n</form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 222 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/userDeleteDialog/userDeleteDialog.template.html';
	var html = "<md-dialog class=\"user-delete-dialog\">\r\n\t<md-dialog-content class=\"md-dialog-content\">\r\n\t\t<h2 class=\"md-title\" translate>Would you like to delete this user?</h2>\r\n\t\t<p translate>The account and content for \"{{::vm.user.UserName}}\" will be deleted.  If you'd like to keep this user's content please select the user to transfer it's ownership to below.</p>\r\n\t\t<md-subheader class=\"md-warn md-no-sticky user-delete-dialog__warning app-animate--fade-in\" ng-if=\"!vm.transferUser.UserName\" translate>\r\n\t\t\tIf no new owner is selected the content will be purged!\r\n\t\t</md-subheader>\r\n\r\n\t\t<sb-user-select selected=\"vm.transferUser\" \r\n\t\t\t\t\t\tplaceholder=\"{{::'Transfer ownership to' | translate}}\"  \r\n\t\t\t\t\t\tinclude-usergroups=\"false\"\r\n\t\t\t\t\t\tdeployment-id=\"vm.deploymentId\">\r\n\t\t</sb-user-select>\r\n\t</md-dialog-content>\r\n\t<md-dialog-actions layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t<md-button ng-click=\"vm.cancel()\" aria-label=\"{{::'Cancel' | translate}}\">{{::'Cancel' | translate}}</md-button>\r\n\t\t<md-button flex-order-xs=\"-1\" class=\"md-primary\" ng-click=\"vm.delete()\" aria-label=\"{{::'Delete' | translate}}\">\r\n\t\t\t<span ng-if=\"!vm.transferUser.UserName\">{{'Delete & Purge Content' | translate}}</span>\r\n\t\t\t<span ng-if=\"vm.transferUser.UserName\">{{'Delete & Transfer Content' | translate}}</span>\r\n\t\t</md-button>\r\n\t</md-dialog-actions>\r\n</md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 223 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/deploymentGroupSelectDialog/deploymentGroupSelectDialog.template.html';
	var html = "<md-dialog aria-label=\"{{::'Select Deployment Group' | translate}}\">\r\n\t<md-dialog-content>\r\n\t\t<div class=\"md-dialog-content\">\r\n\t\t\t<h2 class=\"md-title\" translate>Choose the deployment group to administer</h2>\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<md-select \tng-model=\"vm.selectedGroup\"\r\n\t\t\t\t\t\t\tng-model-options=\"{trackBy: '$value.DeploymentGroupId'}\"\r\n\t\t\t\t\t\t\tng-attr-placeholder=\"{{'Select a group'|translate}}\">\r\n\t\t\t\t\t<md-option ng-value=\"{{group}}\" ng-repeat=\"group in vm.groups\">{{group.GroupName}}</md-option>\r\n\t\t\t\t</md-select>\r\n\t\t\t</md-input-container>\r\n\t\t</div>\r\n\t</md-dialog-content>\r\n\t<md-dialog-actions layout=\"row\" layout-align=\"end center\">\r\n\t\t<md-button ng-click=\"vm.cancel()\">\r\n\t\t\t{{::'Cancel' | translate}}\r\n\t\t</md-button>\r\n\t\t<md-button ng-click=\"vm.done()\">\r\n\t\t\t{{::'Done' | translate}}\r\n\t\t</md-button>\r\n\t</md-dialog-actions>\r\n</md-dialog>\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(225);
	__webpack_require__(227);

/***/ },
/* 225 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 226 */,
/* 227 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular.module('sharebase-admin')
			.controller('sbUserDeleteDialogController', [
				'$q',
				'$mdDialog',
				'sbDeploymentService',
				'sbUsersDataStore',
				'gettextCatalog',
				'user',
				'deploymentID',
				UserDeleteDialogController]);

		function UserDeleteDialogController($q, $mdDialog, sbDeploymentService, sbUsersDataStore, gettextCatalog, user, deploymentID) {
			var vm = this;
			vm.user = user;
			vm.users = null;
			vm.querySearch = querySearch;
			vm.selectedUser = null;
			vm.cancel = function () {
				$mdDialog.cancel();
			};
			vm.delete = function () {
				$mdDialog.hide(vm.transferUser);
			};

			function getUsers() {
				if (!vm.users) {
					return sbDeploymentService.getDetails(deploymentID)
						.then(function (deployment) {
							return sbUsersDataStore.getUsers(deployment.SystemName);
						})
						.then(function (users) {
							vm.users = users;
							return vm.users;
						});
				}

				return $q.resolve(vm.users);
			}
			function querySearch(query) {
				return getUsers()
					.then(function (users) {
						var results = query ? users.filter(createFilterFor(query)) : [];
						return results;
					});
			}
			function createFilterFor(query) {
				var lowercaseQuery = angular.lowercase(query);
				return function filterFn(u) {
					//search username and email
					var combinedUser = u.UserName + ' ' + u.EmailAddress;
					return (combinedUser.indexOf(lowercaseQuery) > -1);
				};
			}
		}
	}());

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(229);
	__webpack_require__(231);

/***/ },
/* 229 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 230 */,
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(232);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminUserGroup
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminAddEditUserGroup` displays a User Group to add/edit
		 *
		 * @usage
		 *
		 * <sbadmin-add-edit-UserGroup UserGroup-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} UserGroupId The id of the User Group to display
		 */

		angular
			.module('sharebase-admin')
			.directive('sbadminUserGroup',[
				UserGroupDirective
			])
			.controller('sbadminUserGroupController',[
				'$q',
				'$state',
				'$mdMedia',
				'sbToastService',
				'sbUserGroupDataStore',
				'sbUsersDataStore',
				'sbDeploymentNameService',
				'sbadminToolbarService',
				'pxProgressService',
				'gettextCatalog',
				UserGroupController
			]);

		function UserGroupDirective() {
			return {
				restrict: 'E',
				controller: 'sbadminUserGroupController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId: '@',
					userGroupId: '@'
				},
				scope: {},
				link: function (scope, element, attrs) {

				}
			};
		}

		function UserGroupController($q, $state, $mdMedia, sbToastService, sbUserGroupDataStore, sbUsersDataStore, sbDeploymentNameService, sbadminToolbarService, pxProgressService, gettextCatalog) {
			var vm = this;
			vm.loading = false;
			vm.mdMedia = $mdMedia;
			vm.doneLoading = doneLoading;
			vm.userGroupDS = sbUserGroupDataStore;
			vm.usersDS = sbUsersDataStore;
			vm.save = save;
			vm.textCatalog = gettextCatalog;
			vm.systemName = null;
			vm.MaxLinkExpirationDays = null;
			vm.MinLinkAuthenticationType = null;
			
			sbadminToolbarService.title = vm.userGroupId ? gettextCatalog.getString('Edit User Group') : gettextCatalog.getString('Create User Group');
			sbadminToolbarService.actions = [];
			sbadminToolbarService.showFilter = false;

			function loadUserGroup() {
				isLoading();

				sbDeploymentNameService.resolveSystemName(vm.deploymentId)
					.then(function (systemName) {
						vm.systemName = systemName;
						var initTasks = [
							vm.userGroupDS.getUserGroup(vm.userGroupId, systemName),
							vm.usersDS.getUsers(systemName)
						];
						if (vm.userGroupId) {
							initTasks.push(vm.userGroupDS.getUserGroupPolicy(vm.userGroupId));
						}
						return $q.all(initTasks);
					})
					.then(function () {
						if (vm.userGroupId) {
							vm.MaxLinkExpirationDays = vm.userGroupDS.userGroupPolicy.MaxLinkExpirationDays;
							vm.expirationSelection = vm.userGroupDS.userGroupPolicy.MaxLinkExpirationDays === null ? 0 : 1;
							vm.MinLinkAuthenticationType = vm.userGroupDS.userGroupPolicy.MinLinkAuthenticationType === -1 ? 0 : vm.userGroupDS.userGroupPolicy.MinLinkAuthenticationType;
						}
					})
					.finally(doneLoading);
			}

			function save() {
				pxProgressService.backdrop = true;
				isLoading();

				var initTasks = [];

				if (vm.userGroupId) {					
					if (vm.expirationSelection === 0) {
						vm.userGroupDS.userGroupPolicy.MaxLinkExpirationDays = null;
					}
					else {
						vm.userGroupDS.userGroupPolicy.MaxLinkExpirationDays = vm.MaxLinkExpirationDays;
					}
					vm.userGroupDS.userGroupPolicy.MinLinkAuthenticationType = vm.MinLinkAuthenticationType;	

					// system groups can only have their policy edited, but not 
					// membership or details
					initTasks.push(vm.userGroupDS.saveUserGroupPolicy(vm.userGroupDS.userGroupPolicy));

					if(!vm.userGroupDS.userGroup.isSystemGroup) {
						initTasks.push(vm.userGroupDS.saveUserGroup(vm.systemName));
					}
				} 
				else {
					initTasks.push(vm.userGroupDS.saveUserGroup(vm.systemName));
				}

				return $q.all(initTasks)
					.then(function (responses) {
						vm.userGroup = responses[0];
						$state.go('^');
						sbToastService.showSimple(vm.userGroupId ? gettextCatalog.getString('User group saved!') : gettextCatalog.getString('New user group created!'));
					})
					.finally(doneLoading);
			}

			function isLoading() {
				vm.loading = true;
				pxProgressService.visible = true;
			}

			function doneLoading() {
				vm.loading = false;
				pxProgressService.visible = false;
			}

			loadUserGroup();
		}
	})();

/***/ },
/* 232 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/userGroup/userGroup.template.html';
	var html = "<form flex name=\"userGroupForm\" class=\"sba-user-group\" layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\" ng-submit=\"userGroupForm.$valid && vm.save()\" novalidate>\r\n\t<div role=\"alert\" class=\"app__background sba-form-errors\" ng-if=\"vm.errorMessage\">\r\n\t\t<md-subheader class=\"md-warn md-no-sticky sba-form-errors__message\">{{vm.errorMessage}}</md-subheader>\r\n\t</div>\r\n\t<md-content layout-gt-xs=\"column\" layout-align-gt-xs=\"start stretch\">\r\n\t\t<div class=\"md-padding\" ng-if=\"vm.userGroupDS.userGroup.isSystemGroup\">\r\n\t\t\t<h1 class=\"md-headline\">{{::vm.userGroupDS.userGroup.name}}</h1>\r\n\t\t\t<div>\r\n\t\t\t\t<md-icon class=\"material-icons pxlogin__input-icon\">warning</md-icon>\r\n\t\t\t\t<span class=\"md-body-2\">\r\n\t\t\t\t\t<translate translate-comment=\"A warning message displayed to users\">\r\n\t\t\t\t\t\tSettings within this System User Group are the default for all users\r\n\t\t\t\t\t</translate>\r\n\t\t\t\t</span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"md-padding\" ng-if=\"!vm.userGroupDS.userGroup.isSystemGroup\">\r\n\t\t\t<md-input-container class=\"md-block\">\r\n\t\t\t\t<label translate>User Group Name</label>\r\n\t\t\t\t<input name=\"name\" ng-model=\"vm.userGroupDS.userGroup.name\" ng-disabled=\"vm.userGroupDS.userGroup.isSystemGroup\" required md-maxlength=\"50\">\r\n\t\t\t\t<div ng-messages=\"userGroupForm.name.$error\" role=\"alert\" multiple>\r\n\t\t\t\t\t<div ng-message=\"required\" translate>You must supply a User Group name.</div>\r\n\t\t\t\t\t<div ng-message=\"md-maxlength\" class=\"my-message\" translate>\r\n\t\t\t\t\t\tYour name must be less than 50 characters.\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</md-input-container>\r\n\t\t</div>\r\n\t\t<div layout-margin>\r\n\t\t\t<div class=\"md-whiteframe-2dp md-padding sb-admin__card\" ng-if=\"!vm.userGroupDS.userGroup.isSystemGroup\">\r\n\t\t\t\t<h3 translate>Assigned Users</h3>\r\n\t\t\t\t<div layout-gt-sm=\"row\" layout-padding>\r\n\t\t\t\t\t<sb-user-select flex\r\n\t\t\t\t\t\t\t\t\tplaceholder=\"{{'Add User' | translate}}\"\r\n\t\t\t\t\t\t\t\t\tinclude-usergroups=\"false\"\r\n\t\t\t\t\t\t\t\t\tselected=\"vm.userGroupDS.userGroup.users\"\r\n\t\t\t\t\t\t\t\t\tmultiple=\"true\"\r\n\t\t\t\t\t\t\t\t\tdeployment-id=\"vm.deploymentId\"></sb-user-select>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"md-whiteframe-2dp md-padding sb-admin__card\" ng-if=\"vm.userGroupId\">\r\n\t\t\t\t<h3 translate>Share Link Settings</h3>\r\n\t\t\t\t<label>\r\n\t\t\t\t\t<translate>Deployment defaults</translate>\r\n\t\t\t\t</label>\r\n\t\t\t\t<div layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t<label translate>Minimum Access Security</label>\r\n\t\t\t\t\t\t<md-select ng-model=\"vm.MinLinkAuthenticationType\">\r\n\t\t\t\t\t\t\t<md-option ng-value=\"0\" ng-if=\"vm.userGroupDS.userGroup.isSystemGroup\">\r\n\t\t\t\t\t\t\t\t<translate>No Restrictions</translate>\r\n\t\t\t\t\t\t\t</md-option>\r\n\t\t\t\t\t\t\t<md-option ng-value=\"0\" ng-if=\"!vm.userGroupDS.userGroup.isSystemGroup\">\r\n\t\t\t\t\t\t\t\t<translate>Default</translate>\r\n\t\t\t\t\t\t\t</md-option>\r\n\r\n\t\t\t\t\t\t\t<!-- this is not implemented on the API side\r\n\t\t\t\t\t\t\t<md-option value=\"either\" translate>\r\n\t\t\t\t\t\t\t\tPassword or Email Secure Password\r\n\t\t\t\t\t\t\t</md-option>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t\t<md-option value=\"100\">\r\n\t\t\t\t\t\t\t\t<translate>Email Secure Password</translate>\r\n\t\t\t\t\t\t\t</md-option>\r\n\t\t\t\t\t\t</md-select>\r\n\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t<div layout=\"row\" layout-xs=\"column\">\r\n\t\t\t\t\t\t<md-input-container flex>\r\n\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t<translate translate-comment=\"configuring the maximum expiration duration of a link\">\r\n\t\t\t\t\t\t\t\t\tMaximum Expiration Duration\r\n\t\t\t\t\t\t\t\t</translate>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<md-select ng-model=\"vm.expirationSelection\">\r\n\t\t\t\t\t\t\t\t<md-option ng-value=\"0\" ng-if=\"vm.userGroupDS.userGroup.isSystemGroup\">\r\n\t\t\t\t\t\t\t\t\t<translate>No Maximum</translate>\r\n\t\t\t\t\t\t\t\t</md-option>\r\n\t\t\t\t\t\t\t\t<md-option ng-value=\"0\" ng-if=\"!vm.userGroupDS.userGroup.isSystemGroup\">\r\n\t\t\t\t\t\t\t\t\t<translate translate-comment=\"value selected from a dropdown stating a created link will never expire\">\r\n\t\t\t\t\t\t\t\t\t\tDefault\r\n\t\t\t\t\t\t\t\t\t</translate>\r\n\t\t\t\t\t\t\t\t</md-option>\r\n\t\t\t\t\t\t\t\t<md-option ng-value=\"1\">\r\n\t\t\t\t\t\t\t\t\t<translate>Days</translate>\r\n\t\t\t\t\t\t\t\t</md-option>\r\n\t\t\t\t\t\t\t</md-select>\r\n\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t\t<md-input-container>\r\n\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t<translate>Days</translate>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<input type=\"number\" name=\"linkExpirationDays\"\r\n\t\t\t\t\t\t\t\t   ng-disabled=\"vm.expirationSelection === 0\"\r\n\t\t\t\t\t\t\t\t   ng-required=\"vm.expirationSelection === 1\"\r\n\t\t\t\t\t\t\t\t   ng-model=\"vm.MaxLinkExpirationDays\"\r\n\t\t\t\t\t\t\t\t   value=\"\" min=\"1\" max=\"999\" aria-label=\"{{::'Maximum link expiration in days' | translate}}\" />\r\n\t\t\t\t\t\t\t<div ng-messages=\"userGroupForm.linkExpirationDays.$error\">\r\n\t\t\t\t\t\t\t\t<div ng-message=\"max\">\r\n\t\t\t\t\t\t\t\t\t<translate>You cannot exceed 999 days</translate>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div ng-message=\"min\">\r\n\t\t\t\t\t\t\t\t\t<translate>You must supply a valid duration</translate>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div ng-message=\"required\">\r\n\t\t\t\t\t\t\t\t\t<translate>You must supply a duration</translate>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</md-input-container>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</md-content>\r\n\t<div class=\"md-padding\" layout=\"row\" layout-align=\"end center\" layout-xs=\"column\" layout-align-xs=\"start stretch\">\r\n\t\t<md-button type=\"submit\" flex-order-xs=\"-1\" class=\"md-primary md-raised\">\r\n\t\t\t{{ vm.userGroupDS.userGroup.id ? vm.textCatalog.getString('Update') : vm.textCatalog.getString('Create') }}\r\n\t\t</md-button>\r\n\t\t<md-button ui-sref=\"^\">\r\n\t\t\t<translate>Cancel</translate>\r\n\t\t</md-button>\r\n\t</div>\r\n</form>\r\n";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(234);
	__webpack_require__(236);

/***/ },
/* 234 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 235 */,
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(237);

		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminUserGroups
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminUserGroups` displays a deployments user groups
		 *
		 * @usage
		 *
		 * <sbadmin-statistics deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminUserGroups',
			[
				'sbadminToolbarService',
				UserGroupsDirective
			])
			.controller('sbadminUserGroupsController', [
				'$state',
				'sbUserGroupsDataStore',
				'sbadminToolbarService',
				'sbDeploymentNameService',
				'pxProgressService',
				'gettextCatalog',
				UserGroupsController
			]);
		
		function UserGroupsDirective(sbadminToolbarService) {
			return {
				restrict: 'E',
				controller: 'sbadminUserGroupsController',
				controllerAs: 'userGroupsCtrl',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId: '@',
				},
				scope: {},
				link: function (scope, element, attrs) {
					scope.$on('$destroy', function () {
						sbadminToolbarService.filterPlaceholder = null;
						sbadminToolbarService.actions = [];
					});
				}
			};
		}

		function UserGroupsController($state, sbUserGroupsDataStore, sbadminToolbarService, sbDeploymentNameService, pxProgressService, gettextCatalog) {
			var self = this;
			self.loading = false;
			self.userGroupDS = sbUserGroupsDataStore;
			self.editGroup = editGroup;

			self.sbadminToolbarService = sbadminToolbarService;
			sbadminToolbarService.title = gettextCatalog.getString('User Groups');
			sbadminToolbarService.filterPlaceholder = gettextCatalog.getString('Find user groups');
			sbadminToolbarService.actions = [{ icon: 'add', label: gettextCatalog.getString('Create Group'), trigger: function () { $state.go('administration.home.deployment.userGroups.details'); } }];
			sbadminToolbarService.showFilter = true;		

			(function loadUserGroups() {
				isLoading();
				sbDeploymentNameService
					.resolveSystemName(self.deploymentId)
					.then(function (systemName) {
						self.systemName = systemName;
						return sbUserGroupsDataStore
							.getUserGroups(systemName);
					})
					.finally(doneLoading);
			})();

			function editGroup(group) {
				$state.go('administration.home.deployment.userGroups.details', { userGroupId: group.UserGroupId });
			}

			function isLoading() {
				self.loading = true;
				pxProgressService.visible = true;
			}

			function doneLoading() {
				self.loading = false;
				pxProgressService.visible = false;
			}
		}
	})();

/***/ },
/* 237 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/userGroups/userGroups.template.html';
	var html = "<md-content flex layout=\"column\" layout-align=\"start strectch\" ng-if=\"userGroupsCtrl.userGroupDS.userGroups.length > 0\">\r\n\t<md-list flex class=\"app--list-no-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t<md-virtual-repeat-container flex md-top-index=\"userGroupsCtrl.itemIndex\">\r\n\t\t\t<div md-virtual-repeat=\"group in userGroupsCtrl.userGroupDS.userGroups | orderBy : '!IsSystemGroup' | filter:{UserGroupName:userGroupsCtrl.sbadminToolbarService.filterPhrase}\">\r\n\t\t\t\t<md-list-item class=\"md-3-line\" layout=\"row\" layout-align=\"center center\" ng-click=\"userGroupsCtrl.editGroup(group)\">\r\n\t\t\t\t\t<md-icon ng-if=\"group.IsSystemGroup\" class=\"md-avatar sba-list-avatar material-icons\">perm_identity</md-icon>\r\n\t\t\t\t\t<md-icon ng-if=\"!group.IsSystemGroup\" class=\"md-avatar sba-list-avatar material-icons\">supervisor_account</md-icon>\r\n\t\t\t\t\t<div class=\"md-list-item-text\" flex>\r\n\t\t\t\t\t\t<h3 class=\"ellipsis\">{{ group.UserGroupName }}</h3>\r\n\t\t\t\t\t\t<p class=\"ellipsis\" \r\n\t\t\t\t\t\ttranslate\r\n\t\t\t\t\t\ttranslate-params-user-count=\"group.UserCount\"\r\n\t\t\t\t\t\ttranslate-comment=\"The number of users in the group\">\r\n\t\t\t\t\t\t\t{{userCount}} users in group\r\n\t\t\t\t\t\t</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</md-list-item>\r\n\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t</div>\r\n\t\t</md-virtual-repeat-container>\r\n\t</md-list>\r\n</md-content>\r\n<!-- Empty State -->\r\n<div class=\"sba__empty-state-wrap\" flex layout=\"column\" layout-align=\"center center\" ng-if=\"userGroupsCtrl.userGroupDS.userGroups.length === 0 && !userGroupsCtrl.loading\">\r\n\t<div class=\"sba__empty-state sba__empty-state---clickable\" layout=\"column\" layout-align=\"center center\" ui-sref=\"administration.home.deployment.userGroups.details\">\r\n\t\t<div class=\"sba__empty-state-bg\">\r\n\t\t\t<md-icon class=\"material-icons sba__empty-state-bg-icon\">group</md-icon>\r\n\t\t</div>\r\n\t\t<h2 class=\"sba__empty-state-title\" translate>You haven't created any user groups</h2>\r\n\t\t<p class=\"sba__empty-state-description\" translate>Create one by clicking here or the plus sign in the top right corner</p>\r\n\t</div>\r\n</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(239);
	__webpack_require__(241);

/***/ },
/* 239 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 240 */,
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
		'use strict';
		var templateUrl = __webpack_require__(242);
		var userDeleteTemplateUrl = __webpack_require__(222);
		
		/**
		 * @ngdoc directive
		 * @name sharebase-admin.directive:sbadminUsers
		 * @module sharebase-admin
		 * @restrict E
		 * @description
		 *
		 * `sbadminUsers` displays a deployments users
		 *
		 * @usage
		 *
		 * <sbadmin-users deployment-id="1" /> 
		 * 
		 * @element input
		 * @param {number=} deploymentId The id of the deployment display api tokens for
		 */

		angular.module('sharebase-admin')
			.directive('sbadminUsers', [
				'sbadminToolbarService',
				UsersDirective])
			.controller('sbadminUsersController', [
				'$q',
				'$state',
				'$mdDialog',
				'sbUserDataStore',
				'sbUsersDataStore',
				'sbadminToolbarService',
				'sbDeploymentService',
				'pxProgressService',
				'gettextCatalog',
				'sbToastService',
				'sbDeploymentNameService',
				UsersController]);

		function UsersDirective(sbadminToolbarService) {
			return {
				restrict: 'E',
				controller: 'sbadminUsersController',
				controllerAs: 'vm',
				templateUrl: templateUrl,
				bindToController: {
					deploymentId: '@',
				},
				scope: {},
				link: function (scope, element, attrs) {
					scope.$on('$destroy', function () {
						sbadminToolbarService.filterPlaceholder = null;
						sbadminToolbarService.actions = [];
					});
				}
			};
		}	
		function UsersController($q, $state, $mdDialog, sbUserDataStore, sbUsersDataStore, sbadminToolbarService, sbDeploymentService, pxProgressService, gettextCatalog, sbToastService, sbDeploymentNameService) {
			var vm = this;

			// Attribute translations do not support comments and a comment was requested for this string		
			/// Used as a label above a list of registered users
			vm.registeredLabel = gettextCatalog.getString('Registered');

			vm.sbUsersDataStore = sbUsersDataStore;
			vm.sbadminToolbarService = sbadminToolbarService;
			vm.pxProgressService = pxProgressService;
			vm.inviteUsers = inviteUsers;
			vm.editUser = editUser;
			vm.deleteUser = deleteUser;
			sbadminToolbarService.title = gettextCatalog.getString('Users');
			sbadminToolbarService.filterPlaceholder = gettextCatalog.getString('Find users');
			sbadminToolbarService.actions = [
				{ icon: 'person_add', label: gettextCatalog.getString('Create User'), trigger: createUser },
				{ icon: 'email', label: gettextCatalog.getString('Invite Users'), trigger: vm.inviteUsers }
			];
			sbadminToolbarService.showFilter = true;

			function inviteUsers() {
				$state.go('administration.home.deployment.users.invite');
			}
			function editUser(user) {
				$state.go('administration.home.deployment.users.details', { deploymentID: vm.deploymentId, userID: user.UserId });
			}

			function createUser() {
				$state.go('administration.home.deployment.users.details', { deploymentID: vm.deploymentId, userID: '' });
			}
			function deleteUser($event, userToDelete) {
				$mdDialog.show({
					controller: 'sbUserDeleteDialogController',
					controllerAs: 'vm',
					templateUrl: userDeleteTemplateUrl,
					targetEvent: $event,
					locals: {
						user: userToDelete,
						deploymentID: vm.deploymentId
					},
					clickOutsideToClose: false
				})
					.then(function (transferUser) {
						pxProgressService.visible = true;
						//delete user & reasign content & udate DS
						transferUser = transferUser ? transferUser : null;
						sbUserDataStore.removeUser(userToDelete, vm.deploymentId, transferUser)
							.then(function () {
								removeUserFromList(userToDelete);
								sbToastService.showSimple(gettextCatalog.getString('User "{{deletedUser}}" deleted successfully.', { deletedUser: userToDelete.UserName }));
							})
							.catch(function (response) {
								pxProgressService.visible = false;
								if (response.status === 409) {
									//conflict - user to delete has other users conent
									var confirm = $mdDialog.confirm()
										.title(gettextCatalog.getString('Continue with user deletion?'))
										.textContent(gettextCatalog.getString('{{deletedUser}} has content that is owned by a different user, which will be deleted if this user is deleted. ', { deletedUser: userToDelete.UserName }))
										.ariaLabel(gettextCatalog.getString('Delete User Conflict'))
										.ok(gettextCatalog.getString('Continue'))
										.cancel(gettextCatalog.getString('Cancel'));
									return $mdDialog.show(confirm).then(function () {
										//delete user & force delete shared content
										pxProgressService.visible = true;
										return sbUserDataStore.removeUser(userToDelete, vm.deploymentId, null, true)
											.then(function () {
												removeUserFromList(userToDelete);
												sbToastService.showSimple(gettextCatalog.getString('User "{{deletedUser}}" deleted successfully.', { deletedUser: userToDelete.UserName }));
											})
											.catch(function () {
												sbToastService.showSimple(gettextCatalog.getString('Error deleting user "{{deletedUser}}".', { deletedUser: userToDelete.UserName }));
											});
									}, angular.noop());
								}
								sbToastService.showSimple(gettextCatalog.getString('Error deleting user "{{deletedUser}}".', { deletedUser: userToDelete.UserName }));
							})
							.finally(function () {
								pxProgressService.visible = false;
							});
					}, angular.noop());
			}

			function removeUserFromList(removedUser) {
				vm.sbUsersDataStore.users = vm.sbUsersDataStore.users.filter(function(user){
					return user.UserId !== removedUser.UserId;
				});
			}

			//initialize
			(function loadUsers() {
				pxProgressService.visible = true;
				sbDeploymentNameService.resolveSystemName(vm.deploymentId)
					.then(function (systemName) {
						vm.systemName = systemName;
					})
					.then(function () {
						return $q.all([
							vm.sbUsersDataStore.getUsers(vm.systemName),
							vm.sbUsersDataStore.getPendingUsers()
						]);
					})
					.finally(function () {
						pxProgressService.visible = false;
					});
			} ());
		}
	} ());

/***/ },
/* 242 */
/***/ function(module, exports) {

	var path = 'sharebase-admin/components/users/users.template.html';
	var html = "<md-content flex layout=\"column\" layout-align=\"start stretch\">\r\n\t<md-tabs flex md-border-bottom ng-class=\"{'sb-admin-users__tab---hide-tabs': vm.sbUsersDataStore.pendingUsers.length === 0}\">\r\n\t\t<md-tab label=\"{{::vm.registeredLabel}}\">\r\n\t\t\t<md-content class=\"sb-admin-users__tab-content\" layout-fill layout=\"column\" layout-align=\"start strectch\">\r\n\t\t\t\t<md-list flex class=\"app--list-no-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-virtual-repeat-container flex md-top-index=\"vm.itemIndex\">\r\n\t\t\t\t\t\t<div md-virtual-repeat=\"user in vm.sbUsersDataStore.users | pxFilterUsers: vm.sbadminToolbarService.filterPhrase\">\r\n\t\t\t\t\t\t\t<md-list-item class=\"md-3-line md-has-secondary\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.editUser(user)\">\r\n\t\t\t\t\t\t\t\t<div class=\"md-avatar app__animate-icon-button\">\r\n\t\t\t\t\t\t\t\t\t<md-icon class=\"sba-list-avatar material-icons\" ng-if=\"!user.IsLocked\">account_circle</md-icon>\r\n\t\t\t\t\t\t\t\t\t<md-icon class=\"md-warn material-icons sba-list-avatar sb-admin-user---locked-icon\" ng-if=\"user.IsLocked\">lock</md-icon>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"md-list-item-text\" flex>\r\n\t\t\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{user.UserName}}</h3>\r\n\t\t\t\t\t\t\t\t\t<h4 class=\"ellipsis\">{{user.EmailAddress}}</h4>\r\n\t\t\t\t\t\t\t\t\t<p translate\r\n\t\t\t\t\t\t\t\t\ttranslate-params-date=\"user.DateCreated | sbSimpleDateTimeString\"\r\n\t\t\t\t\t\t\t\t\ttranslate-comment=\"value between double braces will become a date\">\r\n\t\t\t\t\t\t\t\t\t\tCreated on {{date}}\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<md-icon class=\"md-secondary material-icons\" ng-click=\"vm.deleteUser($event, user)\" aria-label=\"{{::'Delete User' | translate}}\">clear</md-icon>\r\n\t\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</md-virtual-repeat-container>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\t\t</md-tab>\r\n\t\t<md-tab label=\"{{'Pending Invitations' | translate}} ({{vm.sbUsersDataStore.pendingUsers.length}})\" ng-if=\"vm.sbUsersDataStore.pendingUsers.length > 0\" translate-comment=\"value between double braces will become a count of users\">\r\n\t\t\t<md-content class=\"sb-admin-users__tab-content\" layout-fill layout=\"column\" layout-align=\"start strectch\">\r\n\t\t\t\t<md-list flex class=\"app--list-no-padding\" layout=\"column\" layout-align=\"start stretch\">\r\n\t\t\t\t\t<md-virtual-repeat-container flex md-top-index=\"vm.itemIndex\">\r\n\t\t\t\t\t\t<div md-virtual-repeat=\"user in vm.sbUsersDataStore.pendingUsers | filter:{EmailAddress:vm.sbadminToolbarService.filterPhrase }\">\r\n\t\t\t\t\t\t\t<md-list-item class=\"md-2-line\" layout=\"row\" layout-align=\"center center\">\r\n\t\t\t\t\t\t\t\t<md-icon class=\"md-avatar sba-list-avatar material-icons\">account_circle</md-icon>\r\n\t\t\t\t\t\t\t\t<div class=\"md-list-item-text\" flex>\r\n\t\t\t\t\t\t\t\t\t<h3 class=\"ellipsis\">{{user.EmailAddress}}</h3>\r\n\t\t\t\t\t\t\t\t\t<p translate \r\n\t\t\t\t\t\t\t\t\ttranslate-params-date=\"user.ExpirationDate | sbSimpleDateTimeString\"\r\n\t\t\t\t\t\t\t\t\ttranslate-comment=\"Date a user's invitation expires\">\r\n\t\t\t\t\t\t\t\t\t\tExpires on {{date}}\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</md-list-item>\r\n\t\t\t\t\t\t\t<md-divider ng-if=\"!$last\"></md-divider>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</md-virtual-repeat-container>\r\n\t\t\t\t</md-list>\r\n\t\t\t</md-content>\r\n\t\t</md-tab>\r\n\t</md-tabs>\r\n</md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	angular
	    .module('sharebase-admin');


/***/ },
/* 244 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name sharebase-admin.sbadminActiveDirectoryService
		* @requires $http
		* @requires $q
		* @requires pxUriPathService
		* @description
		* A service used to interact with the ActiveDirectory sync agent.
		**/
		angular.module('sharebase-admin')
			.factory('sbadminActiveDirectoryService', [
			'$http',
			'$q',
			'pxUriPathService',
			ActiveDirectoryService
		]);

		function ActiveDirectoryService($http, $q, uriPathService) {
			return {
				/**
				* @ngdoc method
				* @name sbadminActiveDirectoryService#generateSyncSecret
				* @methodOf sharebase-admin.sbadminActiveDirectoryService
				* @kind function
				*
				* @description
				* Generates a new ActiveDirectory sync secret.
				*
				* @returns {String} A hash to be placed in the config file of the sync agent.
				* 
				*/
				generateSyncSecret: generateSyncSecret
			};

			function generateSyncSecret(id) {
				var uri = uriPathService.resolvePath('/admin/deployments/{id}/newSecret', { id: id });
				return $http
					.post(uri)
					.then(function (resp) {
						return resp.data.Secret;
					});
			}
		}
	})();

/***/ },
/* 245 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name sharebase-admin.sbadminApiTokenService
		* @requires $http
		* @requires pxUriPathService
		* @description
		* A service used to interact with the ActiveDirectory sync agent.
		**/
		angular
			.module('sharebase-admin')
			.factory('sbadminApiTokenService', [
				'$http',
				'pxUriPathService',
				ApiTokenService
			]);

		function ApiTokenService($http, uriPathService) {
			return {
				/**
				* @ngdoc method
				* @name sbadminApiTokenService#getTokens
				* @methodOf sharebase-admin.sbadminApiTokenService
				* @kind function
				*
				* @description
				* Gets all API tokens for any users of the deployment who have generated them.  
				*
				* @returns {Array} An array of tokens.
				* 
				*/
				getTokens: getTokens,
				/**
				* @ngdoc method
				* @name sbadminApiTokenService#createToken
				* @methodOf sharebase-admin.sbadminApiTokenService
				* @kind function
				*
				* @description
				* Creates a new token given an email, password, and expiration.  
				*
				* @returns {Deferred} A promise that will resolve with the newly created token.
				* 
				*/
				createToken: createToken,
				/**
				* @ngdoc method
				* @name sbadminApiTokenService#deleteToken
				* @methodOf sharebase-admin.sbadminApiTokenService
				* @kind function
				*
				* @description
				* Delete the token with the specified ID.  
				*
				* @returns {Deferred} An HTTP response promise.
				* 
				*/
				deleteToken: deleteToken
			};

			function getTokens(deploymentId) {
				var uri = uriPathService.resolvePath('/users/apitokens');
				return $http
					.get(uri)
					.then(function (resp) {
						return resp.data;
					});
			}

			function createToken(email, password, expireMeaning) {
				expireMeaning = typeof(expireMeaning) === 'string' ? expireMeaning : 'never';
				var uri = uriPathService.resolvePath('/users/apitoken');
				var data = {
					EmailAddress: email,
					Password: password,
					ExpireMeaning: expireMeaning
				};

				return $http
					.post(uri, data)
					.then(function (resp) {
						return resp.data;
					});
			}

			function deleteToken(tokenId) {
				var uri = uriPathService.resolvePath('/users/apitoken/{id}', { 
					id : tokenId 
				});

				return $http
					.delete(uri);
			}
		}
	})();

/***/ },
/* 246 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		/**
		* @ngdoc service
		* @name sharebase-admin.sbadminDeploymentGroupsService
		* @requires $http
		* @requires settingService
		* @description
		* A service used to retrieve deployment groups
		**/
		angular.module('sharebase-admin')
			.factory('sbadminDeploymentGroupsService', [
				'$http',
				'settingsService',
				'$q',
				DeploymentGroupsService
			]);

		function DeploymentGroupsService($http, settingsService, $q) {
			return {
				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsService#getDeploymentGroup
				* @methodOf sharebase-admin.sbadminDeploymentGroupsService
				* @kind function
				*
				* @description
				* Retrieves a deployment group
				*
				* @returns {Deferred} A promise that will resolve with requested deployment group
				* 
				*/
				//getDeploymentGroup: getDeploymentGroup,

				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsService#getDeploymentGroups
				* @methodOf sharebase-admin.sbadminDeploymentGroupsService
				* @kind function
				*
				* @description
				* Retrieves deployment groups
				*
				* @returns {Deferred} A promise that will resolve with deployment groups
				* 
				*/
				getDeploymentGroups: getDeploymentGroups,

				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsService#getDeploymentGroupAdmins
				* @methodOf sharebase-admin.sbadminDeploymentGroupsService
				* @kind function
				*
				* @description
				* Retrieves deployment group tenant admins
				* @param {object} Deployment group
				* @returns {Deferred} A promise that will resolve with an array of tenant admins
				* 
				*/
				getDeploymentGroupAdmins: getDeploymentGroupAdmins,

				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsService#createDeploymentGroup
				* @methodOf sharebase-admin.sbadminDeploymentGroupsService
				* @kind function
				*
				* @description
				* Creates a deployment group
				* @param {object} Deployment group
				* @returns {Deferred} A promise that will resolve with deployment groups
				* 
				*/
				createDeploymentGroup: createDeploymentGroup,

				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsService#updateDeploymentGroup
				* @methodOf sharebase-admin.sbadminDeploymentGroupsService
				* @kind function
				*
				* @description
				* Updates a deployment group
				* @param {object} Deployment group
				* @returns {Deferred} A promise that will resolve with the updated deployment group
				* 
				*/
				updateDeploymentGroup: updateDeploymentGroup
			};

			function createDeploymentGroup(deploymentGroup) {
				return $http.post(settingsService.serverAPIPath + '/admin/deploymentgroups',
					{
						groupName: deploymentGroup.GroupName,
						partnerIdentifier: deploymentGroup.PartnerIdentifier,
						databaseServer: deploymentGroup.DatabaseServer,
						databaseRootPath: deploymentGroup.DatabaseRootPath,
						logFileRootPath: deploymentGroup.LogFileRootPath,
						diskgroupRootPath: deploymentGroup.DiskgroupRootPath
					})
					.then(function (response) {
						return response.data;
					});
			}

			function getDeploymentGroups() {
				return $http.get(settingsService.serverAPIPath + '/admin/deploymentgroups')
					.then(function (response) {
						return response.data;
					});
			}

			function updateDeploymentGroup(deploymentGroup) {
				return $http.patch(settingsService.serverAPIPath + '/admin/deploymentgroups/' + deploymentGroup.DeploymentGroupId,
					deploymentGroup)
					.then(function (response) {
						return response.data;
					});
			}

			function getDeploymentGroupAdmins(deploymentGroup) {
				return $http.get(settingsService.serverAPIPath + '/admin/deploymentgroups/' + deploymentGroup.DeploymentGroupId + '/admins')
					.then(function (response) {
						return response.data;
					});
			}
		}
	} ());

/***/ },
/* 247 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		/**
		* @ngdoc service
		* @name sharebase-admin.sbadminDeploymentsService
		* @requires $http
		* @requires $q
		* @requires settingsService
		* @description
		* A service used to retrieve active deployments
		**/
		angular
			.module('sharebase-admin')
			.factory('sbadminDeploymentsService', [
				'$http',
				'$q',
				'settingsService',
				DeploymentsService
			]);

		function DeploymentsService($http, $q, settingsService) {
			var deploymentsEndpoint = settingsService.serverAPIPath + '/admin/deployments';
			return {
				/**
				* @ngdoc method
				* @name sbadminDeploymentsService#getDeployments
				* @methodOf sharebase-admin.sbadminDeploymentsService
				* @kind function
				*
				* @description
				* Retrieves active deployments
				*
				* @returns {Deferred} A promise that will resolve with active deployments.
				* 
				*/
				getDeployments: getDeployments			
			};

			function getDeployments() {
				return $http.get(deploymentsEndpoint)
					.then(function (response) {
						return response.data.Embedded.Deployments;
					});
			}
		}
	})();

/***/ },
/* 248 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminDeploymentStatisticsService
		* 
		* @description 
		* Retrieves statistics for a deployment
		* 
		**/
		angular
			.module('sharebase-admin')
			.factory('sbadminDeploymentStatisticsService',
			[
				'$http',
				'pxUriPathService',
				DeploymentStatisticsService
			]);

		function DeploymentStatisticsService($http, pxUriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbadminDeploymentStatisticsService#getDeploymentTotalsUsage
				* @methodOf sharebase-admin.sbadminDeploymentStatisticsService
				* @kind function
				*
				* @description
				* Retrieves the "Core/DeploymentTotalUsage" statistics 
				*
				* @param {deploymentName} The deployment name used to calculate the statistics
				*
				* @returns {Deferred} A promise that will resolve with an object with the following
				* statistics: TotalLibraryDiskUsage, TotalDocumentsCreated, TotalDocumentsViewed, TotalUsers, and TotalLibraries
				* 
				*/
				getDeploymentTotalsUsage: getDeploymentTotalsUsage,
			};

			function getDeploymentTotalsUsage(deploymentName) {
				return fetchStatistic(deploymentName, 'Core', 'DeploymentTotalsUsage').then(function (response) {
					return response.data;
				});
			}

			function fetchStatistic(deploymentName, type, label) {
				return $http.get(pxUriPathService.resolvePath('/{system}/statistics/' + type + '/' + label, {
					system: deploymentName
				}));
			}
		}
	})();

/***/ },
/* 249 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminLibrariesService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase
		* libraries
		**/

		angular
			.module('sharebase-admin')
			.factory('sbadminLibrariesService',
			[
				'$http',
				'pxUriPathService',
				LibrariesService
			]);

		function LibrariesService($http, pxUriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbadminLibrariesService#getLibraries
				* @methodOf sharebase-admin.sbadminLibrariesService
				* @kind function
				*
				* @description
				* Gets a collection of libraries
				*
				* @returns {Deferred} A promise that will resolve with a collection of libraries
				* 
				*/
				getLibraries: getLibraries
			};

			function getLibraries() {
				return $http.get(pxUriPathService.resolvePath('/libraries')).then(function (response) {
					return response.data;
				});
			}
		}

	})();

/***/ },
/* 250 */
/***/ function(module, exports) {

	"use strict";
	(function () {
	    'use strict';
	    /**
	    * @ngdoc service
	    * @name  sharebase-admin.sbadminLibraryService
	    *
	    * @description
	    * A service used to retrieve and interact with a ShareBase
	    * library
	    **/
	    angular
	        .module('sharebase-admin')
	        .factory('sbadminLibraryService', [
	        '$http',
	        'pxUriPathService',
	        LibraryService
	    ]);
	    function LibraryService($http, pxUriPathService) {
	        var service = {
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryService#getLibrary
	            * @methodOf sharebase-admin.sbadminLibraryService
	            * @kind function
	            *
	            * @description
	            * Gets a library
	            *
	            * @param {objectId} libraryId A string to represent the library Id
	            *
	            * @returns {Deferred} A promise that will resolve with a library
	            *
	            */
	            getLibrary: getLibrary,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryService#addLibrary
	            * @methodOf sharebase-admin.sbadminLibraryService
	            * @kind function
	            *
	            * @description
	            * Adds a library
	            *
	            * @param {objectId} library An object to represent the library
	            *
	            * @returns {Deferred} A promise that will resolve with a library
	            *
	            */
	            addLibrary: addLibrary,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryService#updateLibrary
	            * @methodOf sharebase-admin.sbadminLibraryService
	            * @kind function
	            *
	            * @description
	            * Updates a library
	            *
	            * @param {objectId} library An object to represent the library
	            *
	            * @returns {Deferred} A promise that will resolve with a library
	            *
	            */
	            updateLibrary: updateLibrary,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryService#savePermissions
	            * @methodOf sharebase-admin.sbadminLibraryService
	            * @kind function
	            *
	            * @description
	            * Sets permissions for the specified library ID.
	            *
	            * @param {libraryId} ID of the library to set permissions for.
	            *
	            * @param {acls} Array of ACLs to set for the library.
	            *
	            * @returns {Deferred} An $http promise.
	            *
	            */
	            savePermissions: savePermissions,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryService#getPermissions
	            * @methodOf sharebase-admin.sbadminLibraryService
	            * @kind function
	            *
	            * @description
	            * Retrieves permissions for the specified library ID.
	            *
	            * @param {libraryId} ID of the library to get permissions for.
	            *
	            * @returns {Deferred} A promise resolving with an array of the retrieved permissions.
	            *
	            */
	            getPermissions: getPermissions,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryService#getPermissionsForCurrentUser
	            * @methodOf sharebase-admin.sbadminLibraryService
	            * @kind function
	            *
	            * @description
	            * Retrieves permissions for the current user for the specified library ID.
	            *
	            * @param {libraryId} ID of the library to get permissions for.
	            *
	            * @returns {Deferred} A promise resolving with an array of the retrieved permissions.
	            *
	            */
	            getPermissionsForCurrentUser: getPermissionsForCurrentUser
	        };
	        return service;
	        function getLibrary(libraryId) {
	            return $http.get(pxUriPathService.resolvePath('/libraries/' + libraryId)).then(function (response) {
	                return response.data;
	            });
	        }
	        function addLibrary(library) {
	            return $http.post(pxUriPathService.resolvePath('/libraries'), library).then(function (response) {
	                return response.data;
	            });
	        }
	        function updateLibrary(library) {
	            return $http.patch(library.Links.SelfUri, library).then(function (response) {
	                return response.data;
	            });
	        }
	        function savePermissions(libraryId, acls) {
	            var uri = pxUriPathService.resolvePath('/libraries/{id}/permissions/replace', {
	                id: libraryId
	            });
	            return $http.post(uri, acls);
	        }
	        function getPermissionsForCurrentUser(libraryId) {
	            var uri = pxUriPathService.resolvePath('/libraries/{id}/permissionsforuser', {
	                id: libraryId
	            });
	            return $http
	                .get(uri)
	                .then(function (response) {
	                return response.data;
	            });
	        }
	        function getPermissions(libraryId, compact) {
	            compact = typeof (compact) === 'boolean' ? compact : true;
	            var uri = pxUriPathService.resolvePath('/libraries/{id}/permissions', {
	                id: libraryId
	            });
	            if (compact) {
	                uri += '?compact=true';
	            }
	            return $http
	                .get(uri)
	                .then(function (response) {
	                return response.data;
	            });
	        }
	    }
	})();


/***/ },
/* 251 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminPasswordPoliciesService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase
		* password policies
		**/

		angular
			.module('sharebase-admin')
			.factory('sbadminPasswordPoliciesService',
			[
				'$http',
				'pxUriPathService',
				PasswordPoliciesService
			]);

		function PasswordPoliciesService($http, pxUriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbadminPasswordPoliciesService#getPasswordPolicies
				* @methodOf sharebase-admin.sbadminPasswordPoliciesService
				* @kind function
				*
				* @description
				* Gets a collection of password policies
				*
				* @returns {Deferred} A promise that will resolve with a collection of password policies
				* 
				*/
				getPasswordPolicies: getPasswordPolicies,
				
			};

			function getPasswordPolicies() {
				return $http.get(pxUriPathService.resolvePath('/{system}/settings/passwordpolicy')).then(function (response) {
					return response.data;
				});
			}		
		}

	})();

/***/ },
/* 252 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminPasswordPolicyService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase
		* password policies
		**/

		angular
			.module('sharebase-admin')
			.factory('sbadminPasswordPolicyService',
			[
				'$http',
				'pxUriPathService',
				PasswordPolicyService
			]);

		function PasswordPolicyService($http, pxUriPathService) {

			return {
				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyService#getPasswordPolicies
				* @methodOf sharebase-admin.sbadminPasswordPolicyService
				* @kind function
				*
				* @description
				* Gets a collection of password policies
				*
				* @param {string} passwordPolicyId A string to represent a password policy Id
				*
				* @returns {Deferred} A promise that will resolve with a password policy
				* 
				*/
				getPasswordPolicy: getPasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyService#createPasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyService
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with a document
				* 
				*/
				createPasswordPolicy: createPasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyService#updatePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyService
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with a document
				* 
				*/
				updatePasswordPolicy: updatePasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyService#deletePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyService
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with a deleted password policy
				* 
				*/
				deletePasswordPolicy: deletePasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyService#activatePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyService
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with an active password policy
				* 
				*/
				activatePasswordPolicy: activatePasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyService#deactivatePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyService
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with a deactivated password policy
				* 
				*/
				deactivatePasswordPolicy: deactivatePasswordPolicy
			};

			function getPasswordPolicy(passwordPolicyId) {
				return $http.get(pxUriPathService.resolvePath('/{system}/settings/passwordpolicy/' + passwordPolicyId)).then(function (response) {
					return response.data;
				});
			}

			function createPasswordPolicy(passwordPolicy) {
				return $http.post(pxUriPathService.resolvePath('/{system}/settings/passwordpolicy/newpolicy'), passwordPolicy).then(function (response) {
					return response.data;
				});
			}

			function updatePasswordPolicy(passwordPolicy) {
				return $http.post(pxUriPathService.resolvePath('/{system}/settings/passwordpolicy/' + passwordPolicy.PasswordPolicyId + '/update'), passwordPolicy).then(function (response) {
					return response.data;
				});
			}

			function deletePasswordPolicy(passwordPolicyId) {
				return $http.get(pxUriPathService.resolvePath('/{system}/settings/passwordpolicy/' + passwordPolicyId + '/delete')).then(function (response) {
					return response.data;
				});
			}

			function activatePasswordPolicy(passwordPolicyId) {
				return $http.get(pxUriPathService.resolvePath('/{system}/settings/passwordpolicy/' + passwordPolicyId + '/activate')).then(function (response) {
					return response.data;
				});
			}

			function deactivatePasswordPolicy(passwordPolicyId) {
				return $http.get(pxUriPathService.resolvePath('/{system}/settings/passwordpolicy/' + passwordPolicyId + '/deactivate')).then(function (response) {
					return response.data;
				});
			}
		}

	})();

/***/ },
/* 253 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		/**
		* @ngdoc service
		* @name sharebase-admin.sbadminPendingDeploymentsService
		* @requires $http
		* @requires settingService
		* @description
		* A service used to retrieve pending deployments
		**/
		angular.module('sharebase-admin')
			.factory('sbadminPendingDeploymentsService', [
				'$http',
				'settingsService',
				PendingDeploymentsService
			]);

		function PendingDeploymentsService($http, settingsService) {
			return {
				/**
				* @ngdoc method
				* @name sbadminPendingDeploymentsService#getDeployments
				* @methodOf sharebase-admin.sbadminPendingDeploymentsService
				* @kind function
				*
				* @description
				* Retrieves pending deployments
				*
				* @returns {Deferred} A promise that will resolve with pending deployments
				* 
				*/
				getDeployments: getDeployments,

				/**
				* @ngdoc method
				* @name sbadminPendingDeploymentsService#resendNotification
				* @methodOf sharebase-admin.sbadminPendingDeploymentsService
				* @kind function
				*
				* @description
				* Resends email notification to owner of pending deployment
				* @param {object} A pending deployment model
				* @returns {Deferred} A promise that will resolve with the server response
				* 
				*/
				resendNotification: resendNotification,

				/**
				* @ngdoc method
				* @name sbadminPendingDeploymentsService#save
				* @methodOf sharebase-admin.sbadminPendingDeploymentsService
				* @kind function
				*
				* @description
				* Saves a deployment
				* @param {object} A pending deployment model
				* @returns {Deferred} A promise that will resolve with pending deployments
				* 
				*/
				save: save
			};

			function getDeployments() {
				return $http.get(settingsService.serverAPIPath + '/admin/registrations').then(function (response) {
					return response.data;
				});
			}

			function save(pendingDeployment) {
				return $http.patch(pendingDeployment.Links.SelfUri, pendingDeployment);
			}

			function resendNotification(pendingDeployment) {
				return $http.post(pendingDeployment.Links.NotificationUri);
			}
		}
	}());

/***/ },
/* 254 */
/***/ function(module, exports) {

	(function() {
		'use strict';

		/**
		* @ngdoc service
		* @name sharebase-admin.sbadminPermissionsService
		* @requires $state
		* @requires pxAuthService
		* @description
		* A service used to determine rights the current administator has related to ShareBase
		* concepts such as Deployments and Systems.
		**/
		angular
			.module('sharebase-admin')
			.factory('sbadminPermissionsService', [
				'$state',
				'pxAuthService',
				PermissionsService
			]);

		function PermissionsService($state, authService) {
			var _current = {
				get depId() {
					return $state.params.deploymentId || $state.params.deploymentID;
				}
			};

			return {
				/**
				* @namespace system	
				* @description
				* Namespace for system-level rights.  
				*/
				system: {
					/**
					* @ngdoc property	
					* @memberof system			
					* @name sbadminPermissionsService.system#hasRights
					* @type boolean
					*
					* @description
					* Boolean indicating if the current user has system administration rights.  
					*/
					get hasRights() {
						return authService.isSysAdmin || authService.isTenantAdmin;
					},
				},
				/**
				* @namespace deployment	
				* @description
				* Namespace for deployment-level rights.  		
				*/
				deployment : {
					/**
					* @ngdoc property	
					* @memberof deployment			
					* @name sbadminPermissionsService.deployment#belongsToCurrent
					* @type boolean
					*
					* @description
					* Boolean indicating if the current user's home deployment is the currently viewed deployment.  
					*/
					get belongsToCurrent() {
						// eslint-disable-next-line eqeqeq
						return authService.deploymentId == _current.depId;
					},
					/**
					* @ngdoc property	
					* @memberof deployment			
					* @name sbadminPermissionsService.deployment#hasRights
					* @type boolean
					*
					* @description
					* Boolean indicating if the current user has admin rights to the currently viewed deployment.  
					*/
					get hasRights() {					
						return this.belongsToCurrent && (authService.isSiteAdmin || authService.isTenantAdmin);	
					},
					/**
					* @ngdoc property		
					* @memberof deployment		
					* @name sbadminPermissionsService.deployment#isHomed
					* @type boolean
					*
					* @description
					* Boolean indicating if the current user has a home deployment (system admins do not).  
					*/
					get isHomed() {
						return authService.deploymentId >= 0;
					}
				}
			};
		}
	})();

/***/ },
/* 255 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminTenantAdminService
		* 
		* @description 
		* A service used to retrieve and interact with a ShareBase
		* tenant administrator
		**/

		angular.module('sharebase-admin')
			.factory('sbadminTenantAdminService', [
				'$http',
				'$q',
				'settingsService',
				TenantAdminFactory]);

		function TenantAdminFactory($http, $q, settingsService) {

			return {

				/**
				* @ngdoc method
				* @name sbadminTenantAdminService#createAdministrator
				* @methodOf sharebase-admin.sbadminTenantAdminService
				* @kind function
				*
				* @description
				* Creates a new tenant administrator
				*
				* @param {integer} groupID The id of the group to add administrator to
				* @param {string} newUsername The username of the new administrator
				* @param {string} newEmailAddress The email address of the new administrator
				* @param {string} newPassword The password of the new administrator 
				* 
				* @returns {Deferred} A promise that will resolve with the result of the post
				* 
				*/
				createAdministrator: createAdministrator,

				/**
				* @ngdoc method
				* @name sbadminTenantAdminService#addAdministrator
				* @methodOf sharebase-admin.sbadminTenantAdminService
				* @kind function
				*
				* @description
				* Assigns a current user as a tenant administrator
				*
				* @param {integer} groupID The id of the group to add administrator to
				* @param {integer} userID The id of the user to add as administrator
				* 
				*/
				addAdministrator: addAdministrator,

				/**
				* @ngdoc method
				* @name sbadminTenantAdminService#deleteAdministrator
				* @methodOf sharebase-admin.sbadminTenantAdminService
				* @kind function
				*
				* @description
				* Creates a new tenant administrator
				*
				* @param {integer} groupID The id of the group to remove administrator from
				* @param {integer} userID The id of the user to remove as administrator
				* 
				*/
				deleteAdministrator: deleteAdministrator
			};

			function createAdministrator(groupID, newUsername, newEmailAddress, newPassword) {
				return $http.post(settingsService.serverAPIPath + '/admin/deploymentgroups/' + groupID + '/admins',
						{ UserName: newUsername, EmailAddress: newEmailAddress, Password: newPassword }
					).then(function (response) {
						if (response.Error) {
							return $q.reject(response);
						}
						return response;
					});
			}

			function addAdministrator(groupID, userID) {
				/* TODO - new api end point to set a current user as group admin */
				//return $http.post(settingsService.serverAPIPath + '/admin/deploymentgroups/' + groupID + '/admins');
				throw new Error('setAsAdministrator is not implemented!');
			}

			function deleteAdministrator(groupID, userID) {
				/* TODO - find out how to delete admin current UI just shows an alert*/
				//return $http.delete(settingsService.serverAPIPath + '/admin/deploymentgroups/' + groupID + '/admins');
				throw new Error('deleteAdministrator is not implemented!');
			}

		}
	})();

/***/ },
/* 256 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminTenantAdminsService
		* 
		* @description 
		* A service used to retrieve and interact with ShareBase
		* tenant administrators
		**/

		angular.module('sharebase-admin')
			.factory('sbadminTenantAdminsService', [
				'$http',
				'$q',
				'settingsService',
				TenantAdminsFactory]);

		function TenantAdminsFactory($http, $q, settingsService) {

			return {
				/**
				* @ngdoc method
				* @name sbadminTenantAdminsService#getAdministrators
				* @methodOf sharebase-admin.sbadminTenantAdminsService
				* @kind function
				*
				* @description
				* Gets the list of available tenant administrators
				* 
				* @returns {Deferred} A promise that will resolve with an
				* array of users
				* 
				*/
				getAdministrators: getAdministrators,
			};

			function getAdministrators() {
				return $http.get(settingsService.serverAPIPath + '/admin/deploymentgroups/admins/')
					.then(function (response) {
						return response.data;
					});
			}
		}
	})();

/***/ },
/* 257 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular.module('sharebase-admin')
			.factory('sbadminToolbarService', [
				'pxLocalStorageService',
				'gettextCatalog',
				AdminToolbarService]);
		/**
	    * @ngdoc service
	    * @name  sharebase-admin.sbadminToolbarService
	    * 
	    * @description 
	    * A service used to retrieve and interact with ShareBase app 
	    * content toolbar
	    * 
	    **/
		function AdminToolbarService(pxLocalStorageService, gettextCatalog) {
			var _defaultFilterPlaceholder = gettextCatalog.getString('Find content');
			var _title = null;
			var _filterPhrase = '';
			var _filterPlaceholder = _defaultFilterPlaceholder;
			var _showFilter = false;
			var _view = pxLocalStorageService.getStoredValue('sba_user_viewType') === 'list' ? 'list' : 'card';
			var _breadCrumbs = [];
			var _actions = [];
			return {
				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#title
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Title assigned to content toolbar
	            *
	            * @returns {string} value of title 
	            * 
	            */
				get title() { return _title; },
				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#title
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the title for content toolbar
	            *
	            * @returns {string} value of title 
	            * @param {string} val Title to assign to content toolbar 
	            */
				set title(val) { _title = val; },
				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#viewType
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Content view style to be used
	            *
	            * @returns {string} value of the view type 
	            * 
	            */
				get viewType() { return _view; },
				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#viewType
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the content view style
	            *
	            * @returns {string} value of the view type 
	            * @param {string} val View type to assign to content 
	            * 
	            */
				set viewType(val) {
					_view = val === 'list' ? 'list' : 'card';
					pxLocalStorageService.setStoredValue('sba_user_viewType', _view);
				},
				get breadCrumbs() { return _breadCrumbs; },
				set breadCrumbs(val) {
					if (!angular.isArray(val)) {
						return;
					}
					_breadCrumbs = val;
				},

				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#actions
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Get the registered actions to display in the UI
	            *
	            * @returns {array} list of registered actions 
	            * 
	            */
				get actions() { return _actions; },

				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#actions
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the registered actions to display in the UI
	            *
	            * @param {array} val List of actions
	            * @usage
	            * actions = [{ icon: 'search', label: 'Find content', trigger: self.navItemClicked }]
	            * 
	            */
				set actions(val) {
					if (!angular.isArray(val)) {
						return;
					}
					
					_actions = val;
				},

				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#filterPhrase
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Get the content of the filter phrase
	            *
	            * @returns {string} value of the filter phrase 
	            * 
	            */
				get filterPhrase() { return _filterPhrase; },

				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#filterPhrase
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the content of the filter phrase
	            *
	            * @param {string} val New value of the filter phrase 
	            */
				set filterPhrase(val) { _filterPhrase = val !== '' || val !== undefined ? val : ''; },

				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#showFilter
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Get the value of the show filter UI
	            *
	            * @returns {bool} to show the filter UI
	            * 
	            */
				get showFilter() { return _showFilter; },

				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#showFilter
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the value of the show filter UI
	            *
	            * @param {bool} val Value of wheither to show the filter UI 
	            */
				set showFilter(val) { _showFilter = val === true ? true : false; },
				
				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#filterPlaceholder
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Get the value of the filter placeholder
	            *
	            * @returns {string} to show as the filter placeholder
	            * 
	            */
				get filterPlaceholder() { return _filterPlaceholder; },

				/**
	            * @ngdoc property
	            * @name sbadminToolbarService#filterPlaceholder
	            * @propertyOf sharebase-admin.sbadminToolbarService
	            * @kind property
	            *
	            * @description
	            * Set the value of the filter placeholder
	            *
	            * @param {string} val Value of the filter placeholder 
	            */
				set filterPlaceholder(val) { _filterPlaceholder = val === null || val === undefined ? _defaultFilterPlaceholder : val; }

			};
		}

	}());

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(270);

/***/ },
/* 259 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('sharebase-admin')
			.factory('sbadminApiTokenDataStore', [
				'$filter',
				'sbadminApiTokenService',
				ApiTokenDataStore
			]);

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminApiTokenDataStore
		* 
		* @description 
		* A datastore used to interact with API tokens generated for the current deployment.
		* 
		**/
		function ApiTokenDataStore($filter, apiTokenService) {
			var _tokens = [];

			return {
				/**
				* @ngdoc method
				* @name sbadminApiTokenDataStore#load
				* @methodOf sharebase-admin.sbadminApiTokenDataStore
				* @kind function
				*
				* @description
				* Loads all of the generated tokens from users in the deployment.
				* 
				* @returns {Deferred} A promise that will resolve with the API tokens of the current deployment.
				*/
				load: loadApiTokens,
				/**
				* @ngdoc method
				* @name sbadminApiTokenDataStore#createToken
				* @methodOf sharebase-admin.sbadminApiTokenDataStore
				* @kind function
				*
				* @description
				* Creates an API token that never expires given an email and password.
				* 
				* @returns {Deferred} A promise that will resolve with the newly created token.
				*/
				createToken: createToken,
				/**
				* @ngdoc method
				* @name sbadminApiTokenDataStore#deleteToken
				* @methodOf sharebase-admin.sbadminApiTokenDataStore
				* @kind function
				*
				* @description
				*  Delete the specified API token.
				* 
				* @returns {Deferred} A promise that will resolve with the API tokens of the current deployment. 
				*/
				deleteToken: deleteToken,
				/**
				* @ngdoc property
				* @name sbadminApiTokenDataStore#ltokens
				* @propertyOf sharebase-admin.sbadminApiTokenDataStore
				* @kind property
				*
				* @description
				* A list of tokens generated by users of the current deployment.
				*/
				get tokens() {
					return _tokens;
				}
			};

			function loadApiTokens() {
				return apiTokenService
					.getTokens()
					.then(function (tokens) {
						// change to domain object shape
						_tokens = tokens.map(function (token) {
							return toDomainObject(token);
						});

						_tokens = $filter('orderBy')(_tokens, 'userName');

						return _tokens;
					});
			}

			function createToken(email, password) {
				return apiTokenService
					.createToken(email, password, 'never')
					.then(function(token) {
						token = toDomainObject(token);	
						_tokens.push(token);

						return token;
					});
			}

			function deleteToken(tokenId) {
				return apiTokenService
					.deleteToken(tokenId)
					.then(function() {
						_tokens = _tokens.filter(function(token) {
							return token.id !== tokenId;
						});

						return _tokens;
					});
			}
		}

		function toDomainObject(data) {
			return {
				id: data.ApiTokenId,
				dateCreated: data.IssuedDate,
				expires: data.Embedded.AuthToken.ExpirationDate,
				userName: data.Embedded.AuthToken.UserName,
				value: data.Embedded.AuthToken.Token
			};
		}
	})();

/***/ },
/* 260 */
/***/ function(module, exports) {

	(function () {
		'use strict';
		angular
			.module('sharebase-admin')
			.factory('sbadminDeploymentDataStore', [
				'$q',
				'sbDeploymentService',
				DeplomentDataStore
			]);

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminDeploymentDataStore
		* 
		* @description 
		* A datastore used to interact with all active ShareBase deployment details.
		* 
		**/
		function DeplomentDataStore($q, deploymentService) {
			var _details;
			var _originalDetails;
			var _settings;
			reset();

			return {
				/**
				* @ngdoc method
				* @name sbadminDeploymentDataStore#load
				* @methodOf sharebase-admin.sbadminDeploymentDataStore
				* @kind function
				*
				* @description
				* Loads details of the specified deployment.
				* 
				* @returns {Deferred} A promise that will resolve with the details of the specified ShareBase deployment.
				*/
				load: loadDeployment,
				/**
				* @ngdoc method
				* @name sbadminDeploymentDataStore#reset
				* @methodOf sharebase-admin.sbadminDeploymentDataStore
				* @kind function
				*
				* @description
				* Sets the datastore back to its default state.
				*/
				reset: reset,
				/**
				* @ngdoc method
				* @name sbadminDeploymentDataStore#create
				* @methodOf sharebase-admin.sbadminDeploymentDataStore
				* @kind function
				*
				* @description
				* Creates a new ShareBase deplomynet.
				* 
				* @returns {Deferred} A promise that will resolve with the details created deployment.
				*/
				createDeployment: createDeployment,
				/**
				* @ngdoc method
				* @name sbadminDeploymentDataStore#save
				* @methodOf sharebase-admin.sbadminDeploymentDataStore
				* @kind function
				*
				* @description
				* Updates details of the specified deployment.
				* 
				* @returns {Deferred} A promise that will resolve with the status of the attempted save operation.
				*/
				saveDeployment: saveDeployment,
				/**
				* @ngdoc method
				* @name sbadminDeploymentDataStore#getSettings
				* @methodOf sharebase-admin.sbadminDeploymentDataStore
				* @kind function
				*
				* @description
				* Retrieves and populates the settings for the currently loaded deployment.
				* 
				* @returns {Deferred} A promise that will resolve with an array of settings for the deployment.
				*/
				getSettings: getSettings,
				/**
				* @ngdoc method
				* @name sbadminDeploymentDataStore#updateSettings
				* @methodOf sharebase-admin.sbadminDeploymentDataStore
				* @kind function
				*
				* @description
				* Updates the settings for the currently loaded deployment.
				* 
				* @returns {Deferred} A promise that will resolve with an array of updated settings for the deployment.
				*/
				updateSettings: updateSettings,
				/**
				* @ngdoc property
				* @name sbadminDeploymentDataStore#details
				* @propertyOf sharebase-admin.sbadminDeploymentDataStore
				* @kind property
				*
				* @description
				* Details of the loaded deployment.
				*/
				get details() { return _details; },
				/* @ngdoc property
				* @name sbadminDeploymentDataStore#settings
				* @propertyOf sharebase-admin.sbadminDeploymentDataStore
				* @kind property
				*
				* @description
				* Settings of the loaded deployment.
				*/
				get settings() { return _settings; }
			};

			function loadDeployment(deploymentId) {
				var p;
				if (deploymentId) {
					p = deploymentService.getDetails(deploymentId)
						.then(storeDeploymentData);
				}
				else {
					reset();
					p = $q.resolve(_details);
				}

				return p;
			}

			function reset() {
				_details = {		
					DeploymentId: null,	
					CustomerIdentifier: '',
					SystemName : '',
					Name: '',
					DatabaseName: '',
					DatabaseServer: '',
					DatabaseRootPath: '',
					DiskgroupRootPath: ''
				};

				_originalDetails = angular.copy(_details);
				_settings = [];
			}

			function createDeployment() {
				return deploymentService.createDeployment(_details)
					.then(storeDeploymentData);
			}

			function saveDeployment() {
				var p = $q.reject(new Error('Cannot save deployment; none specified.'));

				if(_details.DeploymentId) {
					p = deploymentService.updateDeployment(_details.DeploymentId, diff(_originalDetails, _details));
				}

				return p;
			}

			function updateSettings() {
				var p = $q.reject(new Error('Cannot save deployment; none specified.'));

				if(_details.DeploymentId) {
					p = deploymentService.updateSettings(_details.DeploymentId, {
						'CoreRuntimeDeploymentSettings' : _settings
					});
				}

				return p;
			}

			function getSettings() {
				var p = $q.reject(new Error('Cannot retrieve settings. No deployment loaded.'));
				
				if(_details.DeploymentId) {
					p = deploymentService
						.getSettings(_details.DeploymentId)
						.then(function(settings) {
							// for now, only show the CoreRuntimedeploymentSettings
							_settings = settings.CoreRuntimeDeploymentSettings;
							_settings = _settings.map(function (setting) {
								if (setting.DataType.indexOf('DataSet:') !== 0) { return setting; }

								setting.isDataset = true;
								//pull dataset values into a more easily bindable array
								var dataType = setting.DataType;
								setting.dataSet = dataType.replace('DataSet:', '').split('|');
								return setting;
							});
							return _settings;
						});
				}

				return p;
			}

			function storeDeploymentData(resp) {
				_details = resp;

				// cache a copy of the deployment details to diff against on update to send only the changed values up
				_originalDetails = angular.copy(_details); 
				return _details;
			}

			// generates an object containing key/value pairs that don't exist or are different between two objects
			function diff(old, updated) {
				if(old === null || 
					!angular.isDefined(old) || 
					updated === null ||
					!angular.isDefined(updated)) {
					throw new Error('Two non-null objects required to diff.');
				}

				var diffSet = Object.keys(updated)
					// filter keys down to the properties that are new or updated
					.filter(function(k){
						return angular.isDefined(updated[k]) &&
							(!(k in old) || !angular.equals(updated[k], old[k])); 
					})
					.reduce(function(originalDiffSet, k){
						originalDiffSet[k] = updated[k];
						return originalDiffSet;
					}, {});

				return diffSet;
			}
		}
	})();

/***/ },
/* 261 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('sharebase-admin')
			.factory('sbadminDeploymentGroupsDataStore', [
				'sbadminDeploymentGroupsService',
				'$q',
				DeploymentGroupsDataStore
			]);

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminDeploymentGroupsDataStore
		* 
		* @description 
		* A datastore used to interact with the deployment groups
		* 
		**/
		function DeploymentGroupsDataStore(sbadminDeploymentGroupsService, $q) {
			var _deploymentGroups = null;
			/* eslint-disable no-unused-vars*/
			var _deploymentGroupAdmins = null;
			/* eslint-enable no-unused-vars */
			var _newDeploymentGroup = {
				groupName : null,
				partnerIdentifier: null,
				databaseServer: null,
				databaseRootPath: null,
				logFileRootPath: null,
				diskgroupRootPath : null
			};

			return {
				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsDataStore#loadDeploymentGroups
				* @methodOf sharebase-admin.sbadminDeploymentGroupsDataStore
				* @kind function
				*
				* @description
				* Loads deployment groups
				* 
				* @returns {Deferred} A promise that will resolve with deployment groups
				*/
				load: loadDeploymentGroups,

				/**
				* @ngdoc property
				* @name sbadminDeploymentGroupsDataStore#groups
				* @propertyOf sharebase-admin.sbadminDeploymentGroupsDataStore
				* @kind property
				*
				* @description
				* Returns currently loaded deployment groups
				*/
				get groups() { return _deploymentGroups; },

				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsDataStore#getDeploymentGroup
				* @methodOf sharebase-admin.sbadminDeploymentGroupsDataStore
				* @kind function
				*
				* @description
				* Retrieves a deployment group
				* @param {integer} Deployment group Id
				* @returns {Deferred} A promise that will resolve with selected deployment group or return a new deployment group
				* 
				*/
				getDeploymentGroup: getDeploymentGroup,
				
				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsDataStore#getDeploymentGroupAdmins
				* @methodOf sharebase-admin.sbadminDeploymentGroupsDataStore
				* @kind function
				*
				* @description
				* Retrieves deployment group tenant admins
				* @param {object} Deployment group
				* @returns {Deferred} A promise that will resolve with an array of tenant admins
				* 
				*/
				getDeploymentGroupAdmins : getDeploymentGroupAdmins,

				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsDataStore#create
				* @methodOf sharebase-admin.sbadminDeploymentGroupsDataStore
				* @kind function
				*
				* @description
				* Creates a deployment group
				* @param {object} Deployment group
				* @returns {Deferred} A promise that will resolve with deployment groups
				* 
				*/
				create: sbadminDeploymentGroupsService.createDeploymentGroup,

				/**
				* @ngdoc method
				* @name sbadminDeploymentGroupsDataStore#update
				* @methodOf sharebase-admin.sbadminDeploymentGroupsDataStore
				* @kind function
				*
				* @description
				* Updates a deployment group
				* @param {object} Deployment group
				* @returns {Deferred} A promise that will resolve with the updated deployment group
				* 
				*/
				update: updateDeploymentGroup,
			};

			function filterDeploymentGroupsById(deploymentGroupId) {
				var deploymentGroup = null;
				if (_deploymentGroups) {
					for (var i = 0, ii = _deploymentGroups.length; i < ii; i++) {
						// eslint-disable-next-line eqeqeq
						if (_deploymentGroups[i].DeploymentGroupId == deploymentGroupId) {
							deploymentGroup = _deploymentGroups[i];
							break;
						}
					}
				}
				return deploymentGroup;
			}

			function getDeploymentGroup(deploymentGroupId) {
				var promise = $q.resolve();

				if (!deploymentGroupId) {
					promise = $q.resolve(angular.copy(_newDeploymentGroup));
				}
				else {
					if (!_deploymentGroups) {
						promise = loadDeploymentGroups();
					}
					promise = promise.then(function () {
						return filterDeploymentGroupsById(deploymentGroupId);
					});
				}
				return promise;
			}

			function getDeploymentGroupAdmins(deploymentGroup) {
				return sbadminDeploymentGroupsService.getDeploymentGroupAdmins(deploymentGroup).then(function (admins) {
					_deploymentGroupAdmins = admins;
					return admins;
				});
			}

			function loadDeploymentGroups() {
				return sbadminDeploymentGroupsService.getDeploymentGroups().then(function (deploymentGroups) {
					_deploymentGroups = deploymentGroups;
					return _deploymentGroups;
				});
			}

			function updateDeploymentGroup(deploymentGroup) {
				return sbadminDeploymentGroupsService.updateDeploymentGroup(deploymentGroup).then(function () {
					var deploymentGroupId = deploymentGroup.DeploymentGroupId;
					// Update data store
					if (_deploymentGroups) {
						for (var i = 0, ii = _deploymentGroups.length; i < ii; i++) {
							// eslint-disable-next-line eqeqeq
							if (_deploymentGroups[i].DeploymentGroupId == deploymentGroupId) {
								_deploymentGroups[i] = deploymentGroup;
								break;
							}
						}
					}
					return deploymentGroup;
				});
			}
		}
	})();

/***/ },
/* 262 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('sharebase-admin')
			.factory('sbadminDeploymentsDataStore', [
				'sbadminDeploymentsService',
				DeploymentsDataStore
			]);

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminDeploymentsDataStore
		* 
		* @description 
		* A datastore used to interact with all active ShareBase deployments.
		* 
		**/
		function DeploymentsDataStore(deploymentsService) {
			var _deployments = [];

			return {
				/**
				* @ngdoc method
				* @name sbadminDeploymentsDataStore#load
				* @methodOf sharebase-admin.sbadminDeploymentsDataStore
				* @kind function
				*
				* @description
				* Loads active deployments.
				* 
				* @returns {Deferred} A promise that will resolve with all active ShareBase deployments.
				*/
				load: loadDeployments,
				/**
				* @ngdoc property
				* @name sbadminDeploymentsDataStore#deployments
				* @propertyOf sharebase-admin.sbadminDeploymentsDataStore
				* @kind property
				*
				* @description
				* User's active deployments.
				*/
				get deployments() { return _deployments; }
			};

			function loadDeployments() {
				return deploymentsService
					.getDeployments()
					.then(function(deployments) {
						_deployments = deployments.map(function(dep) {
							return {
								id: dep.DeploymentId,
								groupName: dep.DeploymentGroupName,
								name: dep.Name,
								dbServer: dep.DatabaseServer,
								dbName: dep.DatabaseName,
								apiPath: dep.Links.ApiPath
							};
						});

						return _deployments;
					});
			}
		}
	})();

/***/ },
/* 263 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
	        .module('sharebase-admin')
	        .factory('sbadminDeploymentStatisticsDataStore', [
	            'sbadminDeploymentStatisticsService',
	            '$q',
	            DeploymentStatisticsDataStore
	        ]);

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminDeploymentStatisticsDataStore
		* 
		* @description 
		* A datastore used to interact with a deployment's statistics
		* 
		**/
		function DeploymentStatisticsDataStore(sbadminDeploymentStatisticsService, $q) {
			var _deploymentsStatistics = {};
			return {
				/**
				* @ngdoc method
				* @name sbadminDeploymentStatisticsDataStore#getStatistics
				* @methodOf sharebase-admin.sbadminDeploymentStatisticsDataStore
				* @kind function
				*
				* @description
				* Retrieves deployment statistics
				* 
				* @returns {Deferred} A promise that will resolve with a deployment's statistic
				*/
				getStatistics: getStatistics,
				/**
				* @ngdoc method
				* @name sbadminDeploymentStatisticsDataStore#refreshStatistics
				* @methodOf sharebase-admin.sbadminDeploymentStatisticsDataStore
				* @kind function
				*
				* @description
				* Clears old and retrieves new deployment statistics
				* 
				* @returns {Deferred} A promise that will resolve with a deployment's refreshed statistic
				*/
				refreshStatistics: refreshStatistics,
			};

			function fetchStatistics(deploymentName) {
				return sbadminDeploymentStatisticsService.getDeploymentTotalsUsage(deploymentName)
					.then(function (result) {
						var statistics = {};
						result.forEach(function (statistic) {
							statistics[statistic.Id] = statistic.Count || 0;
						});
						statistics.lastUpdated = Date.now();
						updateDataStore(deploymentName, statistics);
						return statistics;
					});
			}

			function getStatistics(deploymentName) {
				var deploymentStatistics = _deploymentsStatistics[deploymentName];
				var promise = $q.resolve(deploymentStatistics);

				if (!deploymentStatistics) {
					promise = fetchStatistics(deploymentName);
				}
				return promise;
			}

			function refreshStatistics(deploymentName) {
				delete _deploymentsStatistics[deploymentName];
				return getStatistics(deploymentName);
			}

			function updateDataStore(deploymentName, statistics) {
				// Update datastore with deploymentName as key
				_deploymentsStatistics[deploymentName] = statistics;
			}

		}
	})();

/***/ },
/* 264 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminLibrariesDataStore
		* 
		* @description 
		* A datastore used to interact with ShareBase libraries
		**/

		angular
			.module('sharebase-admin')
			.factory('sbadminLibrariesDataStore',
			[
				'$filter',
				'sbadminLibrariesService',
				LibraryDataStore
			]);

		function LibraryDataStore($filter, sbadminLibrariesService) {
			var _libraries = [];

			return {
				/**
				* @ngdoc method
				* @name sbadminLibrariesDataStore#getLibraries
				* @methodOf sharebase-admin.sbadminLibrariesDataStore
				* @kind function
				*
				* @description
				* Gets a collection of libraries
				*
				* @returns {Deferred} A promise that will resolve with a collection of libraries
				* 
				*/
				getLibraries: getLibraries,

				/**
				* @ngdoc property
				* @name sbadminLibrariesDataStore#libraries
				* @propertyOf sharebase-admin.sbadminLibrariesDataStore
				* @kind property
				*
				* @description
				* A collection of libraries
				* 
				* @returns {array} An array of libraries
				*/
				get libraries() { return _libraries; },

			};

			function getLibraries() {
				return sbadminLibrariesService.getLibraries().then(function (response) {
					_libraries = $filter('orderBy')(response, 'LibraryName');

					return _libraries;
				});
			}
		}

	})();

/***/ },
/* 265 */
/***/ function(module, exports) {

	"use strict";
	(function () {
	    'use strict';
	    /**
	    * @ngdoc service
	    * @name  sharebase-admin.sbadminLibraryDataStore
	    *
	    * @description
	    * A datastore used to interact with ShareBase libraries
	    **/
	    angular
	        .module('sharebase-admin')
	        .factory('sbadminLibraryDataStore', [
	        '$q',
	        'PX_OBJECT_TYPE',
	        'sbShareService',
	        'sbadminLibraryService',
	        LibraryDataStore
	    ]);
	    function LibraryDataStore($q, ObjectType, shareService, libraryService) {
	        var _library = null;
	        var _shares = [];
	        var _newLibrary = {
	            LibraryId: null,
	            LibraryName: null
	        };
	        var datastore = {
	            /**
	            * @ngdoc property
	            * @name sbadminLibraryDataStore#type
	            * @propertyOf sharebase-admin.sbadminLibraryDataStore
	            * @kind property
	            *
	            * @description
	            * PX_OBJECT_TYPES enum designation of the entities contained within.
	            *
	            * @returns {int} PX_OBJECT_TYPES enum value.
	            */
	            type: ObjectType.LIBRARY,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#getLibrary
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Gets a library
	            *
	            * @returns {Deferred} A promise that will resolve with a library
	            *
	            */
	            load: getLibrary,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#saveLibrary
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Saves a library
	            *
	            * @returns {Deferred} A promise that will resolve with a library
	            *
	            */
	            saveLibrary: saveLibrary,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#getShares
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Retrieves the associates shares for the currently loaded library.
	            *
	            * @returns {Deferred} A promise that will resolve with a library's shares.
	            *
	            */
	            getShares: getShares,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#createShare
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Creates a new share for the currently loaded library.
	            *
	            * @returns {Deferred} A promise that will resolve with the new share.
	            *
	            */
	            createShare: createShare,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#createShares
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Creates new shares for the currently loaded library.
	            *
	            * @returns {Deferred} A promise that will resolve with the new shares.
	            *
	            */
	            createShares: createShares,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#updateShare
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Updates the rights and advanced permissions of the provided share for the loaded library.
	            *
	            * @returns {Deferred} A promise that will resolve with the updated share.
	            *
	            */
	            updateShare: function (updatedShare, rightId, rights) {
	                guardLibrary();
	                return shareService
	                    .updateShare(_library.LibraryId, updatedShare, rightId, rights)
	                    .then(assignShares);
	            },
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#deleteShare
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Deletes the provided share for the loaded library.
	            *
	            * @returns {Deferred} A promise that will resolve with the deleted share.
	            *
	            */
	            deleteShare: deleteShare,
	            /**
	            * @ngdoc method
	            * @name sbadminLibraryDataStore#getPermissions
	            * @methodOf sharebase-admin.sbadminLibraryDataStore
	            * @kind function
	            *
	            * @description
	            * Gets the available rights and advanced options for the provided share.
	            *
	            * @returns {Deferred} A promise that will resolve with the available rights and advanced options for the share.
	            *
	            */
	            getPermissions: getPermissions,
	            /**
	            * @ngdoc property
	            * @name sbadminLibraryDataStore#library
	            * @propertyOf sharebase-admin.sbadminLibraryDataStore
	            * @kind property
	            *
	            * @description
	            * A library
	            *
	            * @returns {array} A library
	            */
	            get library() { return _library; },
	            set library(lib) { _library = lib; },
	            /**
	            * @ngdoc property
	            * @name sbadminLibraryDataStore#shares
	            * @propertyOf sharebase-admin.sbadminLibraryDataStore
	            * @kind property
	            *
	            * @description
	            * A list of users or groups this library is shared with, if any.
	            *
	            * @returns {array} An an array of shared users or groups.
	            */
	            get shares() { return _shares; }
	        };
	        shareService.configure(datastore.type, libraryService, function () { return _shares; });
	        return datastore;
	        function getLibrary(libraryId) {
	            if (!libraryId) {
	                //create a new instance
	                _library = _newLibrary;
	                return $q.resolve(_newLibrary);
	            }
	            return libraryService
	                .getLibrary(libraryId)
	                .then(function (lib) {
	                _library = lib;
	                return _library;
	            });
	        }
	        function getCurrentUserAcl() {
	            guardLibrary();
	            return shareService.getCurrentUserAcl(_library.LibraryId);
	        }
	        function getPermissions(share) {
	            return getCurrentUserAcl()
	                .then(function (myAcl) { return shareService.getRights(myAcl, datastore.type, share); });
	        }
	        function getShares() {
	            guardLibrary();
	            return shareService
	                .getShares(_library.LibraryId)
	                .then(assignShares);
	        }
	        function createShare(entity, rightId, rights) {
	            guardLibrary();
	            return shareService
	                .createShare(_library.LibraryId, entity, rightId, rights)
	                .then(assignShares);
	        }
	        function createShares(entities, rightId, rights) {
	            guardLibrary();
	            return shareService
	                .createShares(_library.LibraryId, entities, rightId, rights)
	                .then(assignShares);
	        }
	        function deleteShare(deletedShare) {
	            guardLibrary();
	            return shareService
	                .deleteShare(_library.LibraryId, deletedShare)
	                .then(assignShares);
	        }
	        function saveLibrary() {
	            guardLibrary();
	            if (_library.LibraryId) {
	                return libraryService.updateLibrary(_library)
	                    .then(function (lib) {
	                    return lib;
	                });
	            }
	            else {
	                return libraryService.addLibrary(_library)
	                    .then(function (lib) {
	                    _library = lib;
	                    return lib;
	                });
	            }
	        }
	        function assignShares(shares) {
	            return _shares = shares;
	        }
	        function guardLibrary() {
	            if (!angular.isDefined(_library) || _library === null) {
	                throw new Error('No library loaded.');
	            }
	        }
	    }
	})();


/***/ },
/* 266 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminPasswordPoliciesDataStore
		* 
		* @description 
		* A datastore used to interact with ShareBase password policies
		**/

		angular
			.module('sharebase-admin')
			.factory('sbadminPasswordPoliciesDataStore',
			[
				'$filter',
				'sbadminPasswordPoliciesService',
				PasswordPoliciesDataStore
			]);

		function PasswordPoliciesDataStore($filter, sbadminPasswordPoliciesService) {
			var _passwordPolicies = null;

			return {
				/**
				* @ngdoc method
				* @name sbadminPasswordPoliciesDataStore#getPasswordPolicies
				* @methodOf sharebase-admin.sbadminPasswordPoliciesDataStore
				* @kind function
				*
				* @description
				* Gets a collection of password policies
				*
				* @returns {Deferred} A promise that will resolve with a collection of password policies
				* 
				*/
				getPasswordPolicies: getPasswordPolicies,

				/**
				* @ngdoc property
				* @name sbadminPasswordPoliciesDataStore#passwordPolicies
				* @propertyOf sharebase-admin.sbadminPasswordPoliciesDataStore
				* @kind property
				*
				* @description
				* A collection of password policies
				* 
				* @returns {array} An array of password policies
				*/
				get passwordPolicies() { return _passwordPolicies; },
			};

			function getPasswordPolicies() {
				return sbadminPasswordPoliciesService.getPasswordPolicies().then(function (response) {
					_passwordPolicies = $filter('orderBy')(response.Embedded.PasswordPolicies, 'Name');

					return _passwordPolicies;
				});
			}
		}

	})();

/***/ },
/* 267 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminPasswordPolicyDataStore
		* 
		* @description 
		* A datastore used to interact with a ShareBase password policy
		**/

		angular
			.module('sharebase-admin')
			.factory('sbadminPasswordPolicyDataStore',
			[
				'$q',
				'sbadminPasswordPolicyService',
				PasswordPolicyDataStore
			]);

		function PasswordPolicyDataStore($q, sbadminPasswordPolicyService) {
			var _passwordPolicy = null;

			var _enforceIdle = null;
			var _enforceFailure = null;
			var _expire = null;
			var _requireWait = null;

			var _newPasswordPolicy = {
				Active: false,
				PasswordPolicyId: null,
				IdleLimit: 360,
				FailedLoginLimit: 10,
				AutoRelease: true,
				LockoutLength: 5,
				ReuseStyle: 0,
				ReuseChangesLimit: 3,
				ReuseDaysLimit: 0,
				HoursBetweenChanges: 24,
				ExpiryDays: 180,
				AlphaQuota: 0,
				NumericQuota: 0,
				SpecialQuota: 0,
				UppercaseQuota: 0,
				LowercaseQuota: 0,
				RequiredQuotaMatch: 5,
				MaxRepeatedChars: 3,
				MinLength: 15
			};

			return {
				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyDataStore#getPasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind function
				*
				* @description
				* Gets a password policy
				*
				* @returns {Deferred} A promise that will resolve with a password policy
				* 
				*/
				getPasswordPolicy: getPasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyDataStore#savePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind function
				*
				* @description
				* Saves a specific password policy
				*
				* @returns {Deferred} A promise that will resolve with a password policy
				* 
				*/
				savePasswordPolicy: savePasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyDataStore#deletePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with a deleted password policy
				* 
				*/
				deletePasswordPolicy: deletePasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyDataStore#activatePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with an active password policy
				* 
				*/
				activatePasswordPolicy: activatePasswordPolicy,

				/**
				* @ngdoc method
				* @name sbadminPasswordPolicyDataStore#deactivatePasswordPolicy
				* @methodOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind function
				*
				* @description
				* Gets a specific document to the user
				* 
				* @param {object} passwordPolicy A password policy
				*
				* @returns {Deferred} A promise that will resolve with a deactivated password policy
				* 
				*/
				deactivatePasswordPolicy: deactivatePasswordPolicy,

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#passwordPolicy
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* An existing password policy
				* 
				* @returns {object} An existing password policy
				*/
				get passwordPolicy() { return _passwordPolicy; },

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#requireWait
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Require <n> Hours Between Changes'
				* 
				* @returns {boolean} A boolean representing 'Require <n> Hours Between Changes'
				*/
				get requireWait() {
					if (_requireWait === null) {
						_requireWait = _passwordPolicy ? (_passwordPolicy.HoursBetweenChanges > 0) : null;
					}
					return _requireWait;
				},

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#requireWait
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Require <n> Hours Between Changes'
				*/
				set requireWait(val) {
					_requireWait = val;
					if (val === false) {
						_passwordPolicy.HoursBetweenChanges = 0;
					}
				},

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#expire
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Expire Every <n> Days'
				* 
				* @returns {boolean} A boolean representing 'Expire Every <n> Days'
				*/
				get expire() {
					if (_expire === null) {
						_expire = _passwordPolicy ? (_passwordPolicy.ExpiryDays > 0) : null;
					}
					return _expire;
				},

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#expire
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Expire Every <n> Days'
				*/
				set expire(val) {
					_expire = val;
					if (val === false) {
						_passwordPolicy.ExpiryDays = 0;
					}
				},

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#enforceFailure
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Lockout After <n> Failed Logins'
				* 
				* @returns {boolean} A boolean representing 'Lockout After <n> Failed Logins'
				*/
				get enforceFailure() {
					if (_enforceFailure === null) {
						_enforceFailure = _passwordPolicy ? (_passwordPolicy.FailedLoginLimit > 0) : null;
					}
					return _enforceFailure;
				},

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#enforceFailure
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Lockout After <n> Failed Logins'
				*/
				set enforceFailure(val) {
					_enforceFailure = val;
					if (val === false) {
						_passwordPolicy.FailedLoginLimit = 0;
					}
				},

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#enforceIdle
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Lockout After Idle <n> Days'
				* 
				* @returns {boolean} A boolean representing 'Lockout After Idle <n> Days'
				*/
				get enforceIdle() {
					if (_enforceIdle === null) {
						_enforceIdle = _passwordPolicy ? (_passwordPolicy.IdleLimit > 0) : null;
					}
					return _enforceIdle;
				},

				/**
				* @ngdoc property
				* @name sbadminPasswordPolicyDataStore#enforceIdle
				* @propertyOf sharebase-admin.sbadminPasswordPolicyDataStore
				* @kind property
				*
				* @description
				* 'Lockout After Idle <n> Days'
				*/
				set enforceIdle(val) {
					_enforceIdle = val;
					if (val === false) {
						_passwordPolicy.IdleLimit = 0;
					}
				},
			};

			function getPasswordPolicy(passwordPolicyId) {
				resetProperties();

				if (!passwordPolicyId) {
					_passwordPolicy = angular.copy(_newPasswordPolicy);

					return $q.resolve(_passwordPolicy);
				}
				return sbadminPasswordPolicyService.getPasswordPolicy(passwordPolicyId).then(function (response) {
					_passwordPolicy = response;

					return _passwordPolicy;
				});
			}

			function savePasswordPolicy() {
				if (_passwordPolicy.PasswordPolicyId) {
					return sbadminPasswordPolicyService.updatePasswordPolicy(_passwordPolicy).then(function (response) {
						return response;
					});
				}
				else {
					return sbadminPasswordPolicyService.createPasswordPolicy(_passwordPolicy).then(function (response) {
						return response;
					});
				}
			}

			function deletePasswordPolicy(passwordPolicyId) {
				return sbadminPasswordPolicyService.deletePasswordPolicy(passwordPolicyId).then(function (response) {
					return response;
				});
			}

			function activatePasswordPolicy(passwordPolicyId) {
				return sbadminPasswordPolicyService.activatePasswordPolicy(passwordPolicyId).then(function (response) {
					return response;
				});
			}

			function deactivatePasswordPolicy(passwordPolicyId) {
				return sbadminPasswordPolicyService.deactivatePasswordPolicy(passwordPolicyId).then(function (response) {
					return response;
				});
			}

			function resetProperties() {
				_passwordPolicy = null;

				_enforceIdle = null;
				_enforceFailure = null;
				_expire = null;
				_requireWait = null;
			}

		}

	})();

/***/ },
/* 268 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		angular
			.module('sharebase-admin')
			.factory('sbadminPendingDeploymentsDataStore', [
				'sbadminPendingDeploymentsService',
				'$q',
				PendingDeploymentsDataStore
			]);

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminPendingDeploymentsDataStore
		* 
		* @description 
		* A datastore used to interact with the contents of a Document.
		* 
		**/
		function PendingDeploymentsDataStore(sbadminPendingDeploymentsService, $q) {
			var _deployments = null;

			return {
				/**
				* @ngdoc property
				* @name sbadminPendingDeploymentsDataStore#pageCount
				* @propertyOf sharebase-admin.sbadminPendingDeploymentsDataStore
				* @kind property
				*
				* @description
				* User's pending deployments      
				*/
				get deployments() { return _deployments; },
				/**
				* @ngdoc method
				* @name sbadminPendingDeploymentsDataStore#getPendingDeployment
				* @methodOf sharebase-admin.sbadminPendingDeploymentsDataStore
				* @kind function
				*
				* @description
				* Load a pending deployment
				* 
				* @returns {Deferred} A promise that will resolve with a pending deployment model
				*/
				getPendingDeployment: getPendingDeployment,

				/**
				* @ngdoc method
				* @name sbadminPendingDeploymentsDataStore#loadPendingDeployments
				* @methodOf sharebase-admin.sbadminPendingDeploymentsDataStore
				* @kind function
				*
				* @description
				* Loads pending deployments
				* 
				* @returns {Deferred} A promise that will resolve with a selected document
				*/
				load: loadPendingDeployments,

				/**
				* @ngdoc method
				* @name sbadminPendingDeploymentsDataStore#resend
				* @methodOf sharebase-admin.sbadminPendingDeploymentsDataStore
				* @kind function
				*
				* @description
				* Resends email notification to owner of pending deployment
				* @param {object} A pending deployment model
				* @returns {Deferred} A promise that will resolve with the server response
				*/
				resendNotification: resendNotification,

				/**
				* @ngdoc method
				* @name sbadminPendingDeploymentsDataStore#save
				* @methodOf sharebase-admin.sbadminPendingDeploymentsDataStore
				* @kind function
				*
				* @description
				* Saves a pending deployment
				* @param {object} A pending deployment model
				* @returns {Deferred} A promise that will resolve with the server response
				*/
				save: save
			};

			function filterDeploymentsById(pendingDeploymentId) {
				var pendingDeployment = null;
				if (_deployments) {
					for (var i = 0, ii = _deployments.length; i < ii; i++) {
						// eslint-disable-next-line eqeqeq
						if (_deployments[i].PendingDeploymentRegistrationId == pendingDeploymentId) { 
							pendingDeployment = _deployments[i];
							break;
						}
					}
				}
				return pendingDeployment;
			}

			function getPendingDeployment(pendingDeploymentId) {
				var promise = $q.resolve();

				if (!_deployments) {
					promise = loadPendingDeployments();
				}

				promise = promise.then(function () {
					return filterDeploymentsById(pendingDeploymentId);
				});

				return promise;
			}
		
			function loadPendingDeployments() {
				return sbadminPendingDeploymentsService.getDeployments().then(function (deployments) {
					_deployments = deployments;
					return _deployments;
				});
			}

			function resendNotification(pendingDeployment) {
				return sbadminPendingDeploymentsService.resendNotification(pendingDeployment);
			}

			function save(pendingDeployment) {
				return sbadminPendingDeploymentsService.save(pendingDeployment).then(function () {
					var pendingDeploymentId = pendingDeployment.pendingDeploymentId;
					// Update data store
					if (_deployments) {
						for (var i = 0, ii = _deployments.length; i < ii; i++) {
							// eslint-disable-next-line eqeqeq
							if (_deployments[i].PendingDeploymentRegistrationId == pendingDeploymentId) {
								_deployments[i] = pendingDeployment;
								break;
							}
						}
					}
					return pendingDeployment;
				});
			}
		}
	})();

/***/ },
/* 269 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminTenantAdminDataStore
		* 
		* @description 
		* A datastore used to interact with a ShareBase tenant administrator
		* 
		*/

		angular
			.module('sharebase-admin')
			.factory('sbadminTenantAdminDataStore',
			[
				'sbadminTenantAdminService',
				TenantAdminDataStore
			]);
		
		function TenantAdminDataStore(sbadminTenantAdminService) {
			var _administrator = null;

			return {

				/**
				* @ngdoc property
				* @name sbadminTenantAdminDataStore#saveAdministrator
				* @propertyOf sharebase-admin.sbadminTenantAdminDataStore
				* @kind function
				*
				* @param {integer} groupID The id of the group to add administrator to
				* @param {string} username The username of the new administrator
				* @param {string} emailAddress The email address of the new administrator
				* @param {string} password The password of the new administrator 
				*
				* @description
				* Creates a new user that is a tenant administrator
				* 
				*/
				createAdministrator: createAdministrator,

				/**
				* @ngdoc property
				* @name sbadminTenantAdminDataStore#administrator
				* @propertyOf sharebase-admin.sbadminTenantAdminDataStore
				* @kind property
				*
				* @description
				* A tenant administrator
				*
				* @returns {object} A tenant administrator
				*/
				get administrator() { return _administrator || getAdministrator(); }
			};

			function getAdministrator() {
				return sbadminTenantAdminService.getAdministrator().then(function (response) {
					_administrator = response;

					return _administrator;
				});
			}

			function createAdministrator(groupID, username, emailAddress, password) {
				return sbadminTenantAdminService.createAdministrator(groupID, username, emailAddress, password);
			}
		}
	})();

/***/ },
/* 270 */
/***/ function(module, exports) {

	(function () {
		'use strict';

		/**
		* @ngdoc service
		* @name  sharebase-admin.sbadminTenantAdminsDataStore
		* 
		* @description 
		* A datastore used to interact with ShareBase tenant administrators
		* 
		*/

		angular
			.module('sharebase-admin')
			.factory('sbadminTenantAdminsDataStore',
			[
				'$q',
				'sbadminTenantAdminsService',
				TenantAdminsDataStore
			]);
		
		function TenantAdminsDataStore($q, sbadminTenantAdminsService) {
			var _administrators = null;

			return {
				/**
				* @ngdoc method
				* @name sbadminTenantAdminsDataStore#getAdministrators
				* @methodOf sharebase-admin.sbadminTenantAdminsDataStore
				* @kind function
				*
				* @description
				* Loads or refreshes list of tenant admins
				* 
				* @returns {Deferred} A promise that will resolve with a list of group admins
				*/
				getAdministrators: getAdministrators,

				/**
				* @ngdoc property
				* @name sbadminTenantAdminsDataStore#administrators
				* @propertyOf sharebase-admin.sbadminTenantAdminsDataStore
				* @kind property
				*
				* @description
				* A list of tenant admins
				*
				* @returns {object} An array of tenant admins
				*/
				get administrators() { return _administrators; },
			};

			function getAdministrators() {
				return sbadminTenantAdminsService.getAdministrators().then(function (response) {
					_administrators = response;

					return _administrators;
				});
			}
		}
	})();

/***/ },
/* 271 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/sharebase-bundle/sharebase.js
// module id = 208
// module chunks = 3